import { ProposalDecision } from '../../agents/types.js';
import { BlameLogType } from '../../blamelog/index.js';
import { CaseState, CaseStatus, CaseType, SystemEndReason, } from '../../cases/index.js';
import { CaseTag } from '../../cases/index.js';
import { CollectorType, PaymentOptionType } from '../../collectors/index.js';
import { ConnectConnectionStatus } from '../../connect/connections/index.js';
import { ConnectCaseMappingStatus, RetractionReason, } from '../../connect/mappings/index.js';
import { ProductService } from '../../connect/products/index.js';
import { InterestType, LienType, ValuationSource, } from '../../cosmoV2/assets.js';
import { ProviderName } from '../../cosmoV2/providers/index.js';
import { SubmitToCourtError } from '../../court/auto-submit.js';
import { UdbetalingsRekvisitioner } from '../../court/index.js';
import { CreditorState } from '../../creditor/index.js';
import { AlternativeContactType, CompanyStarCycle, DissolvedStatus, FoundationCode, PrivateStarCycle, RelationType, } from '../../customers/index.js';
import { DebtRegistrationState, RegistryType, } from '../../debt-register/index.js';
import { DebtRegistrationError } from '../../debt-register/rki.js';
import { DocumentTypes } from '../../documents/index.js';
import { AutoBillingTiming, Timing, } from '../../economy/billing-appendix-setups/index.js';
import { DepositShareType } from '../../economy/billing/organize.js';
import { CaseVoucherEventType } from '../../economy/case-voucher-events/event-type.js';
import { State as CaseVoucherState } from '../../economy/case-vouchers/index.js';
import { CaseVoucherSource, PaymentType, State, } from '../../economy/case-vouchers/index.js';
import { CaseVoucherTags } from '../../economy/index.js';
import { PaymentPlanEntryStatus } from '../../economy/payment-plans/index.js';
import { PayoutState, PayoutType } from '../../economy/payouts/index.js';
import { CompoundingPeriod, ImposeInterestFrequency, VoucherCategory, VoucherTypeIds, VoucherTypeSetting, } from '../../economy/vouchers/index.js';
import { EmbedPlacement } from '../../embeds/index.js';
import { EndReasonCategory } from '../../end-reasons/index.js';
import { ImportState } from '../../imports/types.js';
import { Entity, Gender, PermissionLevels, TimespanUnit } from '../../index.js';
import { AggregationType } from '../../insights/aggregations.js';
import { BulkActionType } from '../../insights/bulk-actions.js';
import { FilterType } from '../../insights/index.js';
import { DiscountType, IntentType } from '../../intents/index.js';
import { InteractionEventType } from '../../interactions/events/index.js';
import { InteractionType, PhoneIncomingTag, PhoneOutgoingTag, ReturnReason, } from '../../interactions/index.js';
import { PerformedByType } from '../../performed-by/index.js';
import { SystemProcedure, SystemProcedureId } from '../../procedures/index.js';
import { TemplateMention, TemplateTag, TemplateType, } from '../../templates/index.js';
import { SKU } from '../../tenants/billing.js';
import { TenantStatus } from '../../tenants/index.js';
import { TribunalCaseStatus, TribunalCaseType, } from '../../tribunal/cases/types.js';
import { CourtMeetingState, DistraintType, TribunalJobType, } from '../../tribunal/jobs/types.js';
import { UpdateType } from '../../updates/index.js';
import { InterestFrom, VoucherApplicationTarget, VoucherApplicationType, } from '../../voucher-applications/index.js';
import { PathWarning, RequirementType, TimingType, TodoType, } from '../../workflows/index.js';
const map = {
    propertyRefDescriptions: {
        [Entity.Customer]: 'Egenskapen fylles ut på kunden og deles på tvers av kundens saker',
    },
    ultimateCreditors: {
        notes: 'Notater',
    },
    agentProposals: {
        proposedInput: 'Forslag',
        appliedInput: 'Anvendt input',
        finalVersion: 'Endelig versjon',
        agentVersion: 'Agentens forslag',
    },
    categoryInsights: {
        tabTitle: 'Kategorier',
        category: 'Kategori',
        allCategories: 'Alle kategorier',
        interactions: 'Interaksjoner',
        uncategorized: 'Ikke kategorisert',
        addedByCaseworkers: 'Lagt til av saksbehandlere',
        removedByCaseworkers: 'Fjernet av saksbehandlere',
        noInteractions: 'Ingen kategoriserte interaksjoner i perioden.',
        removed: 'Fjernet av en saksbehandler',
        addedByAi: 'Lagt til av AI',
    },
    agentPerformance: {
        tabTitle: 'Agentforslag',
        action: 'Handling',
        allActions: 'Alle handlinger',
        taskPrompt: 'Oppgaveprompt',
        task: 'Oppgave',
        allTaskPrompts: 'Alle oppgaveprompter',
        startedManually: 'Startet manuelt',
        unknownUpdateType: 'Ukjent oppgavetype',
        accepted: 'Godkjent',
        proposals: 'Forslag',
        decisionTime: 'Beslutningstid',
        escalated: 'Eskalert til saksbehandler',
        oldestPending: 'Eldste: {age}',
        comparedToPrevious: 'Sammenlignet med forrige periode',
        percentagePoints: '{points} %-poeng',
        duration: {
            minutes: '{minutes} min',
            hours: '{hours} t',
            days: '{days} dager',
        },
        decisions: {
            [ProposalDecision.Pending]: 'Venter',
            [ProposalDecision.ApprovedAsIs]: 'Godkjent uendret',
            [ProposalDecision.Edited]: 'Redigert',
            [ProposalDecision.Rejected]: 'Avvist',
            [ProposalDecision.Failed]: 'Feilet',
            [ProposalDecision.Closed]: 'Lukket',
        },
        allDecisions: 'Alle',
        noProposals: 'Ingen forslag i perioden.',
    },
    is: {
        currently: 'no',
    },
    langs: {
        en: 'Engelsk',
        da: 'Dansk',
        sv: 'Svensk',
        no: 'Norsk',
        fi: 'Finsk',
        nl: 'Nederlandsk',
        de: 'Tysk',
        fr: 'Fransk',
        es: 'Spansk',
        cs: 'Tsjekkisk',
        el: 'Gresk',
    },
    tribunalCaseTypes: {
        [TribunalCaseType.DKBetalingspaakrav]: '🇩🇰 Betalingspåkravsblankett (Betalingspåkrav)',
        [TribunalCaseType.DKFogedrekvisition]: '🇩🇰 Namsrettsbegjæring (fogedrekvisition)',
        [TribunalCaseType.DKAndreFogedsager]: '🇩🇰 Andre namssaker',
        [TribunalCaseType.GLStaevning]: '🇬🇱 Stævning',
        [TribunalCaseType.GLFogedBegaering]: '🇬🇱 Fogedbegæring',
        [TribunalCaseType.GLBetalingspaakrav]: '🇬🇱 Betalingspåkravsblankett (Betalingspåkrav)',
    },
    tribunalCaseStatuses: {
        [TribunalCaseStatus.Created]: 'Opprettet',
        [TribunalCaseStatus.Awaiting1Paategning]: 'Venter på "1.-påtegning"',
        [TribunalCaseStatus.ClosedBecauseOfObjection]: 'Avsluttet - innsigelse',
        [TribunalCaseStatus.Closed]: 'Avsluttet',
        [TribunalCaseStatus.Awaiting2Paategning]: 'Venter på "2.-påtegning"',
        [TribunalCaseStatus.AwaitingBailiffMeeting]: 'Venter på møte',
        [TribunalCaseStatus.AwaitingNoticeForBailiffMeeting]: 'Venter på møteinnkalling',
        [TribunalCaseStatus.AwaitingVerdict]: 'Venter på dom',
        [TribunalCaseStatus.AwaitingNoticeForFogedmoede]: 'Venter på innkalling',
        [TribunalCaseStatus.AwaitingFogedmoede]: 'Venter på møte',
    },
    tribunalJobTypes: {
        [TribunalJobType.GLCreateBetalingspaakrav]: 'Opprett namsrettssak',
        [TribunalJobType.GLResendBetalingspaakrav]: 'Sender namsrettssak på nytt',
        [TribunalJobType.CreateBetalingspaakrav]: 'Opprett namsrettssak',
        [TribunalJobType.ResendBetalingspaakrav]: 'Sender namsrettssak på nytt',
        [TribunalJobType.Register1Paategning]: 'Registrerer "1.-påtegning"',
        [TribunalJobType.ClosedObjection]: 'Avsluttet etter 1.-påtegning på grunn av innsigelse',
        [TribunalJobType.Register2Paategning]: 'Registrerer "2.-påtegning"',
        [TribunalJobType.CreateFogedrekvisition]: 'Opprett "fogedrekvisition"',
        [TribunalJobType.RegisterInsolvency]: 'Registrer insolvens',
        [TribunalJobType.RegisterPolicePresentation]: 'Registrer politipresentasjon',
        [TribunalJobType.CreateStaevning]: 'Opprett stevning',
        [TribunalJobType.RegisterVerdict]: 'Dom registrert',
        [TribunalJobType.ResendStaevning]: 'Sender stevning på nytt',
        [TribunalJobType.CreateFogedbegaering]: 'Opprett fogedbegæring',
        [TribunalJobType.ResendFogedbegaering]: 'Sender fogedbegæring på nytt',
        [TribunalJobType.RegisterInsolvens]: 'Registrer insolvens',
        [TribunalJobType.CourtMeeting]: 'Rettsmøte',
        [TribunalJobType.Distraint]: 'Utlegg',
        [TribunalJobType.CreateOtherFogedsager]: 'Opprett annen namssak',
        [TribunalJobType.Note]: 'Legg til notat',
        [TribunalJobType.CloseCase]: 'Marker sak som avsluttet',
    },
    distraintType: {
        [DistraintType.Property]: 'Fast eiendom',
        [DistraintType.Vehicle]: 'Kjøretøy',
        [DistraintType.RentalDeposit]: 'Depositum i leiebolig',
        [DistraintType.CooperativeHousing]: 'Andel i borettslag',
        [DistraintType.Other]: 'Annet',
        [DistraintType.MortgageDeed]: 'Pantebrev',
        [DistraintType.ExcessTax]: 'Skatt til gode',
    },
    tenantStatus: {
        [TenantStatus.Active]: 'Aktiv',
        [TenantStatus.Demo]: 'Demo',
        [TenantStatus.Disabled]: 'Deaktivert',
        [TenantStatus.GettingStarted]: 'Venter på lansering',
        [TenantStatus.Sandbox]: 'Sandkasse',
    },
    tenantStatusPlural: {
        [TenantStatus.Active]: 'Aktive',
        [TenantStatus.Demo]: 'Demoer',
        [TenantStatus.Disabled]: 'Deaktiverte',
        [TenantStatus.GettingStarted]: 'Venter på lansering',
        [TenantStatus.Sandbox]: 'Sandkasser',
    },
    tenantBillingUnits: {
        "Concatenated SMS'": "Sammenkjedet SMS'",
        'Min.': 'Min.',
        'Pcs.': 'Stk.',
        Months: 'Måneder',
    },
    tenantBilling: {
        invoices: 'Fakturaer',
        invoice: 'Faktura',
        creditNote: 'Kreditnota',
        noInvoicesYet: 'Ingen fakturaer å vise',
        backToTenantBilling: 'Tilbake til fakturering',
    },
    tenantSKU: {
        [SKU.DomesticSMS]: 'SMS innenlands',
        [SKU.InternationalSMS]: 'SMS internasjonalt',
        [SKU.DomesticAutoCall]: 'Automatisk anrop innenlands',
        [SKU.InternationalAutoCall]: 'Automatisk anrop internasjonalt',
        [SKU.DomesticLetter]: 'Brev innenlands',
        [SKU.InternationalLetter]: 'Brev internasjonalt',
        [SKU.ReturnLetter]: 'Returbrev',
        [SKU.DigitalSignature]: 'Digital signatur',
        [SKU.PhoneLookup]: 'Oppslag av telefonnummer',
        [SKU.EmailLookup]: 'Oppslag av e-post',
        [SKU.CaseCreation]: 'Opprettelse av sak',
        [SKU.MigratedCaseCreation]: 'Opprettelse av migrert sak',
        [SKU.MonthlyBaseFee]: 'Månedlig lisensavgift',
        [SKU.SupportAgreement]: 'Supportavtale',
        [SKU.EBoks0_60KB]: 'e-Boks-melding (0-60kb)',
        [SKU.EBoks61_120KB]: 'e-Boks-melding (61-120kb)',
        [SKU.EBoks121_300KB]: 'e-Boks-melding (121-300kb)',
        [SKU.EBoks301_480KB]: 'e-Boks-melding (301-480kb)',
        [SKU.EBoks481_960KB]: 'e-Boks-melding (481-960kb)',
        [SKU.EBoks961_1440KB]: 'e-Boks-melding (961-1440kb)',
        [SKU.EBoks1441_1920KB]: 'e-Boks-melding (1441-1920kb)',
        [SKU.EBoks1921_10080KB]: 'e-Boks-melding (1921-10080kb)',
        [SKU.Onboarding]: 'Onboarding',
        [SKU.LetterExtraSheet]: 'Ekstra sider, fysisk brev',
        [SKU.NemId]: 'NemId-validering',
        [SKU.MitID]: 'MitID-validering',
        [SKU.FreezingSystemSignOn]: 'Frysesystem pålogging',
        [SKU.FreezingSystemSignOff]: 'Frysesystem avlogging',
        [SKU.Consultancy]: 'Konsulentbistand',
        [SKU.CosmoPersonLookup]: 'Oppslag av person',
        [SKU.CosmoCompanyLookup]: 'Oppslag av selskap',
    },
    caseVoucherTableLabels: {
        overview: 'Saksøkonomi',
        detailed: 'Saksøkonomi detaljert',
        principalWithReferenceCaseVouchers: 'Hovedstol med referansebilag',
    },
    documentSettings: {
        newDocumentSigningLink: 'Ny lenke for dokumentsignering',
        name: 'Navn på flettefelt',
        description: 'Beskrivelse',
        signedProcedure: 'Utløs hvis dokumentet er signert',
        declinedSigningProcedure: 'Utløs hvis signering av dokumentet avvises',
    },
    caseVoucherTables: {
        createNewTable: 'Legg til tabell',
        name: 'Navn på flettefelt',
        description: 'Beskrivelse',
        includeHeader: 'Vis overskrift i tabell',
        includeSumRow: 'Vis sumrad i tabell',
        showDepositDistribution: 'Vis fordeling av innskudd basert på renteinnskuddsrekkefølge',
        showInterestCalculationDetails: 'Vis detaljer for renteberegning',
        showInterestStatus: 'Vis renteårsak (betalt og erkjent)',
        includeDeleted: 'Vis slettede saksbilag',
        includeFIKPaymentDetails: 'Inkluder FIK betalings-ID basert på saksbilagets referanse-id',
        includeDate: 'Vis dato',
        includeDueDate: 'Vis forfallsdato',
        excludeNotDueCaseVouchers: 'Skjul ikke-forfalte fakturaer',
        onlyShowSelectedVoucherCategories: 'Vis kun valgte saksbilagskategorier',
        includeReferenceCaseVouchers: 'Skjul referansebilag',
        filterOnCaseVoucherProperties: 'Filtrer på saksbilagsattributter',
        groupBy: 'Grupper saksbilag',
        groupByText: 'Tekst',
        groupIncludesPayments: 'Inkluder alle betalingstyper',
        excludePaymentsFromSubTotal: 'Ekskluder alle betalingstyper',
        matchPropertiesShouldBeTrue: 'Skal være sann',
        matchPropertiesShouldBeFalse: 'Skal være usann',
        type: 'Tabelltype',
        typeStandard: 'Standard',
        typeLedger: 'Kravsoppstilling med løpende saldo',
        typeLedgerDescription: 'Alle saksbilag og hver måneds rente i kronologisk rekkefølge, med hva hver innbetaling dekket samt gjenstående hovedstol, rente og omkostninger.',
    },
    economyCategories: {
        [VoucherCategory.DISBURSEMENT]: 'Utlegg',
        [VoucherCategory.FEE]: 'Gebyr',
        [VoucherCategory.COLLECTIONCOMMISSION]: 'Inkassokommisjon',
        [VoucherCategory.OVERPAYMENT]: 'Overbetaling',
        [VoucherCategory.PAYOUT]: 'Utbetaling',
        [VoucherCategory.VAT]: 'MVA',
        [VoucherCategory.TRANSACTION]: 'Transaksjon',
        [VoucherCategory.COST]: 'Kostnad',
        [VoucherCategory.COURTCOST]: 'Rettsgebyr',
        [VoucherCategory.INTEREST]: 'Rente',
        [VoucherCategory.PRINCIPAL]: 'Hovedstol',
    },
    pluralEconomyVoucherTypeLabels: {
        [VoucherTypeIds.PRINCIPAL]: 'Hovedstol',
        [VoucherTypeIds.INVOICE]: 'Fakturaer',
        [VoucherTypeIds.ONACCOUNTINVOICE]: 'Fakturaer på konto',
        [VoucherTypeIds.FINALINVOICE]: 'Avsluttende oppgjør',
        [VoucherTypeIds.CONTROLFEE]: 'Kontrollgebyrer',
        [VoucherTypeIds.ADMINISTRATIONCOST]: 'Administrasjonskostnader',
        [VoucherTypeIds.UDTRAEKSGEBYR]: 'Uttaksgebyrer',
        [VoucherTypeIds.CREDITNOTE]: 'Kreditnotaer',
        [VoucherTypeIds.YEARLYINTEREST]: 'Årlige renter',
        [VoucherTypeIds.MONTHLYINTEREST]: 'Månedlige renter',
        [VoucherTypeIds.STARTEDMONTHINTEREST]: 'Renter per påbegynt måned',
        [VoucherTypeIds.PROCESSINTEREST]: 'Renter',
        [VoucherTypeIds.GLPROCESSINTEREST]: 'Renter (GL)',
        [VoucherTypeIds.COMPOUNDINTEREST_DAILY_CAP]: 'Sammensatt rente (daglig rentetilskrivning)',
        [VoucherTypeIds.COMPOUNDINTEREST_MONTHLY_CAP]: 'Sammensatt rente (månedlig rentetilskrivning)',
        [VoucherTypeIds.COMPOUNDINTEREST_QUARTERLY_CAP]: 'Sammensatt rente (kvartalsvis rentetilskrivning)',
        [VoucherTypeIds.REMINDERFEE]: 'Purregebyrer',
        [VoucherTypeIds.COLLECTIONCOST]: 'Inkassokostnader',
        [VoucherTypeIds.COLLECTIONFEE]: 'Inkassogebyrer',
        [VoucherTypeIds.BAILIFFSFEE]: 'Fogedgebyrer',
        [VoucherTypeIds.WRITFEE]: 'Rettssak-gebyr',
        [VoucherTypeIds.COURTCLAIMCOSTWITHOUTCIVILCOURT]: 'Sakskostnader uten sivil rett',
        [VoucherTypeIds.COURTCLAIMSALARY]: 'Lønn ved rettskrav',
        [VoucherTypeIds.BAILIFSSALARY]: 'Lønn for foged',
        [VoucherTypeIds.FOGEDREKVISITIONSFEE]: 'Fogedrekvisitionsgebyrer',
        [VoucherTypeIds.POLICEPRESENTATIONFEE]: 'Gebyr for politipresentasjon',
        [VoucherTypeIds.COURTCLAIMCOSTWITHBAILIFFSCOURT]: 'Sakskostnader med fogedrett',
        [VoucherTypeIds.WRITSALARY]: 'Lønn for rettssaker',
        [VoucherTypeIds.COMPENSATIONCOST]: 'Kompensasjonskostnader',
        [VoucherTypeIds.Folkeregisteropslag]: 'Folkeregisteroppslag',
        [VoucherTypeIds.IMMATERIALRETLIGESAGER]: 'Immaterielle rettssaker',
        [VoucherTypeIds.CIVILCOURTCOST]: 'Kostnader for sivil rett',
        [VoucherTypeIds.DEPOSIT]: 'Innskudd',
        [VoucherTypeIds.WITHDRAWAL]: 'Uttak',
        [VoucherTypeIds.OVERPAYMENT]: 'Overbetalinger',
        [VoucherTypeIds.COLLECTIONCOMMISSION]: 'Inkassokommisjoner',
        [VoucherTypeIds.COLLECTIONCOMMISSIONSURVEILLANCE]: 'Inkassokommisjoner (overvåking)',
        [VoucherTypeIds.COLLECTIONCOMMISSIONCLIENTDEPOSIT]: 'Inkassokommisjoner (kundedepositum)',
        [VoucherTypeIds.JURIDISKBISTAND]: 'Juridisk bistand',
        [VoucherTypeIds.ENDCASEFEE]: 'Avslutningsgebyr',
        [VoucherTypeIds.STARTCASEFEE]: 'Oppstartgebyr',
        [VoucherTypeIds.BPKFEE]: 'BPK-gebyrer',
        [VoucherTypeIds.FOGEDFEE]: 'Fogedgebyrer',
        [VoucherTypeIds.DEBTREGISTERREGISTRATIONFEE]: 'Gjeldsregister-registreringsgebyrer',
        [VoucherTypeIds.BPKDISBURSEMENT]: 'Utløsningsgebyrer',
        [VoucherTypeIds.POLICEDISBURSEMENT]: 'Utlegg for politiframlegg',
        [VoucherTypeIds.FOGEDDISBURSEMENT]: 'Fogedrekvisisjon',
        [VoucherTypeIds.VAT]: 'MVA',
        [VoucherTypeIds.GAELDSBREV]: 'Lån',
        [VoucherTypeIds.SETTLEMENT]: 'Forlik',
        [VoucherTypeIds.FIXEDINTEREST]: 'Fast rente',
        [VoucherTypeIds.DEPOSITPAYOUT]: 'Utbetalinger av depositum',
        [VoucherTypeIds.FOLKEREGISTEROPSLAG]: 'Folkeregisteroppslag',
        [VoucherTypeIds.ANMELDELSEAFKRAV]: 'Anmeldelse av krav',
        [VoucherTypeIds.MeetingFee]: 'Møtegebyrer',
        [VoucherTypeIds.STAEVNINGSGEBYR]: 'Gebyr for stevning',
        [VoucherTypeIds.BERAMMELSESAFGIFT]: 'Berammelsesgebyr',
        [VoucherTypeIds.AFLYSNINGAFUDLAEG]: 'Sletting av utlegg',
        [VoucherTypeIds.LOCKSMITHFEE]: 'Låsesmedgebyr',
        [VoucherTypeIds.DRIVINGFEE]: 'Kjørekostnader',
        [VoucherTypeIds.OTHERFEE]: 'Andre kostnader',
        [VoucherTypeIds.REFUND]: 'Refusjon',
        [VoucherTypeIds.JOINTDEPOSIT]: 'Solidariske betalinger',
        [VoucherTypeIds.SEPROCESSINTEREST]: 'Forsinkelsesrenter (Sverige)',
        [VoucherTypeIds.SEKRONOFOGDENAPPLICATIONFEE]: 'Rettsgebyrer (Kronofogden)',
        [VoucherTypeIds.SEKRONOFOGDENREPRESENTATIONFEE]: 'Ombudsgodtgjørelse (betalingsforelegg)',
        [VoucherTypeIds.NOLATEINTEREST]: 'Forsinkelsesrenter',
        [VoucherTypeIds.NOFORLIKSRADFEE]: 'Rettsgebyrer (forliksrådet)',
        [VoucherTypeIds.NOLEGALCOLLECTIONFEE]: 'Tunge salærer (rettslig inkasso)',
    },
    economyVoucherTypeLabels: {
        [VoucherTypeIds.PRINCIPAL]: 'Hovedstoler',
        [VoucherTypeIds.INVOICE]: 'Faktura',
        [VoucherTypeIds.ONACCOUNTINVOICE]: 'Faktura med kredit',
        [VoucherTypeIds.FINALINVOICE]: 'Endelig oppgjør',
        [VoucherTypeIds.CONTROLFEE]: 'Kontrollgebyr',
        [VoucherTypeIds.ADMINISTRATIONCOST]: 'Administrasjonskostnad',
        [VoucherTypeIds.UDTRAEKSGEBYR]: 'Uttaksgebyr',
        [VoucherTypeIds.CREDITNOTE]: 'Kreditnota',
        [VoucherTypeIds.YEARLYINTEREST]: 'Årlig rente',
        [VoucherTypeIds.MONTHLYINTEREST]: 'Månedlig rente',
        [VoucherTypeIds.STARTEDMONTHINTEREST]: 'Rente per påbegynt måned',
        [VoucherTypeIds.PROCESSINTEREST]: 'Rente',
        [VoucherTypeIds.GLPROCESSINTEREST]: 'Rente (GL)',
        [VoucherTypeIds.COMPOUNDINTEREST_DAILY_CAP]: 'Sammensatt rente (daglig rentetilskrivning)',
        [VoucherTypeIds.COMPOUNDINTEREST_MONTHLY_CAP]: 'Sammensatt rente (månedlig rentetilskrivning)',
        [VoucherTypeIds.COMPOUNDINTEREST_QUARTERLY_CAP]: 'Sammensatt rente (kvartalsvis rentetilskrivning)',
        [VoucherTypeIds.REMINDERFEE]: 'Purregebyr',
        [VoucherTypeIds.COLLECTIONCOST]: 'Innkrevingskostnad',
        [VoucherTypeIds.COLLECTIONFEE]: 'Innkrevingsgebyr',
        [VoucherTypeIds.COMPENSATIONCOST]: 'Erstatningskostnad',
        [VoucherTypeIds.Folkeregisteropslag]: 'Folkeregisteroppslag',
        [VoucherTypeIds.IMMATERIALRETLIGESAGER]: 'Saker om immaterielle rettigheter',
        [VoucherTypeIds.DEPOSIT]: 'Innskudd',
        [VoucherTypeIds.WITHDRAWAL]: 'Uttak',
        [VoucherTypeIds.OVERPAYMENT]: 'Overbetaling',
        [VoucherTypeIds.COLLECTIONCOMMISSION]: 'Innkrevingsprovisjon',
        [VoucherTypeIds.COLLECTIONCOMMISSIONSURVEILLANCE]: 'Innkrevingsprovisjon (overvåkning)',
        [VoucherTypeIds.COLLECTIONCOMMISSIONCLIENTDEPOSIT]: 'Innkrevingsprovisjon (kreditorinnskudd)',
        [VoucherTypeIds.JURIDISKBISTAND]: 'Juridisk bistand',
        [VoucherTypeIds.ENDCASEFEE]: 'Avgift ved avslutning av sak',
        [VoucherTypeIds.STARTCASEFEE]: 'Avgift ved start av sak',
        [VoucherTypeIds.BPKFEE]: 'BPK-avgift',
        [VoucherTypeIds.FOGEDFEE]: 'Fogedrekvisisjonsgebyr',
        [VoucherTypeIds.DEBTREGISTERREGISTRATIONFEE]: 'Gjeldsregister-registreringsgebyr',
        [VoucherTypeIds.BPKDISBURSEMENT]: 'Utlegg for skriftlig begjæring',
        [VoucherTypeIds.POLICEDISBURSEMENT]: 'Utlegg for politiframlegg',
        [VoucherTypeIds.FOGEDDISBURSEMENT]: 'Utlegg for fogedrekvisisjon',
        [VoucherTypeIds.COURTCLAIMCOSTWITHOUTCIVILCOURT]: 'Sakskostnader uten sivilt rettslig krav',
        [VoucherTypeIds.COURTCLAIMSALARY]: 'Saksgebyr',
        [VoucherTypeIds.VAT]: 'MVA',
        [VoucherTypeIds.BAILIFFSFEE]: 'Fogedgebyr',
        [VoucherTypeIds.BAILIFSSALARY]: 'Fogedlønn',
        [VoucherTypeIds.POLICEPRESENTATIONFEE]: 'Gebyr for politiframlegg',
        [VoucherTypeIds.COURTCLAIMCOSTWITHBAILIFFSCOURT]: 'Sakskostnader med fogedrett',
        [VoucherTypeIds.CIVILCOURTCOST]: 'Sivile rettskostnader',
        [VoucherTypeIds.FOGEDREKVISITIONSFEE]: 'Gebyr for fogedrekvisisjon',
        [VoucherTypeIds.WRITFEE]: 'Gebyr for skriftlig begjæring',
        [VoucherTypeIds.WRITSALARY]: 'Lønn for skriftlig begjæring',
        [VoucherTypeIds.GAELDSBREV]: 'Lån',
        [VoucherTypeIds.SETTLEMENT]: 'Forlik',
        [VoucherTypeIds.FIXEDINTEREST]: 'Fast rente',
        [VoucherTypeIds.DEPOSITPAYOUT]: 'Utbetaling av innskudd',
        [VoucherTypeIds.FOLKEREGISTEROPSLAG]: 'Folkeregisteroppslag',
        [VoucherTypeIds.ANMELDELSEAFKRAV]: 'Anmeldelse av krav',
        [VoucherTypeIds.MeetingFee]: 'Møtegebyr',
        [VoucherTypeIds.STAEVNINGSGEBYR]: 'Gebyr for stevning',
        [VoucherTypeIds.BERAMMELSESAFGIFT]: 'Gebyr for beramming',
        [VoucherTypeIds.AFLYSNINGAFUDLAEG]: 'Sletting av utlegg',
        [VoucherTypeIds.LOCKSMITHFEE]: 'Låsesmedgebyr',
        [VoucherTypeIds.DRIVINGFEE]: 'Kjøregodtgjørelse',
        [VoucherTypeIds.OTHERFEE]: 'Andre gebyrer',
        [VoucherTypeIds.REFUND]: 'Refusjon',
        [VoucherTypeIds.JOINTDEPOSIT]: 'Solidarisk betaling',
        [VoucherTypeIds.SEPROCESSINTEREST]: 'Forsinkelsesrente (Sverige)',
        [VoucherTypeIds.SEKRONOFOGDENAPPLICATIONFEE]: 'Rettsgebyr (Kronofogden)',
        [VoucherTypeIds.SEKRONOFOGDENREPRESENTATIONFEE]: 'Ombudsgodtgjørelse (betalingsforelegg)',
        [VoucherTypeIds.NOLATEINTEREST]: 'Forsinkelsesrente',
        [VoucherTypeIds.NOFORLIKSRADFEE]: 'Rettsgebyr (forliksrådet)',
        [VoucherTypeIds.NOLEGALCOLLECTIONFEE]: 'Tungt salær (rettslig inkasso)',
    },
    transactionAccounts: {
        transactionAccount: 'bankkonto',
        name: 'Kontonavn',
        referenceId: 'Referansenr.',
        edit: 'Rediger konto',
        bankAccountsPlaceholder: 'Navn på bankkontoen',
        add: 'Legg til bankkonto',
    },
    connectionReasons: {
        someoneAddedTheFollowingVouchers: 'la til følgende bilag',
        addedTheFollowingVouchers: 'Følgende bilag ble lagt til',
        someoneDeletedTheFollowingVouchers: 'slettet følgende bilag',
        deletedTheFollowingVouchers: 'Følgende bilag ble slettet',
        thatResultedIn: 'Det resulterte i denne avregningen',
    },
    economyDownloadPostings: {
        postingReference: 'Bilags-ID',
        creditorReference: 'Kreditorreferanse',
        transactionId: 'Transaksjons-ID',
        type: 'Type',
        ofVoucher: 'Av bilag',
        date: 'Dato',
        currency: 'Valuta',
        amount: 'Beløp',
        accountType: 'Kontotype',
        account: 'Konto',
    },
    systemTankHandles: {
        DEPOSITS: 'Innbetalinger',
    },
    billingModels: {
        name: 'Navn',
        preventNegativeCreditorBalance: 'Unngå negativ kreditorbalanse',
        moreSettings: 'Flere innstillinger',
        forceCollectionCommissionBilling: 'Tving automatisk avregning av inkassoprovisjon – også før innbetalinger.',
        forceCollectionCommissionBillingVoucherTypeId: 'Velg avregningsbilagstype',
        selectSeparateFeeVoucherType: 'Avregn inkassoprovisjon separat',
        selectVouchersGroup: 'Velg bilag',
        systemConnector: 'Systemavregningsmodell',
        tenantConnector: 'Opprettet avregningsmodell',
        voucherCategory: 'Bilagskategori',
        voucherType: 'Bilagstype',
        allVouchers: 'Alle bilag',
        categoriesOrTypesFilter: 'Velg bilag som skal avregnes',
        caseTagFilter: 'Filtrer saker',
        caseTagSurveillanceFilter: 'Kun overvåking',
        caseTagCompanyFilter: 'Kun bedriftssaker',
        caseTagPrivateFilter: 'Kun privatsaker',
        voucherTagFilter: 'Avregn etter pålagt av',
        imposedByCollector: 'Pålagt av inkassobyrå',
        imposedByCreditor: 'Pålagt av kreditor',
        feeFraction: 'Avregn en andel av bilaget',
        feeFractionPlaceholder: 'Andel av bilaget',
        addShare: 'Legg til et annet avregningsfilter',
        byVoucherCategory: 'Etter bilagskategori',
        byVoucherType: 'Etter bilagstype',
        createBillingModel: 'Opprett avregningsmodell',
        simulateBilling: 'Simuler avregning',
        simulateCompany: 'Simuler en bedrift',
        simulateSurveillance: 'Simuler overvåking',
        simulateAmount: 'Innbetalingsbeløp',
        previewBillingModel: 'Forhåndsvis avregningsmodell',
        selectBillingModel: 'Velg avregningsmodell',
        searchBillingModels: 'Søk avregningsmodeller',
    },
    billingAppendixSetups: {
        tenantBillingAppendixSetup: 'Opprettet oppsett',
        systemBillingAppendixSetup: 'Systemoppsett',
        name: 'Navn',
        billingAppendixSetups: 'Oppsett for avregningsbilag',
        noBillingAppendixSetupsToShow: 'Ingen oppsett å vise',
        newBillingAppendixSetup: 'Nytt oppsett for avregningsbilag',
        addBillingAppendixSetup: 'Opprett oppsett for avregningsbilag',
        billing: 'Avregn',
        createNew: 'Opprett oppsett',
        addNewSetup: 'Legg til oppsett',
        appendixHandle: 'Vedleggsnavn',
        hideFromCreditor: 'Skjul avregninger av denne bilagstypen på kreditorwebben',
        includeVatInDepositShare: 'Inkluder mva. i inkassoprovisjonen i innbetalingstabeller',
        selectBillingAppendixSetup: 'Velg oppsett for avregningsbilag',
        searchBillingAppendixSetups: 'Søk oppsett for avregningsbilag',
        previewBillingAppendixSetup: 'Forhåndsvis oppsett for avregningsbilag',
        autoBilling: 'Automatisk avregning',
        autoBillingDescription: 'Generer avregningen automatisk etter en fast tidsplan. Når avslått opprettes avregningen manuelt.',
        autoBillingOff: 'Avslått',
        selectAllVoucherTypes: 'Velg alle bilagstyper',
    },
    billingAppendixSetupTimings: {
        [Timing.Manual]: 'Manuell avregning',
        [Timing.ASAP]: 'Daglig',
        [Timing.OnCaseEnd]: 'Etter saksavslutning',
        [Timing.Weekly]: 'Ukentlig',
        [Timing.Monthly]: 'Månedlig',
        [Timing.Quarterly]: 'Kvartalsvis',
    },
    autoBillingTimings: {
        [AutoBillingTiming.Weekdays0700]: 'Hverdager kl. 07:00',
    },
    caseVoucherStates: {
        [State.Unmapped]: 'Opprettet',
        [State.Unknown]: 'Uidentifisert',
        [State.Archived]: 'Arkivert',
        [State.Overpayment]: 'Overbetaling',
        [State.FullPayment]: 'Full betaling',
        [State.PartialPayment]: 'Delbetaling',
        [State.PaymentPlanEntryPayment]: 'Betaling av avdrag',
        [State.UnkownPaymentPlanPayment]: 'Ukjent betalingsplan',
        [State.AccordPayment]: 'Akkordbetaling',
        [State.PrincipalPayment]: 'Hovedstolsbetaling',
        [State.Pending]: 'Avventer',
    },
    caseVoucherSources: {
        [CaseVoucherSource.Collector]: 'Inkassobyrå',
        [CaseVoucherSource.Creditor]: 'Kreditor',
    },
    depositShareType: {
        [DepositShareType.AdjustmentCredit]: 'Justering - kredit',
        [DepositShareType.AdjustmentDebit]: 'Justering - debet',
        [DepositShareType.Deposit]: 'Innbetaling',
        [DepositShareType.Fee]: 'Inkassoprovisjon',
    },
    voucherTypeSettings: {
        voucherType: 'Bilagstype',
        category: 'Kategori',
        vat: 'Mva',
        setting: 'Innstilling',
        createNewVoucherType: 'Opprett ny bilagstype',
        create: 'Opprett',
        interruptsLimitationPeriod: 'Avbryter foreldelsen',
        interruptsLimitationPeriodDesc: 'Innbetalinger av denne typen starter gjeldens foreldelsesfrist på nytt.',
        customCaseVoucherType: 'Opprettede saksbilagstyper',
        standardCaseVoucherType: 'Standard saksbilagstyper',
        customBillingVoucherType: 'Opprettede avregningsbilagstyper',
        standardBillingVoucherType: 'Standard avregningsbilagstyper',
        caseVoucherType: 'Saksbilagstype',
        caseVoucherTypeDesc: 'Navn på saksbilagstype, kategori og innstilling.',
        label: 'Navn',
        noSetting: 'Ingen',
        interstDays: 'Rentedager',
        interstDaysDesc: 'Dager per år',
        interestRounding: 'Avrunding',
        interestRoundingDesc: 'Når renten skal avrundes.',
        interestRoundingContent: 'Avrundet til nærmeste øre daglig.',
        interestCompoundingPeriod: 'Rentetilskriving',
        interestCompoundingPeriodDesc: 'Hvor ofte renten skal tilskrives hovedstolen. Kalles også kapitaliseringsperioden.',
        interestCompoundVouchers: 'Kapitaliserte rentebilag',
        interestCompoundVouchersDesc: 'Bilagstyper som skal klassifiseres som kapitalisert rente hvis de refererer til samme hovedstolsbilag.',
        interestFrequency: 'Beregningsfrekvens',
        interestFrequencyDesc: 'Hvor ofte renten beregnes.',
        interestTable: 'Rentesatstabell',
        interestTableDesc: 'Rentesatstabell',
        interestTableFromDate: 'Fra dato',
        interestTableRate: 'Rentesats',
        interestTableAddRate: 'Legg til sats',
        interestTableEditRate: 'Rediger sats',
        interestTableSaveRate: 'Lagre',
        interestTableCancelEdit: 'Avbryt',
        interestTableDeleteRate: 'Slett sats',
        interestTableNoRates: 'Ingen rentesatser ennå. Legg til én for å komme i gang.',
        interestTableWarning: 'Endringer kan påvirke eksisterende saker',
        interestTableWarningDesc: 'Redigering av historiske satser eller tillegg av satser datert før i dag kan endre renten på eksisterende saker, avdrag i betalingsplaner og allerede avsluttede saker. Gå forsiktig frem.',
        editor: 'Bilagseditor',
        editorDesc: 'Konfigurer hvilke felter som er tilgjengelige når du oppretter bilag av denne typen, og hvordan de oppfører seg.',
        editorGroupInputs: 'Tilgjengelige felter',
        editorGroupInputsDesc: 'Velg hvilke felter brukeren kan fylle ut når et bilag opprettes.',
        editorGroupBehavior: 'Oppførsel',
        editorGroupBehaviorDesc: 'Hvordan bilag av denne typen oppfører seg når de er opprettet.',
        editorGroupVisibility: 'Synlighet',
        editorGroupVisibilityDesc: 'Kontroller hvor denne bilagstypen og dens bilag vises.',
        editorRequired: 'Obligatorisk',
        editorDueDate: 'Forfallsdato',
        editorDueDateDesc: 'Vis et felt for forfallsdato.',
        editorDefaultAmount: 'Standardbeløp',
        editorDefaultAmountDesc: 'Forhåndsutfyll beløpsfeltet med denne verdien. La stå tomt for å deaktivere.',
        editorText: 'Fritekst',
        editorTextDesc: 'Vis et tekstfelt for ytterligere merknader.',
        editorReferenceId: 'Referanse-ID',
        editorReferenceIdDesc: 'Vis et felt for en ekstern referanseidentifikator.',
        editorReferenceVoucher: 'Referansebilag',
        editorReferenceVoucherDesc: 'Tillat å knytte bilaget til et annet bilag på samme sak.',
        editorAppendix: 'Vedlegg',
        editorAppendixDesc: 'Tillat å legge ved en vedleggsfil.',
        editorSource: 'Kildevelger',
        editorSourceDesc: 'La saksbehandleren velge om bilaget er pålagt av kreditor eller inkassobyrået.',
        editorSourceDefaultCreditor: 'Standard til kreditor',
        editorAmountNegative: 'Tillat negativt beløp',
        editorAmountNegativeDesc: 'Brukes for kreditnotaer og innbetalinger der beløpet reduserer saksbalansen.',
        editorAddInterest: 'Legg automatisk til prosessrente',
        editorAddInterestDesc: 'Legger til et prosessrentebilag som refererer til dette bilaget.',
        editorShowOnCreditorWeb: 'Vis i kreditorportalen',
        editorShowOnCreditorWebDesc: 'Synlig for kreditorer i selvbetjeningsportalen.',
        editorHideProperties: 'Skjul egenskaper',
        editorHidePropertiesDesc: 'Skjul panelet for bilagsegenskaper i editoren.',
        editorHideFromAllUsers: 'Skjul for alle brukere',
        editorHideFromAllUsersDesc: 'Bilagstypen vil ikke kunne velges når du oppretter et nytt bilag.',
        billingVoucherType: 'Avregningsbilagstype',
        billingVoucherTypeDesc: 'Navn på avregningsbilagstype og kategori.',
        editorPayoutToContact: 'Utbetal til kontakt',
        editorPayoutToContactDesc: 'Saksbehandleren velger en kontakt med kontoopplysninger, og det opprettes en utbetaling til kontakten når bilaget opprettes. Brukes til leverandører hyret på vegne av kreditor, f.eks. en låsesmed.',
        editorCreditorDisbursement: 'Krev utlegget fra kreditor',
        editorCreditorDisbursementDesc: 'Saksbehandleren kan legge beløpet til kreditoravregningen med den valgte avregningsbilagstypen. Er det påkrevd, skjer det hver gang.',
    },
    voucherTypeSetting: {
        [VoucherTypeSetting.AmountFromTable]: 'Beløp fra tabell',
        [VoucherTypeSetting.InterestFromTable]: 'Rente fra tabell',
        [VoucherTypeSetting.CompoundInterest]: 'Rentesrente',
        [VoucherTypeSetting.FixedInterest]: 'Fast rente',
        [VoucherTypeSetting.InterestPercentage]: 'Årlig rente',
        [VoucherTypeSetting.TextAsLabel]: 'Tekst som etikett',
        [VoucherTypeSetting.Payment]: 'Betaling',
    },
    compoundingPeriod: {
        [CompoundingPeriod.Daily]: 'Daglig',
        [CompoundingPeriod.Monthly]: 'Månedlig',
        [CompoundingPeriod.Quarterly]: 'Kvartalsvis',
    },
    imposeInterestFrequency: {
        [ImposeInterestFrequency.Daily]: 'Daglig',
        [ImposeInterestFrequency.Monthly]: 'Per påbegynt måned',
    },
    economy: {
        groupPostings: 'Grupper bilag i eksport',
        generalBillingSettings: 'Faktureringsinnstillinger',
        sendingBillingByEmail: 'Sender faktureringsvedlegg per e-post',
        doNotAttachBillingAppendicesInEmails: 'Ikke legg ved faktureringsvedlegg i e-poster',
        billingModels: 'Faktureringsmodeller',
        tenantBillingModels: 'Dine faktureringsmodeller',
        defaultBillingModels: 'Standard faktureringsmodeller',
        noBillingModelsToShow: 'Ingen faktureringsmodeller å vise',
        newBillingModel: 'Faktureringsmodell',
        addBillingModel: 'Legg til faktureringsmodell',
        billingAppendixSetup: 'Oppsett av faktureringsvedlegg',
        standardPrice: 'standardpris:',
        regNumber: 'Reg.nr.',
        accountNumber: 'Kontonummer',
        pipeFilterSelectVoucherTypes: 'Velg bilagstyper',
        depositFile: 'Innbetalingsfil',
        caseEconomy: 'Saksøkonomi',
        costCeilingReached: 'Kostnadstak nådd',
        costCeilingReachedDescription: 'Renter og gebyrer på denne saken er begrenset til hovedstolen.',
        costCeilingExceeded: 'Kostnadstak overskredet',
        costCeilingExceededDescription: 'Gebyrer og omkostninger på denne saken overstiger allerede i seg selv kostnadstaket.',
        voucherAlreadyExists: 'finnes allerede på saken',
        histItemHeader: 'Økonomi',
        sum: 'Sum',
        voucherType: 'Bilagstype',
        account: 'Konto',
        referenceId: 'Referanse-ID',
        text: 'Beskrivelse',
        amount: 'Beløp',
        originalAmount: 'Opprinnelig beløp',
        amountAfterWriteOffs: 'Beløp etter avskrivninger',
        date: 'Dato',
        addAppendix: 'Legg til vedlegg',
        referenceVoucher: 'Referansebilag å beregne rente ut fra',
        selectReferenceVoucher: 'Velg referansebilag',
        interestRate: 'Rentesats',
        interestAmount: 'Rentebeløp',
        interest: 'Rente',
        dueDate: 'Forfallsdato',
        expirationDate: 'Foreldelsesdato',
        expirationFromDate: 'Spesiell startdato for foreldelse',
        expirationManualSet: 'Foreldelsesdato satt manuelt',
        expiredAmount: 'Foreldet beløp',
        irrecoverableAmount: 'Uerholdelig beløp',
        cannotMoveWrittenOffVoucher: 'Bilaget er helt eller delvis foreldet eller uerholdelig og kan ikke flyttes til denne saken',
        interestStartDate: 'Rentestartdato',
        interestStartDays: 'Dager før rente starter',
        interestEndDate: 'Rentesluttdato',
        imposedByCreditor: 'Pålagt av kreditor',
        debtIrrecoverable: 'Uinndrivelig',
        debtExpied: 'Foreldet',
        markExpired: 'Marker som foreldet og avslutt sak',
        markSomeExpired: 'Marker som foreldet',
        markSomeExpiredPostings: 'bilag',
        sureYouWantToMarkExpired: 'Er du sikker på at du vil markere bilag som foreldet?',
        voucherCreationCreate: 'Opprett',
        voucherCreationIncludeInterest: 'Legg til rente',
        voucherCreationCreditorDeposit: 'Innbetaling til kreditor',
        addDisbursementToBilling: 'Krev utlegget fra kreditor',
        disbursementAddedToBilling: 'Utlegget kreves fra kreditor',
        caseVoucherInfoType: 'Type',
        caseVoucherInfoTypeSeeDetails: 'Se detaljer om saksbilagstype',
        caseVoucherInfoCreatedAt: 'Opprettet',
        voucherInfoId: 'Bilags-ID',
        voucherInfoCreatedBy: 'Opprettet av',
        caseVoucherInfoCategory: 'Kategori',
        caseVoucherInfoState: 'Status',
        caseVoucherInfoHeaderTheVoucher: 'Saksbilag',
        caseVoucherInfoHeaderMeta: 'Informasjon',
        caseVoucherInfoHeaderInterest: 'Rente',
        voucherInfoText: 'Tekst',
        voucherInfoAmount: 'Beløp',
        voucherInfoCasePreview: 'Sak',
        voucherInfoMoveToCase: 'Saksbilag flyttet til sak',
        voucherInfoCreditorName: 'Kreditor',
        voucherInfoAppendix: 'Vedlegg',
        voucherInfoRefVoucher: 'Referansebilag',
        voucherInfoInterestHis: 'Rentehistorikk',
        voucherInfoIfrom: 'Fra',
        voucherInfoITo: 'Til',
        voucherInfoIInterval: 'Intervall',
        voucherInfoIRVA: 'Referansebilagsbeløp',
        voucherInfoICompoundedAmount: 'Tilskrevet rente',
        voucherInfoIDays: 'dager',
        voucherInfoIReapplied: 'Gjenpålagt',
        voucherInfoIReason: 'Årsak',
        voucherInfoIPaid: 'Betalt',
        voucherInfoIAcknowledged: 'Erkjent',
        voucherInfoInterestPeriods: 'Renteperioder',
        voucherInfoInterestPeriodFrozen: 'Rentefri',
        voucherInfoInterestPeriodVoided: 'Gjenpålagt',
        voucherInfoInterestPeriodOpenEnded: 'Åpen',
        voucherInfoDistributedOnto: 'Fordelt på',
        voucherInfoDistributionsReceived: 'Dekket av',
        voucherInfoDistributionVoucher: 'Bilag',
        voucherInfoDistributionAmount: 'Beløp',
        voucherInfoDistributionType: 'Type',
        voucherInfoDistributionFixed: 'Fast',
        voucherInfoDistributionAutomatic: 'Automatisk',
        voucherInfoDistributionBilling: 'Fast (fakturering)',
        voucherInfoDistributionRemaining: 'Utestående',
        voucherInfoDeleteFixedDistribution: 'Fjern fast fordeling',
        voucherInfoEditFixedDistribution: 'Rediger fast fordeling',
        voucherInfoConfirmDeleteFixedDistribution: 'Er du sikker på at du vil fjerne denne faste fordelingen?',
        voucherInfoFixedDistributionSave: 'Lagre',
        voucherInfoFixedDistributionJointInfo: 'Denne endringen vil også påvirke tilknyttede betalinger på andre saker',
        voucherInfoAllocatePayment: 'Fordel betaling',
        voucherInfoAllocatePaymentTarget: 'Fordel til bilag',
        voucherInfoDistributionDynamic: 'Beregnet',
        voucherInfoDistributionUnallocated: 'Ufordelt',
        voucherInfoEditDistributions: 'Rediger fordelinger',
        voucherInfoDistributionDateFromOriginal: 'Dato fra opprinnelig',
        voucherInfoDistributionDateFromApplied: 'Dato fra anvendt',
        voucherInfoCreateCounterEntry: 'Opprett motpostering',
        voucherInfoConfirmCounterEntry: 'Er du sikker på at du vil opprette en motpostering for dette bilaget?',
        voucherInfoCounterEntryAmount: 'Motposteringsbeløp',
        voucherInfoDeleteVoucher: 'Slett bilag',
        voucherDeleteHasFixedDistributions: 'Dette bilaget har faste fordelinger. Vil du fjerne dem og slette bilaget?',
        voucherDeleteHasFixedDistributionsWithJoint: 'Dette bilaget har faste fordelinger. Ved sletting fjernes også tilknyttede betalinger på andre saker. Fortsette?',
        voucherInfoMarkVoucherExpired: 'Marker som foreldet',
        voucherInfoUnmarkVoucherExpired: 'Fjern foreldelsesmarkering',
        voucherInfoMarkVoucherIrrecoverable: 'Uinndrivelig',
        voucherInfoRestoreVoucher: 'Gjenopprett bilag',
        currency: 'Valuta',
        billingModel: 'Faktureringsmodell',
        aggregation: 'Aggregering',
        postings: 'Posteringer',
        bookkeepingMapping: 'Tilordne bokføringskontoer',
        bookkeepingMappingBase: 'Generelt',
        bookkeepingMappingFees: 'Gebyrer',
        bookkeepingMappingDisbursements: 'Utlegg',
        bookkeepingMappingAccount: 'Konto',
        bookkeepingMappingAccountType: 'Kontotype',
        bookkeepingMappingReverse: 'Reverser beløp',
        bookkeepingMappingExclude: 'Ekskluder',
        bookkeepingMappingIncludeVat: 'Inkluder mva',
        bookkeepingMappingContraAccountOn: 'Motbilag',
        bookkeepingMappingContraAccount: 'Motkonto',
        bookkeepingMappingContraAccountType: 'Motkontotype',
        bookkeepingMappingCreditorReferenceId: 'Kreditorreferanse-ID',
        bookkeepingMappingBankOrPSP: 'Bank eller innløser',
    },
    economyAppendixHeaders: {
        type: 'Type',
        date: 'Dato',
        voucherId: 'Bilags-ID',
        voucherType: 'Bilagstype',
        text: 'Tekst',
        amount: 'Beløp',
        currency: 'Valuta',
    },
    caseVoucherTags: {
        [CaseVoucherTags.IMPOSEDBYCOLLECTOR]: 'Pålagt av inkassobyrå',
        [CaseVoucherTags.IMPOSEDBYCREDITOR]: 'Pålagt av kreditor',
        [CaseVoucherTags.CREDITORTRANSACTION]: 'Kreditortransaksjon',
        [CaseVoucherTags.ECONOMIC_IMPORT]: 'E-conomic-import',
        [CaseVoucherTags.EXPIRED]: 'Foreldet',
        [CaseVoucherTags.IRRECOVERABLE]: 'Uinndrivelig',
    },
    caseTags: {
        [CaseTag.SURVEILLANCE]: 'Overvåking',
    },
    transactionImports: {
        transactionImportsHeader: 'Transaksjonsimporter',
        selectType: 'Velg betalingstype',
    },
    caseVouchers: {
        source: 'Kilde',
        irrecoverableDate: 'Uinndrivelig-dato',
        expirationDate: 'Foreldelsesdato',
        expired: 'Foreldet',
        case: 'Sak',
        map: 'Tilordne',
        mapHeader: 'Tilordne saksbilag til sak',
        deleteWarning: 'Er du sikker på at du vil slette dette bilaget? Denne handlingen kan ikke angres.',
        exportFileName: 'saksbilag',
        voucherId: 'Bilags-ID',
        voucherReferenceId: 'Bilagsreferanse',
        caseId: 'Saksnummer',
        creditor: 'Kreditor',
        creditorReference: 'Kreditorreferanse',
        customerReference: 'Kundereferanse',
        account: 'Konto',
        accountId: 'Konto-ID',
        bookingDate: 'Bokføringsdato',
        bookingDateDescription: 'Datoen innbetalingen bokføres i regnskapet. Betalingsdatoen avgjør hvordan renten beregnes; bokføringsdatoen avgjør hvilken regnskapsperiode innbetalingen hører til.',
        bookingDateFollowsDate: 'Følger betalingsdatoen',
        setBookingDate: 'Sett bokføringsdato',
        setBookingDateDescription: 'Sett datoen de valgte innbetalingene bokføres i regnskapet. Bruk den når et oppgjør fra en innløser når banken senere enn selve betalingene.',
        clearBookingDate: 'Tøm, følg betalingsdatoen',
    },
    payouts: {
        caseSeqId: 'Saks-ID',
        caseReferenceId: 'Saksreferanse',
        billingId: 'Fakturerings-ID',
        court: 'Domstol',
        type: 'Type',
        account: 'Konto',
        creditorReference: 'Kreditorreferanse',
        text: 'Tekst',
        state: 'Status',
        amount: 'Beløp',
        currency: 'Valuta',
        createdAt: 'Opprettet',
        updatedAt: 'Oppdatert',
        complete: 'Fullført',
        completeOnExport: 'Marker som fullført ved eksport',
        exportFileName: 'utbetalinger',
    },
    payoutState: {
        [PayoutState.Completed]: 'Fullført',
        [PayoutState.Created]: 'Opprettet',
        [PayoutState.DataUpdated]: 'Data oppdatert',
        [PayoutState.Failed]: 'Mislykket',
        [PayoutState.Initiated]: 'Igangsatt',
    },
    payoutType: {
        [PayoutType.CourtFee]: 'Rettsgebyr',
        [PayoutType.CreditorReceivables]: 'Kreditors tilgodehavende',
        [PayoutType.Other]: 'Annen',
        [PayoutType.Overpayment]: 'Overbetaling',
    },
    clientBilling: {
        clientBilling: 'Kreditorfakturering',
        isAdjustment: 'Justering',
        billings: 'Faktureringer',
        seeDetails: 'Se detaljer om kreditorfakturering',
        seeDetailsCreditor: 'Se faktureringsdetaljer',
        fetchingUpdatedEconomy: 'Henter oppdatert informasjon',
        deposits: 'Innbetalinger',
        fees: 'Gebyrer',
        disbursements: 'Utlegg',
        showPerDeposit: 'Vis per innbetaling',
        voucherType: 'Bilagstype',
        original: 'Opprinnelig',
        paid: 'Betalt',
        residue: 'Resterende',
        collector: 'Inkassobyrå',
        creditor: 'Kreditor',
        overpayment: 'Overbetaling',
        text: 'Tekst',
        addVoucher: 'Legg til bilag',
        otherPayments: 'av andre innbetalinger.',
        noVouchers: 'Ingen bilag',
        hoursOf: 'timer à',
        hourOf: 'time à',
        hourlyRateOn: 'Fakturer timepris',
        hourlyRate: 'Timepris',
        hourlyRateHours: 'Timer',
        hourlyRateMinutes: 'Minutter',
    },
    search: {
        migratedId: 'Migrert saksnr.',
        noResults: 'Ingen resultater',
        voucherReferenceId: 'Bilags-ID',
        cvr: 'CVR',
        cpr: 'CPR',
        phone: 'Telefon',
    },
    deposits: {
        customizeExport: 'Tilpass eksport',
        selectedExportHint: 'Bare de valgte posteringene',
        filteredExportHint: 'Alle resultater fra tabellens filtre · maks. 10 000',
        exportEditorDescription: 'Velg felt til venstre og tilpass filens kolonner til høyre.',
        exportFormat: 'Filformat',
        standardExportColumns: 'Standardfelt',
        availableExportColumns: 'Tilgjengelige felt',
        searchExportColumns: 'Søk etter felt eller attributt…',
        exportColumnHint: 'Dra for å endre rekkefølge. Klikk på et navn for å gi nytt navn.',
        exportColumnName: 'Kolonnenavn',
        chooseExportColumns: 'Velg felt til venstre for å bygge eksporten.',
        resetExportColumns: 'Gjenopprett standard',
        saveExportSettings: 'Lagre innstillinger',
        exportStoredLocally: 'Personlige innstillinger · lagres på denne enheten',
        exportSettings: 'Eksporter betalinger',
        exportFiltered: 'Filtrerte posteringer',
        exportSelected: 'Valgte posteringer',
        exportLimit: 'Eksporter opptil 10 000 betalinger med tabellens filtre. Begrens filtrene hvis det finnes flere resultater.',
        markAsExported: 'Marker posteringer som eksportert',
        exportColumns: 'Eksportkolonner',
        addExportColumn: 'Legg til kolonne',
        moveColumnUp: 'Flytt kolonne opp',
        moveColumnDown: 'Flytt kolonne ned',
        removeExportColumn: 'Fjern kolonne',
        pickPaymentType: 'Velg betalingstype',
        unknownDeposit: 'Ukjente innbetalinger',
        unknownDepositSubHeader: 'Kunne ikke identifisere innbetalingen',
        archive: 'Arkiver',
        exportDesc: 'Eksport av innbetalinger fra bank eller PSP (kreditt-/debetkort osv.)',
        unknownDesc: 'Her er en liste over ukjente innbetalinger.',
        transactionLookUpDesc: 'Her kan du slå opp innbetalinger etter transaksjons-ID.',
        transactionLookUpPlaceholder: 'Skriv inn transaksjons-ID (for eksempel: 12341234)',
        transactionLookUpNotFound: 'Transaksjon ikke funnet.',
        transactionLookUpNotDeposit: 'Transaksjonen er ikke en innbetaling.',
        transactionLookUpButton: 'Slå opp',
        transactionLookUpDeposit: 'Innbetaling',
        downloadSample: 'Last ned eksempel',
        downloadSampleQuantity: 'Antall innbetalinger i eksemplet',
        linkBank: 'Koble til bankkonto',
        selectBankAccount: 'Velg bankkonto',
        dropHere: 'Slipp her',
        upload: 'Registrer innbetalinger',
        deposits: 'Innbetalinger',
        map: 'Registrer innbetalinger',
        handleTransaction: 'Behandle innbetaling',
        addSingleDepositHeader: 'Legg til enkeltinnbetaling',
        addSingleDepositPaymentType: 'Betalingstype',
        addSingleDepositDate: 'Dato',
        addSingleDepositText: 'Tekst',
        addSingleDepositAmount: 'Beløp',
        addSingleDepositAddAndClose: 'Legg til og lukk',
        addSingleDepositAddAndClear: 'Legg til og tøm',
    },
    depositsPaymentTypes: {
        [PaymentType.Mastercard]: 'MasterCard',
        [PaymentType.Swish]: 'Swish',
        [PaymentType.Vipps]: 'Vipps',
        [PaymentType.Visa]: 'Visa',
        [PaymentType.Dankort]: 'Dankort',
        [PaymentType.MobilePay]: 'MobilePay',
        [PaymentType.Betalingsservice]: 'Betalingsservice',
        [PaymentType.Leverandørservice]: 'Leverandørservice',
        [PaymentType.BankTransfer]: 'Banktransaksjon',
        [PaymentType.FIK]: 'FIK',
        [PaymentType.IBAN]: 'IBAN',
        [PaymentType.Creditor]: 'Kreditor',
        [PaymentType.PayPal]: 'PayPal',
        [PaymentType.ApplePay]: 'Apple Pay',
        [PaymentType.GooglePay]: 'Google Pay',
    },
    caseVoucherEvents: {
        header: 'Endringer på innbetalinger',
        desc: 'Alt som har skjedd med innbetalingene vi har mottatt på kontoene våre. Eksporter endringene for å bokføre dem — de merkes som eksportert, slik at den samme endringen aldri bokføres to ganger.',
        eventId: 'Endrings-id',
        eventType: 'Endring',
        eventDate: 'Tidspunkt for endring',
        performedByType: 'Utført av type',
        performedById: 'Utført av id',
        fromCase: 'Fra sak',
        toCase: 'Til sak',
        fromCreditor: 'Fra kreditor',
        fromCreditorReference: 'Fra kreditorreferanse',
        exported: 'Eksportert',
    },
    caseVoucherEventTypes: {
        [CaseVoucherEventType.Created]: 'Opprettet',
        [CaseVoucherEventType.Booked]: 'Bokført på sak',
        [CaseVoucherEventType.Moved]: 'Flyttet til annen sak',
        [CaseVoucherEventType.Unbooked]: 'Avbokført fra sak',
        [CaseVoucherEventType.Deleted]: 'Slettet',
        [CaseVoucherEventType.Restored]: 'Gjenopprettet',
    },
    billingReasons: {
        caseVoucherInlineDeleted: 'Bilag (senere slettet)',
        caseVoucherPatchedCaseId: 'ble tilordnet saken',
        caseVoucherPatched: 'ble redigert',
        caseVoucherCreated: 'lagt til på saken',
        caseVoucherDeleted: 'slettet fra saken',
        billingModelChanged: 'Faktureringsmodell endret',
        billingStartDateChanged: 'Startdato for fakturering endret',
    },
    billing: {
        ongoingWork: 'Pågående arbeid',
        bills: 'Fakturaer',
        billingSequentialId: 'Id',
        case: 'Sak',
        date: 'Dato',
        type: 'Type',
        text: 'Tekst',
        customerReferenceId: 'Kunderef.',
        revenue: 'Gebyrer',
        vat: 'Mva',
        payout: 'Utbetaling',
        disbursements: 'Utlegg',
        overpayments: 'Overbetalinger',
        balance: 'Saldo',
        amount: 'Beløp',
        deposits: 'Innbetalinger',
        deposit: 'Innbetaling',
        depositShareTooLongForPDF: 'Spesifikasjonen av innbetalinger er ikke inkludert i PDF-en fordi denne faktureringen har mer enn 100 innbetalinger. Summen av innbetalingene er fortsatt inkludert.',
        bill: 'Faktura',
        delete: 'Fjern',
        deleteApproval: 'Er du sikker på at du vil slette bilagene fra faktureringen? Handlingen kan ikke angres.',
        adjustments: 'Justeringer',
        billingPrevented: 'Utsatte faktureringer',
        billingStartDate: 'Start fakturering fra',
        appendix: 'Vedlegg',
        readyForBilling: 'Klar for fakturering',
        awaitingCaseEnd: 'Venter på at saken avsluttes',
        appendixMissing: 'Vedlegg mangler',
        billSelected: 'Fakturer valgte',
        addBillingVoucher: 'Legg til bilag',
        recipient: 'Mottaker',
        billingSent: 'Sendt',
        sendBilling: 'Send',
        information: 'Informasjon',
        addedToPayouts: 'Lagt til i utbetalinger',
        addToPayouts: 'Legg til i utbetalinger',
        invoiceNo: 'Fakturanr.',
        specifiedByBankTransfer: 'skal oppgis ved bankoverføring',
        paymentTerms: 'Betalingsbetingelser: Netto',
        daysAndBillingDate: 'dager - Betalingsdato',
        billingAlreadySentAlert: 'Vedlegget er allerede sendt. Er du sikker på at du vil sende det på nytt?',
        amountWillBeWithdrawnToAccount: 'trekkes til konto',
        amountShouldBePaidToAccount: 'betales til konto',
        preview: 'Forhåndsvisning',
        PDFPreview: 'PDF',
        ExcelPreview: 'Excel',
        forPayout: 'Til utbetaling',
        collectionCommission: 'Inkassoprovisjon',
        fees: 'Gebyrer',
        otherVat: 'Annen mva',
        subtotal: 'Delsum',
        total: 'Totalt',
        billingCollectionBillingSequentialId: 'Id',
        billingCollectionBillingDate: 'Dato',
        billingCollectionBillingAddedToPayouts: 'Lagt til i utbetalinger',
        billingCollectionBillingSent: 'Sendt',
        billingCollectionBillingBalance: 'Saldo',
        billingsAppendix: 'Vedlegg',
        billingsType: 'Type',
        billingsCreditor: 'Kreditor',
        billingsCases: 'Saker',
        billingsCurrency: 'Valuta',
        generateAppendix: 'Generer vedlegg',
        awaitingGeneration: 'Vedlegg klare til å genereres',
        warnThisWillAffectBilling: 'Denne handlingen vil påvirke allerede fakturerte innbetalinger. Er du sikker på at du vil fortsette?',
        deletionWarning: 'Er du sikker på at du vil slette denne faktureringen? Denne handlingen kan ikke angres. Vær oppmerksom på at sletting ikke tar hensyn til justeringer – disse må håndteres manuelt. Videre tar det ikke hensyn til om faktureringen allerede er sendt eller bokført.',
    },
    creditorBilling: {
        newBillingFrom: 'Ny fakturering fra',
        dear: 'Kjære',
        herebyForwarded: 'Herved oversendes:',
        seeAttached: 'Se vedlegget.',
    },
    bookkeeping: {
        settleAll: 'Gjør opp alle kreditorer',
        preview: 'Forhåndsvisning',
        type: 'Type',
        date: 'Dato',
        text: 'Tekst',
        amount: 'Beløp',
        account: 'Konto',
        contraAccount: 'Motkonto',
        debtorVoucher: 'Skyldnerbilag',
        showMoreVouchers: 'Vis flere bilag',
        showing: 'Viser',
        of: 'av',
        vouchers: 'bilag',
        exportNdownload: 'Eksporter og last ned',
        history: 'Historikk',
        noHistorical: 'Ingen historiske oppføringer ennå',
        erpIntegrationHeader: 'Integrasjon med regnskapssystem',
        accounts: 'Kontoer',
        revenuePlaceholder: 'Omsetning',
        outlayPlaceholder: 'Utlegg',
        erpVendor: 'ERP-leverandør:',
        makeSureThat: 'Sørg for at:',
        creditorReferenceIdsMatch: 'Kreditorenes referanse-id-er samsvarer med kundenes i e-conomic',
        bankAccountReferenceIdsMatch: 'Bank- og PSP-kontoenes referanse-id-er samsvarer med kontoene i e-conomic',
        activeAccountingYear: 'Det finnes et aktivt regnskapsår',
        connectEconomic: 'Koble til e-conomic',
    },
    sites: {
        caseworkerWeb: 'Saksbehandlerweb',
        clientWeb: 'Kreditorweb',
        detiorWeb: 'Skyldnerweb',
    },
    blameLogs: {
        overview: 'Oversikt',
        userVisits: 'Brukerbesøk',
        debtorUpdates: 'Endringer på skyldner',
        economy: 'Økonomi',
        interactions: 'Interaksjoner',
        noEntries: 'Ingen oppføringer',
        blameLog: 'Handlingslogg',
        logged: 'Handling',
        ago: 'siden',
        type: 'Type',
        content: 'Innhold',
        subject: 'Emne',
        stepTitle: 'Trinntittel',
        chainTitle: 'Arbeidsflyttittel',
        viewLetter: 'Vis brev',
        phoneNumber: 'Telefonnummer',
        label: 'Etikett',
        workflow: 'Arbeidsflyt',
        fromWorkflow: 'Byttet fra arbeidsflyt',
        toWorkflow: 'Til arbeidsflyt',
        noLogs: 'Ingen logger ennå',
        settings: 'Innstillinger',
        toggled: 'Byttet til',
        trueActivated: 'aktivert',
        falseActivated: 'deaktivert',
        key: 'Nøkkel',
        code: 'Kode',
        username: 'Brukernavn',
        password: 'Passord',
        trueChanged: 'Endret',
        falseChanged: 'Uendret',
        experianClientId: 'Experian klient-ID',
        to: 'til',
        when: 'Når',
        procedure: 'Snarvei',
        removed: 'Fjernet',
        other: 'Andre handlinger',
        description: 'Beskrivelse',
        note: 'Notat',
        createdAt: 'Opprettet',
        trueYes: 'Ja',
        falseNo: 'Nei',
        dunning: 'Purring',
        connectorBillingModel: 'Faktureringsmodell',
        cleared: 'Fjernet',
        newValue: 'Ny verdi',
        caseSeqId: 'Saksnummer',
        previousStatus: 'Forrige status',
        reason: 'Årsak',
        direction: 'Retning',
        mergedTo: 'Slått sammen til',
        mergedFrom: 'Slått sammen fra',
        fromCase: 'Fra sak',
        toCase: 'Til sak',
        fromVoucher: 'Fra bilag',
        toVoucher: 'Til bilag',
        fromStatus: 'Fra status',
        toStatus: 'Til status',
        entriesCount: 'Antall oppføringer',
        activationTrigger: 'Aktivering utløst',
        tribunalType: 'Sakstype',
        jobType: 'Handling',
        documentType: 'Dokumenttype',
        fileName: 'Filnavn',
        signedAt: 'Signert',
        signedBy: 'Signert av',
        source: 'Kilde',
        successCount: 'Vellykket',
        updatedCount: 'Oppdatert',
        failedCount: 'Mislykket',
        dateUpdated: 'Dato',
        fileUploaded: 'Fil lastet opp',
        costsRegistered: 'Kostnader',
        meetingStateChanged: 'Status',
        noteUpdated: 'Notat oppdatert',
        caseLifecycle: 'Sakens livssyklus',
        paymentPlans: 'Betalingsplaner',
        tribunal: 'Domstol',
    },
    blameLogSimplfiedType: {
        [BlameLogType.CaseVisit]: 'Saksbesøk',
        [BlameLogType.CaseVoucherCreate]: 'Bilag opprettet',
        [BlameLogType.CaseVoucherDelete]: 'Bilag slettet',
        [BlameLogType.CaseVoucherRestore]: 'Bilag gjenopprettet',
        [BlameLogType.UnknownCaseVoucherMapped]: 'Ukjent innbetaling tilknyttet sak',
        [BlameLogType.CaseVoucherPatch]: 'Bilag oppdatert',
        [BlameLogType.UserOnCustomerVisit]: 'Kundebesøk',
        [BlameLogType.CreditorVisit]: 'Kreditorbesøk',
        [BlameLogType.VisitedBy]: 'Besøk',
        [BlameLogType.CaseVoucherIrrecoverable]: 'Bilag uerholdelig',
        [BlameLogType.CaseVoucherExpired]: 'Bilag foreldet',
        [BlameLogType.InteractionCreate]: 'Interaksjon opprettet',
        [BlameLogType.InteractionDelete]: 'Interaksjon slettet',
        [BlameLogType.WorkflowRollback]: 'Arbeidsflyt tilbakerullet',
        [BlameLogType.InteractionHideFromClient]: 'Interaksjon skjult for kreditor',
        [BlameLogType.InteractionMappedToCase]: 'Interaksjon tilknyttet sak',
        [BlameLogType.InteractionUnmappedFromCase]: 'Interaksjon fjernet fra sak',
        [BlameLogType.InteractionRollback]: 'Interaksjon tilbakerullet',
        [BlameLogType.DebtorWebLoginEId]: 'Innlogging på skyldnerweb med e-ID',
        [BlameLogType.DebtorUpdateName]: 'Navn endret',
        [BlameLogType.DebtorUpdatePhone]: 'Telefon endret',
        [BlameLogType.DebtorUpdateAddress]: 'Adresse endret',
        [BlameLogType.DebtorUpdateEmail]: 'E-post endret',
        [BlameLogType.DebtorUpdateCourt]: 'Verneting endret',
        [BlameLogType.DebtorUpdateBirthdate]: 'Fødselsdato endret',
        [BlameLogType.DebtorUpdateCVR]: 'CVR endret',
        [BlameLogType.DebtorUpdateCPR]: 'CPR endret',
        [BlameLogType.AKSConfiguration]: 'AKS-konfigurasjon',
        [BlameLogType.AutoDebtRegister]: 'Automatisk RKI',
        [BlameLogType.AutoIgnoreUnresolvedOppositions]: 'Ignorer RKI-innsigelser',
        [BlameLogType.AutoDeleteDebtRegistrationOnCaseEnd]: 'Slett RKI-registrering automatisk ved saksavslutning',
        [BlameLogType.AutoRegisterInOpenRegistry]: 'Åpne RKI',
        [BlameLogType.AKSClientID]: 'Experian klient-id',
        [BlameLogType.RKIOveride]: 'Overstyr automatisk RKI',
        [BlameLogType.AKSActivated]: 'AKS aktivert',
        [BlameLogType.PriceList]: 'Prisliste',
        [BlameLogType.UserPasswordUpdate]: 'Brukerpassord endret',
        [BlameLogType.TriggerShortcut]: 'Utløserendring',
        [BlameLogType.WorkflowChange]: 'Arbeidsflytendring',
        [BlameLogType.WorkflowChangeOnCase]: 'Arbeidsflyt endret på sak',
        [BlameLogType.CaseCreate]: 'Sak opprettet',
        [BlameLogType.CaseDelete]: 'Sak slettet',
        [BlameLogType.CaseMerge]: 'Sak slått sammen',
        [BlameLogType.CaseStatusChange]: 'Saksstatus endret',
        [BlameLogType.CaseJournalNumberChange]: 'Journalnummer endret',
        [BlameLogType.CaseCostCeilingAmountChange]: 'Kostnadstakbeløp endret',
        [BlameLogType.CaseCostCeilingEnabledChange]: 'Kostnadstak slått på/av',
        [BlameLogType.PaymentPlanCreate]: 'Betalingsplan opprettet',
        [BlameLogType.PaymentPlanPatched]: 'Betalingsplan oppdatert',
        [BlameLogType.PaymentPlanDelete]: 'Betalingsplan slettet',
        [BlameLogType.CaseVoucherMoved]: 'Bilag flyttet',
        [BlameLogType.TribunalCaseCreate]: 'Domstolssak opprettet',
        [BlameLogType.TribunalJobCreate]: 'Domstolsoppgave opprettet',
        [BlameLogType.TribunalJobPatch]: 'Domstolsoppgave oppdatert',
        [BlameLogType.TribunalJobDelete]: 'Domstolsoppgave slettet',
        [BlameLogType.DocumentUpload]: 'Dokument lastet opp',
        [BlameLogType.DocumentDelete]: 'Dokument slettet',
        [BlameLogType.DocumentSigned]: 'Dokument signert',
        [BlameLogType.ImportCreated]: 'Import opprettet',
        [BlameLogType.ImportRun]: 'Import kjørt',
        [BlameLogType.DeleteUpdate]: 'Oppgave slettet',
        [BlameLogType.ConnectorBillingUpdate]: 'Faktureringsmodell endret',
        [BlameLogType.CreditorSettingsUpdate]: 'Kreditorinnstillinger endret',
        [BlameLogType.BulkAction]: 'Massehandling',
        [BlameLogType.FixedDistributionCreate]: 'Fordeling opprettet',
        [BlameLogType.FixedDistributionUpdate]: 'Fordeling oppdatert',
        [BlameLogType.FixedDistributionDelete]: 'Fordeling slettet',
    },
    caseTypes: {
        [CaseType.CLIENT]: 'Kreditorsak',
        [CaseType.TENANT]: 'Organisasjonssak',
    },
    cases: {
        case: 'Sak',
        customerReferenceId: 'Referansenr.',
        creditor: 'Kreditor',
        debt: 'Opprinnelig',
        deposits: 'Innbetalinger',
        balance: 'Gjeld',
        status: 'Saksstatus',
        caseVoucher: 'Saksbilag',
        amount: 'Beløp',
        workflow: 'Arbeidsflyt',
        responsible: 'Ansvarlig',
        showAll: 'Vis alle',
        caseInfo: 'Saksinfo',
        cases: 'Saker',
        createNewCase: 'Opprett ny sak',
        caseOverview: 'Alle saker',
        casesLeft: 'Saker igjen',
        casePaused: 'Sak satt på pause',
        dueDateIsIn: 'Forfallsdato er om',
        days: 'dager',
        pressCommandOrCtrlToContinue: 'Trykk command eller control for også å fortsette saken.',
        source: 'Kilde',
        sourceClient: 'Saken stammer fra denne saken',
        referenceId: 'Kreditors saksreferanse-id',
        createdAt: 'Opprettelsesdato',
        caseState: {
            [CaseState.ALL]: 'Alle saker',
            [CaseState.ACTIVE]: 'Aktive saker',
            [CaseState.CLOSED]: 'Avsluttede saker',
        },
        caseStatus: {
            [CaseStatus.VERIFIED]: 'Godkjent',
            [CaseStatus.PENDING]: 'Venter',
            [CaseStatus.ENDED]: 'Avsluttet',
        },
        settings: 'Saksinnstillinger',
        caseSettings: {
            disableDebtorPaymentPlan: 'Deaktiver betalingsplan for skyldner',
        },
        VERIFIED: 'Godkjent',
        PENDING: 'Venter',
        ENDED: 'Avsluttet',
        dunning: 'Purring',
        debtCollection: 'Inkasso',
        verify: 'Godkjenn',
        end: 'Avslutt',
        reVerify: 'Godkjenn på nytt',
        endCase: 'Avslutt sak',
        choosEndReason: 'Velg avslutningsårsak',
        caseGroup: 'Saksgruppe',
        pause: 'Pause',
        pauseCase: 'Sett sak på pause',
        pauseReason: 'Årsak til pause',
        pauseComment: 'Kommentar',
        blameLog: 'Handlingslogg',
        logged: 'Handling',
        ago: 'siden',
        newCase: 'Opprett ny sak',
        caseReferenceId: 'Kreditors referanse-id',
        invoiceId: 'Faktura-ID',
        file: 'Faktura-pdf',
        debtorName: 'Navn',
        address: 'Adresse',
        phone: 'Telefonnummer',
        email: 'E-post',
        cpr: 'CPR',
        cvr: 'CVR',
        debtorHaveObjections: 'Skyldner har gjort innsigelse',
        isCompany: 'Skyldner er en virksomhet',
        theDetails: 'Info',
        theDebt: 'Gjelden',
        theDebtor: 'Skyldner',
        manual: 'Manuelt',
        fromFile: 'Fra fil',
        dropFile: 'Slipp faktura her',
        clickHereToUpload: 'Eller last opp',
        addDebt: 'Ny faktura',
        issueDate: 'Fakturadato',
        dueDate: 'Fakturaens forfallsdato',
        sendNoteToCollector: 'Send melding til inkassobyrå',
        sendNoteToCollectorButton: 'Send',
        note: 'Notat',
        caseHasBeenDeleted: 'Saken er blitt slettet',
        missingCreateAccess: 'Avtalen er opphørt, og det kan derfor ikke opprettes nye saker. Kontakt oss for mer informasjon',
        newCaseCreate: 'Saksinfo',
        newCaseEconomy: 'Økonomi',
        newCaseDone: 'Ferdig',
        noDebts: 'Ingen gjeld',
        noDebtsExplainer: "Legg til gjeld med '+'-knappen",
        newCaseCreateExplainer: 'Du er nå i gang med å opprette en ny sak. Her kan du sette inn kundenummeret fra ditt system. Hvis saken er i en annen valuta enn norsk, kan du også velge dette her.',
        newCaseEconomyExplainer: 'Saken din er nå opprettet, og nedenfor skal sakens økonomi legges til. Hvis du har opprettet saken, men trenger å angre, anbefaler vi at du kontakter oss for sletting av saken.',
        newCaseCreationWarning: 'Når du klikker deg videre, vil saken bli opprettet i systemet. Har du ikke all informasjon for å opprette saken, anbefales det at du ikke fortsetter før du har all informasjon om gjelden og skyldneren',
        deleteCase: 'Slett sak',
        sureYouWantToDeleteCase: 'Er du sikker på at du vil slette denne saken?',
    },
    mergeCases: {
        header: 'Slå denne saken sammen med en annen',
        explanation: 'Slå denne saken sammen med en annen sak valgt nedenfor. Bilag vil automatisk bli overført til målsaken, og denne saken vil bli avsluttet med avslutningsårsak "Saken er slått sammen"',
        searchPlaceholder: 'Søk etter målsak på samme kreditor',
        mergeBtn: 'Slå sammen saker',
        undoCaseMerge: 'Angre sammenslåing av sak',
    },
    customers: {
        party: 'part',
        addParty: 'Legg til part',
        contact: 'Kontaktperson',
        selectType: 'Velg type',
        errorEmailValidation: 'Ugyldig e-post',
        errorCPRValidation: 'Ugyldig CPR',
        errorCVRValidation: 'Ugyldig CVR',
        noContactSelected: 'Ingen kontaktperson valgt',
        noContact: 'Ingen kontakt',
        noRelatedCases: 'Ingen tilknyttede saker',
        customer: 'Kunde',
        createdAt: 'Opprettet',
        casesOnCreditor: 'Saker på kunde',
        thatIsRelatedTo: 'som er tilknyttet kundereferanse',
        casesRelatedToCustomerDescription: 'Saker matchet på e-post, CPR, CVR eller via eksterne kilder.',
        information: 'Informasjon',
        casesOnCustomer: 'Saker på kunde',
        relatedCases: 'Tilknyttede saker',
        caseStatus: 'Status',
        relationType: 'Relasjon',
        creditor: 'Kreditor',
        case: 'Sak',
        customerHasBeenDeleted: 'Kunden er blitt slettet',
        parties: 'Parter',
        customerReferenceId: 'Kundereferanse-id',
        private: 'Privatperson',
        company: 'Virksomhet',
        existingCustomer: 'Eksisterende kunde',
        backToCase: 'Tilbake til sak',
        referenceId: 'Referanse-id',
        alternativeContactReferenceId: 'Alternativ kontaktreferanse-id',
        secondaryEntityDisabled: 'Inaktiv',
        addSecondaryEmails: 'Legg til én eller flere sekundære e-postadresser',
        note: 'Valgfritt notat',
        addSecondaryEmail: 'Legg til sekundær e-postadresse',
        addSecondaryPhones: 'Legg til ett eller flere sekundære telefonnumre',
        addSecondaryPhone: 'Legg til sekundært telefonnummer',
        enabled: 'Aktiv',
        save: 'Lagre',
        createNewCaseOnCustomer: 'Legg til sak på kunde',
        copyCaseIds: 'Kopier saksnumre',
        notes: {
            title: 'Notater',
            addNote: 'Legg til et notat',
            noNotes: 'Ingen notater',
            edit: 'Rediger',
            save: 'Lagre',
            cancel: 'Avbryt',
            delete: 'Slett',
            deleteConfirm: 'Slette dette notatet?',
            editPlaceholder: 'Notattekst',
            noDebtor: 'Ingen skyldner på denne kunden',
        },
    },
    assets: {
        note: 'Notat',
        assets: 'Eiendeler',
        realEstate: 'Fast eiendom',
        vehicles: 'Kjøretøy',
        other: 'Andre eiendeler',
        noAssets: 'Ingen eiendeler registrert',
        addAsset: 'Legg til eiendel',
        editAsset: 'Rediger eiendel',
        deleteAsset: 'Slett eiendel',
        confirmDelete: 'Er du sikker på at du vil slette denne eiendelen?',
        description: 'Beskrivelse',
        estimatedValue: 'Estimert verdi',
        bfeNumber: 'BFE-nummer',
        address: 'Adresse',
        zipcode: 'Postnummer',
        city: 'By',
        registrationNumber: 'Registreringsnummer',
        brand: 'Merke',
        model: 'Modell',
        variant: 'Variant',
        year: 'År',
        lienType: 'Panterettstype',
        source: 'Kilde',
        notSubscribed: 'Kunden abonnerer ikke på Cosmo',
        type: 'Type',
        realEstateType: 'Fast eiendom',
        vehicleType: 'Kjøretøy',
        taxType: 'Skatt',
        otherType: 'Annet',
        owners: 'Eiere',
        liens: 'Panteretter',
        transactions: 'Transaksjoner',
        currency: 'Valuta',
        save: 'Lagre',
        cancel: 'Avbryt',
        administrator: 'Administrator',
        creditor: 'Kreditor',
        date: 'Dato',
        amount: 'Beløp',
        totalLiens: 'Totale panteretter',
        noLiens: 'Ingen panteretter registrert',
        noTransactions: 'Ingen transaksjoner registrert',
        lienCountSuffix: 'panteretter',
        assetCountSuffix: 'eiendeler',
        thisCreditor: 'Denne kreditoren',
        linkedCase: 'Sak',
        otherDistraints: 'Andre utlegg',
        transferDate: 'Overføringsdato',
        transferMethod: 'Overføringsmåte',
        purchaseSum: 'Kjøpesum',
        conditional: 'Betinget',
        summary: 'Sammendrag',
        netWorth: 'Estimert nettoformue',
        totalEstimatedValue: 'Total estimert verdi',
        loanToValue: 'Belåningsgrad',
        liensToThisCreditor: 'Panteretter til denne kreditoren',
        addLien: 'Legg til panterett',
        editLien: 'Rediger panterett',
        registrationDate: 'Registreringsdato',
        priority: 'Prioritet',
        missingCreditorRegisterId: 'Denne kreditoren har ingen sentral register-ID — angi en før du legger til panteretter.',
        interestRate: 'Rentesats (%)',
        interestType: 'Rentetype',
        contributionRate: 'Termingebyrsats (%)',
        totalTermYears: 'Total løpetid (år)',
        interestOnlyYears: 'Avdragsfri periode (år)',
        termShort: 'Løpetid',
        interestOnlyShort: 'Avdragsfri',
        yearsShort: 'år',
        outstandingBalances: 'Utestående saldoer',
        outstandingBalance: 'Utestående saldo',
        outstandingBalanceDate: 'Saldo kontrollert dato',
        expectedOutstanding: 'Forventet utestående',
        assumedTooltip: 'Estimert verdi',
        addOutstandingBalance: 'Legg til utestående saldo',
        noOutstandingBalances: 'Ingen utestående saldoer registrert',
        remove: 'Fjern',
        assetRegistrationNumber: 'Reg.nr.',
        assetModelYear: 'Modellår',
        ownershipShare: 'Eierandel',
        ownershipNotConfirmed: 'Eierskap ikke bekreftet',
        bfeAmbiguousOwner: 'Eiendomsdata utilgjengelig',
        bfeAmbiguousOwnerDescription: 'Flere personer med dette navnet ble funnet i eiendomsregisteret. Legg til en fødselsdato på skyldneren for å løse dette.',
        notSubscribedDescription: 'Kunden overvåkes ikke lenger, så disse eiendelene er et øyeblikksbilde fra da overvåkingen stoppet og kan ikke redigeres.',
        proportionalValue: 'Verdi av skyldnerens andel',
        debtors: 'Skyldnere',
        totalLabel: 'totalt',
        showHiddenLiens: 'Vis skjulte panteretter',
        hideHiddenLiens: 'Skjul skjulte panteretter',
        lienTypes: {
            [LienType.Attachment]: 'Utlegg',
            [LienType.Mortgage]: 'Pantelån',
            [LienType.OwnerNote]: 'Eierpantobligasjon',
            [LienType.PrivateNote]: 'Privat pantobligasjon',
            [LienType.PrivateIndexLinkedMortgage]: 'Privat indeksregulert pantobligasjon',
            [LienType.Other]: 'Annet',
            [LienType.Unknown]: 'Ukjent',
        },
        interestTypes: {
            [InterestType.Variable]: 'Flytende',
            [InterestType.Fixed]: 'Fast',
        },
        transferMethods: {
            FREE_SALE: 'Fritt salg',
            FORCED_AUCTION: 'Tvangsauksjon',
            INHERITANCE: 'Arv',
            GIFT: 'Gave',
            FAMILY_TRANSFER: 'Familieoverføring',
            EXCHANGE: 'Bytte',
            OTHER: 'Annet',
        },
        valuations: 'Verdivurderinger',
        assetOverview: 'Oversikt over eiendeler',
        equity: 'Egenkapital',
        viewAllAssets: 'Vis alle eiendeler',
        valuationSources: {
            [ValuationSource.PublicAssessment]: 'Offentlig takst',
            [ValuationSource.LastSale]: 'Siste salg',
            [ValuationSource.Manual]: 'Manuell',
        },
    },
    customerCaseRelationType: {
        [RelationType.CPR]: 'CPR',
        [RelationType.CVR]: 'CVR',
        [RelationType.Cosmo]: 'Ekstern',
        [RelationType.CustomerReferenceId]: 'Kundereferanse',
        [RelationType.Email]: 'E-post',
        [RelationType.NameAddress]: 'Navn/adr.',
    },
    debtors: {
        private: 'Privat',
        company: 'Selskap',
        addAlternativeContact: 'Legg til alternativ kontakt',
        debtor: 'Skyldner',
        alternativeContact: 'Alternativ kontaktperson',
        ownsCompany: 'Eier selskap',
        movedAbroad: 'Flyttet utenlands',
        ownsCompanies: 'Eier selskaper',
        rkiRegistrations: 'RKI-registreringer',
        confirmDeleteUserFromCustomer: 'Er du sikker på at du vil slette denne brukeren fra kunden?',
        companyStatus: 'Selskapsstatus',
        otherCasesOnDebtorTooltip: 'Skyldneren er knyttet til flere saker',
        otherCasesOnDebtor: 'Annen sak',
        otherCasesOnDebtorPlural: 'andre saker',
        movedTo: 'Flyttet til',
        debtors: 'Skyldnere',
        aksFailed: 'AKS mislyktes',
        cprStatus: 'CPR-status',
        status: {
            [PrivateStarCycle.Active]: 'Aktiv',
            [PrivateStarCycle.Dead]: 'Død',
            [PrivateStarCycle.Disappeared]: 'Forsvunnet',
            [PrivateStarCycle.Homeless]: 'Uten fast bopel',
            [PrivateStarCycle.GoneAway]: 'Flyttet utenlands',
            [PrivateStarCycle.ForTaxReason]: 'Personlig skattenummer',
            [PrivateStarCycle.NotVerified]: 'Ikke verifisert',
            // [CompanyStarCycle.Active]: 'Active',
            [CompanyStarCycle.Inactive]: 'Inaktiv',
            [CompanyStarCycle.OperationsCeased]: 'Drift opphørt',
            [CompanyStarCycle.ShelfCompany]: 'Hylleselskap',
        },
        dissolvedStatus: {
            [DissolvedStatus.UnderLiquidation]: 'Under avvikling',
            [DissolvedStatus.DissolvedAfterLiquidation]: 'Oppløst etter avvikling',
            [DissolvedStatus.InvoluntaryDissolution]: 'Tvangsoppløsning',
            [DissolvedStatus.Dissolved]: 'Oppløst',
            [DissolvedStatus.Unknown]: 'Ukjent oppløsningsstatus',
            [DissolvedStatus.Voluntary]: 'Under frivillig avvikling',
            [DissolvedStatus.VoluntaryDeclaration]: 'Under frivillig avvikling (erklæring)',
            [DissolvedStatus.Forced]: 'Under tvangsoppløsning',
            [DissolvedStatus.DissolvedAfterDeclaration]: 'Oppløst etter erklæring',
            [DissolvedStatus.DissolvedAfterMerger]: 'Oppløst etter fusjon',
            [DissolvedStatus.DissolvedAfterDemerger]: 'Oppløst etter fisjon',
            [DissolvedStatus.DissolvedAfterBankruptcy]: 'Oppløst etter konkurs',
            [DissolvedStatus.Ceased]: 'Opphørt',
        },
        dissolutionStatus: 'Oppløsningsstatus',
        addressProtection: 'Adresse- og navnebeskyttelse',
        addressProtectionShort: 'Beskyttet',
        addDebtor: 'Legg til skyldner',
        guardian: 'Verge',
        relatedCases: 'relaterte saker',
        relatedCasesDescription: 'Antall relaterte saker som er verifisert / totalt antall relaterte saker',
        otherCases: 'andre saker',
        otherCasesDescription: 'Antall verifiserte saker for kunden / totalt antall saker',
    },
    emailValidations: {
        risk: 'Risiko',
        emailRisk: 'E-postrisiko',
        didYouMean: 'Mente du',
        isDisposableAddress: 'Er engangs-e-post',
        isRoleAddress: 'Er rolle-e-post',
        high: 'Høy',
        medium: 'Middels',
        low: 'lav',
        unknown: 'Ukjent',
        no_mx: 'Ingen MX-oppføringer',
        unknown_provider: 'Ukjent e-postleverandør',
        high_risk_domain: 'Høyrisikodomene',
        subdomain_mailer: 'Subdomene-avsender',
        immature_domain: 'Umodent domene',
        tld_risk: 'Domenet er registrert som høy risiko',
        mailbox_does_not_exist: 'E-posten finnes ikke',
        mailbox_is_disposable_address: 'E-posten er en engangsadresse',
        mailbox_is_role_address: 'Postkassen er en rolle-e-post',
        catch_all: 'Fang alt',
        long_term_disposable: 'Langtids engangs-e-post',
    },
    phoneValidation: {
        mobile: 'Mobil',
        landline: 'Fasttelefon',
        landline_premium: 'Fasttelefon',
        landline_tollfree: 'Fasttelefon',
        virtual: 'Virtuell',
        unknown: 'Ukjent',
        pager: 'Personsøker',
        roaming: 'Roaming',
    },
    debtorInfo: {
        debtorInfo: 'Skyldnerinformasjon',
        debtorCreatedAt: 'Skyldner opprettet',
        company: 'Selskap',
        male: 'Mann',
        female: 'Kvinne',
        private: 'Privat',
        activated: 'aktivert',
        subscribed: 'abonnert',
        failed: 'mislyktes',
        movedTo: 'Flyttet til',
        description: 'Beskrivelse',
        addDescription: 'Legg til beskrivelse',
        name: 'Navn',
        email: 'E-post',
        noEmailAddr: 'Ingen e-postadresse',
        phone: 'Telefon',
        noAddr: 'Ingen adresse',
        address: 'Adresse',
        letterReturned: 'Brev returnert',
        cpr: 'CPR',
        cvr: 'CVR',
        registryIdentifier: 'Sentral register-ID',
        addressProtection: 'Adresse- og navnebeskyttelse',
        addressProtectionShort: 'Beskyttet',
        jurisdiction: 'Jurisdiksjon',
        noJurisdiction: 'Ingen jurisdiksjon',
        chooseJurisdiction: 'Velg jurisdiksjon',
        status: {
            [PrivateStarCycle.Active]: 'Aktiv',
            [PrivateStarCycle.Dead]: 'Død',
            [PrivateStarCycle.Disappeared]: 'Forsvunnet',
            [PrivateStarCycle.Homeless]: 'Uten fast bopel',
            [PrivateStarCycle.GoneAway]: 'Flyttet utenlands',
            [PrivateStarCycle.ForTaxReason]: 'Personlig skattenummer',
            [PrivateStarCycle.NotVerified]: 'Ikke verifisert',
            // [CompanyStarCycle.Active]: 'Active',
            [CompanyStarCycle.Inactive]: 'Inaktiv',
            [CompanyStarCycle.OperationsCeased]: 'Drift opphørt',
            [CompanyStarCycle.ShelfCompany]: 'Hylleselskap',
        },
        dissolvedStatus: {
            [DissolvedStatus.UnderLiquidation]: 'Under avvikling',
            [DissolvedStatus.DissolvedAfterLiquidation]: 'Oppløst etter avvikling',
            [DissolvedStatus.InvoluntaryDissolution]: 'Tvangsoppløsning',
            [DissolvedStatus.Dissolved]: 'Oppløst',
            [DissolvedStatus.Unknown]: 'Ukjent oppløsningsstatus',
            [DissolvedStatus.Voluntary]: 'Under frivillig avvikling',
            [DissolvedStatus.VoluntaryDeclaration]: 'Under frivillig avvikling (erklæring)',
            [DissolvedStatus.Forced]: 'Under tvangsoppløsning',
            [DissolvedStatus.DissolvedAfterDeclaration]: 'Oppløst etter erklæring',
            [DissolvedStatus.DissolvedAfterMerger]: 'Oppløst etter fusjon',
            [DissolvedStatus.DissolvedAfterDemerger]: 'Oppløst etter fisjon',
            [DissolvedStatus.DissolvedAfterBankruptcy]: 'Oppløst etter konkurs',
            [DissolvedStatus.Ceased]: 'Opphørt',
        },
        dissolutionStatus: 'Oppløsningsstatus',
        save: 'Lagre',
        remove: 'Fjern',
        birthdate: 'Fødselsdato',
        noBirthdate: 'Ingen fødselsdato',
        yearsOld: 'år gammel',
        companyForm: 'Selskapsform',
        industry: 'Bransje',
        employees: 'Ansatte',
        companyStatus: 'Selskapsstatus',
        website: 'Nettside',
        dateOfFoundation: 'Stiftelsesdato',
        quantifyOfPUnits: 'Antall P-enheter',
        powerToBind: 'Signaturrett',
        adProtected: 'Reservert mot reklame',
        cars: 'Biler',
        from: 'Fra',
        liabilities: 'Gjeld',
        priority: 'Prioritet',
        interest: 'Rente',
        properties: 'Eiendommer',
        toilet: 'Toalett',
        roof: 'Tak',
        bath: 'Bad',
        built: 'Bygget',
        rkiRegis: 'RKI-registreringer',
        administrator: 'Administrator',
        disclosureDate: 'Offentliggjøringsdato',
        deleted: 'slettet',
        toBedeleted: 'slettet',
        companyRelations: 'Selskapsrelasjoner',
        roles: 'Roller',
        accountableParticipant: 'Ansvarlig deltaker',
        director: 'Direktør',
        executiveBoard: 'Daglig ledelse',
        beneficialOwner: 'Reell rettighetshaver',
        founder: 'Stifter',
        owner: 'eier',
        stakeholder: 'Interessent',
        chairperson: 'Styreleder',
        managingDirector: 'Administrerende direktør',
        boardMember: 'Styremedlem',
        equityTier: 'Egenkapitalnivå',
        viceChairperson: 'Nestleder',
        rightToVote: 'Stemmerett',
        audit: 'Revisjon',
        specialOwnership: 'Særskilt eierskap',
        previous: 'Tidligere',
        noPreviousToShow: 'Ingen tidligere å vise',
        backTo: 'Tilbake til',
        casesOnThisDebtor: 'Saker på denne skyldneren',
        guardianName: 'Vergens navn',
        guardianAddress: 'Vergens adresse',
        guardianStartDate: 'Vergemålets startdato',
    },
    debtorWebHome: {
        dear: 'Kjære',
        representative: 'Vi har registrert at du har logget inn som representant for skyldneren.',
        you: 'Du',
        debtor: 'Skyldner',
        owe: 'skylder',
        to: 'til',
        youCanDoThisHere: 'Du kan betale på denne siden, melde deg på en betalingsplan eller oppdatere kontaktinformasjonen din. Du er også velkommen til å sende oss en melding hvis du har spørsmål.',
        yourInfo: 'Din informasjon',
        name: 'Navn',
        informName: 'Oppgi navn',
        email: 'E-post',
        informEmail: 'Oppgi e-post',
        phone: 'Telefon',
        informPhone: 'Oppgi telefon',
        address: 'Adresse',
        cpr: 'CPR',
        cvr: 'CVR',
        informAddress: 'Oppgi adresse',
        confirmation: 'Jeg bekrefter at informasjonen min er korrekt.',
        updateButton: 'Oppdater informasjon',
        confirm: 'Bekreft',
        faq: 'Ofte stilte spørsmål',
        contactUs: 'Kontakt oss',
        contactUsText: 'Du er velkommen til å sende oss en e-post, ringe oss eller sende en melding via tekstfeltet nedenfor.',
        yourMessage: 'Din melding',
        enterEmail: 'Oppgi e-post for å sende en melding',
        send: 'Send',
        logout: 'Logg ut',
        privacyPolicy: 'Personvernerklæring',
        businessTerms: 'Forretningsvilkår',
        paymentMethods: 'Betalingsmetoder',
        payWithFI: 'Betal med FI-nummer',
        paySafeWithFI: 'Betal trygt med følgende FI-nummer:',
        payWithIBAN: 'Betal med IBAN',
        paySafeWithIBAN: 'Betal trygt med IBAN fra banken din:',
        payWithSWIFT: 'Betal med SWIFT',
        paySafeWithSWIFT: 'Betal trygt med SWIFT fra banken din:',
        payWithBankTransfer: 'Betal med bankoverføring',
        registrationNumber: 'Registreringsnr.',
        accountNumber: 'Kontonr.',
        payWithBankTransferText: 'Foreta en innbetaling til kontoen vår:',
        payWithBankTransferInfo: 'Husk å oppgi saksnr.',
        or: 'Eller',
        iApprove: 'Jeg godtar',
        theBusinessTerms: 'forretningsvilkårene',
        pleaseAcceptBusinessTerms: 'Du må godta forretningsvilkårene før du kan fortsette til betalingssiden.',
        payWithCardButton: 'Betal med kort',
        createAPaymentPlan: 'Opprett en betalingsplan',
        fullPayment: 'Full betaling',
        partialPayment: 'Delbetaling',
    },
    debtorWebPaymentPlans: {
        backToCase: 'Tilbake til sak',
        paymentPlanOn: 'Betalingsplan på sak',
        selectPlan: 'Velg betalingsplan',
        chooseDifferentPlan: 'Velg en annen betalingsplan',
        sign: 'Signer avtale',
        gatherInfo: 'Legg inn informasjon',
        paymentMethod: 'Velg betalingsmetode',
        approval: 'Bekreftelse',
        info: 'Info',
        paymentPlan: 'Betalingsplan',
        firstPayment: 'Første betaling',
        entry: 'oppføring',
        lastPayment: 'Siste betaling',
        signedDoc: 'Signert dokument',
        needHelp: 'Trenger hjelp?',
        orPay: 'Eller betal hele gjelden',
        pay: 'Betal hele gjelden',
        months: 'Måneder',
        month: 'måned',
        total: 'Total betaling',
        select: 'Velg',
        noOptions: 'Dessverre er det ikke mulig å sette opp en betalingsplan.',
        signTextOne: 'For å melde deg på en betalingsplan med',
        signTextTwoAlternativeContact: 'må debitor signere følgende avtale.',
        signTextTwoDebtor: 'må du signere følgende avtale.',
        signTextThree: 'Før du kan signere avtalen, må du fylle ut informasjonen din.',
        agreement: 'Signer avtale',
        agreementTitle: 'Avtale',
        approvalText: 'Gratulerer. Du har inngått en betalingsplan.',
        paymentMethodText: 'Vi tar vare på kortinformasjonen din og gjør det enkelt for deg å melde deg på automatisk betaling.',
        connectCard: 'Koble til betalingsmetode',
        automaticPaymentMethod: 'Automatisk betalingsmetode',
        manualBankTransferTitle: 'Foretrekker du manuell bankoverføring?',
        manualBankTransferHint: 'Du kan i stedet gjøre en manuell bankoverføring. Bankopplysninger finner du på saksoversikten.',
        securePaymentHint: 'Sikker betaling',
        deleteCardToChange: 'Du kan endre/slette det valgte kortet ved å klikke på slett-kort-knappen.',
        deleteCard: 'Slett kort',
        paymentPlanEntries: 'Betalingsplanoppføringer',
        progressTitle: 'Din betalingsplan',
        progressPaid: 'Betalt',
        progressRemaining: 'Gjenstående',
        progressNext: 'Neste termin',
        progressComplete: 'Betalingsplan fullført',
        progressOf: 'av',
        amount: 'Beløp',
        date: 'Dato',
        status: 'Status',
        statusCode: {
            [PaymentPlanEntryStatus.SETTLED]: 'Betalt',
            [PaymentPlanEntryStatus.CANCELED]: 'Standard',
            [PaymentPlanEntryStatus.PENDING]: 'Fremtidig',
            [PaymentPlanEntryStatus.REMINDED]: 'Påminnet',
            [PaymentPlanEntryStatus.AWAITING]: 'Avventer',
            [PaymentPlanEntryStatus.OVERDUE]: 'Forfalt',
            [PaymentPlanEntryStatus.ERRORSETTLED]: 'Mislykket korttrekning',
        },
    },
    paymentPlanEntryStatuses: {
        [PaymentPlanEntryStatus.SETTLED]: 'Betalt',
        [PaymentPlanEntryStatus.CANCELED]: 'Misligholdt',
        [PaymentPlanEntryStatus.PENDING]: 'Fremtidig',
        [PaymentPlanEntryStatus.REMINDED]: 'Purret',
        [PaymentPlanEntryStatus.AWAITING]: 'Avventer',
        [PaymentPlanEntryStatus.OVERDUE]: 'Forfalt',
        [PaymentPlanEntryStatus.ERRORSETTLED]: 'Feil ved oppgjør',
    },
    chains: {
        nextStep: 'Neste steg',
    },
    chainGroups: {
        dunningChain: 'Purrearbeidsflyt',
        chain: 'Arbeidsflyt',
        add: 'Legg til',
        delete: 'Slett',
        configure: 'Konfigurer arbeidsflyter for saksgrupper',
        caseGroup: 'Saksgruppe',
    },
    migration: {
        migrateData: 'Migrer data',
        modalHeader: 'Migrer data',
        uploadErrorMessage: 'Det oppstod en feil, kontroller at filen er riktig og prøv igjen',
    },
    creditorStateDescriptions: {
        [CreditorState.Lead]: 'Kreditorer som er under oppsett, men som ennå ikke har fått tilgang til kreditorwebben.',
        [CreditorState.SignedOn]: 'Kreditorer som ennå ikke er aktive kunder, men som ønsker en demo av kreditorwebben.',
        [CreditorState.Active]: 'Aktive kreditorer som laster opp nye saker og har full tilgang til kreditorwebben.',
        [CreditorState.Ceased]: 'Kreditorer som er oppsagt, men som fortsatt har aktive saker å følge opp.',
        [CreditorState.Cancelled]: 'Kreditorer som er oppsagt og ikke lenger skal ha tilgang til kreditorwebben.',
    },
    creditors: {
        creditor: 'Kreditor',
        creditors: 'Kreditorer',
        creditorInfo: 'Kreditorinformasjon',
        allCreditors: 'Alle kreditorer',
        searchCreditors: 'Søk kreditorer',
        newCreditorInfo: 'Kreditorinfo',
        newCreditorEconomy: 'Økonomi',
        newCreditorChains: 'Arbeidsflyter',
        newCreditorUsers: 'Brukere',
        newCreditorDone: 'Ferdig',
        states: {
            [CreditorState.Active]: 'Aktiv',
            [CreditorState.Lead]: 'Lead',
            [CreditorState.SignedOn]: 'Registrert',
            [CreditorState.Cancelled]: 'Annullert',
            [CreditorState.Ceased]: 'Opphørt',
        },
        downloadOverview: 'Last ned oversikt',
        newCreditor: 'Ny kreditor',
        defaultBillingModelDescription: 'Velg faktureringsmodell som nye saker skal opprettes med. Alle saker kan ha sin egen faktureringsmodell. Når en ny sak opprettes, opprettes den med kreditorens standard faktureringsmodell.',
        tenantInheritedBillingModelDescription: 'Hvis du ikke velger en standard faktureringsmodell, opprettes saker med organisasjonens standard faktureringsmodell',
        tenantInheritedDunningConnectorDescription: 'Hvis du ikke velger en standard faktureringsmodell, opprettes saker med organisasjonens standard purremodell',
        chainsHeader: 'Velg standard arbeidsflyter',
        chainsDescription: 'Velg hvilken arbeidsflyt nye saker skal opprettes med. Alle saker kan ha sin egen arbeidsflyt. Når en ny sak opprettes, opprettes den med kreditorens standard arbeidsflyt.',
        usersNewHeader: 'Opprett innlogging for kreditorer',
        usersCreditorHeader: 'Velg ansvarlige brukere',
        next: 'Neste',
        previous: 'Forrige',
        setCreditorState: 'Angi kreditorstatus',
        cvr: 'CVR',
        company: 'Selskap',
        person: 'Person',
        vatRegistered: 'Mva-registrert',
        notVatRegistered: 'Ikke mva-registrert',
        acquisitionResponsible: 'Ansvarlig for anskaffelse',
        selectAcquiRespon: 'Velg ansvarlig for anskaffelse',
        contact: 'Kontakt',
        selectContact: 'Velg kontakt',
        caseworkerContact: 'Saksbehandlerkontakt',
        selectCaseworkerContact: 'Velg saksbehandlerkontakt',
        none: 'Ingen',
        createCreditor: 'Opprett kreditor',
        reference: 'Referanse',
        name: 'Navn',
        selectDefaultCollector: 'Velg standard inkassobyrå',
        status: 'Status',
        active: 'Aktiv',
        lead: 'Lead',
        selectClientContact: 'Velg kreditorkontakt',
        isCompany: 'Er selskap',
        create: 'Opprett',
        createdAt: 'Opprettelsesdato',
        quantityCases: 'Antall saker',
        referenceId: 'Nr.',
        wincentAvgPrediction: 'Wincent gj.snitt-score',
        selectDefaultChain: 'Velg standard arbeidsflyt',
        defaultChain: 'Arbeidsflyt',
        selectDefaultClientChain: 'Velg standard arbeidsflyt',
        defaultClientChain: 'Purrearbeidsflyt',
        mandates: 'Mandater',
        mandatesPlaceholder: 'Tom',
        experianClientId: 'Experian klient-id',
        updateExperianClientId: 'Oppdater klient-id',
        requestClientIdExperian: 'Be Experian om en klient-id',
        requestClientIdExperianSuccess: 'Experian er blitt forespurt og vil automatisk fylle inn klient-id-en.',
        erpLink: 'Lenke til kreditorens ERP-system',
        updateErpLink: 'Oppdater lenke',
        aksEnabled: 'AKS aktivert',
        advokatindestaaelse: 'Advokatindeståelse for åpen RKI',
        debitorRegistretCreateCreditor: 'Opprett kreditor i Debitor Registret',
        debitorRegistretCreateCreditorDescription: 'Oppretter kreditoren i Debitor Registret og lagrer kreditornummeret.',
        debitorRegistretCreateCreditorSuccess: 'Kreditoren ble opprettet i Debitor Registret.',
        debitorRegistretCreateCreditorSkipped: 'Kreditoren er allerede opprettet i Debitor Registret.',
        bankAccountDetails: 'Bankkontodetaljer',
        updateBankAccountDetails: 'Oppdater konto',
        autoRKI: 'Auto-RKI',
        automaticDebtRegister: 'Overstyr automatisk registrering i RKI',
        useAutomaticDebtRegister: 'Angi automatisk registrering i RKI på kreditor',
        useAutoRKIOpen: 'Angi åpen RKI på kreditor',
        useAutoRKIIgnoreUnresolvedOppositions: 'Angi ignorer uløste interaksjoner (innsigelser) på kreditor',
        selfCollection: 'Egeninkasso',
        useSelfCollectionOption: 'Angi egeninkasso på kreditor',
        outboundCall: 'Utgående anrop',
        useOutboundCallOption: 'Angi utgående anrop på kreditor',
        autoVerify: 'Verifiser saker automatisk',
        useAutoVerifyOption: 'Angi automatisk verifisering på kreditor',
        paymentTerms: 'Betalingsbetingelser',
        paymentDays: 'Betalingsdager',
        billingRecipients: 'Fakturamottakere',
        billingRecipientsDescription: 'Angi flere e-poster slik',
        automaticExpireVouchers: 'Overstyr automatisk utløp av bilag',
        useAutomaticExpireVouchers: 'Angi automatisk utløp av bilag på kreditor',
        configurationOptions: 'Konfigurasjoner',
        experianConfig: 'Experian-konfigurasjoner',
        courtSubmitConfig: 'Konfigurasjon for automatisk innsending til domstol',
        foundationExpiration: 'Utløp med grunnlag',
        normalExpiration: 'Utløp uten grunnlag',
        interestExpiration: 'Renteutløp',
        debtorFAQ: 'Ofte stilte spørsmål (vises i skyldnerwebben)',
        faqHeader: 'Trenger du hjelp med å opprette en ny kreditor?',
        faqText: 'Vi har laget en artikkel om hvordan du gjør det. Klikk på knappen nedenfor for å lese mer.',
        newUserDisabled: 'Nye brukere kan ikke opprettes med gjeldende kreditorstatus',
        cancelledError: 'Tilgangen er annullert',
        cancelledErrorMessage: 'Tilgangen din er annullert. Kontakt oss for mer informasjon.',
        eInvoice: {
            eInvoice: 'E-faktura',
            companyId: 'Selskaps-id',
            identification: 'Identifikasjonsnummer',
            addChildCompany: 'Legg til som underselskap',
        },
        creditorCreationDisabled: 'Opprettelse av kreditor er slått av',
        creditorCreationDisabledDescription: 'Kreditorer kan ikke opprettes via brukergrensesnittet',
        moveCasesToNewCreditor: 'Flytt saker til ny kreditor',
        moveCases: 'Flytt saker',
        noCreditors: 'Ingen kreditorer',
    },
    collectorTypes: {
        [CollectorType.CREDITOR]: 'Kreditor',
        [CollectorType.TENANT]: 'Inkassobyrå',
    },
    collectors: {
        collector: 'Inkassobyrå',
        updateEntity: 'Lagre',
        masterData: 'Informasjon',
        layout: 'Layout',
        websites: 'Nettsteder',
        legal: 'Juridisk',
        paymentOptions: 'Betalingsalternativ',
        communicationChannels: 'Kommunikasjonskanaler',
        namePlaceholder: 'Navn',
        centralRegisterIdPlaceholder: 'Lokalt organisasjonsnummer',
        nicknamePlaceholder: 'Kallenavn',
        addressPlaceholder: 'Adresse',
        logoFileIdPlaceholder: 'Logo',
        letterFrontLogoFileIdPlaceholder: 'Logo brukt på første side av brev',
        websitePlaceholder: 'Nettsted',
        clientWebBasePlaceholder: 'Kreditorweb-base',
        debtorWebBasePlaceholder: 'Skyldnerweb-base',
        titlePlaceholder: 'Selskapstittel',
        privacyPolicyPlaceholder: 'Personvernerklæring',
        businessTermsPlaceholder: 'Forretningsvilkår',
        emailPlaceholder: 'E-post',
        replyToPlaceholder: 'Svar-til-e-post',
        phonePlaceholder: 'Telefon',
        paymentOptionsPlaceholder: 'Betalingsalternativer',
        themePlaceholder: 'Tema',
        hideEmail: 'Skjul e-post',
        secondaryCollector: 'Sekundær innkrever',
        addSecondaryCollector: 'Legg til sekundær innkrever',
    },
    paymentPlans: {
        cannotOfferPaymentPlan: 'Dessverre kan vi ikke tilby deg noen betalingsplaner på nett. Vennligst kontakt inkassobyrået.',
        paymentPlansDisabled: 'Betalingsplaner deaktivert',
        paymentPlanDisabledForDebtor: 'Skyldner kan ikke opprette betalingsplaner. Se saksinnstillinger',
        paymentPlan: 'Betalingsplan',
        signing: 'Inngåelse av betalingsplaner',
        signedFoundation: 'Skyldner signerer et gjeldsgrunnlag',
        signedFoundationDescription: 'Betalingsplanen blir aktiv når skyldner har signert i skyldnerwebben.',
        noSignature: 'Ingen signering',
        noSignatureDescription: 'Betalingsplanen er aktiv så snart den opprettes.',
        foundationTemplate: 'Mal for gjeldsgrunnlag',
        defaultFoundation: 'Standard gjeldsgrunnlag',
        skipTo: 'Hopp til',
        editPaymentPlan: 'Rediger betalingsplan',
        editPaymentPlanDescription: 'Juster avdragsbeløp, varighet eller intervall. Allerede betalte avdrag beholdes.',
        editPaymentPlanHint: 'De {count} avdragene som allerede er betalt, beholdes. Kun fremtidige avdrag erstattes med den nye planen.',
        collapsedEntries: 'sammenslåtte avdrag',
        deletePaymentPlan: 'Slett betalingsplan',
        progress: 'Fremdrift',
        selectPaymentPlan: 'Velg betalingsplan',
        signPaymentPlan: 'Signer betalingsplan',
        selectPaymentMethod: 'Velg betalingsmetode',
        confirmation: 'Bekreftelse',
        createNewPaymentPlan: 'Opprett ny betalingsplan',
        months: 'måneder',
        month: 'måned',
        totalPayment: 'Total tilbakebetaling',
        createCustomPlan: 'Opprett tilpasset betalingsplan',
        createStandardPlan: 'Opprett standard betalingsplan',
        byAmount: 'Etter beløp',
        byDuration: 'Etter varighet',
        monthly: 'Månedlig',
        everyOtherMonth: 'Annenhver måned',
        quarterly: 'Kvartalsvis',
        yearly: 'Årlig',
        everyOtherWeek: 'Annenhver uke',
        weekly: 'Ukentlig',
        lastBankDayOfMonth: 'Siste bankdag i måneden',
        rest: 'Rest',
        generate: 'Generer',
        entries: 'Avdrag',
        entry: 'Avdrag',
        date: 'Dato',
        reminder: 'Purring',
        lastChanceOfPayment: 'Siste sjanse',
        addedInterests: 'Tillagte renter',
        cancelled: 'Misligholdt',
        amount: 'Beløp',
        confirmationCheckbox: 'Send bekreftelse når betalingsplanen aktiveres',
        activate: 'Aktiver',
        cancel: 'Avbryt',
        agreement: 'Avtale',
        inputAmount: 'Skriv inn beløpet.',
        details: 'Detaljer',
        createPaymentPlan: 'Opprett betalingsplan',
        activatePaymentPlanWithoutFoundation: 'Aktiver betalingsplan uten grunnlag.',
        errorCaseEnded: 'Kan ikke opprette betalingsplan: saken er avsluttet',
        paymentEntryText: 'Betaling av',
        yearlyAPR: 'års effektiv rente',
        before: 'før',
        CREATED: 'Opprettet',
        ACTIVE: 'Aktiv',
        FINISHED: 'Fullført',
        CANCELED: 'Kansellert',
        DELETED: 'Slettet',
        errorInInput: 'Feil i inndata',
        save: 'Lagre',
        calculationFoundation: 'Beløp eller varighet',
        calculationFoundationDescription: 'Velg betalingsplanens beregningsgrunnlag. Enten et beløp eller antall avdrag.',
        calculateByAmount: 'Beregn basert på et beløp',
        calculateByDuration: 'Beregn basert på en varighet',
        addScheduledAmountChange: '+ Juster senere avdrag',
        scheduledAmountChangeFromDate: 'Fra dato',
        createdAt: 'Opprettet',
        startDate: 'Startdato',
        startDateDescription: 'Betalingsdato for det første avdraget.',
        upfrontPayment: 'Forskuddsbetaling',
        upfrontPaymentDescription: 'Hvis det trengs en forskuddsbetaling som viser betalingsvilje, kan den slås på her.',
        upfrontPaymentDate: 'Dato for forskuddsbetaling',
        interval: 'Intervall',
        intervalDescription: 'Velg tidsrommet mellom avdragene i betalingsplanen.',
        interestFree: 'Rentefri periode',
        interestFreeDescription: 'Hvis det trengs en rentefri periode, kan den velges her.',
        interestFreeFrom: 'Fra',
        interestFreeTo: 'Til',
        interestFreeOnDefault: 'Hvis planen misligholdes',
        interestFreeOnDefaultKeepFrozen: 'Behold perioden rentefri, renten gjenopptas fra misligholdsdatoen',
        interestFreeOnDefaultReapply: 'Legg til igjen den ettergitte renten fra perioden',
        settlement: 'Akkord',
        settlementDescription: 'Skyldner betaler et avtalt nedsatt beløp; resten ettergis når planen er fullført.',
        settlementEnable: 'Inngå akkord (betal mindre enn hele gjelden)',
        settlementAgreedTotal: 'Avtalt beløp',
        settlementPercentOfBalance: 'Prosent av saldo',
        settlementAmountForgiven: 'Ettergitt beløp',
        settlementCurrentBalance: 'Gjeldende saldo',
        settlementSettledSoFar: 'Betalt så langt',
        settlementRemainingToPay: 'Gjenstående av avtalt beløp',
        settlementForgivenOnCompletion: 'Ettergis ved fullføring',
        settlementSummary: 'Skyldner betaler {total} av {balance} ({percent} %)',
        settlementExceedsBalance: 'Det avtalte beløpet må være mindre enn gjeldende saldo',
        fees: 'Gebyrer',
        feesDescription: 'Legg til valgfrie gebyrer på betalingsplanen.',
        initialFee: 'Oppstartsgebyr',
        initialFeeDescription: 'Legg til et engangsgebyr når betalingsplanen starter.',
        perEntryFee: 'Gebyr per avdrag',
        perEntryFeeDescription: 'Legg til et gebyr for hvert avdrag i betalingsplanen.',
        selectVoucherType: 'Velg bilagstype',
        selectVoucherTypeRequired: 'Velg en bilagstype for å bruke dette gebyret',
        defaultFees: 'Standardgebyrer',
        defaultFeesDescription: 'Konfigurer standardgebyrer som vil bli lagt til på nye betalingsplaner.',
        feesWillBeApplied: 'Gebyrer vil bli lagt til',
        overrideFees: 'Overstyr gebyrer på kreditor',
        moreSettings: 'Flere innstillinger',
        detailsWarning: 'Denne planen viser sakens utvikling hvis planen følges. Avvik kan oppstå hvis for eksempel betalingsdatoene avviker fra avdragsplanen.',
        debtAmount: 'Gjeldsbeløp',
        accumulatedInterest: 'Akkumulert rente',
        planedAccumulatedPayments: 'Planlagte akkumulerte betalinger',
        disclaimerLastEntryVaries: 'Hvis avdragene ikke betales på den angitte datoen, kan beløpet på det siste avdraget avvike.',
        disclaimerVariableInterest: 'Rentesatsen på saken kan endre seg over tid, noe som også kan påvirke beløpet på det siste avdraget.',
        savedPaymentMethod: 'Lagret betalingsmetode',
        removePaymentMethod: 'Fjern skyldnerens betalingsmetode',
        areYouSureRemovePaymentMethod: 'Er du sikker på at du vil fjerne skyldnerens betalingsmetode?',
        paymentMethodSection: 'Betalingsmetode',
        noPaymentMethodConnected: 'Ingen betalingsmetode tilkoblet',
        noPaymentMethodHint: 'Koble til en betalingsmetode slik at avdrag kan trekkes automatisk på forfallsdatoen.',
        connectPaymentMethod: 'Koble til betalingsmetode',
        connectCardOrBetalingsservice: 'Koble til kort eller Betalingsservice',
        noActiveCardOption: 'Kreditoren har ingen aktiv kortbetalingsmetode tilgjengelig.',
        createBSMandate: 'Opprett Betalingsservice-avtale',
        bsMandateDescription: 'Registrer en Betalingsservice-avtale på vegne av debitor med deres CPR-nummer og kontoopplysninger.',
        bsMandateName: 'Navn',
        bsMandateCpr: 'CPR-nummer',
        bsMandateRegNo: 'Registreringsnummer',
        bsMandateAccountNo: 'Kontonummer',
        bsMandateSubmit: 'Opprett avtale',
        bsMandateCreated: 'Betalingsservice-avtale opprettet. Venter på bekreftelse fra banken.',
        recommendedBadge: 'Anbefalt',
        lastBankDayOfMonthDescription: 'Trekk på lønningsdag — best sjanse for vellykket betaling.',
        recalculate: 'Beregn på nytt',
        recalculateDescription: 'Ny beregning sletter alle ventende avdrag og genererer planen på nytt.',
        daily: 'Daglig',
    },
    debtRegistration: {
        registration: 'Gjeldsregistrering',
        tabGeneral: 'Generelt',
        tabRki: 'RKI',
        tabDebitorRegistret: 'Debitor Registret',
        createNewRegistration: 'Opprett ny registrering',
        newRegistration: 'Ny gjeldsregistrering',
        chooseDebtor: 'Velg skyldner',
        amount: 'Beløp',
        withFoundation: 'Med grunnlag',
        chooseFoundationType: 'Velg grunnlagstype',
        dateFoundation: 'Dato for grunnlag',
        noFoundationsOnCase: 'Ingen grunnlag funnet på saken. Legg til et grunnlag på saken for å fortsette.',
        foundationCode: {
            [FoundationCode.betalingspåkrav1påtegning]: 'Betalingspåkrav 1. påtegning',
            [FoundationCode.betalingspåkrav2påtegning]: 'Betalingspåkrav 2. påtegning',
            [FoundationCode.stævning]: 'Stævning',
            [FoundationCode.fogedsag]: 'Fogedsag',
            [FoundationCode.dom]: 'Dom',
            [FoundationCode.insolvens]: 'Insolvenserklæring i anden sag',
            [FoundationCode.konkurs]: 'Konkurs',
            [FoundationCode.tvangsakkord]: 'Tvangsakkord, indledt',
            [FoundationCode.fogedretsrekv]: 'Fogedretsrekv',
            [FoundationCode.tvangsauktionudlæg]: 'Tvangsauktion - udlæg',
            [FoundationCode.skylderklæring]: 'Skylderklæring',
            [FoundationCode.forlig]: 'Frivilligt forlig',
        },
        state: {
            [DebtRegistrationState.ACTIVE]: 'ACTIVE',
            [DebtRegistrationState.ERROR]: 'ERROR',
            [DebtRegistrationState.DELETED]: 'DELETED',
            [DebtRegistrationState.CONCLUDED]: 'CONCLUDED',
        },
        registry: {
            [RegistryType.OPEN]: 'OPEN',
            [RegistryType.CLOSED]: 'CLOSED',
        },
        status: 'Status',
        remark: 'Merknad',
        deleteReason: 'Sletteårsak',
        migrated: 'Migrert',
        latestWarningDate: 'Dato for siste varsel',
        errors: {
            [DebtRegistrationError.AlreadyRegistered]: 'Skyldneren er allerede registrert',
            [DebtRegistrationError.MissingWarning]: 'Manglende varsel',
            [DebtRegistrationError.WrongCurrency]: 'Valutaen er ikke DKK',
            [DebtRegistrationError.WarningLetterWasReturned]: 'Varselbrevet ble returnert',
            [DebtRegistrationError.EmailWarningWasNeverDelivered]: 'Varsel-e-posten ble aldri levert',
            [DebtRegistrationError.WarningIsOlderThanOneYear]: 'Varselet er eldre enn ett år',
            [DebtRegistrationError.FoundationCouldNotBeMapped]: 'Grunnlagskoden kunne ikke identifiseres',
            [DebtRegistrationError.FoundationDateCouldNotFound]: 'Grunnlagsdatoen kunne ikke finnes',
            [DebtRegistrationError.UnresolvedOpposition]: 'Uløst interaksjon',
            [DebtRegistrationError.OppositionFound]: 'Aktiv innsigelse',
            [DebtRegistrationError.NoRegistryFound]: 'Oppfyller ikke kravene for noe register',
            [DebtRegistrationError.FoundationAmountCouldNotBeFound]: 'Beløp på grunnlaget mangler',
            [DebtRegistrationError.FoundationAmountTooSmall]: 'Beløpet på grunnlaget er for lavt for det åpne registeret',
            [DebtRegistrationError.NameTooLong]: 'Gjeldsregistrering tillater maksimalt 60 tegn i navnet. For enkeltpersonforetak kan "v/" fjernes sammen med alt etter "/v".',
            [DebtRegistrationError.OldestRegistrationIsTooOld]: 'Den eldste registreringen er for gammel',
            [DebtRegistrationError.FoundationFileMissing]: 'Grunnlagsdokumentet har ingen fil (påkrevd for åpen registrering uten advokatgaranti)',
            [DebtRegistrationError.FoundationMissing]: 'Det er ikke noe grunnlag på saken, som er påkrevd for åpen registrering',
            [DebtRegistrationError.BalanceTooSmallForOpen]: 'Saldoen på saken er for lav for åpen registrering',
        },
        infobox: {
            herebyRegister: 'registrerer herved',
            open: 'Åpne',
            closed: 'Lukkede',
            inThe: 'i det',
            debtorNotPaid: 'gjeldsregisteret, siden skyldner ikke har betalt det forfalte beløpet på DKK',
            criteria: 'Saken oppfyller følgende kriterier:',
            min18years: 'Skyldner er minimum 18 år gammel',
            min3messages: 'Skyldner har mottatt minimum 3 meldinger fra kreditor og/eller inkassobyrå angående gjelden',
            totalDebt: 'Samlet gjeld inkludert avdrag og gebyrer er på minimum DKK 1.000',
            hasFoundation: 'Har grunnlag',
            debtorWarning: 'Skyldner er blitt varslet for minst 15 dager siden og høyst 6 måneder siden',
            totalPrincipal: 'Samlet hovedstol er minimum DKK 200',
            noDemurral: 'Skyldner har ikke fremmet innsigelse',
            institutionsInfo: 'Forsikringsselskaper, finansinstitusjoner og kredittforetak har ikke lov til å registrere skyldnere i gjeldsregistre uten at saken er behandlet av sivil domstol eller Namsmannen',
            incoming: 'Interaksjoner merket som innsigelser og uløste interaksjoner',
            specialCreditors: 'Forsikringsselskaper, finansinstitusjoner og kredittforetak har ikke lov til å registrere skyldnere i gjeldsregistre uten at saken er behandlet av sivil domstol eller Namsmannen',
            closedRegister: 'Lukket register',
            openRegister: 'Åpent register',
            foundationType: 'Registrering med riktig grunnlagstype',
            registerButton: 'Registrer i gjeldsregister',
            finePrint: {
                NB: 'NB: Det kan ta opptil 10 minutter å behandle registreringer og endringer. Hvis registreringen eller endringen velges for manuell behandling, kan det ta flere virkedager.',
                letter: 'Skyldner vil motta et brev etter at registreringen er publisert.',
                expiration: 'Registreringer i det lukkede utløper etter 2 år. Det kan forlenges opptil 5 hvis det overføres til det åpne registeret. Registreringer i det åpne utløper etter 5 år fra grunnlagsdatoen.',
                faultyData: 'Hvis det er problemer med dataene, kontakt support.',
                newClient: 'For å opprette en ny klient, kontakt support.',
            },
        },
    },
    RKI: {
        registration: 'RKI-registrering',
    },
    debitorRegistret: {
        registration: 'Debitor Registret-registrering',
    },
    financials: {
        debtExpiresWithinThreeMonths: 'Gjeld foreldes innen 3 måneder',
        debtExpired: 'Gjeld foreldet',
        principal: 'Hovedstol',
        interests: 'Renter',
        costs: 'Kostnader',
        debt: 'Gjeld',
        deposit: 'Innbetalt',
        balance: 'Saldo',
        revenue: 'Omsetning',
        revenueBasedDepositOrder: 'Omsetningsbasert betalingsrekkefølge',
        interestBasedDepositOrder: 'Rentebasert betalingsrekkefølge',
        details: 'Detaljer',
        invoiceId: 'Fakturanummer',
        reminderFee: 'Purregebyr',
        overpayment: 'Overbetaling',
        repayment: 'Tilbakebetaling',
        responsibleForRepayment: 'Ansvarlig for tilbakebetaling',
        sourceBankAccount: 'Fra bankkonto',
        registrationNumber: 'Registreringsnummer',
        accountNumber: 'Kontonummer',
        repaymentAmount: 'Beløp til tilbakebetaling',
        sendRepaymentRequest: 'Send anmodning om tilbakebetaling',
        currency: 'Valuta',
        moneyScaleSuffixes: {
            thousands: 't',
        },
        imposedByCollector: 'Gjeld pålagt av inkassobyrå',
        imposedByCreditor: 'Gjeld pålagt av kreditor',
    },
    sftp: {
        servers: 'SFTP-servere',
        explanation: 'Opprett SFTP-servere for å utveksle filer med kreditorer og samarbeidspartnere. Hver server har sine egne brukere, som logger inn med en SSH-nøkkel.',
        name: 'Navn',
        creditor: 'Kreditor',
        noCreditor: 'Ingen kreditor',
        created: 'Opprettet',
        newServer: 'Ny SFTP-server',
        createServer: 'Opprett SFTP-server',
        deleteServer: 'Slett SFTP-server',
        deleteServerWarning: 'Sletting av SFTP-serveren fjerner alle brukerne og tilgangen deres. Dette kan ikke angres.',
        typeNameToConfirm: 'Skriv navnet på SFTP-serveren for å bekrefte',
        noServers: 'Ingen SFTP-servere er opprettet ennå',
        connection: 'Tilkobling',
        host: 'Vert',
        port: 'Port',
        users: 'Brukere',
        connectionExplanation: 'Brukere kobler til med en SFTP-klient til verten nedenfor og logger inn med SSH-nøkkelen sin. Passord brukes ikke.',
        keyType: 'Nøkkel',
        login: 'Innlogging',
        deleteServerExplanation: 'Sletter SFTP-serveren og alle brukerne. Allerede opplastede filer blir i mappen.',
        newUser: 'Ny bruker',
        createUser: 'Opprett bruker',
        username: 'Brukernavn',
        usernameHint: '3-100 tegn: bokstaver, tall, understrek, bindestrek, punktum og @',
        publicKey: 'Offentlig SSH-nøkkel',
        publicKeyHint: 'Lim inn den offentlige nøkkelen, f.eks. "ssh-ed25519 AAAA... kommentar"',
        deleteUser: 'Slett bruker',
        confirmDeleteUser: 'Er du sikker på at du vil slette denne brukeren? Brukeren mister tilgangen umiddelbart.',
        noUsers: 'Ingen brukere er opprettet ennå',
        backToServers: 'Alle SFTP-servere',
    },
    navigation: {
        overview: 'Oversikt',
        home: 'Hjem',
        cases: 'Saker',
        views: 'Visninger',
        transactions: 'Transaksjoner',
        economy: 'Økonomi',
        economyCaseVouchers: 'Saksbilag',
        economyBookkeeping: 'Regnskap',
        economyImposedDebt: 'Pålagt gjeld',
        economyDeposits: 'Innbetalinger',
        economySetup: 'Innstillinger',
        economyBilling: 'Avregning',
        economyPayment: 'Betaling',
        economyPayouts: 'Utbetalinger',
        economyChartOfAccounts: 'Kontoplan',
        economyUnknown: 'Ukjente transaksjoner',
        bankAccounts: 'Kontoer',
        export: 'Eksporter',
        transactionLookup: 'Transaksjonsoppslag',
        depositChanges: 'Endringer',
        economyIrrecoverableDebt: 'Tapt gjeld',
        economyExpiredDebt: 'Foreldet gjeld',
        reports: 'Innsikt',
        communication: 'Kanaler',
        content: 'Innhold',
        creditors: 'Kreditorer',
        creditorEconomy: 'Økonomi',
        creditorInvoicing: 'Avregning',
        creditorCustomers: 'Kunder',
        creditorCases: 'Saker',
        creditorCollector: 'Inkassobyrå',
        creditorIrrecoverableDebt: 'Tapt gjeld',
        creditorExpiredDebt: 'Foreldet gjeld',
        creditorEconomySetup: 'Oppsett',
        creditorTribunal: 'Domstolsmodul',
        creditorSetup: 'Innstillinger',
        creditorAISettings: 'AI',
        creditorWorkflows: 'Arbeidsflyter',
        creditorUsers: 'Brukere',
        creditorIntegrations: 'Integrasjoner',
        journalizer: 'Journalføring',
        interactionHistory: 'Interaksjonshistorikk',
        returnLetters: 'Returbrev',
        outbox: 'Utboks',
        outboundCalls: 'Utgående anrop',
        import: 'Import',
        support: 'Hjelp',
        search: 'Søk saker...',
        settings: 'Innstillinger',
        settingsDesc: 'Innstillinger for organisasjon',
        user: 'Min konto',
        userDesc: 'Dine innstillinger',
        homeOverview: 'Oversikt',
        settingsGeneral: 'Generelt',
        settingsTemplates: 'Maler',
        settingsDevelopers: 'Utviklere',
        settingsDevelopersDesc: 'Tilgang til API med mer',
        settingsSwitchAccount: 'Bytt konto',
        settingsSwitchAccountDesc: 'Bytt mellom kontoer',
        settingsTenantBilling: 'Fakturaer',
        settingsTenantBillingDesc: 'Se alle fakturaer',
        settingsProperties: 'Attributter',
        settingsCaseVoucherTables: 'Saksbilagstabeller',
        settingsDocuments: 'Dokumenter',
        settingsCaseGroups: 'Saksgrupper',
        settingsCaseConfig: 'Saksoppsett',
        settingsWebhooks: 'Webhooks',
        settingsSftp: 'SFTP',
        settingsEmbed: 'Embed',
        settingsAPI: 'API',
        settingsCollectors: 'Inkassobyråer',
        settingsDebtRegister: 'Gjeldsregistrering',
        settingsIntegrateCalendar: 'Synkroniser oppgaver til kalender',
        settingsEconomy: 'Økonomi',
        settingsPriceList: 'Prisliste',
        settingsBookkeeping: 'Regnskapsvedlegg',
        settingsBilling: 'Avregningsoppsett',
        settingsBankAccounts: 'Bankkontoer',
        settingsCaseVoucherTypes: 'Saksbilagstyper',
        settingsBillingVoucherTypes: 'Avregningsbilagstyper',
        settingsUsers: 'Brukere',
        settingsEndReasons: 'Avslutningsårsaker',
        settingsTribunal: 'Domstolsmodul',
        settingsTeams: 'Team',
        settingsTenant: 'Organisasjon',
        settingsUpdateTypes: 'Oppgaver',
        settingsProcedures: 'Snarveier',
        settingsApplications: 'Regelbaserte bilag',
        settingsCaseMergeRules: 'Regler for sammenslåing av saker',
        settingsPaymentPlansConfig: 'Betalingsplaner',
        settingsJournalizerConfig: 'Journalføring',
        settingsAI: 'AI',
        reportsExorts: 'Fileksporter',
        reportsPaymentPlans: 'Betalingsplaner',
        reportsCourtMeetings: 'Rettsmøter',
        reportsDistraints: 'Utlegg',
        reportsGeneralManagement: 'Ledelsesrapportering',
        reportsAI: 'AI',
        reportsPrevious: 'Tidligere rapporter',
        reportsSankey: 'Debbie flytdiagram',
        settingsWorkflows: 'Arbeidsflyter',
        reportsPaymentDays: 'Betalingsdager-diagram',
        myAccount: 'Min konto',
        integrations: 'Integrasjoner',
    },
    timespanUnits: {
        [TimespanUnit.Years]: 'År',
        [TimespanUnit.Quarters]: 'Kvartaler',
        [TimespanUnit.Months]: 'Måneder',
        [TimespanUnit.Weeks]: 'Uker',
        [TimespanUnit.Days]: 'Dager',
        [TimespanUnit.Hours]: 'Timer',
        [TimespanUnit.Minutes]: 'Minutter',
        [TimespanUnit.Seconds]: 'Sekunder',
        [TimespanUnit.MS]: 'Millisekunder',
    },
    paymentPlansConfig: {
        description: 'Sett opp hvilke muligheter skyldneren skal tilbys når de oppretter en betalingsplan selv.',
        minEntryAmountPlaceholder: 'Minimumsbeløp per avdrag',
        daysBetweenEntriesPlaceholder: 'Dager i mellom',
        durationPlaceholder: 'Måneder',
        addOption: 'Legg til',
        save: 'Lagre',
        override: 'Overstyr oppsett på kreditor',
        disablePaymentPlans: 'Slå av betalingsplaner slik at verken skyldnere eller saksbehandlere kan opprette betalingsplaner.',
        requireCentralRegisterId: 'Krev CPR/CVR-nummer før signatur',
        activationDeadlineDays: 'Kanseller ikke-aktiverte betalingsplaner etter antall dager',
    },
    referenceIdFinders: {
        referenceIdFinding: 'Referansenummersøk',
        description: 'Journalfør e-poster og match innbetalinger basert på referansenumre som kundenumre eller saksbilagsreferanser (f.eks. fakturanummer).',
        length: 'Antall sifre i referansenummeret',
        min: 'Minste mulige referansenummer',
        max: 'Største mulige referansenummer',
        createNew: 'Opprett nytt referansenummersøk',
        add: 'Legg til',
        caseVoucherReference: 'Saksbilagsreferanse',
        caseVoucherReferenceDescription: 'Saksbilagsreferanse (f.eks. fakturanummer)',
        customerReference: 'Kundereferanse',
        customerReferenceDescription: 'Kundereferanse (f.eks. pasient-, klient- eller medlemsnummer)',
    },
    caseMergeRules: {
        description: 'Bestem om nye bilag som gjelder en kunde skal legges til eksisterende saker eller om en ny sak skal opprettes.',
        preventMerge: 'Forhindre sammenslåing med saker',
        caseStatusVerified: 'Slå sammen med verifiserte saker',
        adjustVariableCaseVouchers: 'Juster inkassokostnader og gebyrer',
        caseStatusPending: 'Slå sammen med ventende saker',
        hasFoundation: 'Slå sammen med saker med grunnlag',
        caseVoucherConstraints: 'Saksbilagstyper med duplikatkontroll',
        caseVoucherConstraintsDescription: 'Velg hvilke saksbilagstyper som ikke skal forekomme på begge saker hvis de opprettes innenfor det angitte antall dager. De nyeste saksbilagene vil bli fjernet.',
        caseVoucherConstraintsAllDays: 'Fjern alle',
        caseVoucherConstraintsDays: 'Dager',
        addCaseVoucherConstraint: 'Legg til duplikatkontroll',
        addCaseVoucherConstraintSelectVoucherType: 'Velg saksbilagstype',
        addCaseVoucherConstraintUniqueInDays: 'Unik innenfor antall dager (la stå tom hvis alle skal fjernes)',
        addCaseVoucherConstraintAddButton: 'Legg til',
        doesNotHaveUpdateTypeIds: 'Ikke slå sammen med saker med disse oppgavene',
        doesHaveUpdateTypeIds: 'Slå kun sammen med saker med disse oppgavene',
        hasActivePaymentPlan: 'Slå sammen saker med en aktiv betalingsplan',
    },
    workflows: {
        workflows: 'Arbeidsflyter',
        customWorkflows: 'Opprettede arbeidsflyter',
        standardWorkflow: 'Standardarbeidsflyter',
        creditorStandardWorkflowDescription: 'Sett opp hvilken arbeidsflyt nye saker skal opprettes i. Hvis du endrer arbeidsflyten her, endres ikke allerede opprettede saker.',
        creditorInteraction: 'til kreditor',
        removeVouchers: 'Fjern',
        rollbackTask: 'Angre oppgave',
        rolledback: 'Angret',
        runTask: 'Flytt sak til denne oppgaven',
        sureYouWantToDeleteTask: 'Er du sikker på at du vil slette oppgaven?',
        addRequirement: 'Legg til krav',
        searchUpdates: 'Søk',
        noUpdatesToShow: 'Ingen oppgaver å vise',
        manualSelection: 'Manuelt valg',
        changeWorkflowOnCase: 'Endre arbeidsflyt',
        nextTaskASAP: 'Neste oppgave vil bli utført om et øyeblikk',
        workflowWillStartWhenCaseIsVerified: 'Arbeidsflyten starter når saken er verifisert',
        caseIsPaused: 'Saken er satt på pause',
        pausedBecauseOfPaymentPlan: 'Neste oppgave utføres hvis betalingsplanen misligholdes',
        priority: 'Prioritet',
        priorityDescription: 'Hvis en sti ikke kan finnes automatisk, brukes prioriteten. 1 er høyeste prioritet.',
        timing: 'Tidspunkt',
        requirements: 'Krav',
        amount: 'Beløp',
        imposedByCreditor: 'Pålagt av kreditor',
        text: 'Tekst',
        addTodo: 'Legg til gjøremål',
        selectTemplate: 'Velg mal',
        includeVoucherAttachments: 'Legg ved bilagsvedlegg (for eksempel faktura).',
        attachFoundations: 'Legg ved grunnlag',
        selectEmailPDFAttachment: 'Velg mal som skal legges ved e-posten.',
        sendImmediatelyDeviateFromSettings: 'Skal umiddelbar sending avvike fra generelle innstillinger på kontoen din?',
        sendImmediately: 'Send umiddelbart',
        doNotSendImmediately: 'Ikke send umiddelbart',
        endCaseIfThereIsNoPrincipalLeft: 'Avslutt sak hvis det ikke er noen hovedstol igjen',
        endCaseReason: 'Hvis saken skal avsluttes, hvilken avslutningsårsak skal brukes?',
        selectCollector: 'Velg inkassobyrå',
        useCreditorCollector: 'Bruk kreditors identitet',
        creditorCollector: 'Kreditors identitet',
        setAsPrincipalReferenceCaseVoucher: 'Sett som referansesaksbilag for hovedstol',
        setMaxTotalAmount: 'Sett maks. beløp',
        maxTotalAmount: 'Maks. beløp',
        selectCaseGroup: 'Velg saksgruppe',
        addNewTemplate: 'Legg til mal',
        addNewTemplateSubheading: 'Legg til en ny mal',
        timespan: 'Tidsrom',
        timespanUnit: 'Tidsromsenhet',
        timespanUnitQuantity: 'Tidsrom',
        timeOfDay: 'Tid på dagen',
        moreThan: 'Mer enn',
        updateIsActive: 'Oppgaver skal være aktive',
        onlySpecificDocumentTypes: 'Kun bestemte dokumenttyper',
        onlyOpenRegistries: 'Kun åpne registreringer',
        noSelectedRegistryNeverFulfilledWarning: 'Ingen registre valgt, dette kravet vil aldri bli oppfylt.',
        noSelectedRegistryAlwaysFulfilledWarning: 'Ingen registre valgt, dette kravet vil alltid være oppfylt.',
        propertySingleLineTextOneOfFollowingStrings: 'Er én av følgende tekststrenger (kommaseparert)',
        propertyDropdownOneOfFollowingValues: 'Er én av følgende',
        thresholdAmount: 'Beløp',
        caseGroup: 'Saksgruppe',
        percentageSplitFrom: 'Prosentvis fordeling fra',
        percentageSplitTo: 'Prosentvis fordeling til',
        selectedCreditor: 'Kreditor',
        onlySelectedVoucherCategories: 'Kun valgte bilagskategorier',
        noRequirements: 'Ingen krav',
        infoModalHeading: 'Innstillinger for arbeidsflyt',
        title: 'Tittel',
        description: 'Beskrivelse',
        endCaseIfThereIsNoDebt: 'Avslutt sak hvis det ikke er gjeld igjen',
        endCaseIfThereIsNoDebtDesc: 'Hvis ingen avslutningsårsak er valgt, fortsetter saken bare.',
        selectEndReason: 'Avslutningsårsak',
        newWorkflow: 'Ny arbeidsflyt',
        createNewWorkflow: 'Opprett arbeidsflyt',
        duplicateWorkflow: 'Dupliser arbeidsflyt',
        deleteWorkflow: 'Slett arbeidsflyt',
        deleteWorkflowConfirm: 'Er du sikker på at du vil slette denne arbeidsflyten?',
        endedCasesPercentage: 'avsluttede saker',
        casesInTask: 'saker i status',
        task: 'Oppgave',
        remind: 'Påminn',
        remindCase: 'Skal oppdateringen legges til saken som en påminnelse?',
        pause: 'Pause',
        pauseCase: 'Skal saken settes på pause?',
        pauseUnlimited: 'Krev manuell fortsettelse',
        remindNow: 'Påminn nå',
        stats: 'Statistikk',
        endedCases: 'Avsluttede saker',
        sum: 'Sum',
        totalCases: 'Totalt antall saker som har vært i denne statusen',
        currentCases: 'Saker som for øyeblikket er i denne statusen',
        incomingInteractionsStats: 'Innkommende interaksjoner',
        paymentPlansCreatedStats: 'Betalingsplaner opprettet',
        satisfactionStats: 'Omdømme',
        alternativePaths: 'Alternative stier',
        alternativePath: 'Alternativ sti',
        addAlternativePath: 'Legg til alternativ sti',
        source: 'Fra oppgave-id',
        mergeCaseTodoDescription: 'Saken vil bli forsøkt slått sammen med andre saker på kunden basert på reglene for sammenslåing. Det er også mulig å slå sammen saken med relaterte saker basert på relasjonstypene valgt nedenfor.',
        mergeWithRelatedCasesOfType: 'Mulighet for å slå sammen med relaterte saker med relasjonstyper',
        applyCustomMergeRules: 'Egendefinerte regler for sammenslåing av saker',
        settings: {
            workflowSettings: 'Innstillinger for arbeidsflyt',
            tenantDefaultsDescription: 'Nye saker starter i denne arbeidsflyten. Den kan overstyres for bestemte saksgrupper og den enkelte kreditor.',
            creditorDefaultsDescription: 'Nye saker for denne kreditoren starter i denne arbeidsflyten. Tomme valg følger organisasjonens innstillinger.',
            caseGroupDefaults: 'Unntak per saksgruppe',
            caseGroupDefaultsDescription: 'Bruk en annen arbeidsflyt for bestemte saksgrupper. Den har forrang fremfor standardarbeidsflyten.',
            addCaseGroupDefault: 'Legg til unntak',
            noAvailableCaseGroups: 'Ingen ledige saksgrupper. Du kan velge én arbeidsflyt per saksgruppe. Opprett flere saksgrupper for å legge til flere unntak.',
            newCaseGroupDefault: 'Nytt unntak',
            newCasesOnly: 'Endringer gjelder bare nye saker.',
            executionSettings: 'Kjøring av arbeidsflyter',
            defaultWorkflow: 'Standardarbeidsflyt',
            disableWorkflows: 'Deaktiver arbeidsflyter',
            disableWorkflowsWarning: 'Er du sikker på at du vil deaktivere ALLE arbeidsflyter?',
            workflowsDisabled: 'Arbeidsflyter er deaktivert',
            limitExecutionInterval: 'Begrens tidsintervallet der arbeidsflyter kan kjøre',
        },
    },
    timingTypes: {
        [TimingType.Timespan]: 'Tidsrom',
        [TimingType.TimespanFromDueDate]: 'Tidsrom fra nyeste forfallsdato',
    },
    updatesEditor: {
        update: 'Oppgave',
        information: 'Informasjon',
        informationDescription: 'Arbeidsflyter som oppgaven legges til i.',
        standardSettings: 'Generelt',
        standardSettingsDescription: 'Generelle innstillinger for denne oppgaven.',
        label: 'Etikett',
        save: 'Lagre',
        important: 'Viktig',
        importantPlaceholder: 'Denne oppgaven er viktig og bør fremheves på saken.',
        pausing: 'Pause',
        pausingPlaceholder: 'Denne oppgaven skal sette saken på pause',
        selectable: 'Valgbar',
        selectablePlaceholder: 'Denne oppgaven kan velges på en sak',
        procedure: 'Prosedyre',
        procedureDescription: 'Prosedyren som denne oppgaven skal utføre. Hvis den er slått på, vil den definerte prosedyren utføres hvis den er i en arbeidsflyt.',
        procedureOn: 'Slå på prosedyre for denne oppgaven',
        procedurePlaceholder: 'Slå på prosedyre',
        onCaseExit: 'Ved saksavslutning',
        onCaseExitDescription: 'Hvis en sak avsluttes med denne oppgaven, sett på en selvvalgt oppgave.',
        onCaseExitContinueUpdates: 'Skal oppgaver av denne typen fortsette når en sak avsluttes?',
        continueOnCaseExit: 'Fortsett ved saksavslutning',
        onCaseExitPauseWith: 'Ved saksavslutning, sett saken på pause med denne oppgaven',
        selectUpdateType: 'Oppdateringstype',
        roles: 'Roller',
        rolesDescription: 'Velg ansvarlig rolle',
        responsibleRole: 'Ansvarlig rolle',
        hiddenForCreditors: 'Skjult for kreditorer',
        hiddenForCreditorsPlaceholder: 'Skal denne oppgaven skjules for kreditorer?',
        introduction: 'Introduksjon',
        introductionDescription: 'Introduksjon til oppdateringen med tekst og eventuelt et bilde. Det er en fordel, hvis kreditor er ansvarlig, å lage en god introduksjon.',
        introductionHeaderImage: 'Hovedbilde',
        introductionHeaderImageDropText: 'Dra og slipp et hovedbilde her',
        deleteButton: 'Slett oppgave',
        deleteWarning: 'Du sletter både oppdateringstypen, men også alle oppdateringer av typen. Vil du fortsette?',
    },
    workflowTodoTypes: {
        [TodoType.AddVoucher]: 'Legg til bilag',
        [TodoType.AddBillingVoucher]: 'Legg til avregningsbilag',
        [TodoType.RemoveVoucher]: 'Fjern bilag',
        [TodoType.CreateInteraction]: 'Opprett interaksjon',
        [TodoType.CreateCreditorInteraction]: 'Opprett interaksjon til kreditor',
        [TodoType.CreateOtherInteraction]: 'Opprett interaksjon til annen',
        [TodoType.SetCollector]: 'Sett inkassobyrå',
        [TodoType.SetCaseGroup]: 'Sett saksgruppe',
        [TodoType.MoveToTenant]: 'Flytt sak til organisasjon',
        [TodoType.ChangeCaseStatus]: 'Endre saksstatus',
        [TodoType.OutboundCall]: 'Utgående anrop',
        [TodoType.SetCaseTag]: 'Legg til sakstagg',
        [TodoType.RemoveCaseTag]: 'Fjern sakstagg',
        [TodoType.DebtRegister]: 'Gjeldsregister',
        [TodoType.DebtRegisterSkip]: 'Klar til gjeldsregister?',
        [TodoType.SubmitToCourt]: 'Send til domstol',
        [TodoType.ReadyToSubmitToCourt]: 'Klar til å sende til domstol?',
        [TodoType.ConnectToDebtCollector]: 'Send til en connect-partner',
        [TodoType.ReturnToConnectSource]: 'Returner sak til connect-partner',
        [TodoType.SwitchWorkflow]: 'Bytt arbeidsflyt',
        [TodoType.SwitchBackToPreviousWorkflow]: 'Bytt tilbake til forrige arbeidsflyt',
        [TodoType.Bespoke]: 'Egendefinert',
        [TodoType.MergeCase]: 'Slå sammen sak hvis mulig',
        [TodoType.CreateProperties]: 'Opprett attributter',
        [TodoType.SetResponsible]: 'Sett ansvarlig på sak',
        [TodoType.MarkExpired]: 'Merk saksbilag som foreldet',
        [TodoType.SetCaseSetting]: 'Sett saksinnstilling',
    },
    workflowPathWarnings: {
        [PathWarning.ReadyForEboksRequirementRecommended]: 'Kravet "Klar for e-Boks" anbefales',
        [PathWarning.ValidEmailRequirementRecommended]: 'Kravet "E-post gyldig" anbefales',
        [PathWarning.ValidAddressRequirementRecommended]: 'Kravet "Adresse gyldig" anbefales',
    },
    workflowRequirementTypes: {
        [RequirementType.MissingUpdate]: 'Har ikke én av de valgte oppdateringene',
        [RequirementType.HasUpdate]: 'Har én av de valgte oppdateringene',
        [RequirementType.HasNoValidAddress]: 'Adresse ugyldig',
        [RequirementType.HasValidCentralRegisterId]: 'Har cvr / cpr',
        [RequirementType.HasNoValidCentralRegisterId]: 'Har ikke cvr / cpr',
        [RequirementType.HasValidAddress]: 'Adresse gyldig',
        [RequirementType.HasValidEmail]: 'E-post gyldig',
        [RequirementType.HasNoValidEmail]: 'E-post ugyldig',
        [RequirementType.IsCompany]: 'Er selskap',
        [RequirementType.ReadyForEInvoice]: 'Klar for e-faktura',
        [RequirementType.ReadyForEboks]: 'Klar for e-Boks',
        [RequirementType.DebtRemarks]: 'Betalingsanmerkninger',
        [RequirementType.HasValidPhone]: 'Telefon gyldig',
        [RequirementType.HasNoValidPhone]: 'Telefon ugyldig',
        [RequirementType.IsPrivate]: 'Er privatperson',
        [RequirementType.AmountThreshold]: 'Beløpsgrense',
        [RequirementType.CaseGroup]: 'Er én av saksgruppene',
        [RequirementType.PercentageSplit]: 'Prosentvise saker',
        [RequirementType.HasFoundation]: 'Har grunnlag',
        [RequirementType.DoesNotHaveFoundation]: 'Har ikke grunnlag',
        [RequirementType.SpecificCreditor]: 'Bestemt kreditor',
        [RequirementType.CustomerHasTag]: 'Kunde har tagg',
        [RequirementType.CaseHasTag]: 'Sak har tagg',
        [RequirementType.HasIncomingInteractions]: 'Har innkommende interaksjon',
        [RequirementType.CaseStatusIn]: 'Saksstatus er én av',
        [RequirementType.Property]: 'Regel basert på attributt',
        [RequirementType.InDebtRegister]: 'Registrert av oss i gjeldsregister',
        [RequirementType.NotInDebtRegister]: 'Ikke registrert av oss i gjeldsregister',
    },
    embeds: {
        embeds: 'Embed',
        embedTitle: 'Tittel på embed-område',
        embedURL: 'URL som skal kalles',
        embedHeight: 'Høyde på område i px',
        addEmbedArea: 'Legg til embed-område',
        embedPlacement: 'Plassering',
        embedToken: 'Valideringstoken',
        embedCreatedAt: 'Opprettet',
        noAreasYet: 'Ingen embed-områder ennå',
        couldNotLoad: 'Kunne ikke laste',
        caseworkerNavMenuItemCategory: 'Eksternt',
        creditorNavMenuItemCategory: 'Eksternt',
        calledWithDescription: 'URL-en kalles med en GET-forespørsel med følgende query-parametre og headers',
        header: 'Header',
    },
    embedPlacements: {
        [EmbedPlacement.CaseworkerWebCreditorPage]: 'Debbie Caseworker Web: Kreditorside øverst til høyre',
        [EmbedPlacement.CaseworkerWebCasePage]: 'Debbie Caseworker Web: Sakside under økonomipanelet',
        [EmbedPlacement.CaseworkerWebMenuItem]: 'Debbie Caseworker Web: Full side med lenke i menyen til høyre',
        [EmbedPlacement.CreditorWebCasePage]: 'Debbie Creditor Web: Sakside under økonomipanelet',
        [EmbedPlacement.CreditorWebFrontPage]: 'Debbie Creditor Web: Forside til høyre',
        [EmbedPlacement.CreditorWebMenuItem]: 'Debbie Creditor Web: Full side med lenke i menyen til høyre',
    },
    webhookSettings: {
        noWebhooksYet: 'Ingen webhooks ennå',
        hookNotFound: 'Den tilknyttede webhook-konfigurasjonen kunne ikke finnes. Kontroller at du er på riktig organisasjon.',
        failedToLoad: 'Kunne ikke laste webhook-detaljer. Prøv igjen senere.',
        webhook: 'Webhook',
        webhooks: 'Webhooks',
        columnEvent: 'Hendelse',
        columnWebhook: 'Webhook',
        columnUrl: 'URL',
        columnDate: 'Dato',
        columnState: 'Status',
        stateAwaiting: 'Venter',
        statePermanentlyFailed: 'Permanent feilet',
        stateSucceeded: 'Fullført',
        namePlaceholder: 'Navn på webhook',
        urlPlaceholder: 'Webhook-URL',
        emailPlaceholder: 'E-post for feilvarsler',
        requestHeaders: 'Request headers',
        otherSettings: 'Andre innstillinger',
        deepFlatten: 'Flat ut request body for å unngå nøstede JSON-objekter',
        pullWebhooks: 'Pull webhooks',
        advancedSettings: 'AVANSERTE INNSTILLINGER',
        addWebhook: 'Legg til webhook',
        pullWebhook: 'Pull webhook',
        verificationToken: 'Verifiseringstoken',
        headerKeyPlaceholder: 'Header-nøkkel',
        headerValuePlaceholder: 'Header-verdi',
        addHeader: 'Legg til header',
        eventDate: 'Hendelsesdato',
        headers: 'Headers',
        body: 'Body',
        bodyMapping: 'Body-mapping',
        resendWebhook: 'Send webhook på nytt',
        attempts: 'Forsøk',
        nextAttemptAt: 'Neste forsøk:',
        attemptSuccess: 'Fullført',
        attemptFailed: 'Feilet',
        copy: 'KOPIER',
        columnCreditor: 'Kreditor',
        allCreditors: 'Alle kreditorer',
    },
    userOverrideSettings: {
        label: 'Skyldneroverstyringer',
        description: 'Du kan bruke skyldneroverstyringer til automatisk å endre informasjon for kunder som oppfyller bestemte kriterier. Når en kunde som oppfyller disse kriteriene oppdateres, blir de valgte feltene automatisk erstattet med innstillingene du har angitt.',
        whenMatching: 'Når en skyldner samsvarer',
        overrideFields: 'Overstyr felter',
        deleteEmail: 'Fjern e-post',
    },
    apiSettings: {
        documentation: 'API-dokumentasjon',
        keys: 'API-nøkler',
        noKeysYet: 'Det finnes ingen nøkler ennå',
        newKeyButton: 'Opprett ny API-nøkkel',
        newKey: 'Ny API-nøkkel',
        newKeyCreatedInfo: 'Det var det! Husk å oppbevare nøkkelen din på et trygt sted. Dette er første og siste gang du kan hente den fra Debbie.',
        closeModal: 'Forstått',
        keyName: 'Gi API-nøkkelen din et navn',
        createNewKey: 'Opprett ny API-nøkkel',
    },
    updateTypeSettings: {
        label: 'Etikett',
        responsibleRole: 'Ansvarlig rolle',
        isImportant: 'Viktig',
        tenantSpecific: 'Organisasjonsspesifikk',
        isTenantSpecific: 'Er organisasjonsspesifikk',
        referenceType: 'Referansetype',
        onCaseExit: 'Ved saksavslutning pause med',
        isPausing: 'Setter på pause',
        hiddenForRoles: 'Skjult for rolle',
        knowledgeBaseLink: 'Kunnskapsbase',
        deadlineTitle: 'Frist',
        deadlineDescription: 'Antall dager en oppgave av denne typen kan stå på oppgavelisten før fristen regnes som overskredet. La feltet stå tomt hvis det ikke skal være noen frist.',
        deadlinePlaceholder: 'F.eks. 7',
        deadlineSave: 'Lagre',
    },
    overview: {
        todoList: 'Gjøremålsliste',
        noDescription: 'Ingen beskrivelse',
        noPauseStatus: 'Ingen pausestatus',
        settlementTime: 'Avslutningstid i måneder',
        instalmentAgreement: 'Avdragsavtale',
        statistics: 'Statistikk',
        averageIntro: 'Det tar i gjennomsnitt',
        averageOutro: 'dager før en sak avsluttes.',
        quantityCases: 'Antall saker',
        quantifyCustomers: 'Antall kunder',
        statusDistribution: 'Statusfordeling',
        chartStatuses: {
            Godkendt: 'Godkjent',
            'Afventer Godkendelse': 'Venter på godkjenning',
            Afsluttet: 'Avsluttet',
            Annuleret: 'Annullert',
            Afslutningsårsag: 'Avslutningsårsak',
        },
    },
    endReason: {
        [SystemEndReason.ErrorCreditor]: 'Feil fra kreditor',
        [SystemEndReason.ErrorUs]: 'Feil opprettelse',
        [SystemEndReason.Expiration]: 'Saken er utløpt',
        [SystemEndReason.Departed]: 'Skyldner har flyttet/reist',
        [SystemEndReason.Unidentified]: 'Skyldner kan ikke valideres',
        [SystemEndReason.AddressUnknown]: 'Skyldners adresse er ukjent',
        [SystemEndReason.Paid]: 'Skyldner har betalt hele gjelden',
        [SystemEndReason.Transferred]: 'Saken er overført',
        [SystemEndReason.Dead]: 'Skyldner har gått bort',
        [SystemEndReason.Objection]: 'Avsluttet på grunn av innsigelse',
        [SystemEndReason.Withdrawn]: 'Kreditor har trukket saken tilbake',
        [SystemEndReason.OfferFromUs]: 'Betalt i henhold til akkordtilbud fra oss',
        [SystemEndReason.OfferFromDebtor]: 'Betalt i henhold til akkordtilbud fra skyldner',
        [SystemEndReason.DebtRelief]: 'Skyldner har fått gjeldssanering',
        [SystemEndReason.Bankruptcy]: 'Skyldner er konkurs',
        [SystemEndReason.ForcedDissolved]: 'Skyldner er tvangsoppløst',
        [SystemEndReason.ConflictOfInterest]: 'Interessekonflikt mellom skyldner og oss',
        [SystemEndReason.NegativePayoff]: 'Negativt utfall for kreditor',
        [SystemEndReason.Overpayment]: 'Skyldner har betalt for mye',
        [SystemEndReason.Minor]: 'Skyldner er mindreårig',
        [SystemEndReason.Irrecoverable]: 'Saken er uinndrivelig',
        [SystemEndReason.PartiallyPaid]: 'Delvis betalt',
        [SystemEndReason.CreditorUnresponsive]: 'Kreditor svarer ikke',
        [SystemEndReason.Merged]: 'Saken er slått sammen',
        [SystemEndReason.FireAndForget]: 'Fire & forget',
        [SystemEndReason.SmallCaseNotWanted]: 'Liten sak ikke ønsket',
        [SystemEndReason.NoDebt]: 'Ingen gjeld',
        [SystemEndReason.Deleted]: 'Slettet',
        [SystemEndReason.NoCourt]: 'Saken er gjennom utenrettslig behandling',
        [SystemEndReason.Other]: 'Annen årsak',
    },
    courtSubmitErrors: {
        [SubmitToCourtError.IsNotWarned]: 'Saken er ikke varslet',
        [SubmitToCourtError.CurrencyNotDKK]: 'Valuta er ikke DKK',
        [SubmitToCourtError.WarningWasReturned]: 'Varsel ikke levert',
        [SubmitToCourtError.AlreadyHasFoundation]: 'Et tvangsgrunnlag er allerede registrert på denne saken',
        [SubmitToCourtError.MoreThanOneDebtor]: 'Det er mer enn én skyldner på denne saken',
        [SubmitToCourtError.HasAlternativeContact]: 'Saken har alternativ kontakt',
        [SubmitToCourtError.EconomyContactMissing]: 'En betalingsansvarlig for retten mangler',
        [SubmitToCourtError.CreditorNameMissing]: 'Kreditornavn mangler',
        [SubmitToCourtError.CreditorAddressMissing]: 'Kreditoradresse mangler',
        [SubmitToCourtError.CompanyFullResponsibleParticipantMissing]: '«Fullt ansvarlig deltaker» mangler',
        [SubmitToCourtError.CompanyDirectorNameMissing]: 'Navn på direktør mangler',
        [SubmitToCourtError.CompanyDirectorAddressMissing]: 'Adresse til direktør mangler',
        [SubmitToCourtError.JurisdictionMissing]: 'Kunne ikke finne domstol',
        [SubmitToCourtError.EconomicalSubmitThreshold]: 'Saksbalansen er lavere enn terskelverdien',
        [SubmitToCourtError.SagsfremstillingMissing]: 'Saksfremstilling mangler',
        [SubmitToCourtError.CaseHasExceededMaxDebtRegistrationsThreshold]: 'Saken har overskredet kreditors maksgrense for gjeldsregistreringer',
        [SubmitToCourtError.AlreadyInCourt]: 'Allerede registrert hos domstolen',
        [SubmitToCourtError.AddressNotInDK]: 'Adresse er ikke dansk',
        [SubmitToCourtError.DebtorMovedAbroad]: 'Skyldner har flyttet til utlandet',
        [SubmitToCourtError.CaseHasDeposits]: 'Saken har depositum',
        [SubmitToCourtError.DebtorBankrupt]: 'Skyldner er konkurs',
        [SubmitToCourtError.DebtorCompanyCeased]: 'Skyldnerselskap er opphørt',
        [SubmitToCourtError.DebtorDead]: 'Skyldner er død',
        [SubmitToCourtError.DebtorHomeless]: 'Skyldner er bostedsløs',
        [SubmitToCourtError.ExcessiveReminderFeeImposed]: 'For mange purregebyrer ilagt',
        [SubmitToCourtError.ExcessiveCollectionFeeImposed]: 'For mange inkassosalærer ilagt',
        [SubmitToCourtError.ExcessiveCollectionCostImposed]: 'Inkassoomkostningene stemmer ikke med det beregnede beløpet',
        [SubmitToCourtError.ExcessivePrincipal]: 'Hovedstolen er over det maksimalt tillatte',
        [SubmitToCourtError.IsNotDebtor]: 'Den valgte kontaktpersonen er en representant',
    },
    templateTags: {
        [TemplateTag.BPKWarning]: 'Varsel til Namsmannen',
        [TemplateTag.DebtRegistrationWarning]: 'RKI-varsel',
    },
    templates: {
        allTemplates: 'Alle maler',
        searchTemplates: 'Søk maler',
        customTemplates: 'Opprettede maler',
        standardTemplates: 'Standardmaler',
        confirmDelete: 'Er du sikker på at du vil slette denne malen?',
        delete: 'Slett',
        updateTypesUsingThisTemplate: 'Oppgaver som bruker denne malen',
        newTemplate: 'Ny mal',
        selectType: 'Velg type',
        letter: 'Brev',
        name: 'Navn',
        create: 'Opprett',
        quantityTemplates: 'Antall maler',
        singleOwner: 'Velg én enkelt eier',
        standard: 'Standard',
        alternativeContact: 'Alternativ kontakt',
        saveDraft: 'Lagre utkast',
        saveAndPublish: 'Lagre og publiser',
        preview: 'Forhåndsvisning',
        versions: 'Versjoner',
        publish: 'Publiser',
        copyOtherTemplate: 'Importer fra mal',
        copy: 'Kopier mal',
        settings: 'Innstillinger',
        lastChangedOn: 'Sist endret',
        by: 'av',
        WIP: 'Under arbeid',
        versionPublished: 'Denne versjonen er publisert',
        selectTestCase: 'Velg en testsak',
        collector: 'Inkassobyrå',
        ifCollectorSelected: 'Hvis valgt vil denne malen kun vises på saker med inkassobyrået.',
        selectCollector: 'Velg inkassobyrå',
        creditor: 'Kreditor',
        ifCreditorSelected: 'Hvis valgt vil denne malen kun vises på saker med kreditoren.',
        selectCreditor: 'Velg kreditor',
        letterTheme: 'Brevtema',
        ifThemeSelected: 'Dette velger designet til malen.',
        selectTheme: 'Velg maltema',
        fileName: 'Filnavn',
        docxTemplate: 'Word-mal (.docx)',
        docxTemplateDescription: 'Last opp et Word-dokument som brevet skal genereres fra. Sett inn {~~body} der innholdet fra rik-tekst-editoren skal vises (HTML gjengis via docxtemplater HTML-modulen). Andre plassholdere (f.eks. {customer.name}) fylles inn fra saksdata.',
        uploadDocxTemplate: 'Last opp .docx',
        removeDocxTemplate: 'Fjern .docx-mal',
        docxTemplateUploaded: 'Word-mal lastet opp',
        docxTemplateUploadFailed: 'Kunne ikke laste opp Word-mal',
        docxAvailableTags: 'Tilgjengelige maltagger',
        docxAvailableTagsDescription: 'Klikk på en tagg for å kopiere den. Lim inn i Word-malen der du vil at verdien skal vises.',
        docxTag: 'Tagg',
        docxBodyTagDescription: 'Sett inn innholdet fra rik-tekst-editoren her (gjengis som HTML).',
        docxConditionalBadge: 'Betinget',
        docxConditionalIfTrue: 'Hvis sant',
        docxConditionalIfFalse: 'Hvis usant',
        docxConditionalDescription: 'Bruk den første blokken for å vise innhold når feltet er sant, og den andre blokken når det er usant. Kopier bare den blokken du trenger — begge kan brukes sammen hvis du ønsker ulikt innhold for begge tilfeller.',
        docxHtmlDescription: 'Verdien inneholder HTML og gjengis som formatert tekst (linjeskift, fet skrift osv. bevares).',
        state: 'Tilstand',
        type: 'Type',
        savedAt: 'Lagret',
        firstName: 'Fornavn',
        lastName: 'Etternavn',
        view: 'Vis',
        confirmDeleteItem: 'Er du sikker på at du vil slette dette elementet?',
        confirmPublish: 'Endringer er IKKE lagret. Du er i ferd med å publisere den sist lagrede versjonen av malen. Er du sikker?',
        validations: {
            missing: 'Mangler',
            invalidOrder: 'Ugyldig rekkefølge',
            inSubject: 'i emnet',
            inBody: 'i teksten',
        },
        addTag: 'Legg til tagg',
        selectTag: 'Velg tagg',
    },
    templateTypes: {
        [TemplateType.AUTOCALL]: 'Autocall',
        [TemplateType.EBOKS]: 'e-Boks',
        [TemplateType.KIVRA]: 'Kivra',
        [TemplateType.DIGIPOST]: 'Digipost',
        [TemplateType.EMAIL]: 'E-post',
        [TemplateType.LETTER]: 'Brev',
        [TemplateType.SMS]: 'SMS',
    },
    integrations: {
        chooseCreditor: 'Velg kreditor for integrasjon',
        active: 'Aktiv',
        activeIntegrations: 'Aktive integrasjoner',
        available: 'Integrasjoner tilgjengelig for kreditor',
        unavailable: 'Integrasjoner utilgjengelig for kreditor',
        isAvailable: 'Gi kreditor tilgang til å sette opp eller deaktivere integrasjon',
        connect: 'Koble til',
        deactivate: 'Sett integrasjon på pause',
        reactivate: 'Reaktiver',
        integrationOptions: 'integrasjonsvalg',
        importAllText: 'Importer fakturaer før forfallsdato',
        updateCustomers: 'Oppdater kundedata når de endres i e-conomic',
        cutoffDateText: 'Skjæringsdato (Importer kun fakturaer etter denne datoen, importerer alle hvis ikke satt)',
        runsOut: '',
        turnsDue: '',
        invoiceDate: 'Antall dager etter fakturadatoen posteringene skal overføres',
        dueDate: 'Antall dager etter fakturaens forfallsdato posteringene skal overføres',
        notChangable: 'Valgene kan ikke endres igjen senere.',
        all: 'Alle',
        recommended: 'Anbefalt',
        essential: 'Essensiell',
        additionalCustomers: 'ytterligere kunder',
    },
    eConomicTypeName: {
        creditNote: 'Kreditnota',
        invoice: 'Faktura',
        payment: 'Betaling',
        reminder: 'Purring',
    },
    integrationMapper: {
        voucherNumber: 'Bilagsnummer',
        invoiceNumber: 'Fakturanummer',
        amountLeftToMap: 'Beløp igjen å tilordne',
        totalAmount: 'Bilagsbeløp',
        noMoreEntries: 'Det er ingen flere oppføringer å tilordne',
        selectEntries: 'Velg en oppføring for å begynne tilordningen',
        customerId: 'Kunde-id',
        map: 'Tilordne',
        notAvailable: 'E-conomic-tilordning er ikke tilgjengelig ennå, kontakt Debbie-support for hjelp med tilordning',
        selectedEntryLabel: 'Valgt oppføring uten tilordning',
        potentialMatches: 'Potensielle treff',
    },
    createdBy: {
        createdBy: 'Opprettet av',
        goToImport: 'Gå til import',
    },
    createdByType: {
        [PerformedByType.Connect]: 'connect',
        [PerformedByType.Import]: 'import',
        [PerformedByType.Integration]: 'integrasjon',
        [PerformedByType.Key]: 'API-nøkkel',
        [PerformedByType.User]: 'bruker',
        [PerformedByType.Workflow]: 'arbeidsflyt',
        [PerformedByType.Trigger]: 'utløser',
        [PerformedByType.VoucherApplication]: 'regelbasert bilag',
        [PerformedByType.BulkAction]: 'masseoperasjon',
        [PerformedByType.UpdateTypeOnCaseEnd]: 'oppdateringstype ved saksavslutning',
        [PerformedByType.InteractionCategory]: 'interaksjonskategori',
        [PerformedByType.AI]: 'AI',
        [PerformedByType.PaymentPlan]: 'betalingsplan',
        [PerformedByType.System]: 'system',
    },
    createdByTypeLabel: {
        [PerformedByType.PaymentPlan]: 'bp',
    },
    journalizer: {
        update: 'Oppdater',
        deleteInteraction: 'Slett interaksjon',
        unknownEntityInteraction: 'Be om journalnummer',
        recentlyJournalized: 'NYLIG JOURNALFØRT',
        unmap: 'FJERN TILORDNING',
        suggested: 'FORESLÅTT',
        noInteractions: 'Det finnes for øyeblikket ingen interaksjoner',
        searchCreditors: 'Søk kreditorer...',
        journalizeOnCase: 'Journalfør på sak',
        journalizeOnCreditor: 'Journalfør på kreditor',
    },
    returnLetter: {
        unknownAtAddress: 'Ukjent mottaker',
        addressNotAdequate: 'Adressen er utilstrekkelig',
        nameNotVisible: 'Mottakerens navn er ikke synlig på postkassen',
        recipientMoved: 'Mottakeren har flyttet og den nye adressen er ukjent, eller det er problemer knyttet til flyttingen',
        recipientNoExist: 'Mottakeren finnes ikke',
        letterCantBeDelivered: 'Brevet kan ikke leveres',
        cantFindStreet: 'Gatenavn/husnummer kan ikke finnes',
        mailboxIssue: 'Problemer med postkassen',
        emptyPlace: 'Boligen er ubebodd/tomt hus/leilighet',
        noHouseOrConstruction: 'Det finnes ingen bolig, eller den er under bygging',
        otherIssues: 'Problemer som manglende snørydding eller andre forhold som hindrer adkomst',
        deliveryRejected: 'Levering avvist',
        recipientRejectsLetter: 'Mottakeren avviser leveringen og godtar ikke å motta brevet',
    },
    returnLetterReasons: {
        [ReturnReason.DENIED]: 'Avvist',
        [ReturnReason.NOTDELIVERABLE]: 'Kan ikke leveres ',
        [ReturnReason.UNKNOWNRECIPIENT]: 'Ukjent mottaker',
    },
    outbox: {
        verifyInteraction: 'Verifiser interaksjon',
        editTemplate: 'Rediger mal',
        deleteInteraction: 'Slett interaksjon',
        rollbackChain: 'Tilbakestill arbeidsflyt',
        goToCase: 'Gå til sak',
        envelope: 'Konvolutt',
        nextLetterSending: 'Neste brevutsendelse planlagt til',
        filters: 'Filtre',
        includeInteractionsPaused: 'Inkluder interaksjoner på saker satt på pause',
        aiFilterHeader: 'AI',
        aiFilterAll: 'Alle',
        aiFilterAi: 'AI',
        aiFilterNoAi: 'Ingen AI',
        filterOnInteractionType: 'Filtrer på typer interaksjoner',
        filterOnCreditor: 'Filtrer på kreditor',
        filterOnTemplate: 'Filtrer på mal',
        autoSendModalHeader: 'Sett opp automatisk utsendelse',
        autoSendDescription: 'Angi hvor mange manuelle utsendelser som må gjøres fra utboksen for hver malversjon før meldinger sendes automatisk. Hvis du setter verdien til 0, sendes alle meldinger automatisk uten å kreve godkjenning. Dette gir fleksibilitet mellom full automatisering og manuell kontroll—avhengig av dine behov.',
        configureAutoSend: 'Sett opp automatisk utsendelse',
        autoSendOn: 'Når {{autoSendQuantity}} meldinger med denne malversjonen er sendt, vil alle fremtidige meldinger bli sendt automatisk.',
    },
    inputs: {
        creditorSelect: 'Velg kreditor',
        from: 'Fra',
        to: 'Til',
        max: 'Maks.',
        min: 'Min.',
        phoneNumber: 'Telefonnummer',
        phoneLocale: 'Region',
        searchForCompany: 'Søk selskaper',
        search: 'Søk',
        noResults: 'Ingen resultater',
        recentlyUsed: 'Sist brukte',
        clear: 'Tøm',
        searchAddress: 'Søk adresse',
        manual: 'Manuell',
        address: 'Adresse',
        noAddress: 'Ingen adresse',
        co: 'C/O',
        zipcode: 'Postnummer',
        city: 'By',
        country: 'Land',
        done: 'Ferdig',
        removeAddress: 'Fjern adresse',
        remove: 'Fjern',
        save: 'Lagre',
        saved: 'Lagret',
        dropToUpload: 'Slipp for å laste opp',
        uploadFailed: 'Opplasting mislyktes',
        overrideDefault: 'Overstyr standardverdi',
        overrideTenantSetting: 'Overstyr organisasjonsinnstilling',
    },
    paymentOptions: {
        addNew: 'Legg til ny betalingsmulighet',
        currencies: 'Valutaer',
        bankName: 'Bankens navn',
        registrationNumber: 'Registreringsnummer',
        accountNumber: 'Kontonummer',
        fi: 'FIK-kreditornummer',
        fikSyntax: 'Bruk hovedstolsposteringens referansenummer som id i stedet for saksnummer',
        useAlternativeCreditorNumberInCaseVoucherTables: 'Bruk alternativt kreditornummer i saksposteringstabeller',
        iban: 'IBAN-kreditornummer',
        swift: 'SWIFT-kreditornummer',
        reepayPrivateKey: 'Frisbii privat API-nøkkel',
        farpayPrivateKey: 'Farpay privat API-nøkkel',
        dankort: 'Dankort',
        visa: 'Visa',
        mastercard: 'Mastercard',
        currencySpecific: 'Kun valgte valutaer',
        mobilepay: 'MobilePay',
        swish: 'Swish',
        vipps: 'Vipps',
        betalingsservice: 'Betalingsservice',
        leverandorservice: 'Leverandørservice',
        isActive: 'Aktiv betalingsløsning',
        confirmChangeOfPaymentGateway: 'Er du sikker på at du vil endre betalingsløsningen din?',
        mobilePeopleHmac: 'MobilePeople HMAC',
        mobilePeopleClientRef: 'MobilePeople Client Reference',
        url: 'Lenke til betalingsløsning',
        titleToDebtor: 'Skyldnerweb-tittel',
        descriptionToDebtor: 'Skyldnerweb-beskrivelse',
        hideOnDebtorweb: 'Skjul på skyldnerweb',
    },
    paymentOptionTypes: {
        [PaymentOptionType.BANKTRANSFER]: 'Bankoverføring',
        [PaymentOptionType.FI]: 'FIK-linje',
        [PaymentOptionType.SWIFT]: 'SWIFT',
        [PaymentOptionType.REEPAY]: 'Frisbii betalingsløsning',
        [PaymentOptionType.FARPAY]: 'Farpay betalingsløsning',
        [PaymentOptionType.MOBILE_PEOPLE]: 'MobilePeople betalingsløsning',
        [PaymentOptionType.LINK_TO_OWN_PAYMENT]: 'Lenke til egen betalingsløsning',
    },
    todoPanel: {
        searchTodos: 'Søk',
        overdueTooltip: (count) => `${count} ${count === 1 ? 'oppgave har' : 'oppgaver har'} overskredet fristen`,
    },
    support: {
        imgsrc: 'https://storage.googleapis.com/debbie-public-files/help-ad-en.svg',
        readMore: 'Les mer',
    },
    home: {
        welcome: 'Velkommen',
        todos: 'Gjøremål',
        caseworkerTodo: 'Saksbehandlers gjøremål',
        todoPlaceholder: 'Ingenting å vise',
        clientTodo: 'Kreditors gjøremål',
        clientTodoPlaceholder: 'Ingenting å vise',
        noResponsibleTodo: 'Gjøremål uten ansvarlig',
        noResponsibleTodoPlaceholder: 'Ingenting å vise',
        pendingCases: 'Ventende saker',
        pendingCasesPlaceholder: 'Ingen ventende saker å vise',
        pendingDunningCases: 'Nye purresaker',
        pendingDunningCasesPlaceholder: 'Ingen nye purresaker å vise',
        topCases: 'Topp 150 saker etter gjeldsbeløp',
        topCasesPlaceholder: 'Ingen sak å vise',
        unassigned: 'Ikke tildelt',
        today: 'I dag',
        yesterday: 'I går',
        thisMonth: 'Denne måneden',
        lastMonth: 'Forrige måned',
        deposits: 'Innbetalinger',
        depositsSmall: 'innbetalinger',
        depositsToClient: 'Innbetalinger til kreditor',
        depositsToCollector: 'Innbetalinger til inkassobyrå',
        depositCount: 'Antall innbetalinger',
        paymentPlans: 'Betalingsplaner',
        totalPlans: 'Totalt antall planer',
        totalActivePlans: 'Aktive planer',
        totalSettledAmount: 'Totalt oppgjort beløp',
        settledAmountLastMonth: 'Oppgjort beløp forrige måned',
        settledAmountThisMonth: 'Oppgjort beløp denne måneden',
        plannedAmountNextMonth: 'Planlagt beløp neste måned',
        cases: 'Saker',
        interactions: 'Interaksjoner',
        foundations: 'Fundamenter',
        totalFoundations: 'Totalt antall fundamenter',
    },
    autoCall: {
        called: 'Til',
        from: 'Fra',
        with: 'med',
        withVoice: 's stemme',
        call: 'Ring',
        addAction: 'Legg til handling',
        selectAction: 'Velg handling',
    },
    autoCallEvents: {
        started: 'Startet',
        ringing: 'Ringer',
        answered: 'Besvart',
        completed: 'Fullført',
        inbound: 'Innkommende',
        busy: 'Opptatt',
        timeout: 'Ikke besvart',
        rejected: 'Avvist',
        machine: 'Telefonsvarer',
    },
    interactionTypes: {
        [InteractionType.AutoCall]: 'Autoanrop',
        [InteractionType.ClientNote]: 'Kreditormelding',
        [InteractionType.DebtorNote]: 'Skyldnermelding',
        [InteractionType.Eboks]: 'e-Boks',
        [InteractionType.Kivra]: 'Kivra',
        [InteractionType.Digipost]: 'Digipost',
        [InteractionType.Email]: 'E-post',
        [InteractionType.Letter]: 'Brev',
        [InteractionType.Note]: 'Notat',
        [InteractionType.Other]: 'Annet',
        [InteractionType.Personal]: 'Personlig',
        [InteractionType.Phone]: 'Anrop',
        [InteractionType.SMS]: 'SMS',
        [InteractionType.EInvoice]: 'E-faktura',
    },
    interactions: {
        interaction: 'interaksjon',
        metadata: 'Metadata',
        removingPhoneNumberOnSubmit: 'Når telefonsamtalen registreres, slettes telefonnummeret fra skyldneren.',
        events: 'Hendelser',
        sendLetter: 'Send brev',
        addTemplate: 'Legg til fra mal',
        sendEBoks: 'Send',
        from: 'Fra',
        to: 'Til',
        subject: 'Emne',
        sent: 'Sendt',
        debtorInteraction: 'Melding',
        newInteractions: 'Nye interaksjoner',
        courtEmailSubject: 'Sak hos {{collector.name}}: {{tribunal.latestReferenceId}} [saksnr.: {{journalNumber}}]',
        emailSubjectMessageFrom: 'Melding fra',
        areYouSureProcedure: 'Er du sikker på at du vil utføre denne snarveien?',
        procedures: 'Snarveier',
        reminder: 'Purring',
        unlikelyToReceive: 'Tidligere interaksjoner via denne kanalen mislyktes',
        removeMarking: 'Fjern markering',
        attachment: 'vedlegg',
        other: 'Annet',
        OUTGOING: 'Utgående',
        INCOMING: 'Innkommende',
        UNMAPPED: 'Ikke tilordnet',
        MAPPED: 'Tilordnet',
        HANDLED: 'Behandlet',
        DELETED: 'Slettet',
        PENDING: 'Venter',
        CANCELLED: 'Avbrutt',
        SENT: 'Sendt',
        QUEUED: 'I kø',
        delete: 'Slett',
        verify: 'Verifiser',
        transacted: 'Sendt',
        journalizedAt: 'Journalført',
        at: 'kl.',
        journaled: 'Interaksjonen ble journalført',
        unjournaled: 'Interaksjonen ble avjournalført',
        journaledBy: 'Journalført av',
        unjournaledBy: 'Avjournalført av',
        onCase: 'På sak',
        copiedBy: 'Kopiert av',
        toCase: 'Til sak',
        fromCase: 'Fra sak',
        rollback: 'Tilbakestill',
        unmap: 'Fjern tilordning',
        editTemplate: 'Rediger mal',
        envelope: 'Konvolutt',
        readMore: 'Les mer',
        readLess: 'Les mindre',
        downloadFailed: 'Nedlasting mislyktes',
        downloadSuccessful: 'Forhåndsvisnings-PDF er lastet ned',
        selectTemplate: 'Velg mal',
        contact: 'Kontakt',
        preview: 'Forhåndsvisning',
        mention: 'Flettefelt',
        explanation: 'Forklaring',
        example: 'Eksempel',
        addDebtorDocuments: 'Legg til skyldnerdokumenter',
        addIntent: 'Legg til hensikt',
        sendEmail: 'Send e-post',
        reply: 'Svar',
        replyingTo: 'Svarer på',
        thread: 'Vis tråd',
        emailThread: 'E-posttråd',
        note: 'Notat',
        addNote: 'Legg til notat',
        sendNoteToDebtor: 'Send notat til skyldner',
        sendNoteToClient: 'Send notat til kreditor',
        addFiles: 'Legg til filer',
        remindingDescription: 'Beskrivelse av påminnelse',
        remindingDate: 'Påminnelsesdato',
        setReminder: 'Angi påminnelse',
        download: 'Last ned',
        downloadDocx: 'Last ned Word',
        phoneNumber: 'Telefonnummer',
        phoneNotes: 'Telefonnotater',
        registerPhoneCall: 'Registrer telefonsamtale',
        sendSMS: 'Send SMS',
        smsMultipleDeliveriesWarning: 'Flere leveringshendelser indikerer en lang SMS som ble delt opp i flere deler.',
        opposition: 'Innsigelse',
        notOpposition: 'Ikke innsigelse',
        optionalNote: 'Valgfritt notat',
        visibilityCheckText: 'Synlig for kreditor',
        hideFromClient: 'Skjul for kreditor',
        hiddenFromClient: 'Skjult for kreditor',
        showToClient: 'Vis for kreditor',
        printPDF: 'Last ned PDF',
        seeDocument: 'Se dokument',
        clone: 'Klon til annen sak',
        cloned: 'Interaksjonen ble klonet',
        generateReply: 'Generer AI-svar',
        generatingReply: 'Genererer svar...',
        aiGenerated: 'AI-generert',
        replyGenerated: 'Svar generert og lagt til i utboksen',
        replyBlocked: 'Svar blokkert for manuell gjennomgang',
        deliveredAt: 'Leveringstidspunkt',
        failedAt: 'Tidspunkt for feil',
        eBoksMessageId: 'e-Boks-meldings-ID',
        reason: 'Årsak',
        recipientDomain: 'Mottakerdomene',
        recipient: 'Mottaker',
        recipientIpAddress: 'Mottakers IP-adresse',
        deliveryMethod: 'Leveringsmetode',
        routingDomain: 'Rutingdomene',
        openedAt: 'Åpnet',
        emailOpenedWarning: 'Merk: Statistikk for åpning av e-post kan være unøyaktig. Falske positiver kan oppstå hvis e-postklienten automatisk laster inn bilder. Falske negativer kan oppstå hvis mottakeren har deaktivert bilder i e-postklienten sin.',
        emailDelayed: 'E-posten kunne ikke leveres – prøver igjen senere',
        delayedAt: 'Tidspunkt for forsinkelse',
        delayReason: 'Årsak til forsinkelse',
        bounceCode: 'Returkode',
        errorCode: 'Feilkode',
        complainedAt: 'Tidspunkt for klage',
        complaintType: 'Klagetype',
        letterReturned: 'Brev returnert',
        operator: 'Operatør',
        clickedLink: 'Klikket lenke',
        referer: 'Henviser',
        userAgent: 'User agent',
        duration: 'Varighet',
        network: 'Nettverk',
        subState: 'Understatus',
        digits: 'Sifre tastet inn',
        timedOut: 'Tidsavbrudd',
        timedOutDescription: 'Brukeren avsluttet ikke med firkanttast.',
        actions: 'Handlinger',
        template: 'Mal',
        eInvoiceEvents: {
            created: 'Opprettet',
            transmissionStarted: 'Overføring startet',
            transmissionCompleted: 'Overføring fullført',
            sent: 'Sendt',
            received: 'Mottatt',
            endpointNotFound: 'Feil',
            error: 'Feil',
            documentId: 'Dokument-ID',
            statusCode: 'Statuskode',
            statusMessage: 'Statusmelding',
            deliveryType: 'Leveringstype',
            receiver: 'Mottaker',
            receiverCvr: 'Mottakers CVR',
        },
    },
    interactionEventTypes: {
        [InteractionEventType.Journaled]: 'Journalført',
        [InteractionEventType.Copied]: 'Kopiert',
        [InteractionEventType.Clicked]: 'Lenke klikket',
        [InteractionEventType.Complained]: 'Klaget',
        [InteractionEventType.Delivered]: 'Levert',
        [InteractionEventType.Failed]: 'Mislyktes',
        [InteractionEventType.Opened]: 'Åpnet',
        [InteractionEventType.Delayed]: 'I kø',
        [InteractionEventType.Answered]: 'Besvart',
        [InteractionEventType.Cancelled]: 'Avbrutt',
        [InteractionEventType.Started]: 'Startet',
        [InteractionEventType.Ringing]: 'Ringer',
        [InteractionEventType.Completed]: 'Fullført',
        [InteractionEventType.Voicemail]: 'Telefonsvarer',
        [InteractionEventType.HumanAnswered]: 'Menneske oppdaget',
        [InteractionEventType.DigitsEntered]: 'Sifre tastet inn',
        [InteractionEventType.Inbound]: 'Innkommende anrop',
        [InteractionEventType.Sent]: 'Sendt',
        [InteractionEventType.TransmissionStarted]: 'Overføring startet',
        [InteractionEventType.Created]: 'Opprettet',
        [InteractionEventType.Received]: 'Mottatt',
        [InteractionEventType.SendingApproved]: 'Sending godkjent',
        [InteractionEventType.TransferredToPrintAndDistribution]: 'Sendt til print og distribusjon',
    },
    outboundPhone: {
        noCasesLeft: 'Ingen saker å vise',
        priority: 'Prioritet',
        nextCase: 'Neste sak',
    },
    outgoingPhoneCallTags: {
        [PhoneOutgoingTag.FullPayment]: 'Full betaling',
        [PhoneOutgoingTag.IncorrectNumber]: 'Nummeret finnes ikke',
        [PhoneOutgoingTag.NoAnswer]: 'Ikke besvart',
        [PhoneOutgoingTag.WrongNumber]: 'Feil nummer',
        [PhoneOutgoingTag.Opposition]: 'Innsigelse',
        [PhoneOutgoingTag.Other]: 'Annen årsak',
        [PhoneOutgoingTag.OtherAgreement]: 'Annen avtale',
        [PhoneOutgoingTag.PaymentPlan]: 'Betalingsplan',
    },
    incomingPhoneCallTags: {
        [PhoneIncomingTag.FullPayment]: 'Full betaling',
        [PhoneIncomingTag.Opposition]: 'Innsigelse',
        [PhoneIncomingTag.Other]: 'Annen årsak',
        [PhoneIncomingTag.OtherAgreement]: 'Annen avtale',
        [PhoneIncomingTag.PaymentPlan]: 'Betalingsplan',
        [PhoneIncomingTag.Billing]: 'Fakturering',
        [PhoneIncomingTag.Terms]: 'Vilkår',
        [PhoneIncomingTag.Caseworking]: 'Saksbehandling',
    },
    procedures: {
        procedure: 'Snarvei',
        customProcedures: 'Opprettede snarveier',
        standardProcedures: 'Standardsnarveier',
        deleteProcedure: 'Slett snarvei',
        confirmDeleteProcedure: 'Er du sikker på at du vil slette denne snarveien?',
        general: 'Generelt',
        generalDescription: 'Generelle innstillinger for denne snarveien',
        showOnCase: 'Vis på sak',
        save: 'Lagre',
        selectedProcedure: 'Snarveier',
        createProcedure: 'Opprett snarvei',
        title: 'Tittel',
        description: 'Beskrivelse',
        triggers: 'Utløsere',
        defaultToSystemStandard: 'Hvis ingen utløser er valgt:',
        emptyTrigger: 'Ingen utløser valgt',
        deleteConfirmation: 'Du er i ferd med å fjerne denne prosedyren fra en utløser. Er du sikker på at du vil fortsette?',
        associatedWithCollector: 'Tilknyttet inkassobyrå',
        selectCollector: 'Velg inkassobyrå',
        selectSetting: 'Velg innstilling',
        associatedWithCreditor: 'Tilknyttet kreditor',
        selectCreditor: 'Velg kreditor',
        tasks: 'Oppgaver',
        tasksDescription: 'Oppgaver som skal utføres.',
        automaticTask: 'Automatiske oppgaver',
        selectUpdate: 'Velg oppgaver',
        add: 'Legg til',
        taskOrderExplainer: 'Oppgavene gjennomgås ovenfra og ned – den første oppgaven der kravene er oppfylt, blir utført. Dra i oppgavene for å endre rekkefølgen.',
        noTasksYet: 'Ingen oppgaver ennå – legg til den første nedenfor.',
        otherwise: 'ellers',
        untilManualContinuation: 'til den fortsettes manuelt',
        addTask: 'Legg til oppgave',
        removeTask: 'Fjern oppgave',
        economyProcedureTriggers: 'Økonomi',
        paymentPlansProcedureTriggers: 'Betalingsplaner',
        debtExpiredProcedureTriggers: 'Foreldelse',
        CosmoProcedureTriggers: 'Skyldnerhendelser',
        otherProcedureTriggers: 'Andre',
        timeBeforeExpiration: 'Tid før foreldelse',
        atExpiration: 'Ved foreldelse',
        beforeExpiration: 'før foreldelse',
        proceduresToRun: 'Prosedyrer som kjøres',
        foundationFilter: 'Krav om fundament',
        foundationFilterAny: 'Med eller uten fundament',
        foundationFilterWithFoundation: 'Kun med fundament',
        foundationFilterWithoutFoundation: 'Kun uten fundament',
        addTriggerConfiguration: 'Legg til konfigurasjon',
        duplicateProcedure: 'Du kan ikke legge til samme prosedyre to ganger',
        deleteTriggerConfigurationConfirmation: 'Er du sikker på at du vil slette denne konfigurasjonen?',
    },
    triggers: {
        [SystemProcedure.CreditorEndedCase]: 'Når kreditor avslutter en sak',
        [SystemProcedure.EndCase]: 'Ved saksavslutning',
        [SystemProcedure.Overpayment]: 'Ved overbetaling',
        [SystemProcedure.RemainderReminder]: 'Ved restpurring',
        [SystemProcedure.PrincipalPayment]: 'Ved restpurring som tilsvarer hovedstolen',
        [SystemProcedure.PaymentOnCourtCase]: 'Ved betaling på sak i domstolen',
        [SystemProcedure.EndCaseAccord]: 'Ved avslutning av akkordsak',
        [SystemProcedure.Update]: 'Ved saksoppdatering',
        [SystemProcedure.InteractionSentToDebtor]: 'Ved manuell interaksjon sendt til skyldner',
        [SystemProcedure.CaseStatusChange]: 'Ved endring av sakens status',
        [SystemProcedure.ObjectionOnRelatedCase]: 'Når en ny sak opprettes og kunden har gjort innsigelse mot et krav på en annen sak',
        [SystemProcedure.PaymentPlanInitial]: 'Ved aktivering av betalingsplan',
        [SystemProcedure.PaymentPlanDocumentSigned]: 'Ved signering av dokument når en betalingsplan aktiveres',
        [SystemProcedure.PaymentPlanReminder]: 'Ved påminnelse om avdrag i betalingsplan',
        [SystemProcedure.PaymentPlanPayment]: 'Ved betaling av avdrag i betalingsplan',
        [SystemProcedure.PaymentPlanAutoPaymentFailure]: 'Ved mislykket betaling av avdrag i betalingsplan',
        [SystemProcedure.PaymentPlanBSLSSubmitFailed]: 'Ved mislykket innsending av betaling til betalingsservice',
        [SystemProcedure.PaymentPlanBSLSRejected]: 'Ved avvist betaling via betalingsservice',
        [SystemProcedure.PaymentPlanBSLSAgreementCancelled]: 'Ved kansellert betalingsserviceavtale',
        [SystemProcedure.PaymentPlanDeadline]: 'Ved frist for avdrag i betalingsplan',
        [SystemProcedure.PaymentPlanCanceled]: 'Ved kansellering av avdrag i betalingsplan',
        [SystemProcedure.PaymentPlanTwoHourActivationReminder]: 'To timer etter at en betalingsplan er valgt, men ikke aktivert',
        [SystemProcedure.PaymentPlanOneDayActivationReminder]: 'Én dag etter at en betalingsplan er valgt, men ikke aktivert',
        [SystemProcedure.PaymentPlanThreeDayActivationReminder]: 'Tre dager etter at en betalingsplan er valgt, men ikke aktivert',
        [SystemProcedure.CancelUnactivatedPaymentPlansAfterActivationDeadline]: 'Kanseller ikke-aktiverte betalingsplaner etter aktiveringsfrist',
        [SystemProcedure.PaymentPlanCreationByCaseworker]: 'Når en saksbehandler oppretter en betalingsplan',
        [SystemProcedure.BankAccountDetailsApprovalRefund]: 'Godkjenning etter inntasting av bankkontoopplysninger for utbetaling av overbetaling',
        [SystemProcedure.DebtExpires]: 'Når et bilag foreldes',
        [SystemProcedure.DebtorCanBeRegisteredInDebtRegister]: 'Når skyldner kan registreres i et gjeldsregister, men ennå ikke er registrert',
        [SystemProcedure.DebtorIsUnderage]: 'Ved mindreårig skyldner',
        [SystemProcedure.Address]: 'Ved adresseendring',
        [SystemProcedure.Active]: 'Når en skyldner blir aktiv',
        [SystemProcedure.Dead]: 'Ved dødsfall',
        [SystemProcedure.Disappeared]: 'Ved forsvinning',
        [SystemProcedure.MovedAbroad]: 'Når en skyldner flytter utenlands',
        [SystemProcedure.Homeless]: 'Når en skyldner blir bostedsløs',
        [SystemProcedure.CompanyActive]: 'Når et selskap blir aktivt',
        [SystemProcedure.Inactive]: 'Når et selskap blir inaktivt',
        [SystemProcedure.OperationsCeased]: 'Når driften opphører',
        [SystemProcedure.AddressProtection]: 'Når adresse- eller navnebeskyttelse registreres',
        [SystemProcedure.NewRKIRegristration]: 'Når en ny ekstern RKI-registrering registreres',
        [SystemProcedure.DeletedRKIRegistration]: 'Når en ekstern RKI-registrering slettes',
        [SystemProcedure.DeletedRKIRegistrationWillingnessToPay]: 'Når en ekstern RKI-registrering slettes med indikasjon på betalingsvilje',
        [SystemProcedure.GuardianStatus]: 'Ved endring av vergestatus',
        [SystemProcedure.DissolutionStatus]: 'Ved endring av oppløsningsstatus',
        [SystemProcedure.AKSFailed]: 'Når AKS-tilmelding mislykkes',
        [SystemProcedure.BOBEHANDLING]: 'Ved konkurs eller dødsfall',
        [SystemProcedure.NewAsset]: 'Når en ny eiendel registreres',
        [SystemProcedure.NewLien]: 'Når en ny panterett registreres',
        [SystemProcedure.AssetChanged]: 'Når en eiendel oppdateres',
        [SystemProcedure.LienChanged]: 'Når en panterett oppdateres',
        [SystemProcedure.AssetRemoved]: 'Når en eiendel fjernes',
        [SystemProcedure.LienRemoved]: 'Når en panterett fjernes',
    },
    procedureTitles: {
        [SystemProcedureId.CreditorEndedCase]: 'Når kreditor avslutter en sak via API-et',
        [SystemProcedureId.EndCase]: 'Fullt betalt sak',
        [SystemProcedureId.Overpayment]: 'Overbetaling',
        [SystemProcedureId.RemainderReminder]: 'Delvis betalt sak',
        [SystemProcedureId.PrincipalPayment]: 'Delvis betalt sak',
        [SystemProcedureId.PaymentOnCourtCase]: 'Betaling på sak i retten',
        [SystemProcedureId.EndCaseAccord]: 'Akkordbetaling',
        [SystemProcedureId.Update]: 'Saksoppdatering',
        [SystemProcedureId.PaymentPlanInitial]: 'Betalingsplan opprettet',
        [SystemProcedureId.PaymentPlanReminder]: 'Betalingsplan påminnelse',
        [SystemProcedureId.PaymentPlanPayment]: 'Betalingsplan oppgjort vellykket',
        [SystemProcedureId.PaymentPlanAutoPaymentFailure]: 'Betalingsplan oppgjør mislyktes',
        [SystemProcedureId.PaymentPlanBSLSSubmitFailed]: 'Betalingsplan innsending mislyktes BS og LS',
        [SystemProcedureId.PaymentPlanBSLSRejected]: 'Betalingsplan avvist betaling BS og LS',
        [SystemProcedureId.PaymentPlanBSLSAgreementCancelled]: 'Betalingsplan avtale kansellert BS og LS',
        [SystemProcedureId.PaymentPlanDeadline]: 'Betalingsplan frist',
        [SystemProcedureId.PaymentPlanCanceled]: 'Betalingsplan kansellert',
        [SystemProcedureId.PaymentPlanTwoHourActivationReminder]: 'Betalingsplan aktiveringspåminnelse etter to timer',
        [SystemProcedureId.PaymentPlanOneDayActivationReminder]: 'Betalingsplan aktiveringspåminnelse etter én dag',
        [SystemProcedureId.PaymentPlanThreeDayActivationReminder]: 'Betalingsplan aktiveringspåminnelse etter tre dager',
        [SystemProcedureId.PaymentPlanCreationByCaseworker]: 'Manuell opprettelse av betalingsplan – send tilbud',
        [SystemProcedureId.DebtExpired]: 'Gjeld foreldet',
        [SystemProcedureId.DebtExpiresWithinThreeMonths]: 'Gjeld foreldes innen 3 måneder',
        [SystemProcedureId.DebtExpiresWithinThreeMonthsWithFoundation]: 'Gjeld foreldes innen 3 måneder med fundament',
        [SystemProcedureId.DebtorCanBeRegisteredInDebtRegister]: 'Når skyldner kan registreres i gjeldsregisteret, men ennå ikke er registrert',
        [SystemProcedureId.DebtorIsUnderage]: 'Skyldner er mindreårig',
        [SystemProcedureId.Address]: 'Adresse',
        [SystemProcedureId.Active]: 'Aktiv',
        [SystemProcedureId.Dead]: 'Død',
        [SystemProcedureId.Disappeared]: 'Forsvunnet',
        [SystemProcedureId.MovedAbroad]: 'Flyttet til utlandet',
        [SystemProcedureId.Homeless]: 'Bostedsløs',
        [SystemProcedureId.CompanyActive]: 'Selskap aktivt',
        [SystemProcedureId.Inactive]: 'Inaktiv',
        [SystemProcedureId.OperationsCeased]: 'Drift opphørt',
        [SystemProcedureId.AddressProtection]: 'Navne-/adressebeskyttelse',
        [SystemProcedureId.NewRKIRegristration]: 'Ny RKI-registrering',
        [SystemProcedureId.DeletedRKIRegistration]: 'Slettet RKI-registrering',
        [SystemProcedureId.DeletedRKIRegistrationWillingnessToPay]: 'Slettet RKI-registrering med indikasjon på betalingsvilje',
        [SystemProcedureId.GuardianStatus]: 'Vergestatus',
        [SystemProcedureId.DissolutionStatus]: 'Oppløsningsstatus',
        [SystemProcedureId.AKSFailed]: 'AKS mislyktes',
        [SystemProcedureId.BOBEHANDLING]: 'Bobehandling',
    },
    procedureDescriptions: {
        [SystemProcedureId.CreditorEndedCase]: 'Når kreditor avslutter en sak via API-et',
        [SystemProcedureId.EndCase]: 'Avslutt sak og informer kontaktperson.',
        [SystemProcedureId.Overpayment]: 'Det er betalt mer enn det som er belastet.',
        [SystemProcedureId.RemainderReminder]: 'Sak delvis betalt. Informer kontaktperson',
        [SystemProcedureId.PrincipalPayment]: 'Sak delvis betalt. Informer kontaktperson',
        [SystemProcedureId.PaymentOnCourtCase]: 'Betaling på sak i retten. Informer domstolen',
        [SystemProcedureId.EndCaseAccord]: 'Avslutt sak med akkordbetaling',
        [SystemProcedureId.Update]: 'Saken er oppdatert.',
        [SystemProcedureId.PaymentPlanInitial]: 'Bekreftelse som sendes ut når nye planer opprettes',
        [SystemProcedureId.PaymentPlanReminder]: 'Påminnelse som sendes ut før betalingsdatoen',
        [SystemProcedureId.PaymentPlanPayment]: 'Når en betalingsplan blir oppgjort vellykket',
        [SystemProcedureId.PaymentPlanAutoPaymentFailure]: 'Når oppgjør av en betalingsplan mislykkes',
        [SystemProcedureId.PaymentPlanBSLSSubmitFailed]: 'Når en betalingsplan med BS eller LS ikke klarte å planlegge betaling',
        [SystemProcedureId.PaymentPlanBSLSRejected]: 'Når en betalingsplan med BS eller LS har en avvist betaling etter den første i måneden',
        [SystemProcedureId.PaymentPlanBSLSAgreementCancelled]: 'Når avtalen for en betalingsplan med BS eller LS blir kansellert',
        [SystemProcedureId.PaymentPlanDeadline]: 'Når en betalingsplan ikke er betalt før fristen',
        [SystemProcedureId.PaymentPlanCanceled]: 'Når en betalingsplan ikke er betalt etter en ny sjanse',
        [SystemProcedureId.PaymentPlanTwoHourActivationReminder]: 'Når en betalingsplan er opprettet, men ikke aktivert etter to timer',
        [SystemProcedureId.PaymentPlanOneDayActivationReminder]: 'Når en betalingsplan er opprettet, men ikke aktivert etter én dag',
        [SystemProcedureId.PaymentPlanThreeDayActivationReminder]: 'Når en betalingsplan er opprettet, men ikke aktivert etter tre dager',
        [SystemProcedureId.PaymentPlanCreationByCaseworker]: 'Send tilbud for manuell betalingsplan opprettet av en saksbehandler',
        [SystemProcedureId.DebtExpired]: 'Gjelden er foreldet',
        [SystemProcedureId.DebtExpiresWithinThreeMonths]: 'Gjelden foreldes innen 3 måneder',
        [SystemProcedureId.DebtExpiresWithinThreeMonthsWithFoundation]: 'Gjeld med fundament foreldes innen 3 måneder',
        [SystemProcedureId.DebtorCanBeRegisteredInDebtRegister]: 'Når skyldner kan registreres i gjeldsregisteret, men ennå ikke er registrert',
        [SystemProcedureId.DebtorIsUnderage]: 'Ved mindreårig skyldner',
        [SystemProcedureId.Address]: 'Ved adresseendring',
        [SystemProcedureId.Active]: 'Når en skyldner blir aktiv',
        [SystemProcedureId.Dead]: 'Ved dødsfall',
        [SystemProcedureId.Disappeared]: 'Ved forsvinning',
        [SystemProcedureId.MovedAbroad]: 'Når en skyldner flytter til utlandet',
        [SystemProcedureId.Homeless]: 'Når en skyldner blir bostedsløs',
        [SystemProcedureId.CompanyActive]: 'Når et selskap blir aktivt',
        [SystemProcedureId.Inactive]: 'Når et selskap blir inaktivt',
        [SystemProcedureId.OperationsCeased]: 'Når driften opphører',
        [SystemProcedureId.AddressProtection]: 'Når adresse- eller navnebeskyttelse registreres',
        [SystemProcedureId.NewRKIRegristration]: 'Når ny ekstern RKI-registrering registreres',
        [SystemProcedureId.DeletedRKIRegistration]: 'Når ekstern RKI-registrering slettes',
        [SystemProcedureId.DeletedRKIRegistrationWillingnessToPay]: 'Når ekstern RKI-registrering slettes med indikasjon på betalingsvilje',
        [SystemProcedureId.GuardianStatus]: 'Ved endring av vergestatus',
        [SystemProcedureId.DissolutionStatus]: 'Ved endring av oppløsningsstatus',
        [SystemProcedureId.AKSFailed]: 'Når AKS ikke klarer å abonnere',
        [SystemProcedureId.BOBEHANDLING]: 'Ved konkurs eller dødsfall',
    },
    panels: {
        filters: 'Filtre',
        selectAll: 'Velg alle',
        totalDebt: 'Total gjeld',
        clickToQueueText: 'Klikk for å legge valgte saker i kø',
        queue: 'Kø',
    },
    misc: {
        selectAll: 'Velg alle',
        notChosen: 'Ikke valgt',
        copiedToClipboard: 'Kopiert til utklippstavlen!',
        cosmoActivated: 'Aktivert',
        searchForAccount: 'Søk etter konto',
        approve: 'Godkjenn',
        cancel: 'Avbryt',
        okay: 'OK',
        create: 'Opprett',
        createdAt: 'Opprettet',
        createdBy: 'Opprettet av',
        updatedAt: 'Oppdatert',
        updatedBy: 'Oppdatert av',
        submit: 'Send inn',
        save: 'Lagre',
        saved: 'Lagret',
        edit: 'Rediger',
        update: 'Oppdater',
        errorCreating: 'Feil ved oppretting',
        errorUpdating: 'Feil ved oppdatering',
        errorDeleting: 'Feil ved sletting',
        errorPerforming: 'Feil ved utføring av handling knyttet til',
        successCreating: 'opprettet',
        successUpdating: 'oppdatert',
        successDeleting: 'slettet',
        language: 'Språk',
        chooseFile: 'Velg fil',
        yes: 'Ja',
        no: 'Nei',
        all: 'Alle',
        add: 'Legg til',
        enabled: 'Aktivert',
        search: 'Søk',
        contactSupport: 'Kontakt vår kundestøtte',
        error: 'Feil',
        errorOccured: 'Det oppstod en feil',
        days: 'Dager',
        date: 'Dato',
        loadingError: 'Kunne ikke laste data',
        export: 'Eksporter',
        exported: 'Eksportert',
        goToCase: 'Gå til sak',
        after: 'etter',
        skip: 'Hopp over',
        value: 'Verdi',
        delete: 'Slett',
        apply: 'Bruk',
        unnamed: 'Uten navn',
        name: 'Navn',
        description: 'Beskrivelse',
        learnMore: 'Les mer',
        ascending: 'Stigende',
        descending: 'Synkende',
        and: 'og',
        or: 'eller',
        id: 'id',
        type: 'Type',
        text: 'Tekst',
        state: 'Tilstand',
        limitReached: 'Grense nådd',
        accept: 'Aksepter',
        loading: 'Laster...',
        logo: 'Logo',
    },
    table: {
        selectedOptions: 'Valgte',
        next: 'Neste',
        previous: 'Forrige',
        first: 'Første',
        last: 'Siste',
        showing: 'Viser',
        outOf: 'av',
        loadMore: 'Last inn mer',
        from: 'Fra',
        to: 'Til',
        search: 'Søk',
        noData: 'Ingen data',
        clearFilters: 'Fjern alle filtre',
    },
    history: {
        paymentPlanCreated: 'Nedbetalingsplan opprettet',
        tribunalCaseCreated: 'Rettssak opprettet',
        documentAdded: 'Dokument lagt til',
        history: 'Historikk',
        searchHistory: 'Søk i historikk',
        filterHistory: 'Filtrer historikk',
        filterEconomy: 'Økonomi',
        filterBilling: 'Fakturering',
        filterUpdates: 'Oppgaver',
        filterInteractions: 'Interaksjoner',
        filterDebts: 'Gjeld',
        filterDebtorTransactions: 'Skyldnertransaksjoner',
        filterNotifications: 'Varsler',
        filterCaseStatus: 'Sakstatus',
        filterType: 'Type',
        filterTags: 'Tagger',
        resetFilter: 'Nullstill',
        hideAll: 'Skjul alle',
        caseCreated: 'Sak opprettet',
        creditorDisbursement: 'Utbetaling til kreditor',
        creditorVat: 'Kreditor mva',
        creditorFee: 'Kreditorgebyr',
        deposit: 'Fakturering av depositum',
    },
    connect: {
        fromConnectPartner: 'Fra en connect-partner',
        connection: 'Tilkobling',
        product: 'Produkt',
        updates: 'Oppdateringer',
        mappedCases: 'Tilknyttede saker',
        updatedBy: 'Oppdatert av ',
        partner: 'connect-partner',
        us: 'denne organisasjonen',
        thirdParty: 'en tredjepart',
        sendsToConn: 'Tilkoblingen sender saker til',
        sendsFromConn: 'Tilkoblingen mottar saker fra',
        histItemHeader: 'Connect -',
        histItemExported: 'Sendt til partner',
        histItemRetracted: 'Tilbaketrukket',
        histItemCompleted: 'Oppgave fullført',
        histItemDataUpdated: 'Data oppdatert',
        completedWithReason: 'Fullført med begrunnelse',
        createdDocuments: 'Opprettede dokumenter',
        createdSatisfaction: 'Opprettet anmeldelse',
        goToConnection: 'Gå til tilkobling',
        goToCreditorWeb: 'Gå til kreditorweb',
        goToCreditor: 'Gå til mottakende kreditor',
        goToProduct: 'Gå til produkt',
        goToCase: 'Gå til sak',
        creditorWebLinkError: 'Feil ved henting av lenke til kreditorweb',
        case: 'Sak',
        state: 'Tilstand',
        exportedDate: 'Eksportert dato',
        completedDate: 'Fullført dato',
        connectStateCompleted: 'Fullført',
        connectStateInProgress: 'Pågår',
    },
    connectConnectionUpdate: {
        [ConnectConnectionStatus.Active]: 'Aktiv',
        [ConnectConnectionStatus.Paused]: 'Satt på pause',
        [ConnectConnectionStatus.Disabled]: 'Deaktivert',
    },
    connectCaseMappingUpdate: {
        [ConnectCaseMappingStatus.Exported]: 'Eksportert',
        [ConnectCaseMappingStatus.Retracted]: 'Tilbaketrukket',
        [ConnectCaseMappingStatus.Completed]: 'Fullført',
        [ConnectCaseMappingStatus.DataUpdated]: 'Data oppdatert',
    },
    connectRetractionReason: {
        [RetractionReason.Collected]: 'Gjeld inndrevet',
        [RetractionReason.ConnectionDisabled]: 'Connect-tilkobling deaktivert',
        [RetractionReason.Rollback]: 'Rullet tilbake',
        [RetractionReason.Other]: 'Annet',
    },
    product: {
        productHandles: 'Produktet håndterer',
    },
    productService: {
        [ProductService.Collection]: 'inkasso',
        [ProductService.CourtHandling]: 'rettslig behandling',
    },
    documents: {
        documents: 'Dokumenter',
        noDocuments: 'Ingen dokumenter',
        deleteDocument: 'Slett dokument',
        saveDocument: 'Lagre dokument',
        autoRKIAddFoundation: 'Auto-RKI er aktivert og vil forsøke å flytte RKI-registreringen til det åpne registeret etter at dette fundamentet er lagt til',
        autoRKIUpdateFoundation: 'Auto-RKI er aktivert og vil forsøke å flytte RKI-registreringen til det åpne registeret etter at dette fundamentet er oppdatert',
        file: 'Fil',
        signedFile: 'Signert fil',
        createdBy: 'Opprettet av',
        docId: 'Dok-ID',
        type: 'Type',
        signingLink: 'Signeringslenke',
        generateSigningLink: 'Generer signeringslenke',
        createdAt: 'Opprettet',
        date: 'Dato',
        signedAt: 'signert',
        addDocument: 'Legg til dokument',
        fromFile: 'Fra fil',
        fromTemplate: 'Fra mal',
        selectCourt: 'Domstol',
        documentSignedCheckbox: 'Er dokumentet signert?',
        visibleForDebtor: 'Synlig for skyldner',
        uploadDocument: 'Last opp dokument',
        createDocument: 'Opprett dokument',
        preview: 'Forhåndsvisning',
        sendToCourt: 'Send til domstolen',
        paidCourtFee: 'Betalt rettsgebyr',
        createDate: 'Opprettelsesdato',
        interestDates: 'Rentedatoer',
        interestAmount: 'Rentebeløp',
        totalAmount: 'Totalbeløp',
        amount: 'Beløp',
        note: 'Notat',
        procesinterest: 'Prosessrente',
        interestFromSubmitOfBPK: 'Rente fra innsending av begjæring til Namsmannen',
        caseinterest: 'Sakens rentesats',
        preventForkyndt: 'Ønsker du betalingspåkravet forkyndt, hvis skyldner har afgivet insolvenserklæring i fogedretten, eller er under rekonstruktion, konkurs eller gældssanering og derfor er beskyttet mod udlæg?',
        preventAutDistress: 'Ønsker du, at fogedretten automatisk skal iværksætte udlæg, hvis skyldner ikke kommer med indsigelser (protester) mod dit krav?',
        preventAutCivilCourt: 'Ønsker du, at retssag automatisk skal indledes i civilretten på grundlag af betalingspåkravet, hvis skyldner kommer med indsigelser (protester) mod dit krav?',
        selectBPKWarningDate: 'Velg BPK-varselsdato',
        directorNameAddress: 'Direktørens/styrelederens navn og adresse',
        directorNameAddressDescription: 'Hvis skyldner er et selskap/en forening – vennligst oppgi direktørens/styrelederens navn og adresse hvis mulig:',
        selectDebtors: 'Velg skyldnere',
        selectDebtorsDescription: 'Velg hvilke skyldnere som skal inkluderes i begjæringen til Namsmannen.',
        selectAll: 'Velg alle',
        deselectAll: 'Fjern alle',
        debtorsSelected: 'skyldnere valgt',
        court: 'Domstol',
        selectType: 'Velg dokumenttype',
        sureYouWantToDelete: 'Er du sikker på at du vil slette',
        sureYouWantToSave: 'Er du sikker på at du vil lagre endringene?',
        documentSigned: 'Dokument signert',
        generateLinkForSigning: 'Generer lenke for signering',
        addCourtFeeToClientBilling: 'Legg til gebyr i kreditoravregning',
        addCourtDisbursementToClientBilling: 'Legg til utlegg i kreditoravregning',
        addCourtFeeToCase: 'Legg til kostnad på saken',
        sendInfoAboutRequisitionToRes: 'Send informasjon om rekvisisjon til ansvarlig',
        responsible: 'Ansvarlig',
        isFoundation: 'Er fundament',
        [DocumentTypes.COURT]: 'Rettslig',
        [DocumentTypes.FOUNDATION]: 'Fundament',
        [DocumentTypes.OTHER]: 'Annet',
    },
    documentTypes: {
        [DocumentTypes.COURT]: 'Rettslig',
        [DocumentTypes.FOUNDATION]: 'Fundament',
        [DocumentTypes.OTHER]: 'Annet',
        [DocumentTypes.SKYLDERKLAERING]: 'Skylderklæring',
        [DocumentTypes.COURTOPGJORTOGFREMLAGT]: 'Opgjort og fremlagt i fogedretten',
        [DocumentTypes.FORLIG]: 'Forlik',
        [DocumentTypes.DOM]: 'Dom',
        [DocumentTypes.PAATEGNING]: 'Påtegning',
        [DocumentTypes.GAELDSBREV]: 'Gjeldsbrev',
    },
    files: {
        fileName: 'Filnavn',
        downloadFailed: 'Nedlasting mislyktes',
    },
    updates: {
        continueCase: 'Fortsett sak',
        continueCaseRemove: 'Fjern',
        setRemindedAt: 'Angi påminnelsesdato',
        remindDate: 'Påminn den',
        pauseNow: 'Sett på pause nå',
        remindNow: 'Påminn nå',
        pauseUntilReminding: 'Pause den',
        pauseContinueAt: 'Fortsett den',
        pausedUntil: 'Satt på pause til',
        dateSelectorTooltip: 'Velg datoen for å vise pausestatusen',
        updateWillBeShownIn: 'Settes på pause om',
        paused: 'Satt på pause',
        reminded: 'påminnet',
        pausedAndReminded: 'Satt på pause og påminnet om',
        pausedAndRemindedPast: 'Satt på pause og påminnet',
        ago: 'siden',
        pausedPast: 'Satt på pause',
        andReminded: 'og påminnet om',
        andRemindedPast: 'og påminnet',
        expedientAKSActivated: 'Experian AKS aktivert',
        chooseMoreThanTwoBulkActions: 'Velg to eller flere oppgaver for å utføre en masseoperasjon.',
        bulkActions: 'Masseoperasjon',
        selectAll: 'Velg alle',
    },
    integrateCalendar: {
        name: 'Abonnementets navn',
        newSubscription: 'Nytt kalenderabonnement',
        create: 'Opprett kalenderlenke',
        save: 'Lagre innstillinger',
        edit: 'Rediger',
        cancel: 'Avbryt',
        delete: 'Slett abonnement',
        confirmDelete: 'Slette abonnementet? Kalenderlenken slutter å fungere.',
        courtMeetings: 'Rettsmøter i domstolsmodulen',
        updateTypes: 'Oppgavetyper',
        empty: 'Ingen kalenderabonnementer ennå.',
        description: 'Opprett et kalenderabonnement for denne organisasjonen. Velg rettsmøtetyper og oppgavetyper nedenfor. Bare valgte typer synkroniseres, fra én måned tilbake til ett år frem.',
        privacy: 'Kalenderhendelser inneholder bare generiske titler og tidspunkter. Navn, notater, adresser og saksopplysninger tas ikke med. Alle med lenken kan lese kalenderen til du sletter abonnementet.',
        noTypes: 'Ingen typer valgt: abonnementet er satt på pause.',
        subscription: 'kalenderabonnement',
        namePlaceholder: 'F.eks. Rettsmøter',
        nameHint: 'Brukes bare til å skille abonnementer fra hverandre i Debbie.',
        courtMeetingsHelp: 'Velg møtetypene som skal med i kalenderen. Hvert rettsmøte fra domstolsmodulen vises i kalenderen på møtedatoen sin.',
        updateTypesHelp: 'Velg oppgavetypene som skal med i kalenderen. Hver oppgave vises i kalenderen på påminnelsesdatoen sin.',
        selected: 'valgt',
        selectAll: 'Velg alle',
        clearSelection: 'Tøm',
        paused: 'Satt på pause',
        meetingTypesCount: 'rettsmøtetyper',
        updateTypesCount: 'oppgavetyper',
        link: 'Kalenderlenke',
        copyLink: 'Kopier lenke',
        created: 'Opprettet',
        connectToOffice365: 'Synkroniser med Office 365',
        selectUpdateTypes: 'Velg oppgavetyper',
    },
    auth: {
        account: 'Konto',
        logout: 'Logg ut',
        accountInactive: 'Kontoen din er inaktiv',
        chooseBetweenAccounts: 'Velg mellom kontoer',
    },
    rightNav: {
        creditors: 'Kreditorer',
    },
    login: {
        email: 'E-post',
        password: 'Passord',
        login: 'Logg inn',
        twoFactorExplainer: 'Vi har sendt en sekssifret kode til e-posten din. Angi den nedenfor for å logge inn.',
        twoFactorPlaceholder: 'Kode',
        reset: 'Tilbakestill',
        resetTokenExplainer: 'Du vil motta en kode per e-post som du må taste inn her for å tilbakestille passordet ditt.',
        resetTokenPlaceholder: 'Kode',
        newPasswordExplainer: 'Skriv inn ditt nye passord',
        newPasswordPlaceholder: 'Ditt nye passord',
        updatePassword: 'Oppdater',
        couldNotIdentifyYou: 'Vi kunne ikke identifisere deg. Vennligst kontakt',
        mitIdDescription: 'Logg inn med MitID for å få tilgang til dataene dine.',
        loginWithMitId: 'Logg inn med MitID',
    },
    passwordResetEmail: {
        title: 'Tilbakestill passord',
        body: 'Du har bedt om å endre passordet ditt. For å endre passordet ditt, skriv inn følgende på siden du ba om det fra:',
    },
    onboarding: {
        welcome: 'Velkommen',
        passwordCreatorExplainer: 'For å sette opp kontoen din, opprett et passord.',
    },
    users: {
        userSettings: 'Brukerinnstillinger',
        userCreated: 'Bruker opprettet',
        userUpdated: 'Bruker oppdatert',
        updateFailed: 'Oppdatering av bruker mislyktes',
        createUser: 'Opprett bruker',
        inviteUser: 'Inviter bruker',
        name: 'Navn',
        role: 'Rolle',
        firstName: 'Fornavn',
        lastName: 'Etternavn',
        email: 'E-post',
        phone: 'Telefon',
        username: 'Brukernavn',
        password: 'Passord',
        users: 'Brukere',
        noUsers: 'Ingen brukere å vise',
        search: 'Søk etter brukere',
        newUser: 'Ny bruker',
        passwordConfirmation: 'Bekreft passord',
        creditors: 'Kreditorer',
        tenants: 'Organisasjoner',
        todoNotifications: 'Motta en e-post når det finnes usette gjøremål eller varsler',
        selectCreditors: 'Velg kreditorer',
        selectTenants: 'Velg organisasjoner',
        selectRole: 'Velg rolle',
        selectUser: 'Velg bruker',
        passwordTooShort: 'Passordet er for kort',
        passwordsDontMatch: 'Passordene stemmer ikke overens',
        sendInvite: 'Send e-postinvitasjon',
        sureYouWantToDeleteUser: 'Er du sikker på at du vil slette denne brukeren permanent?',
        deleteUser: 'Slett bruker',
        deleteUserPermanently: 'Slett bruker permanent',
        archiveUser: 'Arkiver bruker',
        sureYouWantToArchiveUser: 'Er du sikker på at du vil arkivere denne brukeren?',
        archiveUserDescription: 'Arkivering opphever brukerens tilgang til plattformen, men beholder navn og e-post slik at historiske logger og aktivitet forblir lesbare.',
        archiveUserWarning: 'Brukeren logges ut overalt og mister passordet sitt. Hvis brukeren gjenaktiveres senere, må en ny invitasjon aksepteres.',
        reactivateUser: 'Gjenaktiver bruker',
        sureYouWantToReactivateUser: 'Er du sikker på at du vil gjenaktivere denne brukeren?',
        reactivateUserDescription: 'Brukeren får tilbake sine tidligere roller og tilganger og mottar en invitasjon på e-post for å velge et nytt passord. Brukeren kan ikke logge inn før invitasjonen er akseptert.',
        userReactivated: 'Brukeren er gjenaktivert og invitert på e-post',
        userReactivatedInviteFailed: 'Brukeren er gjenaktivert, men invitasjonen kunne ikke sendes. Bruk "Send invitasjon på nytt" for å prøve igjen.',
        archivedUsers: 'Arkiverte brukere',
        activeUsers: 'Aktive brukere',
        stateActive: 'Aktiv',
        stateInvited: 'Invitert',
        invitedUsers: 'Inviterte brukere',
        resendInvite: 'Send invitasjon på nytt',
        inviteResent: 'Invitasjonen er sendt på nytt',
        inviteResendFailed: 'Kunne ikke sende invitasjonen på nytt',
        inviteLinkExpired: 'Denne invitasjonslenken er utløpt',
        inviteLinkExpiredDescription: 'Invitasjonslenker er gyldige i 30 dager. Be om en ny, så sender vi en fersk lenke til e-posten din.',
        inviteLinkAlreadyUsed: 'Denne invitasjonslenken er allerede brukt',
        inviteLinkAlreadyUsedDescription: 'Du har allerede opprettet passordet ditt. Logg inn med e-post og passord.',
        inviteLinkInvalid: 'Denne invitasjonslenken er ugyldig',
        inviteLinkInvalidDescription: 'Lenken kunne ikke gjenkjennes. Sørg for at du åpnet den nyeste invitasjonse-posten.',
        requestNewInvite: 'Be om ny invitasjon',
        inviteRequestSent: 'En ny invitasjon er sendt. Sjekk e-posten din.',
        changeRole: 'Endre brukerens rolle',
        changeRoleNotAdmin: 'Endring av roller kan gjøres av en administrator',
        cantChangeClientRole: `Klienters rolle kan ikke endres`,
    },
    rolesDescription: {
        [PermissionLevels.admin]: 'Denne rollen er for bedriftens administrator/superbruker som har tilgang til alle funksjoner og kan konfigurere alle tilgjengelige innstillinger.',
        [PermissionLevels.caseworker]: 'Denne rollen er for den ansatte som skal ha tilgang til alle nødvendige funksjoner på saksnivå. Det er også tilgang til alt på kreditornivå, og under innstillinger har rollen tilgang til maler.',
    },
    teams: {
        team: 'Team',
        user: 'Bruker',
        namePlaceholder: 'Teamnavn',
        saveName: 'Lagre',
        searchNewTeamMember: 'Søk etter nytt teammedlem',
        createTeam: 'Opprett nytt team',
        assignedTasks: 'Ansvarlig for oppgaver',
        catchAll: 'Fang alt',
        responsibleForUpdateTypes: 'Ansvarlig for oppgaver',
        addUpdateType: 'Legg til oppgave',
        selectTeam: 'Team',
        selectUser: 'Bruker',
        responsibleForCase: 'Ansvarlig for sak',
    },
    invite: {
        subject: 'Invitasjon til å bli med',
        body: `Hei \${firstName},

Du har blitt invitert til å bli med i \${platform}. Bruk lenken nedenfor for å godta invitasjonen.
\${url}?nu_token=\${token}`,
        html: `<p>Hei \${firstName},</p><p>Du har blitt invitert til å bli med i \${platform}. Bruk lenken nedenfor for å godta invitasjonen.</p>`,
        linkText: 'Logg inn',
        creditorWeb: 'kreditorwebben fra',
    },
    roles: {
        'super-admin': 'Superadministrator',
        admin: 'Administrator',
        caseworker: 'Saksbehandler',
        client: 'Kreditor',
        debtor: 'Skyldner',
        'alternative-contact': 'Alternativ kontakt',
        unauthorized: 'Uautorisert',
    },
    mentionsConditional: {
        if: 'Hvis',
        endIf: 'Slutt hvis',
    },
    mentions: {
        [TemplateMention.PaymentPlanAmortisation]: 'Nedbetalingsplan',
        [TemplateMention.GENERIC_EMAIL_SUBJECT]: 'Generisk emne',
        [TemplateMention.FINANCIALS_PRICIPAL]: 'Hovedstol',
        [TemplateMention.FINANCIALS_DEBT_COLLECTION_FEES]: 'Inkassogebyrer',
        [TemplateMention.FINANCIALS_ADMINISTRATION_COSTS]: 'Administrasjonskostnader',
        [TemplateMention.FINANCIALS_COMPENSATION_FEES]: 'Kompensasjonsgebyrer',
        [TemplateMention.FINANCIALS_INTERESTS]: 'Renter',
        [TemplateMention.FINANCIALS_INTEREST_RATE]: 'Renteprosent',
        [TemplateMention.FINANCIALS_DEBT_COLLECTION_COSTS]: 'Inkassokostnader',
        [TemplateMention.PRINCIPAL_REFERENECE_IDS]: 'Hovedstolens referanse-ID-er',
        [TemplateMention.CURRENCY]: 'Valuta',
        [TemplateMention.PAYMENT_PLAN_FIRST_AMOUNT]: 'Betalingsplanens første beløp',
        [TemplateMention.PAYMENT_PLAN_FIRST_DEADLINE]: 'Betalingsplanens første frist',
        [TemplateMention.PAYMENT_PLAN_FIRST_DATE]: 'Betalingsplanens første dato',
        [TemplateMention.PAYMENT_PLAN_LAST_AMOUNT]: 'Betalingsplanens siste beløp',
        [TemplateMention.PAYMENT_PLAN_LAST_DEADLINE]: 'Betalingsplanens siste frist',
        [TemplateMention.PAYMENT_PLAN_LAST_DATE]: 'Betalingsplanens siste dato',
        [TemplateMention.PAYMENT_PLAN_ENTRY_AMOUNT]: 'Betalingsplanens avdragsbeløp',
        [TemplateMention.PAYMENT_PLAN_ENTRY_DEADLINE]: 'Betalingsplanens avdragsfrist',
        [TemplateMention.PAYMENT_PLAN_ENTRY_DATE]: 'Betalingsplanens avdragsdato',
        [TemplateMention.PAYMENT_PLAN_CREATION_DATE]: 'Betalingsplanens opprettelsesdato',
        [TemplateMention.PAYMENT_PLAN_LENGTH_IN_DAYS]: 'Betalingsplanens lengde i dager',
        [TemplateMention.PaymentPlanApr]: 'Effektiv rente',
        [TemplateMention.PAYMENT_PLAN_YEARLY_COSTS]: 'Effektiv rente per år',
        [TemplateMention.PAYMENT_PLAN_HAS_YEARLY_INTEREST]: 'Hvis saken har årlig rente',
        [TemplateMention.PAYMENT_PLAN_MIN_ENTRY_AMOUNT]: 'Betalingsplanens min. avdragsbeløp',
        [TemplateMention.PAYMENT_PLAN_MAX_ENTRY_AMOUNT]: 'Betalingsplanens maks. avdragsbeløp',
        [TemplateMention.TOTAL_DEBT]: 'Total gjeld',
        [TemplateMention.OVERPAYMENT]: 'Overbetaling',
        [TemplateMention.ACCORD_TEN_PERCENT]: 'Akkord: 10 % avslag',
        [TemplateMention.ACCORD_TWENTY_PERCENT]: 'Akkord: 20 % avslag',
        [TemplateMention.ACCORD_THIRTY_PERCENT]: 'Akkord: 30 % avslag',
        [TemplateMention.ACCORD_FORTY_PERCENT]: 'Akkord: 40 % avslag',
        [TemplateMention.ACCORD_FIFTY_PERCENT]: 'Akkord: 50 % avslag',
        [TemplateMention.ACCORD_SIXTY_PERCENT]: 'Akkord: 60 % avslag',
        [TemplateMention.ACCORD_SEVENTY_PERCENT]: 'Akkord: 70 % avslag',
        [TemplateMention.ACCORD_EIGHTY_PERCENT]: 'Akkord: 80 % avslag',
        [TemplateMention.ACCORD_NINETY_PERCENT]: 'Akkord: 90 % avslag',
        [TemplateMention.IF_IS_COMPANY]: 'Hvis selskap',
        [TemplateMention.IF_DEBTOR_IS_DEBT_REGISTERED]: 'Hvis skyldner er registrert i et gjeldsregister',
        [TemplateMention.IF_CASE_HAS_MULTIPLE_PRINCIPALS]: 'Hvis saken har flere hovedstoler',
        [TemplateMention.IF_CASE_HAS_REMINDER_FEES]: 'Hvis saken har purregebyrer',
        [TemplateMention.IF_CASE_HAS_COLLECTION_FEES]: 'Hvis saken har inkassogebyrer',
        [TemplateMention.IF_CASE_HAS_COLLECTION_COSTS]: 'Hvis saken har inkassokostnader',
        [TemplateMention.IF_CASE_HAS_COMPENSATION_COSTS]: 'Hvis saken har kompensasjonskostnader',
        [TemplateMention.IF_CASE_HAS_PROCESSRENTE]: 'Hvis saken har prosessrente',
        [TemplateMention.IF_CASE_HAS_FIXED_INTEREST]: 'Hvis saken har fast rente',
        [TemplateMention.IF_CASE_HAS_YEARLT_INTEREST]: 'Hvis saken har årlig rente i prosent',
        [TemplateMention.IF_CASE_HAS_DEPOSIT]: 'Hvis saken har depositum',
        [TemplateMention.DOCUMENTATION]: 'Dokumentasjon',
        [TemplateMention.DATE]: 'Dato',
        [TemplateMention.DATE_IN_THREE_DAYS]: 'Dato om 3 dager',
        [TemplateMention.DATE_IN_SIX_DAYS]: 'Dato om 6 dager',
        [TemplateMention.DATE_IN_TEN_DAYS]: 'Dato om 10 dager',
        [TemplateMention.DATE_IN_ELEVEN_DAYS]: 'Dato om 11 dager',
        [TemplateMention.DATE_IN_TWELVE_DAYS]: 'Dato om 12 dager',
        [TemplateMention.DATE_IN_FOURTEEN_DAYS]: 'Dato om 14 dager',
        [TemplateMention.DATE_IN_SEVENTEEN_DAYS]: 'Dato om 17 dager',
        [TemplateMention.DATE_IN_THIRTY_DAYS]: 'Dato om 30 dager',
        [TemplateMention.PREVIOUS_THREE_YEARS]: 'De tre foregående årstallene',
        [TemplateMention.DEPOSIT]: 'Depositum',
        [TemplateMention.DEPOSITS_TO_CREDITOR]: 'Innbetalt til kreditor',
        [TemplateMention.DEPOSITS_TO_COLLECTOR]: 'Innbetalt til inkassobyrå',
        [TemplateMention.INTEREST_PAID_LAST_YEAR]: 'Rente betalt i fjor',
        [TemplateMention.CONTACT_NAME]: 'Kontaktnavn',
        [TemplateMention.DEBTOR_NAME]: 'Skyldnerens navn',
        [TemplateMention.DEBTOR_FIRST_NAME]: 'Skyldnerens fornavn',
        [TemplateMention.CONTACT_ADDRESS]: 'Kontaktens gate',
        [TemplateMention.CONTACT_COADDRESS]: 'Kontaktens c/o-adresse',
        [TemplateMention.CONTACT_ZIPCODE]: 'Kontaktens postnummer',
        [TemplateMention.CONTACT_CITY]: 'Kontaktens by',
        [TemplateMention.CONTACT_COUNTRY]: 'Kontaktens land',
        [TemplateMention.CREDITOR_IF_IS_COMPANY]: 'Hvis kreditor er et selskap',
        [TemplateMention.CREDITOR_IF_IS_VAT_REGISTERED]: 'Hvis kreditor er mva-registrert',
        [TemplateMention.USER_NAME]: 'Brukernavn',
        [TemplateMention.USER_FIRST_NAME]: 'Brukerens fornavn',
        [TemplateMention.IF_USER]: 'Hvis bruker er tilgjengelig',
        [TemplateMention.IF_COLLECTOR_ALLOWS_BANK_TRANSFERS]: 'Hvis kreditor tillater bankoverføringer',
        [TemplateMention.IF_COLLECTOR_ALLOWS_FI_PAYMENTS]: 'Hvis kreditor tillater FI-betalinger',
        [TemplateMention.DEBTOR_ADDRESS]: 'Skyldnerens gate',
        [TemplateMention.DEBTOR_COADDRESS]: 'Skyldnerens c/o-adresse',
        [TemplateMention.DEBTOR_ZIPCODE]: 'Skyldnerens postnummer',
        [TemplateMention.DEBTOR_CITY]: 'Skyldnerens by',
        [TemplateMention.DEBTOR_COUNTRY]: 'Skyldnerens land',
        [TemplateMention.DEBTOR_EMAIL]: 'Skyldnerens e-post',
        [TemplateMention.DEBTOR_PHONE]: 'Skyldnerens telefonnummer',
        [TemplateMention.LAST_PAYMENT_DATE]: 'Dato for siste betaling',
        [TemplateMention.LAST_PAYMENT_AMOUNT]: 'Beløp for siste betaling',
        [TemplateMention.DEBTOR_SEQ_ID]: 'Skyldnerens løpenr.',
        [TemplateMention.DEBTOR_CVR_AND_OR_CPR]: 'Skyldnerens CVR og/eller CPR',
        [TemplateMention.CREDITOR_NAME]: 'Kreditorens navn',
        [TemplateMention.CASE_ID]: 'Saks-ID',
        [TemplateMention.CASE_REFERENCE_ID]: 'Sakens referanse-ID',
        [TemplateMention.CREDITOR_ADDRESS]: 'Kreditorens adresse',
        [TemplateMention.REMINDER_FEES]: 'Purregebyrer',
        [TemplateMention.COLLECTOR_PAYMENT_OPTIONS]: 'Betalingsmuligheter',
        [TemplateMention.COLLECTOR_ACCOUNT_NUMBER]: 'Inkassobyråets kontonummer',
        [TemplateMention.COLLECTOR_REGISTER_NUMBER]: 'Inkassobyråets registreringsnummer',
        [TemplateMention.COLLECTOR_PHONE]: 'Inkassobyråets telefon',
        [TemplateMention.COLLECTOR_COURT_PHONE]: 'Inkassobyråets domstolstelefon',
        [TemplateMention.COLLECTOR_EMAIL]: 'Inkassobyråets e-post',
        [TemplateMention.COLLECTOR_NICKNAME]: 'Inkassobyråets kallenavn',
        [TemplateMention.COLLECTOR_NAME]: 'Inkassobyråets navn',
        [TemplateMention.COLLECTOR_ADDRESS_ADDRESS]: 'Inkassobyråets adresse',
        [TemplateMention.COLLECTOR_ADDRESS_CITY]: 'Inkassobyråets by',
        [TemplateMention.COLLECTOR_ADDRESS_ZIP]: 'Inkassobyråets postnummer',
        [TemplateMention.COLLECTOR_CVR]: 'Inkassobyråets CVR',
        [TemplateMention.CREDITOR_ZIPCODE]: 'Kreditorens postnummer',
        [TemplateMention.CREDITOR_CITY]: 'Kreditorens by',
        [TemplateMention.CREDITOR_COMPANY_IDENTIFIER]: 'Kreditorens CVR',
        [TemplateMention.PAYMENT_ID]: 'Betalings-ID',
        [TemplateMention.JOURNAL_NUMBER]: 'Journalnummer',
        [TemplateMention.COURT_NAME]: 'Domstolens navn',
        [TemplateMention.COURT_ADDRESS]: 'Domstolens adresse',
        [TemplateMention.COURT_CITY]: 'Domstolens by',
        [TemplateMention.COURT_ZIP]: 'Domstolens postnummer',
        [TemplateMention.COURT_EMAIL]: 'Domstolens e-post',
        [TemplateMention.COURT_PHONE]: 'Domstolens telefon',
        [TemplateMention.COURT_EAN]: 'Domstolens EAN',
        [TemplateMention.REG_NO]: 'Domstolens registreringsnummer',
        [TemplateMention.ACCOUNT_NO]: 'Domstolens kontonummer',
        [TemplateMention.PAYMENT_PLAN_HTML]: 'Oversikt over betalingsplanens avdrag',
        [TemplateMention.CONTACT_ADDRESS_INLINE]: 'Kontaktens adresse på én linje',
        [TemplateMention.CONTACT_ADDRESS_FORMATTED]: 'Kontaktens adresse formatert',
        [TemplateMention.ALTERNATIVE_CONTACT_REFERENCE_ID]: 'Alternativ kontakts referanse-ID',
        [TemplateMention.HAS_ALTERNATIVE_CONTACT_REFERENCE_ID]: 'Hvis alternativ kontakt har en referanse-ID',
        [TemplateMention.DEBTOR_ADDRESS_INLINE]: 'Skyldnerens adresse på én linje',
        [TemplateMention.DEBTOR_ADDRESS_FORMATTED]: 'Skyldnerens adresse formatert',
        [TemplateMention.DEBTOR_TABLE]: 'Skyldnertabell',
        [TemplateMention.SIGN_FIELDS]: 'Signeringsfelter',
        [TemplateMention.DK_BPK]: 'Betalingspåkrav',
        [TemplateMention.GL_BPK]: 'GL Betalingspåkrav',
        [TemplateMention.PAGE_BREAK]: 'Sideskift',
        [TemplateMention.PAYMENT_PLAN_ENTRIES_TAG]: 'Betalingsplanens avdrag',
        [TemplateMention.PAYMENT_PLAN_STATUS_TAG]: 'Betalingsplanens status',
        [TemplateMention.SATISFACTION_BUTTONS]: 'Tilfredshetsknapper',
        [TemplateMention.PAYMENT_PLAN_LINK]: 'Lenke til betalingsplan',
        [TemplateMention.PAYMENT_PLAN_LINK_A_TAG]: 'Lenke til betalingsplan',
        [TemplateMention.OVERPAYMENT_LINK]: 'Lenke til overbetaling',
        [TemplateMention.OVERPAYMENT_LINK_QR_CODE]: 'Lenke til overbetaling QR-kode',
        [TemplateMention.OVERPAYMENT_LINK_A_TAG]: 'Lenke til overbetaling',
        [TemplateMention.PAYMENT_PLAN_LINK_QR_CODE]: 'Lenke til betalingsplan QR-kode',
        [TemplateMention.PAYMENT_LINK]: 'Lenke til betaling',
        [TemplateMention.PAYMENT_LINK_A_TAG]: 'Lenke til betaling',
        [TemplateMention.PAYMENT_LINK_QR_CODE]: 'Lenke til betaling QR-kode',
        [TemplateMention.DEBTOR_WEB_LINK]: 'Lenke til skyldnerweb',
        [TemplateMention.DEBTOR_WEB_LONG_LINK]: 'Lenke til skyldnerweb lang',
        [TemplateMention.DEBTOR_WEB_LINK_A_TAG]: 'Lenke til skyldnerweb',
        [TemplateMention.DEBTOR_WEB_LONG_LINK_A_TAG]: 'Lenke til skyldnerweb lang',
        [TemplateMention.DEBTOR_WEB_LINK_QR_CODE]: 'Lenke til skyldnerweb QR-kode',
        [TemplateMention.CONDITIONAL_ELSE]: 'Ellers',
        [TemplateMention.CONDITIONAL_END_IF]: 'Slutt hvis',
        [TemplateMention.BANK_CREDITOR_NUMBER]: '',
        [TemplateMention.FOUNDATION_TYPE]: 'Grunnlagstype',
        [TemplateMention.FOUNDATION_DATE]: 'Grunnlagsdato',
        [TemplateMention.LATEST_TRIBUNAL_REFERENCE]: 'Siste FS-nr.',
    },
    mentionsExplanation: {
        [TemplateMention.PaymentPlanAmortisation]: 'Opprinnelig betalingsplan med hovedstol, kostnader, renter og restgjeld. Uten betalingsstatus.',
        [TemplateMention.GENERIC_EMAIL_SUBJECT]: 'Tekst til emnefeltet på e-post',
        [TemplateMention.FINANCIALS_PRICIPAL]: 'Sakens totale hovedstol',
        [TemplateMention.FINANCIALS_DEBT_COLLECTION_FEES]: 'Sakens totale inkassogebyr',
        [TemplateMention.FINANCIALS_ADMINISTRATION_COSTS]: 'Sakens totale administrasjonskostnad',
        [TemplateMention.FINANCIALS_COMPENSATION_FEES]: 'Sakens totale kompensasjonsgebyr',
        [TemplateMention.FINANCIALS_INTERESTS]: 'Sakens totale rente',
        [TemplateMention.FINANCIALS_INTEREST_RATE]: 'Den laveste gjeldende renteprosenten på saken',
        [TemplateMention.FINANCIALS_DEBT_COLLECTION_COSTS]: 'Sakens totale inkassokostnad',
        [TemplateMention.PRINCIPAL_REFERENECE_IDS]: 'Hovedstolens referanse-ID-er',
        [TemplateMention.CURRENCY]: 'Valuta for sakens økonomi',
        [TemplateMention.PAYMENT_PLAN_FIRST_AMOUNT]: 'Beløpet for den første betalingen',
        [TemplateMention.PAYMENT_PLAN_FIRST_DEADLINE]: 'Forfallsdato for den første betalingen',
        [TemplateMention.PAYMENT_PLAN_FIRST_DATE]: 'Dato for den første betalingen',
        [TemplateMention.PAYMENT_PLAN_LAST_AMOUNT]: 'Beløpet for den siste betalingen',
        [TemplateMention.PAYMENT_PLAN_LAST_DEADLINE]: 'Forfallsdato for den siste betalingen',
        [TemplateMention.PAYMENT_PLAN_LAST_DATE]: 'Dato for den siste betalingen',
        [TemplateMention.PAYMENT_PLAN_ENTRY_AMOUNT]: 'Beløpet for den seneste betalingen',
        [TemplateMention.PAYMENT_PLAN_ENTRY_DEADLINE]: 'Forfallsdato for den seneste betalingen',
        [TemplateMention.PAYMENT_PLAN_ENTRY_DATE]: 'Dato for den seneste betalingen',
        [TemplateMention.PAYMENT_PLAN_CREATION_DATE]: 'Opprettelsesdato for betalingsplanen',
        [TemplateMention.PAYMENT_PLAN_LENGTH_IN_DAYS]: 'Antall dager i betalingsplanen',
        [TemplateMention.PaymentPlanApr]: 'Betalingsplanens effektive rente som ett enkelt tall i prosent, beregnet etter bilag 1 til den danske kredittavtaleloven',
        [TemplateMention.PAYMENT_PLAN_YEARLY_COSTS]: 'Kostnader i prosent av hovedstolen, satt opp år for år i betalingsplanen',
        [TemplateMention.PAYMENT_PLAN_HAS_YEARLY_INTEREST]: 'Hvis saken har årlig rente',
        [TemplateMention.PAYMENT_PLAN_MIN_ENTRY_AMOUNT]: 'Betalingsplanens min. avdragsbeløp',
        [TemplateMention.PAYMENT_PLAN_MAX_ENTRY_AMOUNT]: 'Betalingsplanens maks. avdragsbeløp',
        [TemplateMention.TOTAL_DEBT]: 'Beløpet for den totale gjelden',
        [TemplateMention.OVERPAYMENT]: 'Overbetalingsbeløp',
        [TemplateMention.ACCORD_TEN_PERCENT]: 'Beløpet for total gjeld med 10 % avslag',
        [TemplateMention.ACCORD_TWENTY_PERCENT]: 'Beløpet for total gjeld med 20 % avslag',
        [TemplateMention.ACCORD_THIRTY_PERCENT]: 'Beløpet for total gjeld med 30 % avslag',
        [TemplateMention.ACCORD_FORTY_PERCENT]: 'Beløpet for total gjeld med 40 % avslag',
        [TemplateMention.ACCORD_FIFTY_PERCENT]: 'Beløpet for total gjeld med 50 % avslag',
        [TemplateMention.ACCORD_SIXTY_PERCENT]: 'Beløpet for total gjeld med 60 % avslag',
        [TemplateMention.ACCORD_SEVENTY_PERCENT]: 'Beløpet for total gjeld med 70 % avslag',
        [TemplateMention.ACCORD_EIGHTY_PERCENT]: 'Beløpet for total gjeld med 80 % avslag',
        [TemplateMention.ACCORD_NINETY_PERCENT]: 'Beløpet for total gjeld med 90 % avslag',
        [TemplateMention.IF_IS_COMPANY]: 'Hvis selskap',
        [TemplateMention.IF_DEBTOR_IS_DEBT_REGISTERED]: 'Hvis skyldner er registrert i et gjeldsregister',
        [TemplateMention.IF_CASE_HAS_MULTIPLE_PRINCIPALS]: 'Hvis saken har flere hovedstoler',
        [TemplateMention.IF_CASE_HAS_REMINDER_FEES]: 'Hvis saken har purregebyrer',
        [TemplateMention.IF_CASE_HAS_COLLECTION_FEES]: 'Hvis saken har inkassogebyrer',
        [TemplateMention.IF_CASE_HAS_COLLECTION_COSTS]: 'Hvis saken har inkassokostnader',
        [TemplateMention.IF_CASE_HAS_COMPENSATION_COSTS]: 'Hvis saken har kompensasjonskostnader',
        [TemplateMention.IF_CASE_HAS_PROCESSRENTE]: 'Hvis saken har prosessrente',
        [TemplateMention.IF_CASE_HAS_FIXED_INTEREST]: 'Hvis saken har fast rente',
        [TemplateMention.IF_CASE_HAS_YEARLT_INTEREST]: 'Hvis saken har årlig rente i prosent',
        [TemplateMention.IF_CASE_HAS_DEPOSIT]: 'Hvis saken har depositum',
        [TemplateMention.DOCUMENTATION]: 'Dokumentasjon',
        [TemplateMention.DATE]: 'Dagens dato',
        [TemplateMention.DATE_IN_THREE_DAYS]: 'Dato om 3 dager',
        [TemplateMention.DATE_IN_SIX_DAYS]: 'Dato om 6 dager',
        [TemplateMention.DATE_IN_TEN_DAYS]: 'Dato om 10 dager',
        [TemplateMention.DATE_IN_ELEVEN_DAYS]: 'Dato om 11 dager',
        [TemplateMention.DATE_IN_TWELVE_DAYS]: 'Dato om 12 dager',
        [TemplateMention.DATE_IN_FOURTEEN_DAYS]: 'Dato om 14 dager',
        [TemplateMention.DATE_IN_SEVENTEEN_DAYS]: 'Dato om 17 dager',
        [TemplateMention.DATE_IN_THIRTY_DAYS]: 'Dato om 30 dager',
        [TemplateMention.PREVIOUS_THREE_YEARS]: 'De tre årstallene som ligger forut for inneværende år',
        [TemplateMention.DEPOSIT]: 'Totalt beløp for depositum',
        [TemplateMention.DEPOSITS_TO_CREDITOR]: 'Beløp innbetalt til kreditor',
        [TemplateMention.DEPOSITS_TO_COLLECTOR]: 'Beløp innbetalt til inkassobyrå',
        [TemplateMention.INTEREST_PAID_LAST_YEAR]: 'Beløp betalt i rente i forrige kalenderår',
        [TemplateMention.CONTACT_NAME]: 'Kontaktpersonens navn',
        [TemplateMention.DEBTOR_NAME]: 'Skyldnerens navn',
        [TemplateMention.DEBTOR_FIRST_NAME]: 'Skyldnerens fornavn',
        [TemplateMention.CONTACT_ADDRESS]: 'Kontaktpersonens gate',
        [TemplateMention.CONTACT_COADDRESS]: 'Kontaktpersonens c/o',
        [TemplateMention.CONTACT_ZIPCODE]: 'Kontaktpersonens postnummer',
        [TemplateMention.CONTACT_CITY]: 'Kontaktpersonens by',
        [TemplateMention.CONTACT_COUNTRY]: 'Kontaktpersonens land',
        [TemplateMention.DEBTOR_ADDRESS]: 'Skyldnerens gate',
        [TemplateMention.DEBTOR_COADDRESS]: 'Skyldnerens c/o',
        [TemplateMention.DEBTOR_ZIPCODE]: 'Skyldnerens postnummer',
        [TemplateMention.DEBTOR_CITY]: 'Skyldnerens by',
        [TemplateMention.DEBTOR_COUNTRY]: 'Skyldnerens land',
        [TemplateMention.DEBTOR_EMAIL]: 'Skyldnerens e-post',
        [TemplateMention.DEBTOR_PHONE]: 'Skyldnerens telefonnummer',
        [TemplateMention.LAST_PAYMENT_DATE]: 'Dato for siste betaling',
        [TemplateMention.LAST_PAYMENT_AMOUNT]: 'Beløp for siste betaling',
        [TemplateMention.DEBTOR_SEQ_ID]: 'Skyldnerens ID',
        [TemplateMention.DEBTOR_CVR_AND_OR_CPR]: 'Skyldnerens CVR og/eller CPR',
        [TemplateMention.CREDITOR_NAME]: 'Kreditorens navn',
        [TemplateMention.CASE_ID]: 'Saks-ID-en',
        [TemplateMention.CASE_REFERENCE_ID]: 'Sakens referanse-ID',
        [TemplateMention.CREDITOR_ADDRESS]: 'Kreditorens adresse',
        [TemplateMention.CREDITOR_IF_IS_COMPANY]: 'Hvis kreditor er et selskap',
        [TemplateMention.CREDITOR_IF_IS_VAT_REGISTERED]: 'Hvis kreditor er mva-registrert',
        [TemplateMention.USER_NAME]: 'Brukernavn',
        [TemplateMention.USER_FIRST_NAME]: 'Brukerens fornavn',
        [TemplateMention.IF_USER]: 'Hvis bruker er tilgjengelig',
        [TemplateMention.IF_COLLECTOR_ALLOWS_BANK_TRANSFERS]: 'Hvis kreditor tillater bankoverføringer',
        [TemplateMention.IF_COLLECTOR_ALLOWS_FI_PAYMENTS]: 'Hvis kreditor tillater FI-betalinger',
        [TemplateMention.REMINDER_FEES]: 'Sakens totale purregebyr',
        [TemplateMention.COLLECTOR_PAYMENT_OPTIONS]: 'Betalingsmuligheter',
        [TemplateMention.COLLECTOR_ACCOUNT_NUMBER]: 'Inkassobyråets bankkontonummer',
        [TemplateMention.COLLECTOR_REGISTER_NUMBER]: 'Inkassobyråets bankregistreringsnummer',
        [TemplateMention.COLLECTOR_PHONE]: 'Inkassobyråets telefonnummer',
        [TemplateMention.COLLECTOR_COURT_PHONE]: 'Inkassobyråets domstolstelefonnummer',
        [TemplateMention.COLLECTOR_EMAIL]: 'Inkassobyråets e-post',
        [TemplateMention.COLLECTOR_NICKNAME]: 'Inkassobyråets kallenavn',
        [TemplateMention.COLLECTOR_NAME]: 'Inkassobyråets navn',
        [TemplateMention.COLLECTOR_ADDRESS_ADDRESS]: 'Inkassobyråets adresse',
        [TemplateMention.COLLECTOR_ADDRESS_CITY]: 'Inkassobyråets by',
        [TemplateMention.COLLECTOR_ADDRESS_ZIP]: 'Inkassobyråets postnummer',
        [TemplateMention.COLLECTOR_CVR]: 'Inkassobyråets CVR',
        [TemplateMention.CREDITOR_ZIPCODE]: 'Kreditorens postnummer',
        [TemplateMention.CREDITOR_CITY]: 'Kreditorens by',
        [TemplateMention.CREDITOR_COMPANY_IDENTIFIER]: 'Kreditorens CVR',
        [TemplateMention.PAYMENT_ID]: 'Betalings-ID / FIK-nummer',
        [TemplateMention.JOURNAL_NUMBER]: 'Journalnummer',
        [TemplateMention.COURT_NAME]: 'Domstolens navn',
        [TemplateMention.COURT_ADDRESS]: 'Sivil domstols adresse',
        [TemplateMention.COURT_CITY]: 'Domstolens by',
        [TemplateMention.COURT_ZIP]: 'Domstolens postnummer',
        [TemplateMention.COURT_EMAIL]: 'Domstolens e-post',
        [TemplateMention.COURT_PHONE]: 'Domstolens telefon',
        [TemplateMention.COURT_EAN]: 'Domstolens EAN',
        [TemplateMention.REG_NO]: 'Domstolens registreringsnummer',
        [TemplateMention.ACCOUNT_NO]: 'Domstolens kontonummer',
        [TemplateMention.PAYMENT_PLAN_HTML]: 'Oversikt over antall betalinger og beløp',
        [TemplateMention.CONTACT_ADDRESS_INLINE]: 'Kontaktpersonens fulle adresse på én linje',
        [TemplateMention.CONTACT_ADDRESS_FORMATTED]: 'Kontaktpersonens fulle adresse på flere linjer',
        [TemplateMention.ALTERNATIVE_CONTACT_REFERENCE_ID]: 'Alternativ kontakts referanse-ID',
        [TemplateMention.HAS_ALTERNATIVE_CONTACT_REFERENCE_ID]: 'Hvis alternativ kontakt har en referanse-ID',
        [TemplateMention.DEBTOR_ADDRESS_INLINE]: 'Skyldnerens fulle adresse på én linje',
        [TemplateMention.DEBTOR_ADDRESS_FORMATTED]: 'Skyldnerens fulle adresse på flere linjer',
        [TemplateMention.DEBTOR_TABLE]: 'Tabell som viser alle skyldnere i saken',
        [TemplateMention.SIGN_FIELDS]: 'Signeringsfelter',
        [TemplateMention.DK_BPK]: 'PDF av betalingspåkrav',
        [TemplateMention.GL_BPK]: 'PDF av betalingspåkrav (GL)',
        [TemplateMention.PAGE_BREAK]: 'Sideskift',
        [TemplateMention.PAYMENT_LINK]: 'Lenke til å betale hele gjelden',
        [TemplateMention.PAYMENT_PLAN_LINK]: 'Lenke til å signere gjeldserklæringen',
        [TemplateMention.PAYMENT_PLAN_LINK_QR_CODE]: 'Lenke til betalingsplan (QR-kode)',
        [TemplateMention.PAYMENT_LINK_QR_CODE]: 'Lenke til betaling (QR-kode)',
        [TemplateMention.DEBTOR_WEB_LINK_QR_CODE]: 'Lenke til skyldnerweb (QR-kode)',
        [TemplateMention.DEBTOR_WEB_LINK]: 'Lenke til skyldnerweb',
        [TemplateMention.DEBTOR_WEB_LONG_LINK]: 'Lenke til skyldnerweb lang',
        [TemplateMention.PAYMENT_LINK_A_TAG]: 'Lenke til å betale hele gjelden',
        [TemplateMention.PAYMENT_PLAN_ENTRIES_TAG]: 'Tabell som viser betaling, dato og status',
        [TemplateMention.PAYMENT_PLAN_STATUS_TAG]: 'Statuskort med fremdrift, betalt beløp, gjenstående beløp og neste betaling',
        [TemplateMention.SATISFACTION_BUTTONS]: 'Tilfredshetsknapper',
        [TemplateMention.PAYMENT_PLAN_LINK_A_TAG]: 'Lenke til å signere gjeldserklæringen',
        [TemplateMention.OVERPAYMENT_LINK]: 'Lenke til overbetaling',
        [TemplateMention.OVERPAYMENT_LINK_QR_CODE]: 'Lenke til overbetaling QR-kode',
        [TemplateMention.OVERPAYMENT_LINK_A_TAG]: 'Lenke til overbetaling',
        [TemplateMention.DEBTOR_WEB_LINK_A_TAG]: 'Lenke til skyldnerweb',
        [TemplateMention.DEBTOR_WEB_LONG_LINK_A_TAG]: 'Lenke til skyldnerweb lang',
        [TemplateMention.CONDITIONAL_ELSE]: 'Ellers',
        [TemplateMention.CONDITIONAL_END_IF]: 'Slutt hvis',
        [TemplateMention.BANK_CREDITOR_NUMBER]: '',
        [TemplateMention.FOUNDATION_TYPE]: 'Grunnlagstype',
        [TemplateMention.FOUNDATION_DATE]: 'Grunnlagsdato',
        [TemplateMention.LATEST_TRIBUNAL_REFERENCE]: 'Siste FS-nr.',
    },
    mentionsExample: {
        [TemplateMention.PaymentPlanAmortisation]: 'Dato | Hovedstol | Kostnader | Renter | Påløpte renter | Totalt | Avdrag | Restgjeld',
        [TemplateMention.GENERIC_EMAIL_SUBJECT]: 'Angående din gjeld til Testkreditor AS [saksnr.: 171001-171533]',
        [TemplateMention.FINANCIALS_PRICIPAL]: '8 570,14 ',
        [TemplateMention.FINANCIALS_DEBT_COLLECTION_FEES]: '100,00',
        [TemplateMention.FINANCIALS_ADMINISTRATION_COSTS]: '175,00',
        [TemplateMention.FINANCIALS_COMPENSATION_FEES]: '310,00',
        [TemplateMention.FINANCIALS_INTERESTS]: '26,70 ',
        [TemplateMention.FINANCIALS_INTEREST_RATE]: '10%',
        [TemplateMention.FINANCIALS_DEBT_COLLECTION_COSTS]: '700,00',
        [TemplateMention.PRINCIPAL_REFERENECE_IDS]: '123, 124 og 125',
        [TemplateMention.CURRENCY]: 'NOK',
        [TemplateMention.PAYMENT_PLAN_FIRST_AMOUNT]: '200,00',
        [TemplateMention.PAYMENT_PLAN_FIRST_DEADLINE]: '20. oktober 2021',
        [TemplateMention.PAYMENT_PLAN_FIRST_DATE]: '15. oktober 2021',
        [TemplateMention.PAYMENT_PLAN_LAST_AMOUNT]: '170,14',
        [TemplateMention.PAYMENT_PLAN_LAST_DEADLINE]: '20. august 2024',
        [TemplateMention.PAYMENT_PLAN_LAST_DATE]: '15. august 2024',
        [TemplateMention.PAYMENT_PLAN_ENTRY_AMOUNT]: '200,00',
        [TemplateMention.PAYMENT_PLAN_ENTRY_DEADLINE]: '20. november 2021',
        [TemplateMention.PAYMENT_PLAN_ENTRY_DATE]: '15. november 20211',
        [TemplateMention.PAYMENT_PLAN_CREATION_DATE]: '17. september 2021',
        [TemplateMention.PAYMENT_PLAN_LENGTH_IN_DAYS]: '1035',
        [TemplateMention.PaymentPlanApr]: '12,34',
        [TemplateMention.PAYMENT_PLAN_YEARLY_COSTS]: '* 1. års effektiv rente: 1,33',
        [TemplateMention.PAYMENT_PLAN_HAS_YEARLY_INTEREST]: 'Hvis saken har renter',
        [TemplateMention.PAYMENT_PLAN_MIN_ENTRY_AMOUNT]: '55,00',
        [TemplateMention.PAYMENT_PLAN_MAX_ENTRY_AMOUNT]: '550,00',
        [TemplateMention.TOTAL_DEBT]: '6 770,14',
        [TemplateMention.OVERPAYMENT]: '123,23',
        [TemplateMention.ACCORD_TEN_PERCENT]: '6 093,13',
        [TemplateMention.ACCORD_TWENTY_PERCENT]: '5 416,11',
        [TemplateMention.ACCORD_THIRTY_PERCENT]: '4 739,10',
        [TemplateMention.ACCORD_FORTY_PERCENT]: '4 062,08',
        [TemplateMention.ACCORD_FIFTY_PERCENT]: '3 385,07',
        [TemplateMention.ACCORD_SIXTY_PERCENT]: '2 708,06',
        [TemplateMention.ACCORD_SEVENTY_PERCENT]: '2 031,04',
        [TemplateMention.ACCORD_EIGHTY_PERCENT]: '1 354,03',
        [TemplateMention.ACCORD_NINETY_PERCENT]: '677,01',
        [TemplateMention.IF_IS_COMPANY]: 'Betingelse hvis selskap',
        [TemplateMention.IF_DEBTOR_IS_DEBT_REGISTERED]: 'Betingelse hvis skyldner er registrert i et gjeldsregister',
        [TemplateMention.IF_CASE_HAS_MULTIPLE_PRINCIPALS]: 'Betingelse hvis saken har flere hovedstoler',
        [TemplateMention.IF_CASE_HAS_REMINDER_FEES]: 'Betingelse hvis saken har purregebyrer',
        [TemplateMention.IF_CASE_HAS_COLLECTION_FEES]: 'Betingelse hvis saken har inkassosalærer',
        [TemplateMention.IF_CASE_HAS_COLLECTION_COSTS]: 'Betingelse hvis saken har inkassokostnader',
        [TemplateMention.IF_CASE_HAS_COMPENSATION_COSTS]: 'Betingelse hvis saken har kompensasjonskostnader',
        [TemplateMention.IF_CASE_HAS_PROCESSRENTE]: 'Betingelse hvis saken har prosessrente',
        [TemplateMention.IF_CASE_HAS_FIXED_INTEREST]: 'Betingelse hvis saken har fast rente',
        [TemplateMention.IF_CASE_HAS_YEARLT_INTEREST]: 'Betingelse hvis saken har årlig rente',
        [TemplateMention.IF_CASE_HAS_DEPOSIT]: 'Betingelse hvis saken har depositum',
        [TemplateMention.DOCUMENTATION]: 'Dokumentasjon',
        [TemplateMention.DATE]: '23. november 2021',
        [TemplateMention.DATE_IN_THREE_DAYS]: '26. november 2021',
        [TemplateMention.DATE_IN_SIX_DAYS]: '29. november 2021',
        [TemplateMention.DATE_IN_TEN_DAYS]: '3. desember 2021',
        [TemplateMention.DATE_IN_ELEVEN_DAYS]: '4. desember 2021',
        [TemplateMention.DATE_IN_TWELVE_DAYS]: '5. desember 2021',
        [TemplateMention.DATE_IN_FOURTEEN_DAYS]: '7. desember 2021',
        [TemplateMention.DATE_IN_SEVENTEEN_DAYS]: '10. desember 2021',
        [TemplateMention.DATE_IN_THIRTY_DAYS]: '23. desember 2021',
        [TemplateMention.PREVIOUS_THREE_YEARS]: '2018, 2019 og 2020',
        [TemplateMention.DEPOSIT]: '400,00',
        [TemplateMention.DEPOSITS_TO_CREDITOR]: '200,00',
        [TemplateMention.DEPOSITS_TO_COLLECTOR]: '200,00',
        [TemplateMention.INTEREST_PAID_LAST_YEAR]: '1 234,56',
        [TemplateMention.CONTACT_NAME]: 'Debbie Kontaktsen',
        [TemplateMention.DEBTOR_NAME]: 'Debbie Skyldnersen',
        [TemplateMention.DEBTOR_FIRST_NAME]: 'Debbie',
        [TemplateMention.CONTACT_ADDRESS]: 'Storgata 7',
        [TemplateMention.CONTACT_COADDRESS]: 'Emil Brandt',
        [TemplateMention.CONTACT_ZIPCODE]: '0155',
        [TemplateMention.CONTACT_CITY]: 'Oslo',
        [TemplateMention.CONTACT_COUNTRY]: 'Norge',
        [TemplateMention.DEBTOR_ADDRESS]: 'Storgata 7',
        [TemplateMention.DEBTOR_COADDRESS]: 'Emil Brandt',
        [TemplateMention.DEBTOR_ZIPCODE]: '0155',
        [TemplateMention.DEBTOR_CITY]: 'Oslo',
        [TemplateMention.DEBTOR_COUNTRY]: 'Norge',
        [TemplateMention.DEBTOR_EMAIL]: 'skyldner@example.com',
        [TemplateMention.DEBTOR_PHONE]: '88888888',
        [TemplateMention.LAST_PAYMENT_DATE]: '12. oktober 2021',
        [TemplateMention.LAST_PAYMENT_AMOUNT]: '200,00',
        [TemplateMention.DEBTOR_SEQ_ID]: '111111',
        [TemplateMention.DEBTOR_CVR_AND_OR_CPR]: '12345678',
        [TemplateMention.CREDITOR_NAME]: 'Testkreditor AS',
        [TemplateMention.CASE_ID]: '12345678',
        [TemplateMention.CASE_REFERENCE_ID]: '123456789',
        [TemplateMention.CREDITOR_ADDRESS]: 'Storgata 7',
        [TemplateMention.CREDITOR_IF_IS_COMPANY]: 'Logikk hvis kreditor er et selskap',
        [TemplateMention.CREDITOR_IF_IS_VAT_REGISTERED]: 'Logikk hvis kreditor er mva-registrert',
        [TemplateMention.USER_NAME]: 'Peter Petersen',
        [TemplateMention.USER_FIRST_NAME]: 'Peter',
        [TemplateMention.IF_USER]: 'Logikk hvis bruker er tilgjengelig',
        [TemplateMention.IF_COLLECTOR_ALLOWS_BANK_TRANSFERS]: 'Logikk hvis kreditor tillater bankoverføringer',
        [TemplateMention.IF_COLLECTOR_ALLOWS_FI_PAYMENTS]: 'Logikk hvis kreditor tillater FI-betalinger',
        [TemplateMention.REMINDER_FEES]: '300,00',
        [TemplateMention.COLLECTOR_PAYMENT_OPTIONS]: 'Betalingsalternativer',
        [TemplateMention.COLLECTOR_ACCOUNT_NUMBER]: '12345678',
        [TemplateMention.COLLECTOR_REGISTER_NUMBER]: '1234',
        [TemplateMention.COLLECTOR_PHONE]: '11223344',
        [TemplateMention.COLLECTOR_COURT_PHONE]: '11223345',
        [TemplateMention.COLLECTOR_EMAIL]: 'inkassobyra@debbie.dk',
        [TemplateMention.COLLECTOR_NICKNAME]: 'Testinkassobyrå',
        [TemplateMention.COLLECTOR_NAME]: 'Testinkassobyrå AS',
        [TemplateMention.COLLECTOR_ADDRESS_ADDRESS]: 'Storgata 7',
        [TemplateMention.COLLECTOR_ADDRESS_CITY]: 'Oslo',
        [TemplateMention.COLLECTOR_ADDRESS_ZIP]: '0155',
        [TemplateMention.COLLECTOR_CVR]: '88776655',
        [TemplateMention.CREDITOR_ZIPCODE]: '0155',
        [TemplateMention.CREDITOR_CITY]: 'Oslo',
        [TemplateMention.CREDITOR_COMPANY_IDENTIFIER]: '66554433',
        [TemplateMention.PAYMENT_ID]: '+71<000000001111111 + 12345678<',
        [TemplateMention.JOURNAL_NUMBER]: '12345678-111111',
        [TemplateMention.COURT_NAME]: 'Oslo tingrett',
        [TemplateMention.COURT_ADDRESS]: 'C.J. Hambros plass 4',
        [TemplateMention.COURT_CITY]: 'Oslo',
        [TemplateMention.COURT_ZIP]: '0164',
        [TemplateMention.COURT_EMAIL]: 'namsfogden@domstol.no',
        [TemplateMention.COURT_PHONE]: '99687000',
        [TemplateMention.COURT_EAN]: '5798000161252',
        [TemplateMention.REG_NO]: '0216',
        [TemplateMention.ACCOUNT_NO]: '4069134793',
        [TemplateMention.PAYMENT_PLAN_HTML]: '* 1. Innskudd på NOK 200,00 før 15. oktober 2021',
        [TemplateMention.CONTACT_ADDRESS_INLINE]: 'Storgata 7, 0155 Oslo',
        [TemplateMention.CONTACT_ADDRESS_FORMATTED]: 'Storgata 7,\n 0155 Oslo',
        [TemplateMention.ALTERNATIVE_CONTACT_REFERENCE_ID]: '123-123',
        [TemplateMention.HAS_ALTERNATIVE_CONTACT_REFERENCE_ID]: 'Logikk hvis alternativ kontaktreferanse-id finnes',
        [TemplateMention.DEBTOR_ADDRESS_INLINE]: 'Storgata 7, 0155 Oslo',
        [TemplateMention.DEBTOR_ADDRESS_FORMATTED]: 'Storgata 7,\n 0155 Oslo',
        [TemplateMention.DEBTOR_TABLE]: 'Skyldner 1|Skyldner 2|...',
        [TemplateMention.SIGN_FIELDS]: 'Dato\n_______________________\nSignatur',
        [TemplateMention.DK_BPK]: 'PDF',
        [TemplateMention.GL_BPK]: 'PDF',
        [TemplateMention.PAGE_BREAK]: 'Sideskift',
        [TemplateMention.PAYMENT_LINK]: 'debtorweb.dk/r/fulldebt',
        [TemplateMention.DEBTOR_WEB_LINK]: 'debtorweb.dk',
        [TemplateMention.DEBTOR_WEB_LONG_LINK]: 'debtorweb.dk',
        [TemplateMention.PAYMENT_PLAN_LINK]: 'debtorweb.dk/r/paymentplant',
        [TemplateMention.OVERPAYMENT_LINK]: 'debtorweb.dk/r/overindbetaling',
        [TemplateMention.OVERPAYMENT_LINK_QR_CODE]: 'QR-kode',
        [TemplateMention.OVERPAYMENT_LINK_A_TAG]: 'debtorweb.dk/r/overindbetaling',
        [TemplateMention.PAYMENT_PLAN_LINK_QR_CODE]: 'QR-kode',
        [TemplateMention.PAYMENT_LINK_QR_CODE]: 'QR-kode',
        [TemplateMention.DEBTOR_WEB_LINK_QR_CODE]: 'QR-kode',
        [TemplateMention.PAYMENT_LINK_A_TAG]: 'debtorweb.dk/r/fulldebt',
        [TemplateMention.PAYMENT_PLAN_ENTRIES_TAG]: 'Beløp | Dato | Status',
        [TemplateMention.PAYMENT_PLAN_STATUS_TAG]: '3 av 8 oppføringer · Neste 31.05.26',
        [TemplateMention.SATISFACTION_BUTTONS]: '(:D) (:|) (:C)',
        [TemplateMention.PAYMENT_PLAN_LINK_A_TAG]: 'debtorweb.dk/r/paymentplant',
        [TemplateMention.DEBTOR_WEB_LINK_A_TAG]: 'debtorweb.dk',
        [TemplateMention.DEBTOR_WEB_LONG_LINK_A_TAG]: 'debtorweb.dk',
        [TemplateMention.CONDITIONAL_ELSE]: 'Ellers',
        [TemplateMention.CONDITIONAL_END_IF]: 'Avslutt hvis',
        [TemplateMention.BANK_CREDITOR_NUMBER]: 'Ikke tilgjengelig',
        [TemplateMention.FOUNDATION_TYPE]: 'Dom',
        [TemplateMention.FOUNDATION_DATE]: '23. november 2021',
        [TemplateMention.LATEST_TRIBUNAL_REFERENCE]: 'FS 11-1111/1111',
    },
    import: {
        result: {
            description: 'Dataene dine er importert. Her kan du se resultatet og arbeide videre med sakene.',
            finishedWithErrors: 'Import fullført med feil',
            errorsDescription: 'Importen er fullført, men noen rader kunne ikke importeres.',
            processedSheets: 'Importerte ark',
            processedRows: 'rader behandlet',
            sheet: 'Ark',
            viewCases: 'Se opprettede saker',
            failedTitle: 'Disse radene trenger oppmerksomhet',
            failedDescription: 'Last ned radene som feilet, rett feilene og importer bare de rettede radene i en ny import.',
            viewFailedRows: 'Se feilede rader',
            nextStep: 'Klar for neste steg',
            approveDescription: 'Når du har gjennomgått resultatet, kan du godkjenne de opprettede sakene som venter på godkjenning.',
            actionStarted: 'Handlingen er lagt i kø. Du mottar en e-post når den er ferdig.',
            noCreatedCases: 'Importen har ingen opprettede saker.',
            endTitle: 'Avslutt de opprettede sakene',
            endDescription: 'Dette avslutter de opprettede sakene som venter på godkjenning eller er godkjent, med årsaken Feil fra vår side. Vil du fortsette?',
        },
        progress: {
            linking: 'Knytter kontaktpersoner',
            title: 'Importerer dataene dine',
            description: 'Du kan forlate siden. Importen fortsetter i bakgrunnen og fremdriften lagres fortløpende.',
            preparing: 'Forbereder importen',
            rows: 'rader importert',
            pending: 'Venter',
            running: 'Importerer',
            completed: 'Ferdig',
            failed: 'Stoppet',
            pausedTitle: 'Importen trenger oppmerksomhet',
            pausedDescription: 'En oppgave mislyktes etter flere forsøk. Rett årsaken og gjenoppta importen. Allerede importerte data blir ikke opprettet igjen.',
            retry: 'Gjenoppta import',
            finishing: 'Avslutter importen',
            legacy: 'Denne importen ble startet uten lagret fremdrift. Status oppdateres når den er ferdig.',
        },
        workbook: {
            otherCaseGroup: 'Annen saksgruppe · lagres, men brukes ikke i denne importen',
            otherCaseGroupMappings: 'Tilordningen inneholder attributter for andre saksgrupper. De bevares og brukes når du importerer til den aktuelle saksgruppen.',
            unavailableField: 'Utilgjengelig felt',
            unavailableMappings: 'Noen tilordninger bruker utilgjengelige felt',
            unavailableMappingsDescription: 'Et valgt felt finnes ikke lenger eller kan ikke importeres i dette arket. Åpne kolonnens feltvalg og fjern eller erstatt det utilgjengelige feltet. Attributter for andre saksgrupper bevares og utløser ikke denne advarselen.',
            selectField: 'Velg felt',
            reuploadForHeaders: 'Last opp filen på nytt for å endre overskriftsraden.',
            fields: {
                accountNumber: 'Bankkontonummer',
                address: 'Adresse',
                administrationCost: 'Administrasjonskostnad',
                alternativeContactAddress: 'Alternativ kontakt: adresse',
                alternativeContactCity: 'Alternativ kontakt: sted',
                alternativeContactCoAddress: 'Alternativ kontakt: c/o-adresse',
                alternativeContactCountry: 'Alternativ kontakt: land',
                alternativeContactEmail: 'Alternativ kontakt: e-post',
                alternativeContactName: 'Alternativ kontakt: navn',
                alternativeContactPhone: 'Alternativ kontakt: telefonnummer',
                alternativeContactType: 'Alternativ kontakt: type',
                alternativeContactZipcode: 'Alternativ kontakt: postnummer',
                amount: 'Beløp',
                bailifsFee: 'Namsmannsgebyr',
                bailifsSalary: 'Namsmannssalær',
                birthdate: 'Fødselsdato',
                bpkWarnedAt: 'BPK-varslet',
                caseCreatedAt: 'Sak opprettet',
                caseGroup: 'Saksgruppe',
                caseReferenceId: 'Saksreferanse',
                caseSeqId: 'Saksnummer',
                caseStatus: 'Saksstatus',
                caseTags: 'Saksetiketter',
                centralRegisterId: 'Organisasjonsnummer',
                city: 'Sted',
                clientContactUserEmail: 'Kontaktpersonens e-post',
                coAddress: 'C/o-adresse',
                collectionCost: 'Inkassokostnader',
                collectionFee: 'Inkassosalær',
                compensationCost: 'Kompensasjonskostnader',
                compoundInterestRate: 'Rentes rente',
                continuedAt: 'Gjenopptakelsesdato',
                controlFee: 'Kontrollgebyr',
                country: 'Land',
                countryCode: 'Landskode',
                cpr: 'Fødselsnummer',
                createdAt: 'Opprettet',
                createdByUserWithEmail: 'Opprettet av bruker med e-post',
                creditNote: 'Kreditnota',
                creditorReferenceId: 'Kreditorreferanse-ID',
                currency: 'Valuta',
                customerReferenceId: 'Kundereferanse',
                customerTerminated: 'Kunde avsluttet',
                cvr: 'Organisasjonsnummer',
                date: 'Dato',
                debtDescription: 'Bilagsbeskrivelse',
                debtReferenceId: 'Faktura-ID',
                defaultBillingModelId: 'Standardavregningsmodell',
                defaultWorkflowId: 'Standardarbeidsflyt',
                deposit: 'Depositum',
                dueDate: 'Forfallsdato',
                economyBillingModelId: 'Faktureringsmodell',
                email: 'E-post',
                endReason: 'Avslutningsårsak',
                experianClientId: 'Kundenummer hos Experian',
                expirationFromDate: 'Foreldelse fra dato',
                fiPaymentIdRaw: 'FI-betalings-ID',
                fileId: 'Fil-ID',
                fileName: 'Filnavn',
                fileNote: 'Filnotat',
                finalSettlement: 'Sluttoppgjør',
                finalStatement: 'Sluttoppgjør',
                firstName: 'Fornavn',
                fixedInterest: 'Fast rente',
                fogedRekvisitionsFee: 'Utleggsbegjæringsgebyr',
                from: 'Avsender',
                html: 'Innhold (HTML)',
                imposedByCreditor: 'Pålagt av kreditor',
                interestEndDate: 'Sluttdato for renter',
                interestRate: 'Rentesats',
                interestStartDate: 'Rentestartdato',
                interval: 'Intervall',
                isCompany: 'Er selskap',
                issueDate: 'Dato',
                lang: 'Språk',
                lastName: 'Etternavn',
                loan: 'Lån',
                migratedId: 'Migrert journalnummer',
                migratedStepId: 'Migrert oppgave-ID',
                name: 'Navn',
                newUserToken: 'Invitasjonstoken for ny bruker',
                note: 'Notat',
                notes: 'Notater',
                onAccount: 'Aconto',
                pausedAt: 'Pausedato',
                phone: 'Telefon',
                phoneLocale: 'Telefonlandskode',
                phoneNumber: 'Telefonnummer',
                policePresentationFee: 'Politifremstillingsgebyr',
                principal: 'Hovedstol',
                referenceId: 'Referansenummer',
                referenceVoucherReferenceId: 'Relatert posteringsreferanse',
                referenceVoucherTypeId: 'Relatert posteringstype',
                refund: 'Refusjon',
                registrationNumber: 'Bankregistreringsnummer',
                registryIdentifierScheme: 'Type registeridentifikator',
                registryIdentifierValue: 'Registeridentifikator',
                remindedAt: 'Påminnelsesdato',
                reminderFee: 'Purregebyrer',
                reminderFeeCollector: 'Purregebyrer fra inkassobyrå',
                rkiWarnedAt: 'RKI-varslet',
                role: 'Rolle',
                settlement: 'Forlik',
                signedAt: 'Signeringsdato',
                startDate: 'Startdato',
                state: 'Tilstand',
                subject: 'Emne',
                text: 'Tekst',
                to: 'Mottaker',
                type: 'Type',
                udtraeksgebyr: 'Uttaksgebyr',
                ultimateCreditorReferenceId: 'Opprinnelig kreditors referansenummer',
                update: 'Oppdatering',
                updateTypeId: 'Oppdateringstype',
                vatRegistered: 'MVA-registrert',
                visibleForDebtor: 'Synlig for skyldneren',
                voucherReferenceId: 'Posteringsreferansenummer',
                writFee: 'Stevningsgebyr',
                writSalary: 'Stevningssalær',
                zipcode: 'Postnummer',
            },
            mappedFromColumn: 'Kolonne i filen',
            mappedColumns: 'tilordnede kolonner',
            columnHint: 'Klikk på feltet under en kolonneoverskrift for å velge hvor verdiene skal brukes.',
            missingFields: 'Obligatoriske felt uten kolonne',
            emptySheet: 'Arket har ingen datarader. Velg et annet ark eller endre overskriftsraden.',
            mappingHint: 'Velg ett eller flere felt for kolonnen. Et felt kan bare hente verdier fra én kolonne om gangen.',
            sheets: 'ark',
            skipped: 'Importeres ikke',
            importAs: 'Importer som',
            skipSheet: 'Hopp over arket',
            headerRow: 'Overskriftsrad',
            skippedDescription: 'Dette arket er ikke med i importen. Du kan fortsatt se innholdet.',
            sourcePreview: 'Data fra filen',
            searchFields: 'Søk etter felt…',
            searchTypes: 'Søk etter arktype…',
            addFixedValue: 'Legg til fast verdi',
            fixedValue: 'Fast verdi',
            mappingSaving: 'Lagrer oppsett…',
            mappingSaved: 'Oppsettet er lagret',
            mappingSaveFailed: 'Oppsettet kunne ikke lagres. Endringene dine er fortsatt på siden.',
            retryMappingSave: 'Prøv igjen',
            unsavedMapping: 'Endringene dine er ikke lagret ennå. Vil du forlate siden?',
            attachmentNotUploaded: 'Vedlegget er ikke lastet opp',
            fixedFileHint: 'Last opp vedlegget under Last opp vedlegg, og velg deretter filen her.',
            fixedValueHint: 'Gjelder alle rader og erstatter feltets kobling til en Excel-kolonne.',
            removeFixedValue: 'Fjern',
            imposedBy: 'Pålagt av',
            creditor: 'Kreditor',
            collector: 'Inkassator',
            attribute: 'Attributt',
            createAttribute: 'Opprett nytt attributt',
            mappingSettings: 'Innstillinger',
            invertSign: 'Snu fortegn',
            voucherSignHint: 'Beløpene i tabellen skal ha disse fortegnene:',
            voucherDebtSign: 'Gjeld, renter og kostnader: et negativt beløp, f.eks. −1 000,00. Det øker gjelden.',
            voucherCreditSign: 'Kreditnotaer og innbetalinger: et positivt beløp, f.eks. +250,00. Det reduserer gjelden.',
            invertSignDescription: 'Positive verdier blir negative, og negative blir positive. Tabellen viser verdiene med innstillingene dine.',
            duplicateHeaders: 'Kolonnenavn må være unike. Velg riktig overskriftsrad eller gi duplikater nye navn i filen.',
            missingColumns: 'Noen lagrede kolonner mangler. Velg en ny kolonne eller fjern tilordningen.',
            types: {
                cases: 'Saker',
                customers: 'Kunder',
                vouchers: 'Posteringer',
                creditors: 'Kreditorer',
                ultimateCreditors: 'Endelige kreditorer',
                users: 'Brukere',
                billingVouchers: 'Avregningsposteringer',
                notes: 'Notater',
                emails: 'E-post',
                letters: 'Brev',
                sms: 'SMS',
                steps: 'Oppgaver',
                updates: 'Oppdateringer',
                documents: 'Dokumenter',
                paymentPlans: 'Nedbetalingsplaner',
            },
        },
        importedData: 'Importerte data',
        downloadInvoiceExampleHeader: 'Fakturagjeld',
        downloadInvoiceExampleText: 'Last ned importark med eksempler på fakturasaker.',
        downloadFinancialExampleHeader: 'Banksaker',
        downloadFinancialExampleText: 'Last ned importark med eksempler på banksaker.',
        downloadAcontoExampleHeader: 'Aconto-saker',
        downloadAcontoExampleText: 'Last ned importark med aconto-fakturerte saker.',
        downloadMigrationExampleHeader: 'Migrer saker',
        downloadMigrationExampleText: 'Last ned migreringsark med eksempler på migreringsdata.',
        download: 'Last ned eksempel',
        import: 'Importer',
        backToImports: 'Tilbake til importer',
        newImport: 'Ny import',
        noImports: 'Ingen importer å vise',
        casesCreated: 'Saker opprettet',
        casesUpdated: 'Saker oppdatert',
        companyStatuses: 'Selskapsstatuser',
        noStatus: 'Ingen status',
        caseUpdates: 'Saksoppdateringer',
        [ImportState.CANCELED]: 'Avbrutt',
        [ImportState.CREATED]: 'Opprettet',
        [ImportState.DELETED]: 'Slettet',
        [ImportState.IMPORTED]: 'Importert',
        [ImportState.IMPORTING]: 'Importerer',
        [ImportState.SHEETADDED]: 'Ark lagt til',
        create: 'Opprett',
        uploadFile: 'Last opp fil',
        uploadedAppendicies: 'Opplastede vedlegg',
        mapColumns: 'Tilordne kolonner',
        imported: 'Importert',
        dropFileHereOr: 'Slipp fil her eller',
        dropAppendixHereOr: 'Slipp vedlegg her eller',
        uploadImport: 'Last opp importark',
        uploadAppendix: 'Last opp vedlegg',
        workbookGuide: {
            title: 'Last opp Excel-arket ditt',
            description: 'Samle dataene dine i en Excel-fil, og koble kolonnene til feltene i Debbie.',
            dropFile: 'Dra og slipp Excel-arket ditt her',
            fileFormats: 'Velg en Excel-fil i formatet .xlsx eller .xls.',
            replaceFile: 'En ny fil erstatter det nåværende importarket.',
            chooseFile: 'Velg fil',
            uploadTitle: 'Last opp importarket',
            uploadDescription: 'Velg Excel-filen med dataene du vil importere. Filen kan inneholde flere ark.',
            sheetsTitle: 'Velg innholdet i hvert ark',
            sheetsDescription: 'Angi om arket inneholder for eksempel saker, kunder eller posteringer. Hopp over ark som ikke skal importeres.',
            mappingTitle: 'Koble kolonnene og kontroller dataene',
            mappingDescription: 'Koble kolonnene til feltene i Debbie, og rett eventuelle feil før du importerer.',
        },
        appendixGuide: {
            title: 'Knytt vedlegg til radene dine i Excel',
            description: 'Last opp filene dine her, og bruk filnavnene i Excel for å knytte hvert vedlegg til riktig rad.',
            dropFiles: 'Dra og slipp vedleggene dine her',
            multipleFiles: 'Du kan laste opp flere filer samtidig.',
            chooseFiles: 'Velg filer',
            uploadTitle: 'Last opp vedleggene',
            uploadDescription: 'Velg filene som skal være med i importen, for eksempel fakturaer eller avtaler.',
            referenceTitle: 'Skriv filnavnet i Excel',
            referenceDescription: 'Legg til en kolonne med filnavnet på raden vedlegget tilhører. Bruk hele filnavnet, inkludert for eksempel .pdf.',
            mappingTitle: 'Koble kolonnen til et filfelt',
            mappingDescription: 'Last opp det oppdaterte Excel-arket under “Last opp importark”. Koble kolonnen til “Filnavn” eller en filegenskap før du importerer.',
        },
        migration: 'Migrering',
        createdAt: 'Opprettet',
        state: 'Tilstand',
        appendixUploaded: 'Vedlegg lastet opp',
        dropAnotherFileHereOr: 'Slipp en annen fil her eller',
        uploadFileBtn: 'Last opp fil',
        deleteImport: 'Slett import',
        importFinished: 'Import fullført',
        withRKIRegistrations: 'med RKI-registreringer',
        endAll: 'Avslutt alle',
        approveAll: 'Godkjenn alle saker',
        createdCases: 'opprettede saker.',
        startedEnding: 'Startet avslutning av',
        cases: 'saker.',
        found: 'Fant',
        rows: 'rader',
        and: 'og',
        debtors: 'skyldnere',
        chain: 'Arbeidsflyt',
        billingModel: 'Faktureringsmodell',
        tenantStandard: 'Kontostandard',
        creditorStandard: 'Kreditorstandard',
        systemStandard: 'Systemstandard',
        more: 'flere.',
        showMore: 'Vis mer',
        importCases: 'Importer saker',
        youWillreceiveAnEmailWhenItIsDone: 'Du vil motta en e-post når importen er klar.',
        importHasStarted: 'Importen har startet',
        see: 'Se',
        seeMore: 'Se mer',
        here: 'her',
        file: 'filens',
        asWell: 'og',
        notMappedColumns: 'Følgende kolonner er ikke tilordnet',
        errors: 'feil',
        error: 'Feil',
        row: 'Rad',
        column: 'Kolonne',
        columnNotFound: 'Kolonne ikke funnet',
        noErrorsFound: 'Ingen feil funnet',
        rowsHeader: 'Rader',
        columnsHeader: 'Kolonner',
        failedRows: 'Mislykkede rader',
        failedImportRows: 'Mislykkede importrader',
        referenceId: 'Referanse-ID',
        creditorReferenceId: 'Kreditorreferanse-ID',
        isCompany: 'Er selskap',
        caseCreatedAt: 'Sak opprettet',
        caseStatus: 'Saksstatus',
        endReason: 'Avslutningsårsak',
        caseGroup: 'Saksgruppe',
        migratedId: 'Migrert journalnummer',
        name: 'Navn',
        birthdate: 'Fødselsdato',
        cpr: 'Fødselsnummer',
        cvr: 'Organisasjonsnummer',
        email: 'E-post',
        phone: 'Telefon',
        lang: 'Språk',
        address: 'Adresse',
        coAddress: 'C/O-adresse',
        zipcode: 'Postnummer',
        city: 'Sted',
        country: 'Land',
        fiPaymentIdRaw: 'FI-betalings-ID',
        caseTags: 'Sakstagger',
        economyBillingModelId: 'Faktureringsmodell',
        debtReferenceId: 'Faktura-ID',
        fileName: 'Filnavn',
        issueDate: 'Dato',
        dueDate: 'Forfallsdato',
        expirationFromDate: 'Foreldelse fra dato',
        currency: 'Valuta',
        debtDescription: 'Bilagsbeskrivelse',
        principal: 'Hovedstol',
        controlFee: 'Kontrollgebyr',
        onAccount: 'Aconto',
        finalSettlement: 'Sluttoppgjør',
        deposit: 'Depositum',
        loan: 'Lån',
        settlement: 'Forlik',
        fixedInterest: 'Fast rente',
        udtraeksgebyr: 'Uttaksgebyr',
        administrationCost: 'Administrasjonskostnad',
        reminderFee: 'Purregebyrer',
        reminderFeeCollector: 'Purregebyrer fra inkassobyrå',
        refund: 'Refusjon',
        compensationCost: 'Kompensasjonskostnader',
        collectionCost: 'Inkassokostnader',
        collectionFee: 'Inkassosalær',
        writFee: 'Stevningsgebyr',
        writSalary: 'Stevningssalær',
        policePresentationFee: 'Politifremstillingsgebyr',
        fogedRekvisitionsFee: 'Utleggsbegjæringsgebyr',
        bailifsSalary: 'Namsmannssalær',
        bailifsFee: 'Namsmannsgebyr',
        creditNote: 'Kreditnota',
        interestStartDate: 'Rentestartdato',
        interestRate: 'Rentesats',
        finalStatement: 'Sluttoppgjør',
        customerTerminated: 'Kunde avsluttet',
        rkiWarnedAt: 'RKI-varslet',
        bpkWarnedAt: 'BPK-varslet',
        errorWarning: 'Filen din inneholder feil som hindrer importen.',
        faqHeader: 'Trenger du hjelp til å importere saker?',
        faqText: 'Vi har skrevet en artikkel om filimport i hjelpeseksjonen vår. Her finner du også en forklaring på typiske feil ved import av filer.',
        newCase: 'Ny sak',
        selectColumn: '-- Velg kolonne --',
        debtorMessages: 'Debitormeldinger',
        importDebtorMessages: 'Importer debitormeldinger',
    },
    updateTypesSettings: {
        addUpdateType: 'Opprett oppdateringstype',
        title: 'Etikett for oppdateringstype',
        editUpdateType: 'Rediger oppdateringstype',
        createNewUpdateType: 'Opprett ny oppdateringstype',
        customUpdateTypes: 'Opprettede oppdateringstyper',
        standardUpdateTypes: 'Standard oppdateringstyper',
        allUpdateTypes: 'Alle oppdateringstyper',
        filterAutomatic: 'Automatiske',
        filterPause: 'Pause',
        filterInfo: 'Info',
    },
    updateTypes: {
        [UpdateType.CreditorEndedCase]: 'Kreditor har avsluttet saken',
        [UpdateType.AKSStatus]: 'AKS-status',
        [UpdateType.AKSFailed]: 'AKS-tilmelding mislyktes',
        [UpdateType.EXITREQUEST]: 'Avslutningsanmodning fra kreditor',
        [UpdateType.CASESTATUSMOVE]: 'Saksstatus endret',
        [UpdateType.SOP]: 'Sluttoppgjør',
        [UpdateType.UPDATE]: 'Oppdatering',
        [UpdateType.NOCONTACTINFORMATION]: 'Manglende kontaktinformasjon',
        [UpdateType.DEPOSIT]: 'Innskudd',
        [UpdateType.NEWDEBT]: 'Ny gjeld',
        [UpdateType.NEWINTERACTION]: 'Ny innkommende e-post',
        [UpdateType.eBoksFailed]: 'e-Boks-melding kunne ikke leveres',
        [UpdateType.TECHNICALINVESTIGATION]: 'Undersøkt av en tekniker',
        [UpdateType.TERMINATIONREQUEST]: 'Anmodning om avbrudd sendt til kreditor',
        [UpdateType.PENDINGTERMINATION]: 'Avventer avbrudd av saksbehandler',
        [UpdateType.CANCELTERMINATION]: 'Annullert avbrudd',
        [UpdateType.CASECONTINUED]: 'Sak fortsatt',
        [UpdateType.POSTPONECASEWORKING]: 'Utsett saksbehandling',
        [UpdateType.RETURNLETTER]: 'Returnert brev',
        [UpdateType.BOBEHANDLING]: 'Bobehandling',
        [UpdateType.BOBEHANDLET]: 'Bobehandlet',
        [UpdateType.NotSureCourtSubmit]: 'Avventer betalingsoppfordringsblankett',
        [UpdateType.YesCourtSubmit]: 'Klar til automatisk innlevering til domstolen',
        [UpdateType.NoCourtSubmit]: 'Ikke uttatt til automatisk innlevering til domstolen',
        [UpdateType.AWAITINGSTAEVNING]: 'Avventer begjæring',
        [UpdateType.AFDRAGSORDNINGER]: 'Betalingsplan',
        [UpdateType.ApprovedByCreditor]: 'Godkjent av kreditor',
        [UpdateType.ApprovedByDatahub]: 'Godkjent av Datahub',
        [UpdateType.CancelApprovedByDatahub]: 'Annullering godkjent av Datahub',
        [UpdateType.REMOVEFROMRKI]: 'Fjern fra RKI',
        [UpdateType.AUTOREMOVEFROMRKI]: 'Automatisk sletting av RKI-registrering',
        [UpdateType.CancelRejectedByDatahub]: 'Annullering avvist av Datahub',
        [UpdateType.CancelRequestedBecauseOfPaymentToCreditor]: 'Annullering anmodet grunnet betaling til kreditor',
        [UpdateType.RejectedByCreditor]: 'Avvist av kreditor',
        [UpdateType.RejectedByDatahub]: 'Avvist av Datahub',
        [UpdateType.PAYMENTPLANINITIAL]: 'Ny betalingsplan opprettet',
        [UpdateType.NEWCLIENTINTERACTION]: 'Ny kreditorinteraksjon',
        [UpdateType.NEWDEBTORINTERACTION]: 'Ny skyldnerinteraksjon',
        [UpdateType.DEBTORPERSONALDATAREQUEST]: 'Anmodning om endring av skyldnerinformasjon',
        [UpdateType.AWAITINGCLIENTANSWER]: 'Avventer svar fra kreditor',
        [UpdateType.DEFAULTEDPAYMENTPLAN]: 'Misligholdt betalingsplan',
        [UpdateType.OVERPAYPAYMENTPLAN]: 'Overbetalt betalingsplan',
        [UpdateType.RKIApprovalRequest]: 'RKI-anmodning til saksbehandler',
        [UpdateType.RKIREGISTRATION]: 'RKI-registrering påkrevd',
        [UpdateType.DOCSIGNED]: 'Dokument signert',
        [UpdateType.COSMOSUBSCRIBED]: 'Abonnert på Cosmo',
        [UpdateType.COSMOUNSUBSCRIBED]: 'Avmeldt Cosmo',
        [UpdateType.AWAITINGFOGEDREKVISITION]: 'Avventer utleggsbegjæring',
        [UpdateType.ISINFOGEDRETTEN]: 'Hos Namsmannen',
        [UpdateType.ISINCIVILCOURT]: 'I sivil domstol',
        [UpdateType.PAYMENTONCASEINCOURT]: 'Betaling på sak i domstolen',
        [UpdateType.RECEIVEDCOURTFOUNDATION]: 'Mottatt dom/betalingsoppfordringsblankett/rettsforlik avventer utlegg',
        [UpdateType.POLITIFREMSTILLING]: 'Pågripelse ved manglende oppmøte',
        [UpdateType.DECIDECOURT]: 'Vurder rettslig avgjørelse',
        [UpdateType.RKISTATUS]: 'RKI-status',
        [UpdateType.AWAITINGPOWERTERMINATION]: 'Avventer strømstenging',
        [UpdateType.RKIAPPROVEDBYCLIENT]: 'RKI godkjent av kreditor',
        [UpdateType.REQUESTCLIENTRKI]: 'RKI-anmodning til kreditor',
        [UpdateType.TERMINATEDCUSTOMER]: 'Oppsagt kunde',
        [UpdateType.FOGEDREVISITIONCLIENTREQUEST]: 'Anmodning om utleggsbegjæring til kreditor',
        [UpdateType.TICKETRESOLVED]: 'Sak løst',
        [UpdateType.MIGRATIONNOTE]: 'Migreringsnotat',
        [UpdateType.TILJURIDISKBEHANDLING]: 'Til juridisk behandling',
        [UpdateType.COURTEVENTS]: 'Rettshendelser',
        [UpdateType.AFTEROFFICEHOURS]: 'Utsatt til etter kontortid',
        [UpdateType.AWAITINGPAYMENTAFTERCONCILIATION]: 'Avventer betaling etter forlik',
        [UpdateType.PHONEMEETING]: 'Innkalt til telefonisk namsmøte',
        [UpdateType.INSOLVENS]: 'Insolvens',
        [UpdateType.DEBTEXPIRESWITHINTHREEMONTHS]: 'Gjeld foreldes innen tre måneder',
        [UpdateType.DEBTEXPIRED]: 'Gjeld foreldet',
        [UpdateType.EMAILFAILED]: 'E-post mislyktes',
        [UpdateType.EINVOICEFAILED]: 'E-faktura mislyktes',
        [UpdateType.AWAITINGCIVILCOURT]: 'Avventer sivil domstol',
        [UpdateType.AWAITINGFINALSTATEMENT]: 'Avventer sluttoppgjør',
        [UpdateType.MIGRATEDJOURNALNUMBER]: 'Migrert journalnummer',
        [UpdateType.RKIREGISTRATIONOPEN]: 'RKI-registrering (Åpen)',
        [UpdateType.RKIREGISTRATIONCLOSED]: 'RKI-registrering (Lukket)',
        [UpdateType.AUTORKIREGISTRATIONOPEN]: 'Auto-RKI-registrering (Åpen)',
        [UpdateType.AUTORKIREGISTRATIONCLOSED]: 'Auto-RKI-registrering (Lukket)',
        [UpdateType.DEBTREGISTRATIONWARNED]: 'RKI-varslet',
        [UpdateType.STAEVNINGREQUSTCLIENT]: 'Skal skyldner få en begjæring',
        [UpdateType.UDLAEG]: 'Utlegg',
        [UpdateType.UDLAEGCIVIL]: 'Utlegg',
        [UpdateType.NEWCOURTINTERACTION]: 'Ny domstolsinteraksjon',
        [UpdateType.REMINDER]: 'Purring',
        [UpdateType.OUTBOUNDCALL]: 'Utgående anrop',
        [UpdateType.UDLAEGAFLYSES]: 'Utlegg skal avlyses',
        [UpdateType.OPPOSITION]: 'Innsigelse',
        [UpdateType.NOTOPPOSITION]: 'Ikke-innsigelse',
        [UpdateType.FSNUMMER]: 'FS-nummer',
        [UpdateType.OVERDRAGESTILINKASSOPARTNER]: 'Overfør sak til ekstern inkassopartner',
        [UpdateType.AKSUpdateName]: 'AKS oppdatert: Navn',
        [UpdateType.AKSUpdateAddress]: 'AKS oppdatert: Adresse',
        [UpdateType.AKSUpdateStatus]: 'AKS oppdatert: Status',
        [UpdateType.AKSUpdateProtection]: 'AKS oppdatert: Navn/adressebeskyttelse',
        [UpdateType.AKSUpdateNewRKI]: 'AKS oppdatert: Ny RKI-registrering',
        [UpdateType.AKSUpdateDeletedRKI]: 'AKS oppdatert: Slettet RKI-registrering',
        [UpdateType.AKSUpdateCreditWarning]: 'AKS oppdatert: Kredittadvarsel',
        [UpdateType.AKSUpdateAdvertisementPreference]: 'AKS oppdatert: Reklamepreferanse',
        [UpdateType.AKSUpdateGuardianStatus]: 'AKS oppdatert: Vergestatus',
        [UpdateType.AKSUpdateRKI]: 'AKS oppdatert: RKI-merknad',
        [UpdateType.COURTREMINDER]: 'Rettslig påminnelse',
        [UpdateType.DEPARTED]: 'Utreist',
        [UpdateType.DECIDECONTINUE]: 'Vurder fortsettelse',
        [UpdateType.Dead]: 'Skyldner er død',
        [UpdateType.MovedAbroad]: 'Skyldner har flyttet til utlandet',
        [UpdateType.Disappeared]: 'Skyldner har forsvunnet',
        [UpdateType.Homeless]: 'Skyldner er blitt hjemløs',
        [UpdateType.Inactive]: 'Selskapet er inaktivt',
        [UpdateType.OperationsCeased]: 'Selskapet har opphørt driften',
        [UpdateType.GuardianStatus]: 'Vergestatus oppdatert',
        [UpdateType.DeletedRKIRegistration]: 'RKI-registrering slettet',
        [UpdateType.DeletedRKIRegistrationWillingnessToPay]: 'RKI-registrering slettet - indikasjon på betalingsvilje',
        [UpdateType.NewRKIRegristration]: 'Ny RKI-registrering',
        [UpdateType.Address]: 'Adresse oppdatert',
        [UpdateType.AddressProtection]: 'Navn/adressebeskyttelse oppdatert',
        [UpdateType.RKIRemark]: 'RKI-merknad oppdatert',
        [UpdateType.Active]: 'Skyldner er nå aktiv',
        [UpdateType.CompanyActive]: 'Selskapet er nå aktivt',
        [UpdateType.DissolutionStatus]: 'Oppløsningsstatus',
        [UpdateType.PAYMENTPLANCANCLED]: 'Betalingsplan avbrutt',
        [UpdateType.INTERNALREMARK]: 'Intern merknad',
        [UpdateType.MOVETOOPENRKI]: 'Flytt til åpen RKI',
        [UpdateType.DebtorIsUnderage]: 'Skyldner er under 18 år',
        [UpdateType.SentToConnectPartner]: 'Sendt til connect-partner',
        [UpdateType.ReturnedToConnectPartner]: 'Returnert til connect-partner',
        [UpdateType.DebtorCanBeRegisteredInDebtRegister]: 'Skyldner kan registreres i et gjeldsregister',
        [UpdateType.PAYMENTREVOKED]: 'Betaling tilbakekalt',
    },
    updateTypesClient: {
        [UpdateType.AWAITINGCLIENTANSWER]: 'Ny melding fra inkassobyrå',
    },
    caseFilter: {
        moreFilters: 'Filtre',
        advancedFilters: 'Avanserte filtre',
        casesSelected: 'valgte saker',
        aggregationSum: 'Sum',
        orderCaseOverview: 'Bestill saksoversikt',
        creditorsGroup: 'Kreditorer',
        contactsGroup: 'Kontaktpersoner',
        maxRkiRegistrations: 'Maks. RKI-registreringer',
        maxRkiRegistrationsSub: 'Velg maksimalt antall RKI-registreringer skyldneren kan ha.',
        maxRkiRegistrationsBadge: 'RKI maks.',
        minRkiRegistrations: 'Min. RKI-registreringer',
        minRkiRegistrationsSub: 'Velg minimalt antall RKI-registreringer skyldneren kan ha.',
        minRkiRegistrationsBadge: 'RKI min.',
        rkiRegisteredByCollector: 'Er RKI-registrert av inkassobyrå',
        isRegisteredByCollector: 'Er registrert',
        isNotRegisteredByCollector: 'Er ikke registrert',
        contactHasEmail: 'Kontaktpersonen har en e-post',
        contactHasEmailBadge: 'Har e-post',
        contactHasPhone: 'Kontaktpersonen har telefonnummer',
        contactHasPhoneBadge: 'Har telefon',
        contactHasAddress: 'Kontaktpersonen har en adresse',
        contactHasAddressBadge: 'Har adresse',
        contactPersonIs: 'Kontaktpersonen er',
        debtor: 'Skyldner',
        debtorBadge: 'Skyldner er kontaktperson',
        alternativeContact: 'Alternativ kontaktperson',
        alternativeContactBadge: 'Har alternativ kontaktperson',
        company: 'Selskap',
        companyBadge: 'Er selskap',
        person: 'Er person',
        personBadge: 'Er person',
        paymentMethod: 'Betalingsmetode',
        hasCard: 'Har betalingskort',
        doNotHaveCard: 'Har ikke betalingskort',
        companyStatus: 'Selskapsstatus',
        selectCompanyStatus: 'Velg selskapsstatus',
        companyTypes: 'Selskapstyper',
        selectCompanyTypes: 'Velg selskapstyper',
        court: 'Domstol',
        courtBadge: 'Domstol valgt',
        selectCourt: 'Velg domstol',
        companyBranch: 'Bransje',
        selectCompanyBranch: 'Velg bransjer',
        gender: 'Kjønn',
        [Gender.MALE]: 'Mann',
        [Gender.FEMALE]: 'Kvinne',
        [Gender.BOTH]: 'Begge',
        zipcode: 'Postnummer',
        selectZipcode: 'Velg postnummer',
        satisfactions: 'Fornøydheter',
        casesGroup: 'Saker',
        caseStatus: 'Saksstatus',
        selectCaseStatus: 'Velg saksstatus',
        endReasons: 'Avslutningsårsak',
        selectEndReasons: 'Velg avslutningsårsaker',
        caseGroup: 'Saksgruppe',
        selectCaseGroup: 'Velg saksgruppe',
        caseImport: 'Saksimport',
        selectCaseImport: 'Velg saksimport',
        caseCreatedAfter: 'Sak opprettet etter',
        caseCreatedAfterPlaceholder: 'Etter',
        caseCreatedBefore: 'Sak opprettet før',
        caseCreatedBeforePlaceholder: 'Før',
        caseEndedAfter: 'Sak avsluttet etter',
        caseEndedAfterPlaceholder: 'Etter',
        caseEndedBefore: 'Sak avsluttet før',
        caseEndedBeforePlaceholder: 'Før',
        caseSeqIds: 'Saksnumre',
        exceptCaseSeqIds: 'Unntatt saksnumre',
        caseSeqIdsDescription: 'Saksnumre atskilt med linjeskift, semikolon, komma eller mellomrom.',
        caseSeqIdFilterBadge: 'Etter saksnumre',
        updatesGroup: 'Saksstatuser',
        caseIsCurrently: 'Saker som er',
        caseIsCurrentlyPaused: 'Satt på pause',
        caseIsCurrentlyNotPaused: 'Ikke satt på pause',
        paused: 'Satt på pause',
        notPaused: 'Ikke satt på pause',
        selectStatus: 'Velg status',
        hasFollowingStatus: 'Har status',
        hasFollowingStatusSub: 'Har eller har hatt en av følgende statuser',
        hasFollowingStatusBadge: 'Har status',
        doNotHaveFollowingStatus: 'Har ikke status',
        doNotHaveFollowingStatusSub: 'Har ikke eller har ikke hatt en av følgende statuser',
        doNotHaveFollowingStatusBadge: 'Har ikke status',
        isPausedFollowingStatus: 'Er satt på pause med status',
        isPausedFollowingStatusSub: 'Er satt på pause med en av følgende statuser akkurat nå',
        isPausedFollowingStatusBadge: 'Er satt på pause med status',
        isNotPausedFollowingStatus: 'Ikke satt på pause',
        isNotPausedFollowingStatusSub: 'Er ikke satt på pause med en av følgende statuser',
        isNotPausedFollowingStatusBadge: 'Er ikke satt på pause med status',
        economyFilter: {
            postingsGroup: 'Saksposteringer',
            billingStatus: 'Avregningsstatus',
            amountMode: 'Beløpet gjelder',
            individualAmount: 'En enkelt postering',
            totalAmount: 'Posteringene til sammen',
            totalAmountLabel: 'Samlet beløp for valgte posteringer',
            individualExample: '200–200 finner saker med minst én postering på 200, også hvis saken har flere posteringer på 200.',
            totalExample: '200–200 finner for eksempel 100 + 100, men ikke 200 + 200.',
            totalHint: 'Bare posteringer som samsvarer med valgene dine, teller med i summen. Motposteringer trekkes fra.',
            paymentType: 'Betalingsmetode',
            allPaymentTypes: 'Alle betalingsmetoder',
            voucherState: 'Betalingsstatus',
            allVoucherStates: 'Alle betalingsstatuser',
            paymentHint: 'Betalingsmetode og status må samsvare med de samme posteringene som beløpet.',
            postings: 'Posteringer',
            postingsHint: 'Finn saker med minst én postering som samsvarer.',
            types: 'Posteringstype',
            anyType: 'Alle posteringstyper',
            typesHint: 'Velger du flere typer, trenger bare én av dem å samsvare.',
            amount: 'Beløp per postering',
            amountHint: 'Skriv beløp uten minustegn — for både gjeld, innbetalinger og kreditnotaer.',
            debt: 'Samlet gjeld',
            debtHint: 'Det som gjenstår å betale på saken, etter innbetalinger og kreditnotaer.',
            debtNote: 'Gjelden beregnes fra alle posteringene på saken, uansett hvilke typer du velger ovenfor.',
            billing: 'Avregning',
            billingHint: 'Finn saker ut fra avregningsposteringene deres.',
            allCases: 'Alle saker',
            allCasesHint: 'Uansett avregningsstatus',
            pending: 'Har pågående',
            pendingHint: 'Minst én postering venter på avregning',
            billed: 'Har avregnede',
            billedHint: 'Minst én postering er avregnet',
            both: 'Har begge deler',
            bothHint: 'Både pågående og avregnede posteringer',
            overlapHint: 'En sak kan ha begge deler. Den vises da også under både «Har pågående» og «Har avregnede».',
            minimum: 'Fra og med',
            maximum: 'Til og med',
            noLimit: 'Ingen grense',
            rangeError: 'Fra-beløpet kan ikke være større enn til-beløpet. Rett intervallet for å bruke det.',
            currencyHint: 'Beløp angis i sakens valuta. Fyll ut ett eller begge beløpsfeltene.',
            anyAmount: 'Alle beløp',
            combinedHint: 'Filtrene kombineres: saken må oppfylle alle utfylte filtre.',
        },
        economyGroup: 'Økonomi',
        economyOnlyVoucherTypeIds: 'Kun valgte bilagstyper',
        economyMinAmount: 'Min.-saldo',
        economyMaxAmount: 'Maks.-saldo',
        economyBillingModels: 'Saker med faktureringsmodell',
        economyBillingAppendixSetups: 'Saker med faktureringsvedleggsoppsett',
        billingModels: 'Faktureringsmodeller',
        economyMin: 'Min.',
        economyMax: 'Maks.',
        economySelectedBillingModels: 'Valgte faktureringsmodeller',
        economySelectedBillingAppendixSetups: 'Valgte vedleggsoppsett',
        workflowsGroup: 'Arbeidsflyter',
        inSelectedWorkflows: 'Valgte arbeidsflyter',
        isInWorkflows: 'Er i arbeidsflyt',
        selectWorkflows: 'Valgte arbeidsflyter',
        selectNextTaskIds: 'Velg oppgaver',
        nextTaskIds: 'Neste oppgave i arbeidsflyt',
        selectCurrentTaskIds: 'Velg oppgaver',
        currentTaskIds: 'Nåværende oppgave i arbeidsflyt',
        noNextTask: 'Ingen neste oppgave',
        documentsGroup: 'Dokumenter',
        hasDocumentOfType: 'Har dokument av type',
        hasDocumentOfTypeBadge: 'Har dokument av type',
        selectDocumentTypes: 'Velg dokumenttyper',
        documentsIsSigned: 'Velg kun signerte dokumenter',
        hasFoundation: 'Har fundament',
        hasNoFoundation: 'Har ikke fundament',
        paymentPlansGroup: 'Betalingsplaner',
        paymentPlanStatuses: 'betalingsplaner med status',
        selectPaymentPlanStatus: 'Velg status',
        paymentPlanIsNotHavingStatuses: 'Velg betalingsplaner uten statusene ovenfor',
        paymentPlanIsNotHavingStatusesBadge: 'Betalingsplaner uten statuser',
        interactionsGroup: 'Interaksjoner',
        interactionType: 'Interaksjonstype',
        selectInteractionType: 'Velg interaksjonstype',
        interactionState: 'Interaksjonstilstand',
        selectInteractionState: 'Velg interaksjonstilstand',
        interactionDirection: 'Interaksjonsretning',
        selectInteractionDirection: 'Velg interaksjonsretning',
        noneOfTheAboveBadge: 'Ingen av de valgte interaksjonene',
        noneOfTheAbove: 'Saker med interaksjoner med ingen av de ovennevnte',
        accountsGroups: 'Brukere',
        selectedCreditors: 'kreditor(er) valgt',
        caseVisitedBy: 'Sak besøkt av',
        selectAccount: 'Velg brukere',
        caseVisitedBefore: 'Sak besøkt før',
        to: 'Til',
        caseVisitedAfter: 'Sak besøkt etter',
        from: 'Fra',
        offset: 'Forskyvning',
        offsetExplanation: 'Velg antall saker som skal hoppes over',
        limit: 'Grense',
        limitExplanation: 'Velg antall saker som skal velges',
        pagination: 'Paginering',
        properties: 'Eiendommer',
        property: 'Eiendom',
        propertyExplanation: 'Filer',
        bulkActions: 'Massehandlinger',
        bulkActionsConfirm: 'Er du sikker på at du vil kjøre den valgte massehandlingen på de valgte sakene?',
        approveVerifyAllCases: 'Er du sikker på at du vil verifisere alle valgte saker?',
        casesVerified: 'De valgte sakene blir nå verifisert',
        pauseCasesBulk: 'De valgte sakene blir nå satt på pause. Du vil motta en e-post når systemet er ferdig.',
        continueCasesBulk: 'Den valgte pausestatusen din vil bli fortsatt på de valgte sakene. Du vil motta en e-post når systemet er ferdig.',
        runProcedureBulk: 'Den valgte snarveien vil nå bli utført på de valgte sakene. Du vil motta en e-post når systemet er ferdig.',
        changeBillingModelBulk: 'Den valgte snarveien vil nå bli utført på de valgte sakene. Du vil motta en e-post når systemet er ferdig.',
        changeBillingModelDesc: 'Flytt saker til valgt faktureringsmodell for saker som ikke er fakturert.',
        changeBillingModelPlaceholder: 'Faktureringsmodell',
        changeWorkflowBulk: 'Den valgte snarveien vil nå bli utført på de valgte sakene. Du vil motta en e-post når systemet er ferdig.',
        changeWorkflowDesc: 'Flytt saker til valgt arbeidsflyt.',
        changeWorkflowPlaceholder: 'Arbeidsflyter',
    },
    aggregations: {
        aggregate: 'Aggreger saker',
    },
    aggregationTypes: {
        [AggregationType.CountAll]: 'Antall saker',
        [AggregationType.ByCaseGroup]: 'Saksgruppe',
        [AggregationType.ByBillingModel]: 'Faktureringsmodell',
        [AggregationType.ByBillingAppendixSetup]: 'Faktureringsvedleggsoppsett',
        [AggregationType.ByWorkflow]: 'Arbeidsflyt',
        [AggregationType.ByCaseStatus]: 'Saksstatus',
        [AggregationType.ByCreditor]: 'Kreditor',
        [AggregationType.ByMigratedWorkflowTaskId]: 'Migrert arbeidsflytoppgave',
    },
    bulkActions: {
        runBulkAction: 'Kjør massehandling',
        bulkActionStarted: 'Massehandling startet',
        bulkActions: 'Massehandling',
        bulkActionsConfirm: 'Er du sikker på at du vil kjøre denne massehandlingen?',
        bulkActionBillingModelPlaceholder: 'Faktureringsmodell',
        bulkActionWorkflowPlaceholder: 'Arbeidsflyt',
        bulkActionMoveToTaskInWorkflowPlaceholder: 'Velg oppgave i arbeidsflyt',
        bulkActionChangeCaseGroup: 'Velg saksgruppe',
        pleaseSelectAWorkflow: 'Velg en arbeidsflyt i saksfilteret',
    },
    bulkActionTypes: {
        [BulkActionType.MoveCaseStatus]: 'Endre saksstatus',
        [BulkActionType.PauseCases]: 'Sett valgte saker på pause',
        [BulkActionType.ContinueCases]: 'Fortsett valgte saker',
        [BulkActionType.RunProcedure]: 'Kjør snarvei på valgte saker',
        [BulkActionType.ChangeBillingModel]: 'Endre faktureringsmodell',
        [BulkActionType.ChangeBillingAppendixSetup]: 'Endre faktureringsvedleggsoppsett',
        [BulkActionType.ChangeWorkflow]: 'Endre arbeidsflyt',
        [BulkActionType.MoveCaseToWorkflowTask]: 'Flytt til arbeidsflytoppgave',
        [BulkActionType.RollbackOneTask]: 'Tilbakestill siste arbeidsflytoppgave',
        [BulkActionType.RollbackAllTasks]: 'Tilbakestill alle arbeidsflytoppgaver',
        [BulkActionType.RunBillingModel]: 'Kjør faktureringsmodell',
        [BulkActionType.ResubscribeCosmo]: 'Abonner på nytt på Cosmo',
        [BulkActionType.DeleteRKIRegistrationsOnEndedCases]: 'Slett RKI-registreringer på avsluttede saker',
        [BulkActionType.MoveRKIRegistrationsToMergeCases]: 'Flytt RKI-registreringer til sammenslåtte saker',
        [BulkActionType.ChangeCaseGroup]: 'Endre saksgruppe',
        [BulkActionType.ResyncCosmo]: 'Synkroniser Cosmo på nytt',
    },
    bulkActionDescriptions: {
        [BulkActionType.MoveCaseStatus]: 'Endre saksstatus til',
        [BulkActionType.PauseCases]: 'Sett valgte saker på pause',
        [BulkActionType.ContinueCases]: 'Fortsett valgte saker',
        [BulkActionType.RunProcedure]: 'Kjør snarvei på valgte saker',
        [BulkActionType.ChangeBillingModel]: 'Endre faktureringsmodell',
        [BulkActionType.ChangeBillingAppendixSetup]: 'Endre faktureringsvedleggsoppsett',
        [BulkActionType.ChangeWorkflow]: 'Endre arbeidsflyt',
        [BulkActionType.MoveCaseToWorkflowTask]: 'Flytt til arbeidsflytoppgave',
        [BulkActionType.RollbackOneTask]: 'Tilbakestill siste arbeidsflytoppgave',
        [BulkActionType.RollbackAllTasks]: 'Tilbakestill alle arbeidsflytoppgaver',
        [BulkActionType.RunBillingModel]: 'Kjør faktureringsmodell',
        [BulkActionType.ResubscribeCosmo]: 'Abonner på nytt på Cosmo',
        [BulkActionType.DeleteRKIRegistrationsOnEndedCases]: 'Slett RKI-registreringer på avsluttede saker',
        [BulkActionType.MoveRKIRegistrationsToMergeCases]: 'Flytt RKI-registreringer til sammenslåtte saker',
        [BulkActionType.ChangeCaseGroup]: 'Endre saksgruppe',
        [BulkActionType.ResyncCosmo]: 'Synkroniser Cosmo på nytt',
    },
    bulkActionsEmailConfirmationSubject: {
        [BulkActionType.MoveCaseStatus]: 'Endre saksstatus',
        [BulkActionType.PauseCases]: 'Sett valgte saker på pause',
        [BulkActionType.ContinueCases]: 'Fortsett valgte saker',
        [BulkActionType.RunProcedure]: 'Kjør snarvei på valgte saker',
        [BulkActionType.ChangeBillingModel]: 'Endre faktureringsmodell',
        [BulkActionType.ChangeBillingAppendixSetup]: 'Endre faktureringsvedleggsoppsett',
        [BulkActionType.ChangeWorkflow]: 'Endre arbeidsflyt',
        [BulkActionType.MoveCaseToWorkflowTask]: 'Flytt til arbeidsflytoppgave',
        [BulkActionType.RollbackOneTask]: 'Arbeidsflytoppgaver tilbakestilt',
        [BulkActionType.RollbackAllTasks]: 'Arbeidsflytoppgaver tilbakestilt',
        [BulkActionType.RunBillingModel]: 'Faktureringsmodellen er kjørt',
        [BulkActionType.ResubscribeCosmo]: 'Nytt abonnement på Cosmo er kjørt',
        [BulkActionType.DeleteRKIRegistrationsOnEndedCases]: 'RKI-registreringer på avsluttede saker er slettet',
        [BulkActionType.MoveRKIRegistrationsToMergeCases]: 'RKI-registreringer er flyttet til sammenslåtte saker',
        [BulkActionType.ChangeCaseGroup]: 'Saksgrupper er endret',
        [BulkActionType.ResyncCosmo]: 'Cosmo synkronisert på nytt',
    },
    bulkActionsEmailConfirmationBody: {
        [BulkActionType.MoveCaseStatus]: 'Endret saksstatus på de valgte sakene.',
        [BulkActionType.PauseCases]: 'Pausing av valgte saker er ferdig.',
        [BulkActionType.ContinueCases]: 'Fortsatte valgte saker.',
        [BulkActionType.RunProcedure]: 'Snarvei utført på valgte saker.',
        [BulkActionType.ChangeBillingModel]: 'Endret faktureringsmodell på de valgte sakene.',
        [BulkActionType.ChangeBillingAppendixSetup]: 'Endret faktureringsvedleggsoppsett på de valgte sakene.',
        [BulkActionType.ChangeWorkflow]: 'Endret arbeidsflyt på de valgte sakene.',
        [BulkActionType.MoveCaseToWorkflowTask]: 'Flyttet arbeidsflytoppgave på de valgte sakene.',
        [BulkActionType.RollbackOneTask]: 'Arbeidsflytoppgaver tilbakestilt.',
        [BulkActionType.RollbackAllTasks]: 'Arbeidsflytoppgaver tilbakestilt.',
        [BulkActionType.RunBillingModel]: 'Faktureringsmodellen er kjørt',
        [BulkActionType.ResubscribeCosmo]: 'Nytt abonnement på Cosmo er kjørt',
        [BulkActionType.DeleteRKIRegistrationsOnEndedCases]: 'RKI-registreringer på avsluttede saker er slettet',
        [BulkActionType.MoveRKIRegistrationsToMergeCases]: 'RKI-registreringer er flyttet til sammenslåtte saker',
        [BulkActionType.ChangeCaseGroup]: 'Saksgrupper er endret',
        [BulkActionType.ResyncCosmo]: 'Cosmo er synkronisert på nytt',
    },
    paymentPlansInsights: {
        paymentPlans: 'Betalingsplaner',
        quantityEntries: 'Antall avdrag',
        amountEntries: 'Beløp',
        funnelHeader: 'Livsløp',
        totalCreated: 'Opprettet',
        activated: 'Aktivert',
        inProgress: 'Pågående',
        completed: 'Fullført',
        defaulted: 'Misligholdt',
        deletedAfterActivation: 'Slettet',
        awaitingActivation: 'Venter på aktivering',
        neverActivated: 'Aldri aktivert',
        ofCreated: (share) => `${share}% av opprettede`,
        ofActivated: (share) => `${share}% av aktiverte`,
        churnHeader: 'Frafall',
        churnRate: 'Frafallsrate',
        churnRateInfo: 'Andel aktiverte nedbetalingsavtaler som endte i mislighold.',
        defaultedPlans: 'Misligholdte nedbetalingsavtaler',
        churnedBeforeFirstPayment: 'Før første betaling',
        churnedAfterFirstPayment: 'Etter første betaling',
        ofDefaulted: (share) => `${share}% av misligholdte`,
        neverActivatedHeader: 'Opprettet, men aldri aktivert',
        neverActivatedInfo: 'Nedbetalingsavtaler som ble opprettet, men aldri aktivert, fordelt etter hvem som opprettet dem.',
        createdByDebtor: 'Opprettet av skyldner',
        createdByCaseworker: 'Opprettet av saksbehandler',
        paymentMethodsHeader: 'Betalingsmetoder',
        methodColumn: 'Metode',
        plansColumn: 'Nedbetalingsavtaler',
        activationRateColumn: 'Aktiveringsrate',
        defaultRateColumn: 'Misligholdsrate',
        methodBetalingsservice: 'Betalingsservice',
        methodLeverandorservice: 'Leverandørservice',
        methodVisa: 'Visa',
        methodMastercard: 'Mastercard',
        methodDankort: 'Dankort',
        methodCard: 'Kort',
        methodMobilePay: 'MobilePay',
        methodVipps: 'Vipps',
        methodSwish: 'Swish',
        methodOther: 'Annet',
        methodNone: 'Ingen betalingsmetode',
        creditorsHeader: 'Kreditorer med flest nedbetalingsavtaler',
        creditorColumn: 'Kreditor',
        finishedColumn: 'Fullført',
        defaultedColumn: 'Misligholdt',
        vintageHeader: 'Kohortanalyse (vintage)',
        vintageInfo: 'Hver rad viser måneden avtalene ble opprettet, fulgt etter alder. Les nedover i en kolonne (samme alder) for å se om nyere kohorter misligholdes oftere eller sjeldnere enn eldre. Cellene er tomme til en kohort har nådd den aktuelle alderen.',
        vintageCohortColumn: 'Opprettet',
        vintageAgeAxis: 'Måneder siden opprettelse',
        vintageActivatedShort: (n) => `${n} aktiverte`,
        vintageLegendLabel: 'Kumulativ misligholdsrate',
        vintageLow: 'lavere',
        vintageHigh: 'høyere',
        vintageCellInfo: (rate, defaults, activated) => `${rate}% kumulativt mislighold (${defaults} av ${activated} aktiverte)`,
    },
    insights: {
        showingNewest: 'Viser de {count} nyeste.',
        lastDays: 'Siste {days} dager',
        fromDate: 'Fra dato',
        toDate: 'Til dato',
        getReport: 'Hent rapport',
        powerbi: {
            title: 'Dine data. Din innsikt.',
            intro: 'Velg datakildene for rapporten. Last ned et Power BI-prosjekt (.pbip), pakket med nødvendige mapper, spørringer og databeskrivelser i én ZIP-fil.',
            openInstructions: 'Pakk ut ZIP-filen og åpne Debbie.pbip i Power BI Desktop for Windows. Aktiver Power BI Project og det utvidede rapportformatet (PBIR) under forhåndsvisningsfunksjoner hvis versjonen krever det. Velg Anonym autentisering for webkilden: API-nøkkelen sendes allerede i spørringens header. Oppdater for å laste inn data.',
            dataSources: 'Datakilder',
            selectSources: 'Velg minst én datakilde og godta advarselen om API-nøkkelen.',
            selectAll: 'Velg alle datakilder',
            includeSource: 'Ta med i prosjekt',
            downloadProject: 'Opprett nøkkel og last ned Power BI-prosjekt (.pbip)',
            downloadAgain: 'Last ned samme prosjekt igjen',
            securityWarning: 'Nedlastingen oppretter en API-nøkkel med lesetilgang til de valgte datakildene. Nøkkelen lagres i klartekst i prosjektet og spørringsfilene. Alle med filene kan bruke tilgangen. Oppbevar dem sikkert, og del dem bare med mottakere du stoler på. Hvis du deler dem med andre personer eller eksterne tjenester, deler du også nøkkelen og tilgangen til data. Du kan tilbakekalle nøkkelen nedenfor.',
            acceptWarning: 'Jeg forstår at en API-nøkkel opprettes og inkluderes i filene.',
            keyCreated: 'API-nøkkelen er utstedt og vises nedenfor. Laster du ned prosjektet igjen, brukes samme nøkkel. Endrer du valget eller nøkkelens navn, opprettes en ny nøkkel ved neste nedlasting.',
            noAccess: 'Du trenger tilgang til å utstede API-nøkler for å opprette et prosjekt. Velg først en kreditor i kreditorportalen.',
            extendTitle: 'Legg til datakilder i en eksisterende rapport',
            manualInstructions: 'Velg de ekstra kildene her og last ned et prosjekt. I den eksisterende Power BI-rapporten velger du Transformer data → Ny kilde → Tom spørring → Avansert redigering. Lim inn innholdet fra den tilhørende filen i queries/, gi spørringen kildens navn og velg Lukk og bruk. Kilden legges til med sin nye nøkkel, mens eksisterende spørringer, visualiseringer og mål bevares. Legg til relasjoner i modellvisningen ved hjelp av data-dictionary.json. Ikke erstatt det eksisterende prosjektet med det nedlastede prosjektet.',
            manualConnection: 'API / legg til manuelt',
            manualKeyInstructions: 'For manuelt oppsett kopierer du spørringen nedenfor og erstatter PASTE_API_KEY_HERE med en API-nøkkel med angitt scope. Utsted en nøkkel ved å velge kilden og laste ned et prosjekt, eller under API-innstillinger. Eksisterende nøkler får ikke automatisk tilgang til nye kilder.',
            copyQuery: 'Kopier Power Query',
            keysDescription: 'Utstedte nøkler med tilgang til rapportdata, inkludert nøkler opprettet under API-innstillinger. Den hemmelige nøkkelen kan ikke hentes igjen. Tilbakekalling stopper fremtidig tilgang for alle rapporter og integrasjoner som bruker nøkkelen; allerede innlastede data blir i Power BI.',
            issuedAt: 'Utstedt',
            revoke: 'Tilbakekall nøkkel',
            revokeWarning: 'Vil du tilbakekalle denne API-nøkkelen? Alle rapporter og integrasjoner som bruker den, mister tilgang ved kommende forespørsler når den korte autentiseringscachen utløper. Allerede nedlastede data blir i filene.',
            refreshInstructions: 'API-et begrenser forespørsler per kilde til én gang i døgnet. Unngå hyppige forhåndsvisninger og oppdateringer. Ved planlagt oppdatering i Power BI Service skal webtilkoblingen autentiseres som Anonym; nøkkelen forblir i spørringen. Oppdatering og autentisering i Service konfigureres separat etter publisering.',
            modelNotes: 'Koble tabeller med stabile id-er som caseId, customerId og creditorId; cases.id og referenceId er visnings-/eksterne referanser. Relasjoner filtrerer én vei fra én-siden til mange-siden og omfatter bare valgte tabeller. Andre mulige koblinger: cases.creditorId → creditors.creditorId, cases.workflowId → workflows.id, workflow-tasks.updateTypeId → update-types.updateTypeId, billing-vouchers.caseVoucherId → case-vouchers.caseVoucherId, payment-plans.documentId → documents.documentId. Unngå tvetydige filterveier. Updates.referenceId kan vise til ulike entiteter: kontroller update-types.referenceType; interactions og documents har referenceType, properties har ref. Filtrer referansetypen før kobling til saker eller kunder. Beløp beholder API-ets minste valutaenhet, f.eks. øre; divider med 100 for DKK/SEK/NOK/EUR og summer hver valuta separat. Payment-plan-entries mangler valutakolonne; finn valutaen i sakens kontekst. Posteringer har fortegn; ikke summer alle typer ukritisk for å beregne saldo. Unngå dobbelttelling ved kobling av detaljtabeller. Status- og typetekster følger valgt språk. Tidsstempler med tidssone konverteres til UTC; rene datoer beholdes ved midnatt. Objekter og lister lagres som JSON-tekst. Tomme kilder beholder kolonnene; manglende valgfrie felt blir null. Modellen inneholder standardfelt, ikke valgfrie detaljfelt. Kundedata lastes først inn ved oppdatering.',
            shortIntro: 'Koble Debbie til Power BI og bygg rapporter med dataene du trenger.',
            help: 'Kom i gang',
            chooseSources: 'Velg datakildene dine',
            chooseHint: 'Marker kilder for Power BI, eller bruk </> for å koble til manuelt.',
            clearSelection: 'Fjern valg',
            groupCases: 'Saker og kunder',
            groupEconomy: 'Økonomi og betalinger',
            groupActivity: 'Aktivitet og dokumenter',
            groupOrganisation: 'Organisasjon og arbeidsflyter',
            yourProject: 'Ditt Power BI-prosjekt',
            projectContents: 'Datatilkoblinger, relasjoner og databeskrivelser — klart for rapporten din.',
            selectedSources: 'datakilder valgt',
            emptySelection: 'Velg kilder til venstre for å sette sammen prosjektet.',
            downloadLabel: 'Last ned Power BI-prosjekt',
            downloadFormat: '.pbip-prosjekt · Leveres som ZIP · Power BI Desktop',
            shortSecurity: 'En ny API-nøkkel følger med prosjektet. Du gjennomgår tilgangen før nedlasting og kan alltid tilbakekalle den.',
            confirmTitle: 'Opprett tilgang til dataene dine',
            projectReady: 'Prosjektet ditt er klart',
            manageKeys: 'Se og administrer API-nøkler',
            openProject: 'Åpne prosjektet i Power BI',
            refreshTitle: 'Hold rapporten oppdatert',
            extendHint: 'Bruk </>-knappen på en datakilde for en trinnvis veiledning til å legge den til i den eksisterende Power BI-rapporten. Nåværende visualiseringer og mål bevares.',
            guideKeyTitle: 'Opprett en API-nøkkel i Debbie',
            guideKey: 'Åpne Innstillinger → Utviklere → API og velg Opprett API-nøkkel. Gi den et navn du kjenner igjen, og velg tilgangen nedenfor. Opprett nøkkelen og lagre den sikkert — den vises bare én gang. Du kan gjenbruke en eksisterende nøkkel med denne tilgangen.',
            guideWebTitle: 'Legg til en webkilde i Power BI',
            guideWeb: 'Åpne den eksisterende rapporten i Power BI Desktop. Velg Hjem → Hent data → Web og deretter Avansert. Kopier adressen nedenfor inn i det første URL-feltet.',
            guideAuthTitle: 'Sett inn API-nøkkelen din',
            guideAuth: 'Under HTTP-forespørselshodeparametere velger du Authorization. I feltet ved siden av skriver du Bearer, etterfulgt av et mellomrom og API-nøkkelen din. Erstatt <your URL> i bildet med adressen ovenfor og <your token> med nøkkelen din. Velg OK. Hvis du blir spurt om autentisering, velger du Anonym — nøkkelen er allerede satt inn i headeren.',
            guideImageAlt: 'Power BI-webtilkobling: URL øverst og Authorization med Bearer etterfulgt av API-nøkkelen nederst.',
            guideLoadTitle: 'Last inn data i rapporten',
            guideLoad: 'Hvis Power Query viser en liste, velger du Til tabell og godtar standardinnstillingene. Utvid deretter kolonnen med ikonet med to piler, og velg ønskede felt. Gi spørringen datakildens navn, og velg Lukk og bruk. Den nye tabellen vises sammen med eksisterende data. Koble den til andre tabeller i modellvisningen via samsvarende id-er, for eksempel caseId. Den eksisterende rapporten bevares.',
            advancedQuery: 'Avansert: bruk Power Query-kode',
            dictionaryInstructions: 'data-dictionary.json beskriver valgte kilder, kolonner og relasjoner uten API-nøkkelen. Bruk den som oppslagsverk når du bygger eller utvider rapporter. Prosjektet inneholder også tabellbeskrivelser og forhåndsdefinerte relasjoner.',
            sourceDescriptions: {
                cases: 'Én rad per ikke-slettet sak med kunde, kreditor, status og arbeidsflytreferanser.',
                creditors: 'Én rad per kreditor med identitet, status og kontaktreferanser.',
                satisfactions: 'Én rad per tilfredshetssvar på en sak med poengsum (1–5) og kommentar.',
                'case-vouchers': 'Én rad per ikke-slettet sakspostering med beløp med fortegn, valuta, kategori og datoer.',
                'billing-vouchers': 'Én rad per ikke-slettet avregningspostering. Kreditorer ser bare avregnede poster.',
                users: 'Én rad per bruker i organisasjonen med rolle og kontaktinformasjon. Slettede brukere utelates.',
                updates: 'Én rad per oppgave. referenceId kan vise til ulike entiteter; kontroller oppgavetypen.',
                'update-types': 'Én rad per oppgavetype med navn, referansetype og atferdsflagg.',
                workflows: 'Én rad per arbeidsflyt. Nøkkelen heter id.',
                'workflow-tasks': 'Én rad per oppgave i en arbeidsflyt med workflowId og updateTypeId.',
                'case-statuses': 'Én rad per statusendring på en sak. En sak kan ha flere rader.',
                interactions: 'Én rad per interaksjon med kanal, retning, status og referansetype.',
                documents: 'Én rad per dokument med referansetype, datoer og filmetadata; uten filinnhold.',
                'payment-plans': 'Én rad per avdragsordning på en sak med status og påminnelsesflagg.',
                'payment-plan-entries': 'Én rad per avdrag med beløp, frister og status. Ingen valutakolonne.',
                customers: 'Én rad per ikke-slettet kunde hos en kreditor. En kunde kan ha flere saker.',
                'users-on-customers': 'Én rad per kontakt-/kunderelasjon. Kontaktinformasjon er JSON, ikke organisasjonens userId.',
                properties: 'Én rad per gjeldende attributtverdi. ref angir entitetstype for refId; data er JSON.',
            },
            sourceSummaries: {
                cases: 'Status, kunder og arbeidsflyter',
                creditors: 'Kreditoropplysninger og kontakter',
                satisfactions: 'Vurderinger og tilbakemeldinger på saker',
                'case-vouchers': 'Beløp, valutaer og posteringstyper',
                'billing-vouchers': 'Avregninger, fakturering og merverdiavgift',
                users: 'Medarbeidere og roller',
                updates: 'Oppgaver, datoer og fremdrift',
                'update-types': 'Oppgavekategorier og atferd',
                workflows: 'Definisjoner av arbeidsflyter',
                'workflow-tasks': 'Trinnene i hver arbeidsflyt',
                'case-statuses': 'Historikk over sakenes statusendringer',
                interactions: 'Kanaler, retning og leveringsstatus',
                documents: 'Dokumenttyper, datoer og underskrifter',
                'payment-plans': 'Avtaler og avdragsordningenes status',
                'payment-plan-entries': 'Avdrag, beløp og betalingsfrister',
                customers: 'Kundeopplysninger og referanser',
                'users-on-customers': 'Kontakter og deres kunderelasjoner',
                properties: 'Tilpassede attributter og verdier',
            },
        },
        connectToApi: 'Koble til dataene dine via et API',
        downloadLimit: 'Grensen for å be om en bestemt datakilde er én gang per døgn',
        apiTypes: {
            ['cases']: 'Saker',
            ['users']: 'Brukere',
            ['satisfactions']: 'Tilfredshetssvar',
            ['case-vouchers']: 'Saksbilag',
            ['billing-vouchers']: 'Avregningsbilag',
            ['creditors']: 'Kreditorer',
            ['updates']: 'Oppgaver',
            ['update-types']: 'Oppgavetyper',
            ['workflows']: 'Arbeidsflyter',
            ['workflow-tasks']: 'Arbeidsflytoppgaver',
            ['case-statuses']: 'Saksstatuslogg',
            ['interactions']: 'Interaksjoner',
            ['documents']: 'Dokumenter',
            ['payment-plans']: 'Betalingsplaner',
            ['payment-plan-entries']: 'Betalingsplanoppføringer',
            ['users-on-customers']: 'Brukere på kunder',
            ['customers']: 'Kunder',
            ['properties']: 'Attributter',
        },
        connectGuide: {
            description: 'Du kan få tilgang til dataene dine gjennom et API for ekstern bruk',
            liIntroStep1: 'Gå til Innstillinger og velg Utviklere',
            liIntroStep2: 'Opprett en ny API-nøkkel',
            liIntroStep3: 'Gi nøkkelen et navn og velg tilsvarende scope',
            liIntroStep4: 'Tilsvarende scope er',
            liIntroStep5: 'Du kan nå bruke den nye API-nøkkelen din for å koble til',
            powerbiDescription: 'Gjennomgangen nedenfor viser hvordan du kobler til Power BI',
            liPowerbiStep1: "Koble til en ny 'Web'-datakilde inne i Power BI",
            liPowerbiStep2: 'Fyll ut konfigurasjonene som på bildet nedenfor, der du erstatter',
            liPowerbiStep3: 'med nettadressen ovenfra og',
            liPowerbiStep4: 'med den nyopprettede API-nøkkelen din',
            liPowerbiStep5: 'Trykk OK, så er du klar',
            understood: 'Lukk',
        },
        connect: 'Koble til',
        download: 'Last ned',
        orderReport: 'Bestill rapport',
        billingFile: 'Avregningsfil',
        billingFileDesc: 'Avregningsfil for skyldnertransaksjoner per kreditor per dag.',
        caseOverview: 'Saksoversikt',
        caseOverviewDesc: 'Oversikt over alle aktive og avsluttede saker inkludert status, økonomi og skyldnerinformasjon.',
        includeDocuments: 'Inkluder dokumenter',
        includeVouchers: 'Inkluder bilag',
        includeRki: 'Inkluder RKI-rapporter',
        documents: 'Dokumenter',
        steps: 'Steg',
        vouchers: 'Bilag',
        cases: 'Saker',
        collector: 'Inkassobyrå',
        creditor: 'Kreditor',
        rki: 'RKI',
        downloadsYourExportIsReady: 'Rapporten din er klar',
        downloadsYourExportIsReadyBody: '<p>Hei</p><p>Rapporten din er klar til nedlasting.</p>',
        downloadsYourExportIsReadyButton: 'Last ned rapport',
        caseOverviewHeaderDocumentId: 'Dok-ID',
        caseOverviewHeaderFileLink: 'Lenke til fil',
        caseOverviewHeaderType: 'Type',
        caseOverviewHeaderSignedAt: 'Dato for underskrift',
        caseOverviewHeaderCreatedAt: 'Dato for opprettelse',
        caseOverviewHeaderDate: 'Dato',
        caseOverviewHeaderDueDate: 'Forfallsdato',
        caseOverviewHeaderCategory: 'Kategori',
        caseOverviewHeaderImposedBy: 'Pålagt av',
        caseOverviewHeaderText: 'Tekst',
        caseOverviewHeaderInterest: 'Rentesats',
        caseOverviewHeaderInterestStartDate: 'Rentestartdato',
        caseOverviewHeaderInterestEndDate: 'Renteslutdato',
        caseOverviewHeaderAmount: 'Beløp',
        caseOverviewHeaderExpirationDate: 'Foreldelsesdato',
        caseOverviewHeaderExpired: 'Foreldet',
        caseOverviewCompany: 'Virksomhet',
        caseOverviewPrivate: 'Person',
        caseOverviewHeaderCreditor: 'Kreditor',
        caseOverviewHeaderCreditorSeqId: 'Kreditornummer',
        caseOverviewHeaderCaseGroup: 'Saksgruppe',
        caseOverviewHeaderImportedAt: 'Importdato',
        caseOverviewHeaderCaseSeqId: 'Saksnummer',
        caseOverviewHeaderMigratedJournalNumber: 'Migrert j.nr.',
        caseOverviewHeaderReferenceId: 'Referanse',
        caseOverviewHeaderDebtorSeqId: 'Skyldnernummer',
        caseOverviewHeaderDebtorName: 'Navn',
        caseOverviewHeaderDebtorEmail: 'E-post',
        caseOverviewHeaderDebtorPhone: 'Telefon',
        caseOverviewHeaderDebtorSatisfaction: 'Tilfredshet',
        caseOverviewHeaderDebtorSatisfactionComment: 'Tilfredshetskommentar',
        caseOverviewHeaderDebtorRKICount: 'Antall RKI-registreringer',
        caseOverviewHeaderDebtorCompanyStatus: 'Virksomhetsstatus',
        caseOverviewHeaderDebtorCVR: 'CVR',
        caseOverviewHeaderDebtorBirthdate: 'Fødselsdato',
        caseOverviewHeaderDebtorAddressProtection: 'Adressebeskyttet',
        caseOverviewHeaderDebtorCountry: 'Land',
        caseOverviewHeaderDebtorZipCode: 'Postnummer',
        caseOverviewHeaderDebtorCity: 'Poststed',
        caseOverviewHeaderDebtorAddress: 'Adresse',
        caseOverviewHeaderDebtorCoAddress: 'C/o-adresse',
        caseOverviewHeaderDebtorType: 'Skyldnertype',
        caseOverviewHeaderDebtorCount: 'Antall skyldnere',
        caseOverviewHeaderCreditScore: 'Kredittscore',
        caseOverviewHeaderCurrency: 'Valuta',
        caseOverviewHeaderPrincipal: 'Hovedstol',
        caseOverviewHeaderPrincipalPaid: 'Betalt av hovedstol',
        caseOverviewHeaderPrincipalLeft: 'Gjenstående av hovedstol',
        caseOverviewHeaderReminderFeeCreditor: 'Purregebyr fra kreditor',
        caseOverviewHeaderReminderFeeCreditorPaid: 'Betalt av purregebyr fra kreditor',
        caseOverviewHeaderReminderFeeCreditorLeft: 'Gjenstående av purregebyr fra kreditor',
        caseOverviewHeaderReminderFeeCollector: 'Purregebyr fra inkassobyrå',
        caseOverviewHeaderReminderFeeCollectorPaid: 'Betalt av purregebyr fra inkassobyrå',
        caseOverviewHeaderReminderFeeCollectorLeft: 'Gjenstående av purregebyr fra inkassobyrå',
        caseOverviewHeaderCompensationCostCreditor: 'Kompensasjonsgebyr fra kreditor',
        caseOverviewHeaderCompensationCostCreditorPaid: 'Betalt av kompensasjonsgebyr fra kreditor',
        caseOverviewHeaderCompensationCostCreditorLeft: 'Gjenstående av kompensasjonsgebyr fra kreditor',
        caseOverviewHeaderCompensationCostCollector: 'Kompensasjonsgebyr fra inkassobyrå',
        caseOverviewHeaderCompensationCostCollectorPaid: 'Betalt av kompensasjonsgebyr fra inkassobyrå',
        caseOverviewHeaderCompensationCostCollectorLeft: 'Gjenstående av kompensasjonsgebyr fra inkassobyrå',
        caseOverviewHeaderCollectionCostCreditor: 'Inkassokostnader fra kreditor',
        caseOverviewHeaderCollectionCostCreditorPaid: 'Betalt av inkassokostnader fra kreditor',
        caseOverviewHeaderCollectionCostCreditorLeft: 'Gjenstående av inkassokostnader fra kreditor',
        caseOverviewHeaderCollectionCostCollector: 'Inkassokostnader fra inkassobyrå',
        caseOverviewHeaderCollectionCostCollectorPaid: 'Betalt av inkassokostnader fra inkassobyrå',
        caseOverviewHeaderCollectionCostCollectorLeft: 'Gjenstående av inkassokostnader fra inkassobyrå',
        caseOverviewHeaderCollectionFeeCreditor: 'Inkassosalær fra kreditor',
        caseOverviewHeaderCollectionFeeCreditorPaid: 'Betalt av inkassosalær fra kreditor',
        caseOverviewHeaderCollectionFeeCreditorLeft: 'Gjenstående av inkassosalær fra kreditor',
        caseOverviewHeaderCollectionFeeCollector: 'Inkassosalær fra inkassobyrå',
        caseOverviewHeaderCollectionFeeCollectorPaid: 'Betalt av inkassosalær fra inkassobyrå',
        caseOverviewHeaderCollectionFeeCollectorLeft: 'Gjenstående av inkassosalær fra inkassobyrå',
        caseOverviewHeaderCourtCostCreditor: 'Rettsomkostninger fra kreditor',
        caseOverviewHeaderCourtCostCreditorPaid: 'Betalt av rettsomkostninger fra kreditor',
        caseOverviewHeaderCourtCostCreditorLeft: 'Gjenstående av rettsomkostninger fra kreditor',
        caseOverviewHeaderCourtCostCollector: 'Rettsomkostninger fra inkassobyrå',
        caseOverviewHeaderCourtCostCollectorPaid: 'Betalt av rettsomkostninger fra inkassobyrå',
        caseOverviewHeaderCourtCostCollectorLeft: 'Gjenstående av rettsomkostninger fra inkassobyrå',
        caseOverviewHeaderInterestCreditor: 'Renter fra kreditor',
        caseOverviewHeaderInterestCreditorPaid: 'Betalt av renter fra kreditor',
        caseOverviewHeaderInterestCreditorLeft: 'Gjenstående av renter fra kreditor',
        caseOverviewHeaderInterestCollector: 'Renter fra inkassobyrå',
        caseOverviewHeaderInterestCollectorPaid: 'Betalt av renter fra inkassobyrå',
        caseOverviewHeaderInterestCollectorLeft: 'Gjenstående av renter fra inkassobyrå',
        caseOverviewHeaderCreditorTotal: 'Totalt fra kreditor',
        caseOverviewHeaderCreditorTotalPaid: 'Betalt av totalt fra kreditor',
        caseOverviewHeaderCreditorTotalLeft: 'Gjenstående av totalt fra kreditor',
        caseOverviewHeaderCreditorTotalDepositsToCreditor: 'Innbetalt til kreditor totalt',
        caseOverviewHeaderCollectorTotal: 'Totalt fra inkassobyrå',
        caseOverviewHeaderCollectorTotalPaid: 'Betalt av totalt fra inkassobyrå',
        caseOverviewHeaderCollectorTotalLeft: 'Gjenstående av totalt fra inkassobyrå',
        caseOverviewHeaderTotal: 'Totalt',
        caseOverviewHeaderTotalPaid: 'Betalt av totalt',
        caseOverviewHeaderTotalLeft: 'Gjenstående av totalt',
        caseOverviewHeaderLastDepositDate: 'Siste innbetalingsdato',
        caseOverviewHeaderCurrentWorkflow: 'Arbeidsflyt',
        caseOverviewHeaderCurrentWorkflowTask: 'Gjeldende oppgave',
        caseOverviewHeaderCurrentWorkflowTaskTime: 'Dato for gjeldende oppgave',
        caseOverviewHeaderNextWorkflowTask: 'Neste oppgave',
        caseOverviewHeaderNextWorkflowTaskTime: 'Dato for neste oppgave',
        caseOverviewHeaderFoundation: 'Grunnlag',
        caseOverviewHeaderPaymentPlan: 'Betalingsplan',
        caseOverviewHeaderPaidPaymentPlanEntries: 'Betalte oppføringer',
        caseOverviewHeaderTotalPaymentPlanEntries: 'Totalt antall betalingsplanoppføringer',
        caseOverviewHeaderCaseStatus: 'Saksstatus',
        caseOverviewHeaderEndReason: 'Avslutningsårsak',
        caseOverviewHeaderExitDate: 'Sluttdato',
        caseOverviewHeaderStepTitle: 'Steg-tittel',
        caseOverviewHeaderStepCategory: 'Steg-kategori',
        caseOverviewHeaderNextStepTitle: 'Tittel på neste steg',
        caseOverviewHeaderNextStepCategory: 'Kategori for neste steg',
        caseOverviewHeaderSignedFoudations: 'Signerte grunnlag',
        caseOverviewHeaderPaymentPlans: 'Betalingsplaner opprettet',
        caseOverviewHeaderFoundationDate: 'Grunnlagsdato',
        caseOverviewHeaderFoundationCode: 'Grunnlagskode',
        caseOverviewHeaderFoundationType: 'Grunnlagstype',
        caseOverviewHeaderRkiRegistry: 'Register',
        caseOverviewHeaderState: 'Status',
        caseOverviewHeaderReportedAt: 'Rapportert den',
        caseOverviewHeaderError: 'Feilmelding',
        caseOverviewHeaderRKIReference: 'RKI-referansenummer',
        caseOverviewHeaderClientNumber: 'Kreditornummer',
        caseOverviewHeaderSurveillance: 'Overvåking',
        caseOverviewHeaderSurveillanceDate: 'Overvåkingsdato',
        paymentPlansOverview: 'Oversikt over betalingsplaner',
        paymentPlansOverviewTabPaymentPlans: 'Betalingsplaner',
        paymentPlansOverviewTabPaymentPlanEntries: 'Avdrag',
        paymentPlansOverviewHeaderPaymentPlanId: 'Betalingsplan-ID',
        paymentPlansOverviewHeaderCaseSequentialId: 'Saksnummer',
        paymentPlansOverviewHeaderCaseStatus: 'Saksstatus',
        paymentPlansOverviewHeaderCreditorName: 'Kreditornavn',
        paymentPlansOverviewHeaderStatus: 'Status',
        paymentPlansOverviewHeaderCreatedAt: 'Opprettelsesdato',
        paymentPlansOverviewHeaderSettledEntries: 'Betalte avdrag',
        paymentPlansOverviewHeaderTotalEntries: 'Totalt antall avdrag',
        paymentPlansOverviewHeaderAmount: 'Avdragsbeløp',
        paymentPlansOverviewHeaderFromDate: 'Fra dato',
        paymentPlansOverviewHeaderToDate: 'Til dato',
        paymentPlansOverviewEntriesHeaderPaymentPlanId: 'Avdrags-ID',
        paymentPlansOverviewEntriesHeaderCaseSequentialId: 'Saksnummer',
        paymentPlansOverviewEntriesHeaderCaseStatus: 'Saksstatus',
        paymentPlansOverviewEntriesHeaderCreditorName: 'Kreditornavn',
        paymentPlansOverviewEntriesHeaderAmount: 'Beløp',
        paymentPlansOverviewEntriesHeaderEntryStatus: 'Status',
        paymentPlansOverviewEntriesHeaderReminderDate: 'Purredato',
        paymentPlansOverviewEntriesHeaderDate: 'Avdragsdato',
        paymentPlansOverviewEntriesHeaderDeadlineDate: 'Endelig frist',
        paymentPlansOverviewEntriesHeaderCancelDate: 'Misligholdsdato',
        reportOrdered: 'Rapport bestilt',
        reportOrderedText: 'Du vil snart motta en e-post med rapporten din.',
        reportOrderedCloseButton: 'Lukk',
        interactionsReports: 'Interaksjonsrapport',
        interactionsReportsDesc: 'Rapport over alle inngående og utgående interaksjoner',
        interactionsReportsCreatedAt: 'Opprettet',
        interactionsReportsState: 'Status',
        interactionsReportsType: 'Type',
        interactionsReportsDirection: 'Retning',
        interactionsReportsCreditorSeqId: 'Kreditornummer',
        interactionsReportsCreditor: 'Kreditor',
        interactionsReportsCaseSeqId: 'Saks-ID',
        interactionsReportsAddress: 'Adresse',
        interactionsReportsZipcode: 'Postnummer',
        interactionsReportsCity: 'Poststed',
        interactionsReportsCountry: 'Land',
        creditorsReportSeqId: 'Kreditornummer',
        creditorsReportName: 'Kreditornavn',
        creditorsReportCentralRegisterId: 'Org.nr / fødselsnr',
        creditorsReportStatus: 'Status',
        creditorsReportAddress: 'Adresse',
        creditorsReportZipcode: 'Postnummer',
        creditorsReportCity: 'By',
        creditorsReportContactPerson: 'Kontaktperson hos kreditor',
        creditorsReportAcquisitionResponsible: 'Akkvisisjonsansvarlig',
        creditorsReportCaseworkerContact: 'Saksbehandlerkontakt',
        creditorsReportDefaultWorkflow: 'Standard workflow',
        creditorsReportCatchAllResponsible: 'Catch-all-ansvarlig for oppgaver',
        creditorsReportExperianClientNumber: 'Experian klientnummer',
        creditorsReportCaseCount: 'Antall saker',
        creditorsReportLatestCaseCreatedAt: 'Dato for siste saksopprettelse',
        creditorsReportCollectorName: 'Inkassoselskapets navn',
        creditorsReportDefaultBillingModel: 'Standard avregningsmodell',
        creditorsReportDefaultBillingAppendixSetup: 'Standard oppsett for avregningsbilag',
        creditorsReportBillingEmailTo: 'Avregningsemail til',
        creditorsReportBillingEmailCc: 'Avregningsemail cc',
        creditorsReportBillingEmailBcc: 'Avregningsemail bcc',
        creditorsReportPaymentDays: 'Betalingsdager',
        creditorsReportMinimumBillingThreshold: 'Minimumsgrense for saksavregning',
        creditorsReportCreatedAt: 'Opprettet',
        dailyDeposits: 'Daglige innbetalinger',
        dailyDepositsDesc: 'Daglige innbetalinger per kreditor',
        paymentPlanReport: 'Betalingsplanrapport',
        paymentPlanReportDesc: 'Rapport med informasjon om aktive, kansellerte og tidligere betalingsplaner.',
        dailyDepositsEconomic: 'Daglige innbetalinger per kreditor (e-conomic)',
        dailyDepositsEconomicDesc: 'Daglige innbetalinger per kreditor. per kreditor til e-conomic uten Frisbii',
        invoiceAppendix: 'Fakturavedlegg',
        invoiceAppendixDesc: 'Ark som viser finansielle transaksjoner for kreditorer i en tidsperiode.',
        employeePerformance: 'Medarbeiderytelse',
        employeePerformanceDesc: 'Rapport som viser effektiviteten til hver medarbeider.',
        phoneCalls: 'Oversikt over telefonsamtaler',
        phoneCallsDesc: 'Oversikt som viser hvem som ringte og mengden innbetalinger dette medførte.',
        phoneCallsDays: 'Antall dager etter samtalen som innbetalingen må være registrert.',
        depositAmount: 'Innbetalt beløp',
        depositCount: 'Antall innbetalinger',
        selectCreditor: 'Velg kreditor',
        quarter: 'Kvartal',
        optional: 'valgfri',
        noDownloads: 'Det er ingen rapporter å laste ned.',
    },
    tribunal: {
        tribunal: 'Domstolsmodul',
        couldNotCreateTribunalCase: 'Kunne ikke opprette domstolssak',
        createTribunalCase: 'Opprett',
        noTribunalCases: 'Ingen domstolssaker ennå',
        addTribunalCase: 'Legg til domstolssak',
        fsNo: 'FS-nr.',
        editFsNo: 'Rediger FS-nr.',
        FsNoUpdated: 'FS-nr. oppdatert',
        document: 'Dokument',
        addDocument: 'Legg til dokument',
        closedObjection: 'Avsluttet på grunn av innsigelse',
        insolvency: 'Insolvens',
        insolvencyDate: 'Insolvensdato',
        phoneCourtMeeting: 'Rettsmøte per telefon',
        register: 'Registrer',
        date: 'Dato',
        meetingLocation: 'Møtested',
        meetingDate: 'Møtedato',
        courtCaseCosts: 'Saksomkostninger',
        notRegistered: 'Ikke registrert',
        createFogedrekvisition: 'Opprett begjæring om utlegg',
        assignee: 'Ansvarlig',
        selectDistraintType: 'Velg utleggstype',
        registerDistraint: 'Registrer utlegg',
        distraintType: 'Utleggstype',
        amount: 'Beløp',
        comment: 'Kommentar',
        address: 'Adresse',
        licenseplate: 'Registreringsnummer',
        vin: 'VIN',
        distraintDate: 'Dato for utlegg',
        distraintReferenceId: 'Tinglysingsnummer',
        distraintUpdated: 'Utlegg oppdatert',
        distraintCancelled: 'Utlegg annullert',
        distraintCancelledDate: 'Dato for annullering av utlegg',
        registerPolicePresentation: 'Registrer politifremstilling',
        register1Paategning: 'Registrer 1.-påtegning',
        foerstePaategningDate: 'Dato for 1.-påtegning',
        register2Paategning: 'Registrer 2.-påtegning',
        andenPaategningDate: 'Dato for 2.-påtegning',
        resendBPK: 'Send betalingsoppfordring på nytt',
        editBPK: 'Rediger betalingsoppfordring',
        debtorSentToPolicePresentation: 'Skyldner sendt til politifremstilling',
        resendStaevning: 'Send stevning på nytt',
        editStaevning: 'Rediger stevning',
        resendFogedbegaering: 'Send begjæring om utlegg på nytt',
        editFogedbegaering: 'Rediger begjæring om utlegg',
        courtMeetingType: 'Møtetype',
        bailiffInvoice: {
            bailiffInvoice: 'Faktura fra Namsmannen',
            client: 'Kreditor',
            debt: 'Gjeld',
            paymentFee: 'Gebyr for betalingsoppfordring',
            distress: 'Utlegg',
            yesStartDistress: 'Ja til iverksettelse av utlegg',
            yesAutoCase: 'Ja til automatisk oppstart av sak i sivil domstol',
            createInvoice: 'Opprett faktura',
        },
        noFoundation: 'Ingen tvangsgrunnlag funnet. Legg til ett på saken.',
        addFoundation: 'Legg til tvangsgrunnlag',
        foundation: 'Tvangsgrunnlag',
        economy: 'Økonomi',
        jurisdiction: 'Verneting',
        requisition: 'Begjæring',
        court: 'Domstol',
        responsible: 'Ansvarlig',
        sendRequisition: 'Send begjæring',
        debt: 'Gjeld',
        noCourt: 'Ingen domstol funnet',
        typeOfRequisituion: 'Type begjæring',
        types: {
            [UdbetalingsRekvisitioner.Politifremstilling]: 'Politifremstilling',
            [UdbetalingsRekvisitioner.Betalingspåkrav]: 'Betalingsoppfordring',
            [UdbetalingsRekvisitioner.Fogedrekvisition]: 'Begjæring om utlegg',
        },
        claim: 'Påstand',
        sendToCourt: 'Send til domstol',
        smallCase: 'Småkravssak',
        commonCivilCase: 'Alminnelig sivil sak',
        shortDescription: 'Kort beskrivelse',
        statementClaim: 'Saksfremstilling og faktum',
        addAppendix: 'Legg til vedlegg',
        additionalInformation: 'Ytterligere informasjon',
        caseCreation: 'Oppretter sak',
        caseCreationDescription: `Saken opprettes nå i domstolens system. Det tar litt tid, men saken blir oppdatert i Debbie når den er ferdig.`,
        keyCodeTitle: 'Skriv nøkkelkode for',
        keyCodeDescription: 'Bruk NemID-nøkkelkortet til å finne nøkkelen som svarer til',
        sessionCreation: 'Oppretter økt',
        sessionCreationFailure: 'Oppretting av økt mislyktes',
        keySubmittedExplainer: 'Nøkkelkoden brukes til å logge inn.',
        sessionCreationExplainer: 'For at en sak skal kunne sendes til domstolen, må det opprettes en økt i tribunal. Til det trenger vi en nøkkelkode fra NemID-nøkkelkortet ditt.',
        keycode: 'NemID-nøkkelkode',
        authKey: 'Nøkkel',
        missingKeyTitle: 'Mangler tribunal-nøkkel',
        missingKeyExplainer: 'For å sende saker til domstolen trenger du en nøkkel til tribunal.',
        meetings: 'Møter',
    },
    courtMeetingState: {
        [CourtMeetingState.Accepted]: 'Møte akseptert',
        [CourtMeetingState.Concluded]: 'Ferdig',
        [CourtMeetingState.NeedsApproval]: 'Venter på godkjenning',
        [CourtMeetingState.NeedsRevision]: 'Venter på revisjon',
        [CourtMeetingState.NotesSent]: 'Notater mottatt',
        [CourtMeetingState.ReadyForMeeting]: 'Venter på møtenotater',
        [CourtMeetingState.Rejected]: 'Avvist av ansvarlig',
        [CourtMeetingState.Canceled]: 'Avlyst',
    },
    debtorWeb: {
        overpaymentHeader: 'Du har penger til gode',
        overpaymentSuccessHeader: 'Kontoopplysningene dine er mottatt',
        overpaymentSuccessTextHeader: 'Refusjonen din blir utbetalt så snart som mulig. Har du gjort en feil i innleggingen, kan du oppdatere opplysningene dine nedenfor.',
        overpaymentPreAmount: 'Du skal ha',
        overpaymentPostAmount: 'til gode. Skriv kontonummeret ditt nedenfor, så sender vi det til deg.',
        userInfoUpdateSuccess: 'Forespørselen din er sendt. Takk.',
        userInfoUpdateNoDataChanged: 'Ingen endringer registrert',
        congratsNoDebt: 'Gratulerer. Du har ikke mer gjeld på denne saken.',
        congratsDeposit: 'Takk for innbetalingen på denne saken.',
        congratsCaseEnd: 'Saken er avsluttet.',
        satisfactionOne: 'Vi vil gjerne høre om opplevelsen din. Trykk',
        satisfactionTwo: 'her',
        satisfactionThree: 'for å fortelle om den.',
        documentation: 'Dokumentasjon',
        goToPayment: 'Gå til betaling',
        signingPageSigned: 'Du har signert dokumentet',
        signingPageDeclinedSigning: 'Du har avslått å signere dokumentet',
        seeMore: 'Se mer',
        noCasesFound: 'Ingen saker funnet',
    },
    associateCases: {
        associateCase: 'Solidarisk ansvar',
        associateWithCase: 'Finn saken med den solidarisk ansvarlige skyldneren.',
        associateWithCaseSearch: 'Søk etter sak',
        associateCaseVoucher: 'Vil du synkronisere denne saksposteringen med de andre sakene?',
        caseVoucherIsAssociated: 'Denne saksposteringen er synkronisert med andre saker i det solidariske ansvaret.',
        joinExistingCase: 'Koble til eksisterende sak',
        createNewAssociatedCase: 'Opprett ny tilknyttet sak',
        selectVouchers: 'Velg posteringer',
        selectVouchersDescription: 'Velg hvilke posteringer som skal kopieres til den nye saken.',
        createAssociatedCaseButton: 'Opprett tilknyttet sak',
        noVouchersAvailable: 'Ingen posteringer tilgjengelige å kopiere',
    },
    caseGroups: {
        caseGroups: 'Saksgrupper',
        aiSettings: 'AI-innstillinger',
        aiSettingsDescription: 'Instruksjoner her brukes for alle saker i denne saksgruppen.',
        createCaseGroup: 'Opprett saksgruppe',
        addCaseGroup: 'Legg til saksgruppe',
        editCaseGroup: 'Rediger saksgruppe',
        selectCaseGroup: 'Velg saksgruppe',
        searchCaseGroups: 'Søk saksgrupper',
        confirmDelete: 'Er du sikker på at du vil slette saksgruppen? Alle saker fjernes fra gruppen.',
        caseGroup: 'Saksgruppe',
        deleteCaseGroup: 'Slett',
        label: 'Navn',
        categorisedDebtOverview: 'Legg til attributter i kategorisert gjeldsoversikt',
        showPropertyLabel: 'Navn',
        addShowProperty: 'Legg til attributt',
    },
    costCeiling: {
        failedToLoad: 'Noe gikk galt. Prøv igjen senere.',
        costCeiling: 'Kostnadstak',
        customAmount: 'Tilpasset kostnadstak (standard er hovedstolen)',
        defaultForNewCases: 'Kostnadstak på nye saker',
        caseGroupDefaultDescription: 'Om kostnadstak er aktivert på nye saker opprettet i denne saksgruppen. Hvis ingen saksgruppeinnstilling er angitt, brukes innstillingen fra kreditor eller virksomheten.',
        noCreditorSetting: 'Ingen kreditorinnstilling',
        noCaseGroupSetting: 'Ingen saksgruppeinnstilling',
        enabled: 'Aktivert',
        disabled: 'Deaktivert',
    },
    createTenantContent: {
        defaultCaseGroupLabel: 'Saker til inkasso',
        defaultBankAccountName: 'Bankkonto',
    },
    tenants: {
        tenantDetails: 'Kontoopplysninger',
        status: 'Status',
        goLive: 'Aktiver',
        disableTenant: 'Deaktiver konto',
        disableTenantWarning: 'Er du sikker på at du vil deaktivere denne kontoen? Brukerne mister tilgang, og handlingen kan ikke angres i Lighthouse.',
        tenantTypeNotSet: 'Ikke angitt',
        prices: 'Priser',
        identityCollector: 'Inkassobyrå',
        invoicePipeFilter: 'Faktureringsfilter',
        defaultBillingModel: 'Standard faktureringsmodell',
        defaultBillingAppendixSetup: 'Standard bilagsoppsett for fakturering',
        configurationOptions: 'Konfigurasjoner',
        depositBankAccountForCreditors: 'Innbetalingskonto for kreditorer',
        depositBankAccountForCreditorsName: 'Bankens navn',
        billingCustomText: {
            title: 'Egendefinert tekst for fakturering',
            underCreditorName: 'Under kreditorens navn',
            endWhenReceivingPayment: 'Under betalingsinformasjon når kreditor skal betale noe',
            endWhenSendingPayment: 'Under betalingsinformasjon når kreditor skal motta noe',
        },
        collectionCommission: 'Inkassohonorar',
        depositOrder: 'Betalingsrekkefølge',
        date: 'Dato',
        voucherFrom: 'Postering pålagt av',
        voucherType: 'Posteringstype',
        voucherCategory: 'Posteringskategori',
        newestFirst: 'Nyeste først',
        oldestFirst: 'Eldste først',
        caseCloseFee: 'Saksavslutningsgebyr',
        clientCaseCreationFee: 'Saksopprettelsesgebyr kreditor',
        tenantCaseCreationFee: 'Saksopprettelsesgebyr organisasjon',
        debtRegisterRegistrationFee: 'Gjeldsregister-registreringsgebyr',
        paymentDemandFee: 'Gebyr for betalingsoppfordring',
        fogedrekvisitionFee: 'Gebyr for begjæring om utlegg',
        folkeregisteropslagsFee: 'Folkeregisteroppslag',
        anmeldelseAfKravFee: 'Anmeldelse av krav',
        legalAdviceHourlyRate: 'Timepris for juridisk bistand',
        afslysningAfUdlaeg: 'Sletting av utlegg',
        autoDebtRegisterHeader: 'Auto gjeldsregistrering',
        automaticDebtRegister: 'Automatisk gjeldsregistrering',
        autoRegisterInOpenRegistry: 'Åpent register',
        autoIgnoreUnresolvedOppositions: 'Ignorer uavklarte interaksjoner (innsigelser)',
        autoDeleteDebtRegistrationOnCaseEnd: 'Slett gjeldsregistrering automatisk ved saksavslutning',
        autoDebtRegisterInfoTip: 'Klikk her for mer info',
        areYouSureAutoDebtRegister: 'Er du sikker?',
        autoDebtRegisterRKI: {
            headline: 'Automatisk registrering i gjeldsregistre.',
            info: 'Denne funksjonen tar hensyn til følgende: ',
            exclude: 'Den tar IKKE hensyn til følgende: : ',
            endingInfo: 'Aktiver kun denne funksjonen hvis du vet at sakene dine overholder ovenstående.',
            note: 'Merk at denne funksjonen også kan aktiveres/deaktiveres på kreditornivå.',
        },
        autoImposeCompensationCost: 'Pålegg automatisk kompensasjonskostnader ved import av bedriftssaker',
        autoSendInteractionsAfterXVerifications: 'Send interaksjoner automatisk etter x godkjenninger',
        preventSendingLetters: 'Hindre utsending av fysiske brev (webhooks kan brukes til å sende dem på andre måter)',
        selfCollection: 'Pålegg egeninkassokostnader',
        twoFactorRequired: 'Tofaktorautentisering påkrevd for brukere',
        outboundCall: 'Utgående anrop',
        autoExpireVouchers: 'Automatisk foreldelse av posteringer',
        hideDocumentsFromCreditors: 'Skjul dokumenter for kreditorer',
        allowDebtorSelfOverwrite: 'Tillat skyldnere å overskrive egne opplysninger uten godkjenning',
        costCeilingEnabledByDefault: 'Aktiver kostnadstak på nye saker som standard',
        deleteCaseDataAfterYears: 'Slett saksdata x år etter at saken er avsluttet (GDPR)',
        enableGdprDataDeletion: 'Aktiver automatisk GDPR-datasletting',
        dangerZone: 'Faresone',
        AKSSettings: 'RKI-innstillinger',
        rkiEnabled: 'Aktiver RKI',
        AKSKey: 'AKS-nøkkel',
        AKSCode: 'AKS-kode',
        AKSUsername: 'AKS-brukernavn',
        AKSPassword: 'AKS-passord',
        manglerAdvokatindestaaelse: 'Mangler advokatgaranti',
        debitorRegistretEnabled: 'Aktiver Debitor Registret',
        debitorRegistretClientId: 'Client ID',
        debitorRegistretClientSecret: 'Client Secret',
        debitorRegistretCredentialsRequired: 'Fyll ut både Client ID og Client Secret for å lagre tilgangsopplysningene',
        debitorRegistretSetupCreditors: 'Opprett kreditorer i Debitor Registret',
        debitorRegistretSetupCreditorsDescription: 'Oppretter alle aktive kreditorer i Debitor Registret og lagrer kreditornummeret deres.',
        debitorRegistretSetupCreditorsSuccess: 'Kreditorer opprettet i Debitor Registret',
        debitorRegistretSetupCreditorsSkipped: 'Allerede opprettet',
        debitorRegistretSetupCreditorsFailed: 'Feil ved opprettelse av kreditorer i Debitor Registret',
        affiliatePartners: 'Affiliate-partnere',
        createNewTenant: 'Opprett ny konto',
        createNewTenantAsAffiliatePartner: 'Opprett ny konto som affiliate-partner',
        disableAi: 'Deaktiver AI',
        disableCreditorCreationFromUi: 'Deaktiver opprettelse av kreditorer fra brukergrensesnittet',
        autoVerifyCases: 'Verifiser saker automatisk',
    },
    intents: {
        intent: 'Hensikt',
        days: 'Dager',
        discount: 'Rabatt',
        percentDiscount: 'Prosentrabatt',
        type: 'Type',
        noDiscount: 'Ingen rabatt',
    },
    intentDiscountTypes: {
        [DiscountType.Amount]: 'Beløp',
        [DiscountType.Fraction]: 'Prosent',
    },
    intentTypes: {
        [IntentType.Unknown]: 'Ukjent',
        [IntentType.Deposit]: 'Innbetaling',
    },
    errors: {
        notFound: 'Siden du leter etter ble ikke funnet.',
        caseNotFound: 'Saken kunne ikke finnes',
        pleaseCreateTicket: 'Opprett en ticket hvis du mener dette er en feil.',
        unknownError: 'Det oppstod en feil.',
        authError: 'Du har ikke tilgang.',
        meError: 'Det oppstod en feil ved henting av brukerinformasjonen din. Hvis dette er uventet, prøv på nytt.',
        unauthorizedError: 'Du har ikke tillatelse til å utføre denne handlingen',
        invalid: 'ugyldig',
        missing: 'Mangler',
        loadingError: 'Feil ved lasting av data',
    },
    letterTemplates: {
        journalNumber: 'Ang.:',
        caseReferenceId: 'Referanse:',
        caseVoucherReferenceIds: 'Referanser:',
        returnAddress: 'Returadresse:',
        w: 'W',
        e: 'E',
        t: 'T',
        centralRegisterId: 'Org.nr.',
    },
    mentionContent: {
        amortisationRemainingAfterFinalPayment: 'Restgjeld etter siste avdrag',
        amortisationForgivenOnCompletion: 'Ettergis når avtalen er oppfylt',
        amortisationDebtAfterSettlement: 'Gjeld etter oppfylt akkordavtale',
        amortisationPaymentDate: 'Betalingsdato',
        amortisationAddedFees: 'Tillagte gebyrer',
        amortisationRemainingAfterPayment: 'Restgjeld etter betaling',
        amortisationRemainingDebt: 'Restgjeld',
        amortisationPrincipal: 'Hovedstol',
        amortisationCosts: 'Kostnader',
        amortisationInterest: 'Renter',
        amortisationAccruedInterest: 'Tillagte renter',
        amortisationPayment: 'Avdrag',
        amortisationCurrentBalance: 'Nåværende saldo',
        reminderFeeRow: 'Rykkergebyr, jf. renteloven § 9b, annet ledd',
        debtCollectionFeeRow: 'Inkassogebyr, jf. renteloven § 9b, første ledd',
        debtCollectionCostRow: 'Inkassoomkostninger, jf. renteloven § 9a, første ledd',
        compensationFeeRow: 'Kompensasjonsgebyr, jf. renteloven § 9a, tredje ledd',
        fixedInterestRow: 'Tidligere påløpte renter',
        processInterestRow: 'Påløpte renter fra forfallsdato',
        yearlyInterestRow: 'Påløpte renter',
        otherCosts: 'Andre kostnader',
        sum: 'Totalt utestående',
        paid: 'Allerede betalt',
        invoice: 'Faktura',
        caseVoucher: ' ',
        currency: 'Valuta',
        date: 'Dato',
        dueDate: 'Forfallsdato',
        amount: 'Beløp',
        deposited: 'Innskudd',
        residue: 'Restbeløp',
        text: 'Tekst',
        appliedToPrincipal: 'Avdrag hovedstol',
        appliedToInterest: 'Avdrag rente',
        appliedToCosts: 'Avdrag omkostninger',
        principalBalance: 'Gjenstående hovedstol',
        interestBalance: 'Gjenstående rente',
        costsBalance: 'Gjenstående omkostninger',
        expiredSince: 'Herav foreldet',
        total: 'Totalt',
        email: 'E-post',
        phone: 'Telefon',
        signature: 'Signatur',
        journalNumber: 'Journalnummer',
        genericEmailSubjectPre: 'Angående din gjeld til',
        genericEmailSubjectForAlternativeContactPre: 'Sak hos',
        satisfactionsOrClick: 'eller klikk',
        satisfactionsHere: 'her',
        principalReferenceIdsAnd: ' og ',
        previousYearsAnd: ' og ',
        nameAndAddressProtectedPerson: 'Person med navne- og adressebeskyttelse',
    },
    emailSignature: {
        privacyPolicyText: 'Behandling av data. Vi kan behandle personopplysninger om deg. Du kan lese personvernerklæringen vår her:',
        regards: 'Med vennlig hilsen',
    },
    notificationEmail: {
        newPendingMessages: 'Nye ventende meldinger',
        from: 'fra',
        regarding: 'vedr.',
        goToApp: 'Gå til webappen',
        newNotifications: 'Nye varsler',
        newTodos: 'Nye oppgaver',
    },
    newNoteEmail: {
        dear: 'Kjære',
        newMessageFromCollector: 'Du har mottatt en ny melding fra',
        subjectNewMessageFrom: 'Ny melding fra',
        clickHereToAnswer: 'Trykk på knappen nedenfor for å lese mer eller svare på henvendelsen.',
        answerAndReadMore: 'Svar eller les mer',
        sentTo: 'Sendt til',
    },
    invoice: {
        deposit: 'Innskudd',
        overpayment: 'Overbetaling',
        inclVat: 'inkl. mva.',
        deposits: 'Innskudd',
        creditorSeqId: 'Id',
        period: 'Periode',
        description: 'Beskrivelse',
        amount: 'Beløp',
        ofVoucher: 'Av bilag',
        subTotal: 'Delsum',
        customerReferenceId: 'Kundereferanse-id',
        imposedBy: 'Pålagt av',
        vat: 'Mva',
        total: 'Total',
        date: 'Dato',
        number: 'Nummer',
        appendix: 'Vedlegg',
        voucher: 'Bilag',
        voucherReferenceId: 'Bilagsreferanse',
        text: 'Tekst',
        disbursements: 'Utlegg',
        fees: 'Gebyrer',
        collectionCommission: 'Inkassoprovisjon',
        creditorName: 'Kreditor',
        creditorReference: 'Kreditorreferanse-id',
        caseGroup: 'Saksgruppe',
        caseSeqId: 'Saks-id',
        caseReferenceId: 'Saksreferanse-id',
        depositId: 'Innskudds-id',
        paidToClient: 'Betalt til kreditor',
        economicMovement: 'Kreditorbevegelse',
        debtorName: 'Skyldnernavn',
        creditorDeposit: 'Kreditorinnskudd',
        previous: 'Forr.',
        credited: 'Kreditert',
        currency: 'Valuta',
    },
    properties: {
        selectProperty: 'Velg en egenskap',
        searchProperties: 'Søk egenskaper',
        properties: 'Egenskaper',
        createNewPropertyType: 'Opprett ny egenskapstype',
        infoGuideMentions: 'For å sette inn dataene i en mal, bruk denne taggen',
        infoGuideAPI: 'For å få tilgang til egenskapen via API kan du bruke feltet',
        infoGuideImport: 'For å importere data inn i egenskapen kan du lage en kolonne i Excel-arket ditt med en av følgende kolonneoverskrifter',
        newProperty: 'Ny egenskapstype',
        newPropertyFor: 'Opprett en ny egenskapstype for',
        label: 'Etikett',
        description: 'Beskrivelse',
        searchable: 'Søkbar',
        handle: 'Handle',
        type: 'Type',
        ref: 'Referanse',
        scope: 'Tilknytning',
        required: 'Obligatorisk',
        usage: 'Bruk',
        historical: 'Historiske data',
        create: 'Opprett',
        defaultDropdownOptions: 'Alternativ 1\nAlternativ 2',
        dropdownOptions: 'Nedtrekksalternativer',
        cases: 'Saker',
        caseVouchers: 'Saksbilag',
        creditors: 'Kreditorer',
        delete: 'Slett',
        or: 'eller',
        deleteAreYouSure: 'Hvis denne egenskapen slettes, fjernes den fra alle saker og maler. Er du sikker?',
        option: 'Alternativ',
    },
    entities: {
        [Entity.Billing]: 'Fakturering',
        [Entity.Case]: 'Sak',
        [Entity.Creditor]: 'Kreditor',
        [Entity.Customer]: 'Kunde',
        [Entity.TribunalCase]: 'Domstolssak',
        [Entity.Debtor]: 'Skyldner',
        [Entity.Collector]: 'Inkassobyrå',
        [Entity.BillingVoucher]: 'Faktureringsbilag',
        [Entity.CaseVoucher]: 'Saksbilag',
        [Entity.Template]: 'Mal',
        [Entity.Workflow]: 'Arbeidsflyt',
    },
    filterType: {
        [FilterType.Exact]: 'Filtrer på nøyaktig treff',
        [FilterType.Containing]: 'Filtrer på delvis treff',
    },
    propertyTypeLabels: {
        ['Name']: 'Navn',
        ['Address']: 'Adresse',
        ['Phone']: 'Telefon',
        ['Email']: 'E-post',
        ['Type']: 'Type',
        ['Company']: 'Selskap',
    },
    propertyTypeDescriptions: {
        ['Name of the alternative contact person.']: 'Navn på den alternative kontaktpersonen.',
        ['Address for the alternative contact person.']: 'Adresse til den alternative kontaktpersonen.',
        ['Phone to the alternative contact person.']: 'Telefon til den alternative kontaktpersonen.',
        ['Email to the alternative contact person.']: 'E-post til den alternative kontaktpersonen.',
        ['Type of the alternative contact person.']: 'Type alternativ kontaktperson.',
        ['Company where the alternative contact person works.']: 'Selskap der den alternative kontaktpersonen jobber.',
    },
    alternativeContactTypes: {
        [AlternativeContactType.Lawyer]: 'Advokat',
        [AlternativeContactType.Proprietorship]: 'Boligforvalter',
        [AlternativeContactType.Owner]: 'Eier',
        [AlternativeContactType.Guardian]: 'Verge',
        [AlternativeContactType.Curator]: 'Bostyrer',
        [AlternativeContactType.Landlord]: 'Utleier',
        [AlternativeContactType.FinancialAdvisor]: 'Finansiell rådgiver',
        [AlternativeContactType.TaxAuthority]: 'Skattemyndighet',
        [AlternativeContactType.PowerOfAttorney]: 'Fullmakt',
        [AlternativeContactType.Administrator]: 'Administrator',
        [AlternativeContactType.Police]: 'Politi',
        [AlternativeContactType.Guarantor]: 'Kausjonist',
        [AlternativeContactType.Other]: 'Annet',
    },
    creditScore: {
        estimated: 'Estimert',
        estimate: 'sannsynlighet for inndrivelse av restgjelden',
        estimateZero: 'sannsynlighet for inndrivelse',
        paid: 'Gjelden er betalt',
    },
    voucherApplications: {
        header: 'Bilagsregler',
        createError: 'Kunne ikke opprette bilagsregel, sjekk at du ikke oppretter sirkulære referanser',
        creditorCustomApplicationList: 'Kreditorer med egne regler',
        noCustomApplications: 'Ingen kreditorer har egne regler',
        textSelector1: 'Når en ny ',
        textSelector2: ' opprettes, der sakens type er ',
        textSelector3: ', opprettes følgende bilag',
        forCreditor: 'Når kreditor er',
        addCreditor: 'Velg kreditor',
    },
    voucherApplicationTypeLabels: {
        [VoucherApplicationType.Case]: 'sak',
        [VoucherApplicationType.VoucherCategory]: 'bilag med kategorien',
        [VoucherApplicationType.VoucherType]: 'bilag av typen',
    },
    voucherApplicationTargetLabels: {
        [VoucherApplicationTarget.Both]: 'privat/bedrift',
        [VoucherApplicationTarget.Person]: 'privat',
        [VoucherApplicationTarget.Company]: 'bedrift',
    },
    interestFromLabels: {
        [InterestFrom.Date]: 'fra opprettelsesdato',
        [InterestFrom.DueDate]: 'fra forfallsdato',
    },
    todoQueue: {
        sorting: 'Sortering',
        oldest: 'Eldste',
        creditScore: 'Kredittscore',
        creditorTodosNotSupported: 'Oppgaver håndteres ennå ikke for kreditorer',
    },
    views: {
        associated: 'Tilknyttet',
        notAssociated: 'Ikke tilknyttet',
        filter: 'Filter',
        view: 'visning',
        name: 'Visningsnavn',
        introHeader: 'Ingen visninger her',
        introDescription: 'Du kan opprette en visning ved å klikke på knappen øverst i høyre hjørne.',
        clear: 'Tøm',
        collapse: 'Skjul',
        expand: 'Utvid',
        noData: 'Siden er tom',
        is: 'er',
        oneOf: 'er en av',
        before: 'før',
        after: 'etter',
        values: 'verdier',
        isNot: 'er ikke',
        noneOf: 'er ikke en av',
        invalidNumberError: ' er ikke et gyldig tall',
        displayOptions: 'Verdier',
        localChanges: 'Visning redigert lokalt',
        resetLocalChanges: 'tilbakestill endringer',
        orderedBy: 'Sorter etter',
        orderedByDirection: 'Sorteringsretning',
        primaryLabel: 'Primær etikett',
        secondaryLabel: 'Sekundær etikett',
        betaDisclaimer: 'Visninger er en betafunksjon. Det kan forekomme endringer eller oppdateringer som potensielt kan påvirke tidligere opprettede visninger. Vi jobber kontinuerlig med å forbedre denne funksjonen og setter pris på tålmodigheten din',
        commaSeparated: 'Kommaseparert',
    },
    viewFilterTypeLabels: {
        isAssociatedCase: 'Sakstilknytning',
        agentProposalProposedAt: 'Dato for agentforslag',
        agentProposalDecidedAt: 'Beslutningsdato for agentforslag',
        caseStatus: 'Saksstatus',
        creditorId: 'Kreditor',
        creditorState: 'Kreditortilstand',
        interactionDirection: 'Interaksjonsretning',
        interactionType: 'Interaksjonstype',
        caseVoucherState: 'Bilagstilstand',
        caseVoucherSource: 'Bilagskilde',
        caseVoucherCurrency: 'Bilagsvaluta',
        caseVoucherType: 'Bilagstype',
        pausedWithUpdates: 'Pauset oppdatering',
        historicallyPausedUpdates: 'Historisk pauset oppdatering',
        creditorCreatedAt: 'Kreditor opprettet',
        updatePausedAt: 'Oppdatering pauset',
        updateContinuedAt: 'Oppdatering fortsatt',
        updateRemindedAt: 'Oppdatering påminnet',
        caseCreatedAt: 'Sak opprettet',
        caseVoucherDate: 'Bilagsdato',
        caseVoucherExpirationDate: 'Bilagets utløpsdato',
        caseVoucherIrrecoverableDate: 'Dato bilag uinndrivelig',
        caseVoucherCreatedAt: 'Bilag opprettet',
        satisfactionCreatedAt: 'Innfrielse opprettet',
        interactionCreatedAt: 'Interaksjon opprettet',
        endReasonId: 'Avslutningsårsak',
        caseGroupId: 'Saksgruppe',
        billingModelId: 'Faktureringsmodell',
        documentType: 'Dokumenttype',
        caseWorkflow: 'Saksarbeidsflyt',
        currentCaseWorkflowTask: 'Nåværende oppgave i saksarbeidsflyt',
        nextCaseWorkflowTask: 'Neste oppgave i saksarbeidsflyt',
        caseStatusTime: 'Tid for saksstatus',
        caseNumbers: 'Saks-id',
        properties: 'Egenskap',
        caseTags: 'Sakstagger',
        isCompany: 'Skyldnertype',
    },
    viewLabels: {
        'cases.id': 'Saks-id',
        'cases.status': 'Saksstatus',
        'cases.createdAt': 'Sakens opprettelsesdato',
        'cases.createdBy': 'Sak opprettet av',
        'creditors.name': 'Kreditornavn',
        'creditors.id': 'Kreditor-id',
        'billingModels.name': 'Faktureringsmodell',
        'caseGroups.label': 'Saksgruppe',
        'workflows.title': 'Arbeidsflyt',
        'caseVouchers.amount': 'Saksbilagsbeløp',
        caseVoucherProperties: 'Saksbilagsegenskaper',
        caseProperties: 'Saksegenskaper',
        contactName: 'Kontaktnavn',
        'voucherTypes.label': 'Bilagstype',
        caseResponsible: 'Saksansvarlig',
        caseEndReason: 'Sakens avslutningsårsak',
        caseUpdates: 'Pausede saksoppdateringer',
    },
    interactionCategories: {
        title: 'Interaksjonskategorier',
        createCategory: 'Opprett kategori',
        interactionCategory: 'interaksjonskategori',
        interactionCategories: 'interaksjonskategorier',
    },
    ai: {
        suggestion: 'AI-forslag',
        qualityScore: 'Kvalitetsscore',
        safetyScore: 'Sikkerhetsscore',
        manipulationDetected: 'Manipulasjon oppdaget',
        sensitivityFlags: 'Sensitivitetsflagg',
        reasoning: 'Begrunnelse',
    },
    autoReply: {
        customInstructions: 'Egendefinerte AI-instruksjoner',
        customInstructionsDescription: 'Disse instruksjonene vil bli inkludert i alle AI-genererte svar. Bruk dette til å definere tone, spesifikke regler eller informasjon som alltid skal inkluderes.',
        customInstructionsPlaceholder: 'F.eks.: Henvis alltid til nettstedet vårt for betalingsinformasjon. Bruk alltid kundens fornavn.',
        creditorAISettings: 'Kreditor AI-innstillinger',
        creditorAISettingsDescription: 'Egendefinerte instruksjoner for AI-genererte svar for saker på denne kreditoren.',
        title: 'AI Auto-svar',
        description: 'Generer automatisk svar på innkommende e-poster ved hjelp av AI',
        enabled: 'Aktiver auto-svar',
        enabledDescription: 'Når aktivert, vil AI generere svarutkast for innkommende e-poster knyttet til saker',
        mode: 'Modus',
        modeOutbox: 'Utboks (Gjennomgang)',
        modeOutboxDescription: 'Genererte svar lagres som utkast for manuell gjennomgang før sending',
        modeAutoSend: 'Auto-send',
        modeAutoSendDescription: 'Svar som oppfyller kvalitetsterskler sendes automatisk',
        qualityThreshold: 'Kvalitetsterskel',
        qualityThresholdDescription: 'Minimum kvalitetsscore (0-1) som kreves for automatisk sending',
        safetyThreshold: 'Sikkerhetsterskel',
        safetyThresholdDescription: 'Minimum sikkerhetsscore (0-1) som kreves. Under dette blokkeres svar',
        sensitivityFlags: 'Sensitivitetsblokkeringsliste',
        sensitivityFlagsDescription: 'Emner som krever manuell gjennomgang når de oppdages',
        customFlags: 'Egendefinerte sensitivitetsflagg',
        customFlagsDescription: 'Definer egendefinerte emner som skal utløse manuell gjennomgang',
        addCustomFlag: 'Legg til egendefinert flagg',
        flagId: 'Flagg-ID',
        flagName: 'Navn',
        flagDescription: 'Beskrivelse (hva skal AI-en se etter)',
        noCustomFlags: 'Ingen egendefinerte flagg definert',
        generationModel: 'Genereringsmodell',
        judgeModel: 'Dommermodell',
        usageTitle: 'AI-bruk',
        usageSuggestions: 'Forslag',
        usageCategorizations: 'Kategoriseringer',
        usageAutoReplies: 'Auto-svar',
        usageLimitReached: 'AI-bruksgrense nådd for denne måneden',
        generateSuggestion: 'Generer AI-forslag',
        flags: {
            COURT_LEGAL: 'Domstol / Juridisk',
            POLICE: 'Politi',
            FINANCIAL_HARDSHIP: 'Økonomiske vanskeligheter',
            DISPUTE: 'Tvist',
            THREAT_HOSTILE: 'Trusler / Fiendtlig',
            MEDICAL_HEALTH: 'Medisinsk / Helse',
        },
        blockedReasons: {
            auto_reply_disabled: 'Auto-svar er deaktivert',
            manipulation_detected: 'Manipulasjon oppdaget i innkommende melding',
            safety_threshold: 'Sikkerhetsscore under terskelen',
            blocklist_match: 'Traff sensitivitetsblokkeringsliste',
            custom_flag_match: 'Traff egendefinert sensitivitetsflagg',
            case_reassigned: 'Saken ble tildelt på nytt',
        },
    },
    languages: {
        aa: 'Afar',
        ab: 'Abkhasisk',
        ae: 'Avestisk',
        af: 'Afrikaans',
        ak: 'Akan',
        am: 'Amharisk',
        an: 'Aragonsk',
        ar: 'Arabisk',
        as: 'Assamesisk',
        av: 'Avarisk',
        ay: 'Aymara',
        az: 'Aserbajdsjansk',
        ba: 'Basjkirsk',
        be: 'Hviterussisk',
        bg: 'Bulgarsk',
        bh: 'Biharispråk',
        bi: 'Bislama',
        bm: 'Bambara',
        bn: 'Bengali',
        bo: 'Tibetansk',
        br: 'Bretonsk',
        bs: 'Bosnisk',
        ca: 'Katalansk',
        ce: 'Tsjetsjensk',
        ch: 'Chamorro',
        co: 'Korsikansk',
        cr: 'Cree',
        cs: 'Tsjekkisk',
        cu: 'Kirkeslavisk',
        cv: 'Tsjuvasjisk',
        cy: 'Walisisk',
        da: 'Dansk',
        de: 'Tysk',
        dv: 'Divehi',
        dz: 'Dzongkha',
        ee: 'Ewe',
        el: 'Gresk (moderne)',
        en: 'Engelsk',
        eo: 'Esperanto',
        es: 'Spansk',
        et: 'Estisk',
        eu: 'Baskisk',
        fa: 'Persisk',
        ff: 'Fulani',
        fi: 'Finsk',
        fj: 'Fijiansk',
        fo: 'Færøysk',
        fr: 'Fransk',
        fy: 'Vestfrisisk',
        ga: 'Irsk',
        gd: 'Skotsk-gælisk',
        gl: 'Galisisk',
        gn: 'Guaraní',
        gu: 'Gujarati',
        gv: 'Mansk',
        ha: 'Hausa',
        he: 'Hebraisk (moderne)',
        hi: 'Hindi',
        ho: 'Hiri Motu',
        hr: 'Kroatisk',
        ht: 'Haitisk kreol',
        hu: 'Ungarsk',
        hy: 'Armensk',
        hz: 'Herero',
        ia: 'Interlingua',
        id: 'Indonesisk',
        ie: 'Interlingue',
        ig: 'Igbo',
        ii: 'Nuosu',
        ik: 'Inupiaq',
        io: 'Ido',
        is: 'Islandsk',
        it: 'Italiensk',
        iu: 'Inuktitut',
        ja: 'Japansk',
        jv: 'Javanesisk',
        ka: 'Georgisk',
        kg: 'Kikongo',
        ki: 'Kikuyu',
        kj: 'Kwanyama',
        kk: 'Kasakhisk',
        kl: 'Grønlandsk',
        km: 'Khmer',
        kn: 'Kannada',
        ko: 'Koreansk',
        kr: 'Kanuri',
        ks: 'Kasjmiri',
        ku: 'Kurdisk',
        kv: 'Komi',
        kw: 'Kornisk',
        ky: 'Kirgisisk',
        la: 'Latin',
        lb: 'Luxembourgsk',
        lg: 'Ganda',
        li: 'Limburgsk',
        ln: 'Lingala',
        lo: 'Laotisk',
        lt: 'Litauisk',
        lu: 'Luba-Katanga',
        lv: 'Latvisk',
        mg: 'Gassisk',
        mh: 'Marshallesisk',
        mi: 'Maori',
        mk: 'Makedonsk',
        ml: 'Malayalam',
        mn: 'Mongolsk',
        mr: 'Marathi',
        ms: 'Malayisk',
        mt: 'Maltesisk',
        my: 'Burmesisk',
        na: 'Nauru',
        nb: 'Bokmål',
        nd: 'Nord-ndebele',
        ne: 'Nepali',
        ng: 'Ndonga',
        nl: 'Nederlandsk',
        nn: 'Nynorsk',
        no: 'Norsk',
        nr: 'Sør-ndebele',
        nv: 'Navajo',
        ny: 'Nyanja',
        oc: 'Oksitansk',
        oj: 'Ojibwa',
        om: 'Oromo',
        or: 'Oriya',
        os: 'Ossetisk',
        pa: 'Punjabi',
        pi: 'Pali',
        pl: 'Polsk',
        ps: 'Pashto',
        pt: 'Portugisisk',
        qu: 'Quechua',
        rm: 'Retoromansk',
        rn: 'Rundi',
        ro: 'Rumensk',
        ru: 'Russisk',
        rw: 'Kinyarwanda',
        sa: 'Sanskrit',
        sc: 'Sardinsk',
        sd: 'Sindhi',
        se: 'Nordsamisk',
        sg: 'Sango',
        si: 'Singalesisk',
        sk: 'Slovakisk',
        sl: 'Slovensk',
        sm: 'Samoansk',
        sn: 'Shona',
        so: 'Somali',
        sq: 'Albansk',
        sr: 'Serbisk',
        ss: 'Swati',
        st: 'Sørsotho',
        su: 'Sundanesisk',
        sv: 'Svensk',
        sw: 'Swahili',
        ta: 'Tamil',
        te: 'Telugu',
        tg: 'Tadsjikisk',
        th: 'Thai',
        ti: 'Tigrinja',
        tk: 'Turkmensk',
        tl: 'Tagalog',
        tn: 'Tswana',
        to: 'Tonga',
        tr: 'Tyrkisk',
        ts: 'Tsonga',
        tt: 'Tatarisk',
        tw: 'Twi',
        ty: 'Tahitisk',
        ug: 'Uigurisk',
        uk: 'Ukrainsk',
        ur: 'Urdu',
        uz: 'Usbekisk',
        ve: 'Venda',
        vi: 'Vietnamesisk',
        vo: 'Volapük',
        wa: 'Vallonsk',
        wo: 'Wolof',
        xh: 'Xhosa',
        yi: 'Jiddisk',
        yo: 'Joruba',
        za: 'Zhuang',
        zh: 'Kinesisk',
        zu: 'Zulu',
    },
    weekdays: {
        0: 'Mandag',
        1: 'Tirsdag',
        2: 'Onsdag',
        3: 'Torsdag',
        4: 'Fredag',
        5: 'Lørdag',
        6: 'Søndag',
    },
    cosmo: {
        [ProviderName.DEBBIE]: {
            title: 'Debbie',
            description: 'Oppdaterer Cosmo med data fra Debbie',
        },
        [ProviderName.LEGACY]: {
            title: 'Legacy [IKKE AKTIVER]',
            description: 'Migrering fra legacy cosmo til cosmoV2',
        },
        [ProviderName.AKS]: {
            title: 'Experian Aktiv KreditSikring (AKS)',
            description: 'Aktiv KreditSikring (Aktiv kredittsikring) gir deg oppdatert og detaljert kredittinformasjon om kundene dine. Tjenesten omfatter de nyeste stamdataene, økonomiske nøkkeltall, notater og annen vesentlig informasjon som hjelper deg med å vurdere en virksomhets økonomiske helse.',
        },
        [ProviderName.CVR]: {
            title: 'CVR',
            description: 'Få tilgang til offisielle virksomhetsdata direkte fra CVR. Inkluderer informasjon om en virksomhets navn, adresse, CVR-nummer, selskapsform, oppstartsdato, eiere og andre sentrale data.',
        },
        [ProviderName.CPR]: {
            title: 'CPR',
            description: 'Få tilgang til den danske statens offisielle register over personnummer. Her kan du hente personopplysninger basert på CPR-nummer eller navn-/adressesøk.',
        },
        [ProviderName.TINGBOGEN]: {
            title: 'Tingbogen',
            description: 'Få tilgang til registreringsinformasjon for fast eiendom, kjøretøy og andre eiendeler. Sjekk eierdetaljer, pantobligasjoner, servitutter og andre heftelser direkte fra den digitale Tingbogen.',
        },
        [ProviderName.MAILVALIDATOR]: {
            title: 'E-postvalidering',
            description: 'Debbie E-postvalidering sjekker om en e-postadresse er korrekt og aktiv. Den kontrollerer at adressen er skrevet riktig, at domenet finnes, og forsøker også å bekrefte om den spesifikke e-postadressen er aktiv, slik at du kan unngå å sende meldinger til adresser som ikke finnes.',
        },
        [ProviderName.COURT]: {
            title: 'Rettskrets',
            description: 'Finn og tildel rettskrets til saker automatisk',
        },
        [ProviderName.VONAGE]: {
            title: 'Vonage',
            description: 'Hent informasjon om telefonnumre, som gyldighet, type (mobil eller fasttelefon) og opplysninger om operatør.',
        },
        [ProviderName.EJF]: {
            title: 'Ejerfortegnelsen',
            description: 'Få tilgang til data om eiendomsbesittelse fra det danske eierregisteret (Ejerfortegnelsen). Slå opp eierdetaljer for fast eiendom basert på adresse eller bygningskode.',
        },
    },
    endReasonCategory: {
        [EndReasonCategory.Success]: 'Løst',
        [EndReasonCategory.Unresolved]: 'Forgjeves',
        [EndReasonCategory.NotPossible]: 'Ikke mulig',
        [EndReasonCategory.Error]: 'Avbrutt',
    },
    endReasonCategoryDescription: {
        [EndReasonCategory.Success]: 'Saker der vi har drevet inn penger til kreditor – helt eller delvis – via betaling eller akkord. Det er kategorien vi forsøker å maksimere.',
        [EndReasonCategory.Unresolved]: 'Reelle saker som ikke ble løst, men der ingen ytre omstendighet gjorde det umulig: gjelden ble foreldet, ble erklært uerholdelig, eller saken ble henlagt fordi det ikke lønte seg å forfølge den videre.',
        [EndReasonCategory.NotPossible]: 'Saker der inndrivelse ble umulig på grunn av ytre omstendigheter hos skyldneren – f.eks. konkurs, dødsfall, gjeldssanering eller ukjent adresse. Teller med i statistikken, men kan ikke regnes som vår feil.',
        [EndReasonCategory.Error]: 'Saker som tas ut av statistikken (også ut av netto løsningsgrad) fordi de aldri burde ha ligget hos oss: feilopprettelse, duplikater (sammenslått), kreditor trakk saken, eller skyldneren var mindreårig.',
    },
    endReasonsSettings: {
        customEndReasons: 'Opprettede avslutningsårsaker',
        systemEndReasons: 'Standard avslutningsårsaker',
        createEndReason: 'Opprett avslutningsårsak',
        label: 'Navn',
        category: 'Kategori',
        labelPlaceholder: 'Navn på avslutningsårsak',
        categoryPlaceholder: 'Velg kategori',
        uncategorized: 'Ukategorisert',
        editEndReason: 'Rediger avslutningsårsak',
        deleteEndReason: 'Slett avslutningsårsak',
        deleteEndReasonConfirm: 'Er du sikker på at du vil slette denne avslutningsårsaken? Det kan ikke angres.',
        deleteEndReasonInUse: 'Avslutningsårsaken brukes av avsluttede saker og kan ikke slettes',
        standardReadOnly: 'Standardårsaker deles av alle og kan ikke redigeres eller slettes.',
        endReasonNotFound: 'Avslutningsårsaken ble ikke funnet',
        handle: 'Handle',
    },
    voucherTypeSelect: {
        selectBillingVoucherType: 'Velg avregningsbilagstype',
        selectCaseVoucherType: 'Velg saksbilagstype',
        selectPaymentVoucherType: 'Velg bilagstype for betaling',
        searchVoucherTypes: 'Søk bilagstyper',
        allVoucherTypes: 'Alle bilagstyper',
    },
    paymentTypeSelect: {
        selectPaymentType: 'Velg betalingstype',
        searchPaymentTypes: 'Søk betalingstyper',
        allPaymentTypes: 'Alle betalingstyper',
    },
    contacts: {
        contact: 'kontakt',
        selectContact: 'Velg kontakt',
        selectPayoutContact: 'Utbetal til kontakt',
        searchContacts: 'Søk kontakter',
        allContacts: 'Alle kontakter',
        createContact: 'Opprett kontakt',
        editContact: 'Rediger kontakt',
        deleteContact: 'Slett kontakt',
        deleteContactConfirm: 'Er du sikker på at du vil slette kontakten?',
        notSelectableHere: 'Kontakten mangler opplysningene som kreves her, og ble derfor ikke valgt',
        email: 'E-post',
        phone: 'Telefon',
        registryIdentifier: 'Organisasjons-/fødselsnummer',
        bankAccount: 'Kontoopplysninger',
    },
    errorEntities: {
        sftpServer: 'SFTP-server',
        sftpUser: 'SFTP-bruker',
        endReason: 'avslutningsårsak',
        update: 'oppdatering',
        workflow: 'arbeidsflyt',
        creditorLink: 'kreditorkobling',
        interaction: 'interaksjon',
        procedure: 'prosedyre',
        tribunalCase: 'domstolssak',
        tribunalJob: 'domstolsjobb',
        document: 'dokument',
        paymentPlan: 'betalingsplan',
        file: 'fil',
        creditor: 'kreditor',
        billing: 'fakturering',
        billingCollection: 'faktureringsinnkreving',
        caseVoucher: 'saksbilag',
        caseVoucherTable: 'saksbilagstabell',
        fixedDistribution: 'fast fordeling',
        billingModel: 'faktureringsmodell',
        billingAppendixSetup: 'oppsett for faktureringsvedlegg',
        customer: 'kunde',
        user: 'bruker',
        settings: 'innstillinger',
        case: 'sak',
        party: 'part',
        import: 'import',
        transactionAccount: 'transaksjonskonto',
        interactionCategory: 'interaksjonskategori',
        view: 'visning',
        apiKey: 'API-nøkkel',
        searchIndex: 'søkeindeks',
        merge: 'sakssammenslåing',
        associateCase: 'sakstilknytning',
        deposit: 'depositum',
        task: 'oppgave',
        chain: 'arbeidsflyt',
        contact: 'kontakt',
        remindDate: 'purredato',
        changelog: 'endringslogg',
        referenceId: 'referanse-ID',
        aiSuggestion: 'AI-forslag',
        attachment: 'vedlegg',
        preview: 'forhåndsvisning',
        note: 'notat',
        rollbackTask: 'tilbakerulling av oppgave',
        runTask: 'oppgaveutførelse',
        bankAccountDetails: 'bankkontodetaljer',
        bulkActions: 'masshandling',
        pause: 'pause',
        meetingLocation: 'møtested',
        meetingDate: 'møtedato',
        satisfaction: 'tilfredshet',
        tags: 'etiketter',
        template: 'mal',
        webhook: 'webhook',
        property: 'eiendom',
        updateType: 'oppdateringstype',
        phone: 'telefonnummer',
        email: 'e-postadresse',
        report: 'rapport',
        caseGroup: 'saksgruppe',
        collector: 'inkassobyrå',
        team: 'team',
        rkiRegistration: 'RKI-registrering',
        interestCalculation: 'renteberegning',
        integration: 'integrasjon',
        asset: 'eiendel',
    },
    tribunalSettings: {
        box4CaseStatementTemplate: 'Rubrikk 4 - Mal for saksfremstilling',
        caseStatementTemplate: 'Mal for saksfremstilling',
        submission: 'Innlevering',
        ignorePaymentsWarning: 'Ignorer advarsel om at saken inneholder innbetalinger',
        box1Creditor: 'Rubrikk 1 - Kreditor (og eventuell representant)',
        creditor: 'Kreditor',
        representative: 'Eventuell representant',
        contactInformation: 'Kontaktopplysninger',
        noPhoneMeetingBelow: 'Ikke be om telefonmøte hvis kravets samlede beløp er under (DKK):',
        representativePhone: 'Representantens telefonnummer',
        representativeEmail: 'Representantens e-post',
        representativeRegistrationNumber: 'Representantens reg.nr.',
        representativeAccountNumber: 'Representantens kontonr.',
        box2Debtor: 'Rubrikk 2 - Skyldner',
        includeCprInPaymentDemand: 'Inkluder CPR-nummer i betalingskravet',
        box4ClaimSize: 'Rubrikk 4 - Kravets størrelse',
        excludeVoucherTypesDescription: 'Ekskluder utvalgte sakposteringstyper ved innlevering av betalingskravet. For eksempel inkassoomkostninger.',
        selectVoucherTypesToSubtract: 'Velg sakposteringstyper som skal trekkes fra ved innlevering',
        box5CaseStatement: 'Rubrikk 5 - Saksfremstilling',
        box9SubmittedBy: 'Rubrikk 9 - Innsendt av (kreditor eller kreditors representant)',
        courtCosts: 'Saksomkostninger',
        selectCourtCostVoucherType: 'Velg sakposteringstype for saksomkostninger',
        vouchersToOverride: 'Posteringer som skal overskrives (fjernes fra saken)',
        selectVouchers: 'Velg posteringer',
        vouchersToSubtractFromCourtCosts: 'Posteringer som skal motregnes i saksomkostningene',
        keepHigherExtrajudicialCosts: 'Behold utenrettslige kostnader hvis de er høyere enn de innenrettslige',
        interestActSection8a: 'Renteloven § 8 a',
        interestActSection8aDescription: 'Saksomkostninger tilkjent ved dom eller annen rettsavgjørelse i en sivil sak forrentes fra fullbyrdelsesfristens utløp med rente som fastsatt etter § 5, stk. 1 og 2.',
        selectInterestVoucherTypesAfterVerdict: 'Velg posteringstyper som det skal beregnes rente av 14 dager fra dom',
        insolvencyDeclaration: 'Insolvenserklæring',
        useCustomInsolvencyUpdateType: 'Bruk tilpasset oppgavetype for insolvens',
        defaultEmailTemplate: 'Standardmal for e-post',
        defaultEmailAttachmentTemplate: 'Standardmal for e-postvedlegget',
        editTemplate: 'Rediger mal',
    },
    cosmoSettings: {
        header: 'Cosmo-innstillinger',
        warningPrefix: 'OBS:',
        warning: 'Ikke gjør endringer på denne siden uten å rådføre deg med Debbie support.',
        identityProviderDescription: 'Velg hvilke identitetsleverandører som skal brukes for henholdsvis personer og virksomheter. En identitetsleverandør er dataleverandøren som brukes til å unikt identifisere en person eller virksomhet',
        personIdentityProvider: 'Identitetsleverandør for personer',
        selectPersonIdentityProvider: 'Velg identitetsleverandør for personer',
        companyIdentityProvider: 'Identitetsleverandør for virksomheter',
        selectCompanyIdentityProvider: 'Velg identitetsleverandør for virksomheter',
        subscriptionStrategyDescription: 'Velg når brukere skal meldes på Cosmo',
        strategyOnOpenCases: 'Meld på brukere på alle aktive saker og meld av når sakene avsluttes',
        strategyOnAllCustomers: '[not implemented] Meld på brukere ved kundeopprettelse og meld av ved sletting',
        strategyManual: 'Manuell påmelding og avmelding av brukere. Ingen automatisk påmelding/avmelding.',
        providers: 'Leverandører',
        disabledProviders: 'Deaktiverte leverandører',
        notActivated: 'Ikke aktivert',
        settings: 'Innstillinger',
        deactivate: 'Deaktiver',
        activate: 'Aktiver',
        identityProvider: 'Identitetsleverandør',
        persons: 'Personer',
        companies: 'Virksomheter',
    },
    dnsSetup: {
        checkDns: 'Sjekk DNS',
        title: 'DNS-oppsett',
        allRecordsConfirmed: 'Alle oppføringer er bekreftet',
        domainVerification: 'Domeneverifisering',
        email: 'E-post',
        outboundEmails: 'Utgående e-post (DKIM & SPF)',
        spfExistingPrefix: 'Hvis det allerede finnes en SPF-oppføring, må du sørge for å legge til',
        spfExistingSuffix: 'til den eksisterende oppføringen.',
        inboundEmails: 'Innkommende e-post',
        inboundForwarded: 'All innkommende e-post skal videresendes automatisk.',
        sites: 'Nettsteder',
        debtorWebApp: 'Debitor-webapp',
        creditorWebApp: 'Kreditor-webapp',
        verified: 'Verifisert',
        type: 'Type',
        hostname: 'Vertsnavn',
        value: 'Verdi',
        currentValue: 'Nåværende verdi',
    },
    createTenant: {
        tenantType: 'Kontotype',
        agency: 'Inkassobyrå',
        agencyDescription: 'Inkassobyrå som inndriver på vegne av eksterne kunder. Innkrevde midler fordeles til kreditorene, og funksjoner som namsmann/rettssaker er aktivert.',
        accountsReceivable: 'Kundereskontro',
        accountsReceivableDescription: 'Virksomhet som selv inndriver sine fordringer. Kontoen er selv den eneste kreditoren og bruker en forenklet kundereskontromodell.',
        companyName: 'Virksomhetens navn',
        vatNumber: 'Organisasjonsnummer (DK12345678)',
        billingAddress: 'Faktureringsadresse',
        country: 'Land',
        language: 'Språk',
        currency: 'Valuta',
        timezone: 'Tidssone',
        demoDescription: 'Demokonto brukt til salgspresentasjoner. Disse kontoene kan ha testdata, og noe statistikk vil være fiktiv. Sending av e-post, sms osv. simuleres, og ingen ekte data sendes. Data sendes til brukeren som bruker systemet.',
        sandboxDescription: 'Brukes for kunder som trenger et sandkassemiljø. Sending av e-post, sms osv. simuleres, og ingen ekte data sendes. Data sendes til brukeren som bruker systemet.',
        gettingStartedDescription: 'Kontoer etter go-live der konfigurasjon, API-integrasjon, onboarding osv. pågår. Kontoen kan senere settes som aktiv. Sending av e-post, sms osv. simuleres, og ingen ekte data sendes. Data sendes til brukeren som bruker systemet.',
        demoMockData: 'Demo-testdata',
        noMockData: '-- Ingen testdata --',
        addFrisbiiPaymentGateway: 'Legg til Frisbii betalingsgateway',
        principalType: 'Hovedstoltype',
        interestType: 'Rentetype',
        noInterest: '-- Ingen rente --',
        quantityCreditors: 'Antall kreditorer',
        quantityCasesPerCreditor: 'Antall saker per kreditor',
        privateDebtors: 'Private debitorer',
        companyDebtors: 'Virksomhetsdebitorer',
        mixed: 'Blandet',
        createTenant: 'Opprett konto',
    },
    experianClientNumber: {
        header: 'Send inn Experian-klientnummer',
        withAksCustomerNumber: 'med AKS-kundenummer:',
        partnershipText: 'har inngått samarbeid med nedenstående virksomhet. Det bes derfor om et RKI-klientnummer til',
        forFutureRegistrations: 'til fremtidige innrapporteringer.',
        companyName: 'Virksomhetsnavn:',
        address: 'Adresse:',
        clientNumberRegistered: 'Klientnummeret ble registrert',
        clientNumberPlaceholder: 'Klientnummer',
        submit: 'Send inn',
    },
    satisfaction: {
        backToMyCase: 'Tilbake til min sak',
        header: 'Din mening betyr mye for oss',
        intro: 'For å kunne yte best mulig service vil vi gjerne høre om din opplevelse.',
        whichSmiley: 'Hvilken smiley beskriver best din opplevelse av behandlingen av sak #',
        optionalComment: 'Eventuell kommentar',
        submit: 'Send inn',
        thanks: 'Takk for at du sendte inn din tilbakemelding',
    },
    webappSettings: {
        title: 'Webapper',
        debtorWeb: 'Skyldnerportal',
        creditorWeb: 'Kreditorportal',
        creditorIntroduction: 'Velg hvilke opplysninger kreditorer kan se i portalen sin.',
        documentsTitle: 'Dokumenter',
        hideDocumentsDescription: 'Skjul sakenes dokumenter i kreditorportalen. Dokumentene er fortsatt tilgjengelige for saksbehandlerne deres.',
    },
    lighthouse: {
        cosmo: 'Cosmo',
        modules: 'Moduler',
        recalculateTenant: 'Beregn tenant på nytt',
        recalculateTenantDescription: 'Beregn renter, foreldelse og fakturering på nytt for alle ventende og verifiserte saker på tenanten.',
        recalculateTenantConfirm: 'Beregn alle ventende og verifiserte saker på denne tenanten på nytt? Det kan opprette faktureringsjusteringer.',
        recalculate: 'Beregn på nytt',
        recalculation: 'Ny beregning',
        recalculationRunsInBackground: 'Den kjører i bakgrunnen.',
    },
    debtorWebSettings: {
        introduction: 'Tilpass tekster og selvbetjening i portalen som skyldnerne dine bruker.',
        textsTitle: 'Tekster og kontakt',
        textsDescription: 'Bruk standardtekstene eller skriv egne. Tekstene vises på skyldnerens sak.',
        customWelcome: 'Bruk egen velkomsttekst',
        welcomeDescription: 'Erstatter introduksjonen øverst i saken.',
        defaultText: 'Standardtekst',
        defaultWelcomeDescription: 'Standardteksten viser skyldnerens saldo, kreditors navn og portalens muligheter.',
        showContactInformation: 'Vis kontaktopplysninger',
        contactInformationDescription: 'Vis kontaktdelen med e-post og telefonnummer i saken.',
        customContact: 'Bruk egen kontakttekst',
        contactDescription: 'Teksten vises sammen med kontaktopplysningene deres.',
        paymentsTitle: 'Betaling og avdrag',
        allowPartialPayments: 'Tillat delbetalinger',
        partialPaymentsDescription: 'La skyldneren betale deler av saldoen via betalingsportalen.',
        encouragePaymentPlan: 'Vis forslag om avdragsordning',
        paymentPlanDescription: 'Foreslå å be om en avdragsordning når det er mulig i saken.',
        detailsTitle: 'Opplysninger og saksnummer',
        allowSelfOverwrite: 'Tillat endringer uten godkjenning',
        selfOverwriteDescription: 'La skyldnere overskrive egne opplysninger uten godkjenning fra en saksbehandler.',
        preferOriginalJournalNumber: 'Bruk opprinnelig saksnummer',
        journalNumberDescription: 'Vis saksnummeret fra det tidligere systemet. Hvis det mangler, brukes saksnummeret i Debbie.',
        unsavedChanges: 'Ulagrede endringer',
        saveDescription: 'Endringene trer i kraft når du lagrer.',
        saveChanges: 'Lagre endringer',
        emptyText: 'Fyll inn egen tekst eller slå av tilpasningen for å bruke standardteksten.',
        leaveWithoutSaving: 'Du har ulagrede endringer. Vil du forlate siden?',
        welcomeText: 'Velkomsttekst',
        contactUsText: 'Kontakt oss-tekst',
        hideContactInformation: 'Skjul kontaktopplysninger',
        noPartialPayments: 'Ingen delbetalinger',
        doNotEncouragePaymentPlan: 'Ikke oppfordre til nedbetalingsplan',
        useMigratedJournalNumber: 'Bruk migrert journalnummer (fallback til Debbie-journalnummer)',
    },
    resolutionRate: {
        title: 'Løsningsgrad',
        description: 'Andel saker som ble løst, og hvor raskt de ble løst.',
        headerEnded: 'Avsluttede saker',
        headerSuccess: 'Løst',
        headerNotPossible: 'Ikke mulig',
        headerUnresolved: 'Uløst',
        headerError: 'Feil (utelatt fra statistikken)',
        headerPending: 'Venter',
        headerVerified: 'Verifisert',
        grossRate: 'Brutto løsningsgrad',
        grossRateInfo: 'Andel av alle avsluttede saker som ble løst gjennom betaling, delbetaling eller akkord.',
        netRate: 'Netto løsningsgrad',
        netRateInfo: 'Andel løste saker av alle avsluttede saker, unntatt saker som er fjernet fra statistikken som feil (feilopprettede, trukket tilbake, slått sammen osv.).',
        grossMoneyRate: 'Brutto løsningsgrad (DKK)',
        grossMoneyRateInfo: 'Innkrevd beløp i forhold til samlet hovedstol for alle saker som er avsluttet i perioden.',
        collectedAmount: 'Innkrevd',
        totalPrincipalEnded: 'Hovedstol i avsluttede saker',
        avgDaysToResolution: 'Gjennomsnittlig tid til løsning',
        avgDaysToResolutionInfo: 'Gjennomsnittlig antall dager fra saken ble opprettet til den ble avsluttet som løst.',
        medianDaysToResolution: 'Mediantid til løsning',
        speedHeader: 'Løsningshastighet',
        speedInfo: 'Andel av de løste sakene som ble løst innen hvert tidsintervall. Kumulativ andel.',
        speedWithinDays: 'Innen {days} dager',
        byMonthHeader: 'Avsluttede saker per måned',
        byEndReasonHeader: 'Fordeling etter avslutningsårsak',
        legendHeader: 'Hva kategoriene betyr',
        legendIntro: 'Hver avslutningsårsak tilhører én av fire kategorier. Kategorien avgjør om saken regnes som løst, uløst eller utelates fra statistikken.',
        columnEndReason: 'Avslutningsårsak',
        columnCategory: 'Kategori',
        columnCount: 'Antall',
        columnPrincipal: 'Hovedstol',
        columnCollected: 'Innkrevd',
        daysSuffix: 'dager',
        explainCategories: 'Forklar løsningskategorier',
        excludingErrors: (count) => `${count} ekskl. feil`,
        percentOfAll: (percent) => `${percent} av alle`,
        medianPrefix: 'Median',
    },
    generalManagementInsights: {
        tabs: {
            portfolio: 'Saksportefølje',
            resolutionRate: 'Løsningsgrad',
            caseHandling: 'Saksbehandling',
            calls: 'Samtaler',
            communicationsAndWorkflows: 'Kommunikasjon og arbeidsflyter',
            expiration: 'Foreldelse',
            revenue: 'Inntekter',
            tribunal: 'Domstol',
            incomingPayments: 'Innbetalinger',
            paymentPlans: 'Nedbetalingsavtaler',
        },
        filters: {
            caseGroupsPlaceholder: 'Alle saksgrupper',
            creditorsPlaceholder: 'Alle kreditorer',
            searchPlaceholder: 'Skriv for å søke',
        },
        incomingPayments: {
            byMonthHeader: 'Betalinger per måned',
            bySourceHeader: 'Fordeling etter mottaker',
            byStateHeader: 'Fordeling etter type',
            byPaymentTypeHeader: 'Fordeling etter betalingsmetode',
            countLabel: 'Antall',
            amountLabel: 'Beløp',
            sourceCollector: 'Mottatt hos inkassobyrået',
            sourceCreditor: 'Mottatt hos kreditor',
            shareOfAmount: (share) => `${share}% av beløpet`,
            countWithShare: (count, share) => `${count} betalinger (${share}%)`,
            stateLabels: {
                [CaseVoucherState.FullPayment]: 'Full betaling',
                [CaseVoucherState.PartialPayment]: 'Delbetaling',
                [CaseVoucherState.Overpayment]: 'Overbetaling',
                [CaseVoucherState.PaymentPlanEntryPayment]: 'Avdrag på nedbetalingsavtale',
                [CaseVoucherState.UnkownPaymentPlanPayment]: 'Ukjent avdrag',
                [CaseVoucherState.AccordPayment]: 'Akkord',
                [CaseVoucherState.PrincipalPayment]: 'Betaling av hovedstol',
            },
            paymentTypeUnknown: 'Ukjent',
            columnPaymentType: 'Betalingsmetode',
            columnCount: 'Antall',
            columnCountShare: 'Andel av antall',
            columnAmount: 'Beløp',
            columnAmountShare: 'Andel av beløp',
            currencyLabel: 'Valuta',
            noData: 'Ingen data',
        },
        common: {
            incoming: 'Innkommende',
            outgoing: 'Utgående',
            others: 'Andre',
            noCaseGroup: 'Ingen saksgruppe',
            noData: 'Ingen data',
            creditor: 'Kreditor',
            caseGroup: 'Saksgruppe',
            updateType: 'Oppgavetype',
            user: 'Bruker',
            tag: 'Tagg',
            count: 'Antall',
            total: 'Totalt',
            payment: 'Betaling',
            paymentPlan: 'Nedbetalingsavtale',
            revenue: 'Inntekter',
            open: 'Åpne',
            oldest: 'Eldst',
            over7Days: 'Over 7 d',
            over30Days: 'Over 30 d',
            medianAge: 'Medianalder',
            daysValue: (days) => `${days} dager`,
            xOfY: (a, b) => `${a} av ${b}`,
        },
        portfolio: {
            createdAndEndedCasesPerMonth: 'Opprettede og avsluttede saker per måned',
            createdCasesPerCreditor: 'Opprettede saker per kreditor',
            activeCasesPerMonth: 'Aktive saker per måned',
            submittedAndImposedPerMonth: 'Innsendte og påførte beløp per måned',
            ageDistributionOfActiveCases: 'Aldersfordeling for aktive saker',
            top10CreditorsByOutstanding: 'De 10 kreditorene med høyest samlet utestående beløp',
            createdCases: 'Opprettede saker',
            activeCases: 'Aktive saker',
            imposedByCreditor: 'Påført av kreditor',
            imposedByCollector: 'Påført av inkassobyrået',
            compositionFootnote: 'Bilagene deles etter hvem som registrerte dem: kreditor (hovedstol, fakturaer, purregebyrer) eller inkassobyrået (renter, kostnader, rettsgebyrer og gebyrer lagt til under innkrevingen).',
            cases: 'Saker',
            balance: 'Saldo',
            columnCaseCount: 'Saker',
            columnTotalOutstanding: 'Samlet utestående',
        },
        caseHandling: {
            allCaseGroups: 'Alle saksgrupper',
            allCreditors: 'Alle kreditorer',
            allUpdateTypes: 'Alle oppgavetyper',
            allResponsibles: 'Alle ansvarlige',
            unassignedOption: 'Ikke tildelt',
            teamsGroup: 'Team',
            usersGroup: 'Brukere',
            behindPerUser: 'Etterslep per bruker',
            behindPerUserDescription: 'Åpne oppgaver per bruker, inkludert oppgaver som ikke er tildelt, slik at manglende ansvar blir synlig.',
            behindPerTeam: 'Etterslep per team',
            behindPerTeamDescription: 'Åpne oppgaver per team for å se hvilke team som ligger etter.',
            noOpenTasksByUser: 'Ingen åpne oppgaver per bruker',
            noOpenTasksByTeam: 'Ingen åpne oppgaver per team',
            unknownUser: 'Ukjent bruker',
            unknownTeam: 'Ukjent team',
            user: 'Bruker',
            currentTaskBacklog: 'Nåværende oppgavekø',
            timeSpentPerUpdateType: 'Tidsbruk per oppgavetype',
            avgTimeOnTaskList: (label) => (label ?? '')
                ? `Gjennomsnittlig tid på oppgavelisten – ${label}`
                : 'Gjennomsnittlig tid på oppgavelisten',
            lessThanOneDay: '< 1 d',
            taskBacklogDescription: 'Viser oppgavene som nå står på oppgavelisten. Bruk oversikten til å se hva teamet ligger etter med, og hvilke oppgavetyper som må prioriteres.',
            totalOpenTasks: 'Totalt antall åpne oppgaver',
            oldestLabel: (days) => `Eldst: ${days}`,
            overDeadline: 'Overskredet frist',
            percentOfTasksWithDeadline: (percent) => `${percent}% av oppgaver med frist`,
            noDeadlinesConfigured: 'Ingen frister angitt',
            olderThan7Days: 'Eldre enn 7 dager',
            percentOfBacklog: (percent) => `${percent}% av oppgavekøen`,
            olderThan30Days: 'Eldre enn 30 dager',
            unassigned: 'Ikke tildelt',
            ageDistribution: 'Aldersfordeling',
            ageDistributionDescription: 'Hvor lenge har de åpne oppgavene stått på oppgavelisten? Søylene til høyre bør være lave, ellers begynner oppgavene å hope seg opp.',
            quantity: 'Antall',
            prioritizationPerUpdateType: 'Prioritering per oppgavetype',
            prioritizationDescription: 'Sortert etter antall oppgaver med overskredet frist. Oppgavetyper uten frist havner nederst. Angi en frist for oppgavetypen for å ta den med i prioriteringen.',
            noTasksOnList: 'Det er ingen oppgaver på oppgavelisten.',
            behindPerCreditor: 'Etterslep per kreditor',
            behindPerCreditorDescription: 'Sortert etter antall oppgaver som er eldre enn 7 dager. Bruk oversikten til å se hvilke kreditorer som nå trenger ekstra oppmerksomhet.',
            noOpenTasksByCreditor: 'Ingen åpne oppgaver per kreditor.',
            behindPerCaseGroup: 'Etterslep per saksgruppe',
            behindPerCaseGroupDescription: 'Hvilke saksgrupper har størst oppgavekø, og hvor venter oppgavene lengst?',
            noOpenTasksByCaseGroup: 'Ingen åpne oppgaver per saksgruppe.',
            hoursPerUpdateType: 'Timer per oppgavetype',
            timeTrackingDescription: 'Tid registreres automatisk på en oppgave når en oppgavetype velges fra oppgavelisten. Klokken starter når en sak åpnes, og stopper når saken forlates eller oppgaven markeres som løst.',
            average: 'Gjennomsnitt',
            median: 'Median',
            taskCount: 'Antall oppgaver',
            taskQueueDurationDescription: 'Viser hvor lenge oppgaver i gjennomsnitt har stått på oppgavelisten, målt fra de ble opprettet til de ble videreført.',
            columnAvgPerTask: 'Gjennomsnitt per oppgave',
            columnResolvedTasksCount: 'Løste oppgaver',
            totalTimeSpent: 'Samlet tidsbruk',
            weekdays: {
                sun: 'Søn',
                mon: 'Man',
                tue: 'Tir',
                wed: 'Ons',
                thu: 'Tor',
                fri: 'Fre',
                sat: 'Lør',
            },
            onParWithTeam: 'På nivå med teamet',
            comparedToTeam: (signedPct) => `${signedPct} sammenlignet med teamet`,
            resolvedCount: 'Antall løste',
            percentile25: '25. persentil',
            percentile75: '75. persentil',
            fastest: 'Raskest',
            slowest: 'Tregest',
            timeSpentDistribution: 'Fordeling av tidsbruk',
            timeSpentDistributionDescription: 'Hvordan brukerens oppgaver fordeler seg over tid, sammenlignet med teamets fordeling. Ligger brukeren til høyre for teamet, tar oppgavene generelt lengre tid.',
            team: 'Team',
            efficiencyPerWeekday: 'Effektivitet per ukedag',
            efficiencyPerWeekdayDescription: 'Gjennomsnittlig oppgavetid per ukedag: brukerens egen tid (mørk) mot teamets gjennomsnitt (lys). Søylene viser også hvor mange oppgaver brukeren har løst hver dag.',
            userAvg: 'Brukerens gjennomsnitt',
            teamAvg: 'Teamets gjennomsnitt',
            tasks: 'Oppgaver',
            minutesSuffix: ' min',
        },
        calls: {
            overviewSectionHeader: 'Samtaler og inntekter i perioden',
            callsPerMonthHeader: 'Samtaler per måned',
            creditorReachHeader: 'Kreditorer – hvor lett når vi skyldnerne?',
            outgoingTagsHeader: 'Utgående samtaler – tagger og resultat',
            incomingTagsHeader: 'Innkommende samtaler – tagger og resultat',
            caseworkerPerformanceHeader: 'Saksbehandlere – resultat',
            shareOfCalls: (share) => `${share}% av samtalene`,
            stat: {
                totalCalls: 'Totalt antall samtaler',
                totalCallsInfo: 'Totalt antall samtaleinteraksjoner registrert på saker i den valgte perioden.',
                incomingInfo: 'Antall samtaler der en skyldner eller noen andre ringte inn.',
                outgoingInfo: 'Antall samtaler utført av saksbehandlere.',
                outgoingAnswered: 'Besvarte utgående samtaler',
                outgoingAnsweredInfo: 'Utgående samtaler uten taggen «Ikke svar». Andelen vises i forhold til alle utgående samtaler.',
                outgoingNoAnswer: 'Ubesvarte utgående samtaler',
                outgoingNoAnswerInfo: 'Utgående samtaler der saksbehandleren har satt taggen «Ikke svar». Andelen vises i forhold til alle utgående samtaler.',
                withPayment: 'Med betaling',
                withPaymentInfo: 'Antall samtaler etterfulgt av en betaling på samme sak innen 7 dager.',
                withNewPaymentPlan: 'Med ny nedbetalingsavtale',
                withNewPaymentPlanInfo: 'Antall samtaler etterfulgt av en ny nedbetalingsavtale på samme sak innen 7 dager.',
                collectionCommission: 'Inkassoprovisjon',
                collectionCommissionInfo: 'Summen av inkassoprovisjon (avregningsbilag) bokført innen 7 dager etter en samtale i perioden.',
                otherFees: 'Andre gebyrer',
                otherFeesInfo: 'Summen av andre gebyrer (avregningsbilag) bokført innen 7 dager etter en samtale i perioden.',
                totalRevenue: 'Samlede inntekter',
                totalRevenueInfo: 'Samlede inntekter (inkassoprovisjon og andre gebyrer) bokført innen 7 dager etter en samtale i perioden. «Per samtale» er gjennomsnittet fordelt på alle samtaler.',
                perCall: (amount) => `${amount} per samtale`,
            },
            emptyTags: 'Ingen tagger registrert i perioden.',
            unknownUser: 'Ukjent bruker',
            emptyCaseworkers: (minCalls) => `Ingen saksbehandlere med minst ${minCalls} samtaler i perioden.`,
            caseworkerHelp: (minCalls) => `Kun saksbehandlere med minst ${minCalls} registrerte samtaler i perioden vises. Resultatet måler andelen av saksbehandlerens samtaler som er etterfulgt av en betaling eller en ny nedbetalingsavtale på samme sak innen 7 dager.`,
            emptyCreditors: (minCalls) => `Ingen kreditorer med minst ${minCalls} samtaler i perioden.`,
            creditorReachHelpPrefix: 'Sorter etter ',
            creditorReachHelpAnswered: 'Besvart',
            creditorReachHelpMiddle: ' for å se hvilke skyldnere som er lettest å nå. Kun utgående samtaler teller i svarprosenten. Samtaler uten taggen ',
            creditorReachHelpNoAnswer: '«Ikke svar»',
            creditorReachHelpMin: (minCalls) => ` regnes som besvart. Kun kreditorer med minst ${minCalls} samtaler i perioden vises.`,
            answered: 'Besvart',
            caseworker: 'Saksbehandler',
        },
        communications: {
            sectionHeader: 'Kommunikasjon i perioden',
            templatesHeader: 'Maler – resultat og tilknyttede inntekter',
            byTypeHeader: 'Interaksjoner per type og retning',
            letterReturnsHeader: 'Returbrev – antall, svartid og årsak',
            dataQualityHeader: 'Kvalitet på kontaktdata per kreditor og saksgruppe',
            futureWorkflowsHeader: 'Arbeidsflyter – kommende oppgaver per oppgavetype',
            shareOfAll: (percent) => `${percent} av alle`,
            shareOfSent: (percent) => `${percent} av sendte`,
            stat: {
                totalInteractions: 'Totalt antall interaksjoner',
                totalInteractionsInfo: 'Totalt antall kommunikasjonsinteraksjoner i perioden, uansett type og retning.',
                outgoingInfo: 'Antall utgående interaksjoner i perioden.',
                incomingInfo: 'Antall innkommende interaksjoner i perioden.',
                withPaymentPlan: 'Med ny nedbetalingsavtale',
                withPaymentPlanInfo: 'Interaksjoner etterfulgt av en ny nedbetalingsavtale på samme sak innen 7 dager.',
                withPayment: 'Med betaling',
                withPaymentInfo: 'Interaksjoner etterfulgt av en betaling på samme sak innen 7 dager.',
                linkClicks: 'Lenkeklikk',
                linkClicksInfo: 'Totalt antall lenkeklikk registrert på interaksjoner i perioden.',
                collectionCommission: 'Inkassoprovisjon',
                collectionCommissionInfo: 'Summen av inkassoprovisjon bokført innen 7 dager på saker som mottok en interaksjon i perioden.',
                otherFees: 'Andre gebyrer',
                otherFeesInfo: 'Summen av andre gebyrer (kategorien FEE) bokført innen 7 dager på saker som mottok en interaksjon i perioden.',
                totalRevenue: 'Samlede inntekter',
                totalRevenueInfo: 'Inntekter knyttes til den siste utgående malmeldingen før hvert gebyr, innen 7 dager. Hvert gebyr telles én gang.',
                lettersSent: 'Sendte brev',
                lettersSentInfo: 'Antall brev sendt i perioden.',
                lettersReturned: 'Returnerte brev',
                lettersReturnedInfo: 'Antall brev der PostNord har registrert mislykket levering i perioden.',
                averageReturnTime: 'Gjennomsnittlig svartid',
                averageReturnTimeInfo: 'Gjennomsnittlig antall dager fra brevet sendes til returen registreres.',
            },
            emptyTemplates: 'Ingen malbaserte interaksjoner i perioden.',
            emptyInteractions: 'Ingen interaksjoner i perioden.',
            emptyReturns: 'Ingen returbrev registrert i perioden.',
            emptyCases: 'Ingen saker funnet.',
            emptyWorkflowTasks: 'Ingen kommende arbeidsflytoppgaver funnet.',
            templatesHelp: 'Hver rad viser en mal brukt på utgående interaksjoner i perioden. Nedbetalingsavtale % og Betaling % viser hvor mange sendte interaksjoner som innen 7 dager er etterfulgt av henholdsvis en ny nedbetalingsavtale eller en innbetaling på samme sak. Lenkeklikk er klikkhendelser registrert på interaksjonene. Inntekter er summen av inkassoprovisjon og andre gebyrer bokført på samme sak innen 7 dager etter utsending.',
            dataQualityHelp: 'Tabellen viser kvaliteten på kontaktdata per kreditor og saksgruppe. Lave retur- og feilrater betyr at vi når skyldnerne via de valgte kanalene. Tallene i parentes er det faktiske antallet mislykkede leveringer.',
            workflowHelp: 'Antall kommende arbeidsflytoppgaver per oppgavetype, basert på sakens neste planlagte oppgave (cases.workflow_next_task_id). Filtrene ovenfor brukes ikke; tabellen viser den nåværende oppgavekøen.',
            daysValue: (days) => `${days} dager`,
            col: {
                template: 'Mal',
                type: 'Type',
                sent: 'Sendt',
                linkClicks: 'Lenkeklikk',
                returnReason: 'Returårsak',
                shareOfSent: 'Andel av sendte',
                averageResponseTime: 'Svartid (gjennomsnitt)',
                lettersReturned: 'Returnerte brev',
                emailsFailed: 'Mislykkede e-postleveringer',
                eboksFailed: 'Mislykkede e-Boks-leveringer',
                cases: 'Saker',
                overdue: 'Forsinket',
                next7Days: 'Neste 7 dager',
                days8To30: '8–30 dager',
                later: 'Senere',
            },
        },
        expiration: {
            headerExpiration: 'Foreldelse',
            headerSuspension: 'Mulighet til å avbryte foreldelse',
            clear: 'Tøm',
            loadingForMonth: (month) => `Laster fordeling for ${month}…`,
            distributionPerCreditor: (month) => `Fordeling per kreditor – ${month}`,
            distributionPerCaseGroup: (month) => `Fordeling per saksgruppe – ${month}`,
        },
        revenue: {
            settledRevenuePerMonth: 'Avregnede inntekter per måned',
            collectionCommissionByCasePostingType: 'Inkassoprovisjon etter saksposteringstype',
            otherFeesByFeeType: 'Andre gebyrer etter gebyrtype',
            billingSpeedPerCreditor: 'Faktureringshastighet per kreditor',
            workInProgressNotYetBilled: 'Pågående arbeid (ennå ikke fakturert)',
            revenuePerCreditor: 'Inntekter per kreditor',
            revenuePerCaseGroup: 'Inntekter per saksgruppe',
            collectionCommission: 'Inkassoprovisjon',
            fees: 'Gebyrer',
            otherFees: 'Andre gebyrer',
            avgDaysToBilling: 'Gjennomsnittlig antall dager til fakturering',
            billed: 'Fakturert',
            unbilled: 'Ikke fakturert',
            totalOtherFees: 'Samlede andre gebyrer',
            totalCollectionCommission: 'Samlet inkassoprovisjon',
            name: 'Navn',
        },
        tribunal: {
            paymentOrderOutcomes: 'Utfall av betalingspålegg',
            casesFiledAndBailiffMeetingsPerMonth: 'Innsendte rettssaker og utleggsforretninger per måned',
            courtProcessingTime: 'Domstolens behandlingstid (betalingspålegg)',
            percentOfCases: (share) => `${share}% av sakene`,
            stat: {
                totalFiled: 'Totalt innsendt',
                totalFiledInfo: 'Antall unike saker der et betalingspålegg er opprettet eller sendt inn på nytt i den valgte perioden. Datoen er tidspunktet da betalingspålegget ble sendt inn.',
                paidAfterFiling: 'Betalt etter innsending',
                paidAfterFilingInfo: 'Antall saker avsluttet som betalt innen 3 måneder etter den siste handlingen i domstolsmodulen. Sakene telles etter datoen for det opprinnelige betalingspålegget, ikke betalingsdatoen. Saken må være avsluttet med årsaken «Betalt» i Debbie.',
                paidBetweenFirstAndSecondEndorsement: 'Betalt mellom første og andre påtegning',
                paidBetweenFirstAndSecondEndorsementInfo: 'Antall unike saker der en betaling er registrert mellom første påtegning og inntil 5 dager etter andre påtegning, for å fange opp betalinger registrert senere. Saken trenger ikke å være avsluttet som betalt. Sakene telles etter datoen for det opprinnelige betalingspålegget.',
                paidBetweenSecondEndorsementAndBailiffMeeting: 'Betalt mellom andre påtegning og utleggsforretning',
                paidBetweenSecondEndorsementAndBailiffMeetingInfo: 'Antall unike saker der en betaling er registrert mellom andre påtegning og inntil 5 dager etter utleggsforretningen, for å fange opp betalinger registrert senere. Saken trenger ikke å være avsluttet som betalt. Sakene telles etter datoen for det opprinnelige betalingspålegget. Utleggsforretningen må være registrert i Debbie.',
                distraintsPerformed: 'Utførte utlegg',
                distraintsPerformedInfo: 'Antall unike saker der et utlegg er registrert. Sakene telles etter datoen for det opprinnelige betalingspålegget, ikke datoen for utlegget. Merk at utlegg som ikke er registrert i Debbie, ikke er inkludert.',
                paymentPlansCreatedAfterBailiffMeeting: 'Nedbetalingsavtaler opprettet etter utleggsforretning',
                paymentPlansCreatedAfterBailiffMeetingInfo: 'Antall nedbetalingsavtaler opprettet innen 1 måned etter en utleggsforretning. Sakene telles etter datoen for det opprinnelige betalingspålegget, ikke datoen for avtalen. Alle opprettede avtaler teller, også de som senere ble avbrutt eller misligholdt. Utleggsforretningen må være registrert i Debbie.',
                activePaymentPlansNow: 'Aktive nedbetalingsavtaler nå',
                activePaymentPlansNowInfo: 'Hvor mange av nedbetalingsavtalene som ble opprettet etter en utleggsforretning, som er aktive nå.',
                finishedPaymentPlans: 'Fullførte nedbetalingsavtaler',
                finishedPaymentPlansInfo: 'Hvor mange av nedbetalingsavtalene som ble opprettet etter en utleggsforretning, som er fullført og fullt betalt.',
                objections: 'Innsigelser',
                objectionsInfo: 'Antall utleggssaker avsluttet med en innsigelse etter første påtegning. Sakene telles etter datoen for det opprinnelige betalingspålegget, ikke datoen for innsigelsen. Innsigelser som ikke er registrert i Debbie, er ikke inkludert.',
                insolvencies: 'Insolvenser',
                insolvenciesInfo: 'Antall unike saker der insolvens er registrert. Sakene telles etter datoen for det opprinnelige betalingspålegget, ikke datoen for insolvensregistreringen. Insolvenser som ikke er registrert i Debbie, er ikke inkludert.',
            },
            bailiffMeetings: 'Utleggsforretninger',
            courtSpeedBenchmarkDescription: 'Samlet tid fra sakens start til hvert trinn i den forenklede prosessen. Tallet under viser tiden fra forrige trinn.',
            court: 'Domstol',
            firstEndorsement: 'Første påtegning',
            secondEndorsement: 'Andre påtegning',
            invitation: 'Innkalling',
            bailiffMeeting: 'Utleggsforretning',
            casesByCourt: 'Innsendte saker per domstol',
            casesByCourtDescription: 'Antall opprinnelige betalingspålegg denne klienten har sendt til hver domstol i den valgte perioden, og hvor mange som ble returnert av domstolen for retting og ny innsending.',
            casesByCourtCount: 'Innsendte saker',
            casesByCourtShare: 'Andel av totalt',
            casesByCourtRevised: 'Returnert for retting',
            casesByCourtRevisedShare: 'Andel rettinger',
        },
    },
};
export default map;
//# sourceMappingURL=no.js.map